// const citiesAndZips = [
//     { city: 'Aachen*2', zip: '241' },
//     { city: 'Aachen-Kornelimünster', zip: '2408' },
//     { city: 'Aalen', zip: '7361' },
//     { city: 'Aalen-Ebnat', zip: '7367' },
//     { city: 'Aarbergen', zip: '6120' },
//     { city: 'Abberode', zip: '34779' },
//     { city: 'Abenberg Mittelfr', zip: '9178' },
//     { city: 'Abenberg-Wassermungenau', zip: '9873' },
//     { city: 'Abensberg', zip: '9443' },
//     { city: 'Abtsgmünd', zip: '7366' },
//     { city: 'Achberg', zip: '8380' },
//     { city: 'Achern', zip: '7841' },
//     { city: 'Achim b Bremen', zip: '4202' },
//     { city: 'Achterwehr', zip: '4340' },
//     { city: 'Adelberg', zip: '7166' },
//     { city: 'Adelebsen', zip: '5506' },
//     { city: 'Adelmannsfelden', zip: '7963' },
//     { city: 'Adelsdorf Mittelfr', zip: '9195' },
//     { city: 'Adelsheim', zip: '6291' },
//     { city: 'Adelshofen Mittelfr', zip: '9865' },
//     { city: 'Adenau', zip: '2691' },
//     { city: 'Adlkofen', zip: '8707' },
//     { city: 'Adorf Vogtl', zip: '37423' },
//     { city: 'Aerzen', zip: '5154' },
//     { city: 'Affing', zip: '8207' },
//     { city: 'Affinghausen', zip: '4247' },
//     { city: 'Aglasterhausen', zip: '6262' },
//     { city: 'Ahaus', zip: '2561' },
//     { city: 'Ahaus-Alstätte', zip: '2567' },
//     { city: 'Ahausen-Kirchwalsede', zip: '4269' },
//     { city: 'Ahlbeck b Torgelow', zip: '39775' },
//     { city: 'Ahlen Westf', zip: '2382' },
//     { city: 'Ahlerstedt', zip: '4166' },
//     { city: 'Ahnatal', zip: '5609' },
//     { city: 'Ahorn Baden', zip: '6296' },
//     { city: 'Ahrensbök', zip: '4525' },
//     { city: 'Ahrensbök-Gnissau', zip: '4556' },
//     { city: 'Ahrensburg', zip: '4102' },
//     { city: 'Aichach', zip: '8251' },
//     { city: 'Aichstetten Kr Ravensburg', zip: '7565' },
//     { city: 'Aidenbach', zip: '8543' },
//     { city: 'Aindling', zip: '8237' },
//     { city: 'Aitrang', zip: '8343' },
//     { city: 'Aken Elbe', zip: '34909' },
//     { city: 'Albbruck', zip: '7753' },
//     { city: 'Albersdorf Holst', zip: '4835' },
//     { city: 'Albersweiler', zip: '6345' },
//     { city: 'Albisheim Pfrimm', zip: '6355' },
//     { city: 'Albstadt-Ebingen', zip: '7431' },
//     { city: 'Albstadt-Laufen', zip: '7435' },
//     { city: 'Albstadt-Tailfingen', zip: '7432' },
//     { city: 'Aldenhoven b Jülich', zip: '2464' },
//     { city: 'Alerheim', zip: '9085' },
//     { city: 'Alfeld Leine', zip: '5181' },
//     { city: 'Alfeld Mittelfr', zip: '9157' },
//     { city: 'Alfhausen', zip: '5464' },
//     { city: 'Algermissen', zip: '5126' },
//     { city: 'Allensbach', zip: '7533' },
//     { city: 'Allersberg', zip: '9176' },
//     { city: 'Allershausen Oberbay', zip: '8166' },
//     { city: 'Allstedt', zip: '34652' },
//     { city: 'Alpen', zip: '2802' },
//     { city: 'Alpirsbach', zip: '7444' },
//     { city: 'Alsdorf Rheinl', zip: '2404' },
//     { city: 'Alsenz', zip: '6362' },
//     { city: 'Alsfeld', zip: '6631' },
//     { city: 'Alsleben Saale', zip: '34692' },
//     { city: 'Alt Duvenstedt', zip: '4338' },
//     { city: 'Alt Zachun', zip: '38859' },
//     { city: 'Alt Zeschdorf', zip: '33602' },
//     { city: 'Altdöbern', zip: '35434' },
//     { city: 'Altdorf b Nürnberg', zip: '9187' },
//     { city: 'Altdorf-Pfettrach', zip: '8704' },
//     { city: 'Altena Westf', zip: '2352' },
//     { city: 'Altenahr', zip: '2643' },
//     { city: 'Altenau Harz', zip: '5328' },
//     { city: 'Altenbeken', zip: '5255' },
//     { city: 'Altenberg Sachs', zip: '35056' },
//     { city: 'Altenberge Westf', zip: '2505' },
//     { city: 'Altenbrak', zip: '39456' },
//     { city: 'Altenburg Thür', zip: '3447' },
//     { city: 'Altendorf a Nabburg', zip: '9675' },
//     { city: 'Altengrabow', zip: '39225' },
//     { city: 'Altenhof Kr Barnim', zip: '33363' },
//     { city: 'Altenkirchen Pfalz', zip: '6386' },
//     { city: 'Altenkirchen Rügen', zip: '38391' },
//     { city: 'Altenkirchen Westerwald', zip: '2681' },
//     { city: 'Altenmedingen', zip: '5807' },
//     { city: 'Altenmünster Schwab', zip: '8295' },
//     { city: 'Altenstadt Hess', zip: '6047' },
//     { city: 'Altenstadt Iller', zip: '8337' },
//     { city: 'Altensteig Württ', zip: '7453' },
//     { city: 'Altenthann', zip: '9408' },
//     { city: 'Altentreptow', zip: '3961' },
//     { city: 'Altertheim', zip: '9307' },
//     { city: 'Altfraunhofen', zip: '8705' },
//     { city: 'Althegnenberg', zip: '8202' },
//     { city: 'Altkalen', zip: '39973' },
//     { city: 'Altkünkendorf', zip: '33337' },
//     { city: 'Altlandsberg', zip: '33438' },
//     { city: 'Altmannstein', zip: '9446' },
//     { city: 'Altmannstein-Pondorf', zip: '8468' },
//     { city: 'Altomünster', zip: '8254' },
//     { city: 'Altötting', zip: '8671' },
//     { city: 'Altreetz', zip: '33457' },
//     { city: 'Altshausen', zip: '7584' },
//     { city: 'Altusried', zip: '8373' },
//     { city: 'Altwarp', zip: '39773' },
//     { city: 'Alzenau i Ufr', zip: '6023' },
//     { city: 'Alzey', zip: '6731' },
//     { city: 'Amberg Oberpf', zip: '9621' },
//     { city: 'Amelinghausen', zip: '4132' },
//     { city: 'Amerang', zip: '8075' },
//     { city: 'Ammerbuch', zip: '7073' },
//     { city: 'Amorbach', zip: '9373' },
//     { city: 'Ampfing', zip: '8636' },
//     { city: 'Amrum', zip: '4682' },
//     { city: 'Andernach', zip: '2632' },
//     { city: 'Angelbachtal', zip: '7265' },
//     { city: 'Angelburg', zip: '6464' },
//     { city: 'Anger', zip: '8656' },
//     { city: 'Angermünde', zip: '3331' },
//     { city: 'Angern', zip: '39363' },
//     { city: 'Anhausen Kr Neuwied', zip: '2639' },
//     { city: 'Ankershagen', zip: '39921' },
//     { city: 'Anklam', zip: '3971' },
//     { city: 'Ankum', zip: '5462' },
//     { city: 'Annaberg-Buchholz', zip: '3733' },
//     { city: 'Annaburg', zip: '35385' },
//     { city: 'Annweiler am Trifels', zip: '6346' },
//     { city: 'Anröchte', zip: '2947' },
//     { city: 'Ansbach', zip: '981' },
//     { city: 'Ansbach-Katterbach', zip: '9802' },
//     { city: 'Antweiler', zip: '2693' },
//     { city: 'Apen', zip: '4489' },
//     { city: 'Apenburg', zip: '39001' },
//     { city: 'Apensen', zip: '4167' },
//     { city: 'Apolda', zip: '3644' },
//     { city: 'Appenweier', zip: '7805' },
//     { city: 'Arendsee Altmark', zip: '39384' },
//     { city: 'Arensdorf Kr Oder-Spree', zip: '33635' },
//     { city: 'Arenshausen', zip: '36081' },
//     { city: 'Argenbühl', zip: '7566' },
//     { city: 'Arnbruck', zip: '9945' },
//     { city: 'Arneburg', zip: '39321' },
//     { city: 'Arnsberg', zip: '2931' },
//     { city: 'Arnsberg-Oeventrop', zip: '2937' },
//     { city: 'Arnschwang', zip: '9977' },
//     { city: 'Arnsdorf b Dresden', zip: '35200' },
//     { city: 'Arnsgereuth', zip: '36736' },
//     { city: 'Arnstadt', zip: '3628' },
//     { city: 'Arnstein Unterfr', zip: '9363' },
//     { city: 'Arnstorf', zip: '8723' },
//     { city: 'Artern Unstrut', zip: '3466' },
//     { city: 'Arzberg b Torgau', zip: '34222' },
//     { city: 'Arzberg Oberfr', zip: '9233' },
//     { city: 'Asbach Westerw', zip: '2683' },
//     { city: 'Aschaffenburg', zip: '6021' },
//     { city: 'Aschau i Chiemgau', zip: '8052' },
//     { city: 'Aschau-Sachrang', zip: '8057' },
//     { city: 'Ascheberg Holstein', zip: '4526' },
//     { city: 'Ascheberg Westf', zip: '2593' },
//     { city: 'Ascheberg-Herbern', zip: '2599' },
//     { city: 'Ascheffel', zip: '4353' },
//     { city: 'Aschersleben Sachs-Anh', zip: '3473' },
//     { city: 'Asendorf Kr Diepholz', zip: '4253' },
//     { city: 'Attendorn', zip: '2722' },
//     { city: 'Attenkirchen', zip: '8168' },
//     { city: 'Attenweiler', zip: '7357' },
//     { city: 'Au b Bad Aibling', zip: '8064' },
//     { city: 'Au i d Hallertau', zip: '8752' },
//     { city: 'Aub Kr Würzburg', zip: '9335' },
//     { city: 'Aue Sachs', zip: '3771' },
//     { city: 'Auerbach i d Opf', zip: '9643' },
//     { city: 'Auerbach Vogtl', zip: '3744' },
//     { city: 'Auerswalde', zip: '37208' },
//     { city: 'Auetal-Bernsen', zip: '5753' },
//     { city: 'Auetal-Hattendorf', zip: '5752' },
//     { city: 'Aufhausen Oberpf', zip: '9454' },
//     { city: 'Augsburg', zip: '821' },
//     { city: 'Augustdorf', zip: '5237' },
//     { city: 'Augustusburg', zip: '37291' },
//     { city: 'Aukrug', zip: '4873' },
//     { city: 'Aulendorf', zip: '7525' },
//     { city: 'Auma', zip: '36626' },
//     { city: 'Aumühle b Hamburg', zip: '4104' },
//     { city: 'Aurach', zip: '9804' },
//     { city: 'Aurich', zip: '4941' },
//     { city: 'Aurich-Ogenbargen', zip: '4947' },
//     { city: 'Ausleben', zip: '39404' },
//     { city: 'Aying', zip: '8095' },
//     { city: 'Baar Schwaben', zip: '8276' },
//     { city: 'Babenhausen Hess', zip: '6073' },
//     { city: 'Babenhausen Schwab', zip: '8333' },
//     { city: 'Bacharach', zip: '6743' },
//     { city: 'Bachhagel', zip: '9077' },
//     { city: 'Backnang', zip: '7191' },
//     { city: 'Bad Abbach', zip: '9405' },
//     { city: 'Bad Aibling', zip: '8061' },
//     { city: 'Bad Arolsen', zip: '5691' },
//     { city: 'Bad Arolsen-Landau', zip: '5696' },
//     { city: 'Bad Bederkesa', zip: '4745' },
//     { city: 'Bad Bentheim', zip: '5922' },
//     { city: 'Bad Bentheim-Gildehaus', zip: '5924' },
//     { city: 'Bad Bergzabern', zip: '6343' },
//     { city: 'Bad Berka', zip: '36458' },
//     { city: 'Bad Berleburg', zip: '2751' },
//     { city: 'Bad Berleburg-Aue', zip: '2759' },
//     { city: 'Bad Berleburg-Girkhausen', zip: '2758' },
//     { city: 'Bad Berleburg-Schwarzenau', zip: '2755' },
//     { city: 'Bad Berneck i Fichtelgebirge', zip: '9273' },
//     { city: 'Bad Bertrich', zip: '2674' },
//     { city: 'Bad Bevensen', zip: '5821' },
//     { city: 'Bad Bibra', zip: '34465' },
//     { city: 'Bad Birnbach Rottal', zip: '8563' },
//     { city: 'Bad Blankenburg', zip: '36741' },
//     { city: 'Bad Bocklet', zip: '9708' },
//     { city: 'Bad Bodenteich', zip: '5824' },
//     { city: 'Bad Brambach', zip: '37438' },
//     { city: 'Bad Bramstedt', zip: '4192' },
//     { city: 'Bad Brückenau', zip: '9741' },
//     { city: 'Bad Buchau', zip: '7582' },
//     { city: 'Bad Camberg', zip: '6434' },
//     { city: 'Bad Colberg-Heldburg', zip: '36871' },
//     { city: 'Bad Doberan', zip: '38203' },
//     { city: 'Bad Driburg', zip: '5253' },
//     { city: 'Bad Driburg-Neuenheerse', zip: '5259' },
//     { city: 'Bad Düben', zip: '34243' },
//     { city: 'Bad Dürkheim', zip: '6322' },
//     { city: 'Bad Dürrenberg', zip: '3462' },
//     { city: 'Bad Dürrheim', zip: '7726' },
//     { city: 'Bad Elster', zip: '37437' },
//     { city: 'Bad Ems', zip: '2603' },
//     { city: 'Bad Emstal', zip: '5624' },
//     { city: 'Bad Endbach-Hartenrod', zip: '2776' },
//     { city: 'Bad Endorf', zip: '8053' },
//     { city: 'Bad Essen', zip: '5472' },
//     { city: 'Bad Feilnbach', zip: '8066' },
//     { city: 'Bad Frankenhausen Kyffhäuser', zip: '34671' },
//     { city: 'Bad Freienwalde', zip: '3344' },
//     { city: 'Bad Friedrichshall', zip: '7136' },
//     { city: 'Bad Füssing-Aigen', zip: '8537' },
//     { city: 'Bad Gandersheim', zip: '5382' },
//     { city: 'Bad Gottleuba', zip: '35023' },
//     { city: 'Bad Grönenbach', zip: '8334' },
//     { city: 'Bad Grund Harz', zip: '5327' },
//     { city: 'Bad Harzburg', zip: '5322' },
//     { city: 'Bad Heilbrunn', zip: '8046' },
//     { city: 'Bad Herrenalb', zip: '7083' },
//     { city: 'Bad Hersfeld', zip: '6621' },
//     { city: 'Bad Höhenstadt', zip: '8506' },
//     { city: 'Bad Homburg v d Höhe', zip: '6172' },
//     { city: 'Bad Honnef', zip: '2224' },
//     { city: 'Bad Iburg', zip: '5403' },
//     { city: 'Bad Karlshafen', zip: '5672' },
//     { city: 'Bad Kissingen', zip: '971' },
//     { city: 'Bad Kleinen', zip: '38423' },
//     { city: 'Bad Kohlgrub', zip: '8845' },
//     { city: 'Bad König', zip: '6063' },
//     { city: 'Bad Königshofen i Grabfeld', zip: '9761' },
//     { city: 'Bad Kösen', zip: '34463' },
//     { city: 'Bad Köstritz', zip: '36605' },
//     { city: 'Bad Kreuznach', zip: '671' },
//     { city: 'Bad Laasphe', zip: '2752' },
//     { city: 'Bad Laasphe-Feudingen', zip: '2754' },
//     { city: 'Bad Langensalza', zip: '3603' },
//     { city: 'Bad Lauchstädt', zip: '34635' },
//     { city: 'Bad Lausick', zip: '34345' },
//     { city: 'Bad Lauterberg im Harz', zip: '5524' },
//     { city: 'Bad Liebenstein', zip: '36961' },
//     { city: 'Bad Liebenwerda', zip: '35341' },
//     { city: 'Bad Liebenzell', zip: '7052' },
//     { city: 'Bad Lippspringe', zip: '5252' },
//     { city: 'Bad Marienberg Westerwald', zip: '2661' },
//     { city: 'Bad Mergentheim', zip: '7931' },
//     { city: 'Bad Münder am Deister', zip: '5042' },
//     { city: 'Bad Münster am Stein-Ebernburg', zip: '6708' },
//     { city: 'Bad Münstereifel', zip: '2253' },
//     { city: 'Bad Muskau', zip: '35771' },
//     { city: 'Bad Nauheim', zip: '6032' },
//     { city: 'Bad Nenndorf', zip: '5723' },
//     { city: 'Bad Neuenahr-Ahrweiler', zip: '2641' },
//     { city: 'Bad Neustadt a d Saale', zip: '9771' },
//     { city: 'Bad Oeynhausen', zip: '5731' },
//     { city: 'Bad Oldesloe', zip: '4531' },
//     { city: 'Bad Orb', zip: '6052' },
//     { city: 'Bad Peterstal-Griesbach', zip: '7806' },
//     { city: 'Bad Pyrmont', zip: '5281' },
//     { city: 'Bad Pyrmont-Kleinenberg', zip: '5285' },
//     { city: 'Bad Rappenau', zip: '7264' },
//     { city: 'Bad Rappenau-Bonfeld', zip: '7066' },
//     { city: 'Bad Rappenau-Obergimpern', zip: '7268' },
//     { city: 'Bad Rehburg', zip: '5037' },
//     { city: 'Bad Reichenhall', zip: '8651' },
//     { city: 'Bad Rippoldsau', zip: '7440' },
//     { city: 'Bad Rodach', zip: '9564' },
//     { city: 'Bad Rothenfelde', zip: '5424' },
//     { city: 'Bad Saarow-Pieskow', zip: '33631' },
//     { city: 'Bad Sachsa', zip: '5523' },
//     { city: 'Bad Säckingen', zip: '7761' },
//     { city: 'Bad Salzdetfurth', zip: '5063' },
//     { city: 'Bad Salzschlirf', zip: '6648' },
//     { city: 'Bad Salzuflen', zip: '5222' },
//     { city: 'Bad Salzungen', zip: '3695' },
//     { city: 'Bad Schandau', zip: '35022' },
//     { city: 'Bad Schmiedeberg', zip: '34925' },
//     { city: 'Bad Schönborn', zip: '7253' },
//     { city: 'Bad Schussenried', zip: '7583' },
//     { city: 'Bad Schwalbach', zip: '6124' },
//     { city: 'Bad Segeberg', zip: '4551' },
//     { city: 'Bad Sobernheim', zip: '6751' },
//     { city: 'Bad Soden am Taunus', zip: '6196' },
//     { city: 'Bad Soden-Salmünster', zip: '6056' },
//     { city: 'Bad Sooden-Allendorf', zip: '5652' },
//     { city: 'Bad Steben', zip: '9288' },
//     { city: 'Bad Sulza', zip: '36461' },
//     { city: 'Bad Sülze', zip: '38229' },
//     { city: 'Bad Teinach-Zavelstein', zip: '7053' },
//     { city: 'Bad Tennstedt', zip: '36041' },
//     { city: 'Bad Tölz', zip: '8041' },
//     { city: 'Bad Urach', zip: '7125' },
//     { city: 'Bad Vilbel', zip: '6101' },
//     { city: 'Bad Waldsee', zip: '7524' },
//     { city: 'Bad Wildbad', zip: '7081' },
//     { city: 'Bad Wildungen', zip: '5621' },
//     { city: 'Bad Wilsnack', zip: '38791' },
//     { city: 'Bad Wimpfen', zip: '7063' },
//     { city: 'Bad Windsheim', zip: '9841' },
//     { city: 'Bad Wörishofen', zip: '8247' },
//     { city: 'Bad Wurzach', zip: '7564' },
//     { city: 'Bad Wurzach-Hauerz', zip: '7568' },
//     { city: 'Bad Zwesten', zip: '5626' },
//     { city: 'Bad Zwischenahn', zip: '4403' },
//     { city: 'Badbergen', zip: '5433' },
//     { city: 'Baddeckenstedt', zip: '5345' },
//     { city: 'Badel', zip: '39009' },
//     { city: 'Baden-Baden', zip: '7221' },
//     { city: 'Badenweiler', zip: '7632' },
//     { city: 'Badersleben', zip: '39422' },
//     { city: 'Baesweiler', zip: '2401' },
//     { city: 'Bagenz', zip: '35697' },
//     { city: 'Bahrdorf-Mackendorf', zip: '5358' },
//     { city: 'Bahro', zip: '33656' },
//     { city: 'Baiersbronn', zip: '7442' },
//     { city: 'Baiersbronn-Obertal', zip: '7449' },
//     { city: 'Baiersbronn-Schwarzenberg', zip: '7447' },
//     { city: 'Baiersdorf Mittelfr', zip: '9133' },
//     { city: 'Baisweil', zip: '8340' },
//     { city: 'Bakum Kr Vechta', zip: '4446' },
//     { city: 'Bakum-Lüsche', zip: '5438' },
//     { city: 'Balderschwang', zip: '8328' },
//     { city: 'Balingen', zip: '7433' },
//     { city: 'Balje', zip: '4753' },
//     { city: 'Ballenstedt', zip: '39483' },
//     { city: 'Baltrum', zip: '4939' },
//     { city: 'Balve', zip: '2375' },
//     { city: 'Bamberg', zip: '951' },
//     { city: 'Barby Elbe', zip: '39298' },
//     { city: 'Barderup', zip: '4630' },
//     { city: 'Barendorf', zip: '4137' },
//     { city: 'Bärenklau NL', zip: '35691' },
//     { city: 'Bärenstein Kr Annaberg', zip: '37347' },
//     { city: 'Bargteheide', zip: '4532' },
//     { city: 'Barleben', zip: '39203' },
//     { city: 'Barlt', zip: '4857' },
//     { city: 'Barmstedt', zip: '4123' },
//     { city: 'Bärnau', zip: '9635' },
//     { city: 'Barnstorf Kr Diepholz', zip: '5442' },
//     { city: 'Barntrup', zip: '5263' },
//     { city: 'Barsinghausen', zip: '5105' },
//     { city: 'Barssel', zip: '4499' },
//     { city: 'Barßel-Harkebrügge', zip: '4497' },
//     { city: 'Bartensleben', zip: '39050' },
//     { city: 'Barth', zip: '38231' },
//     { city: 'Barum b Bad Bevensen', zip: '5806' },
//     { city: 'Baruth Mark', zip: '33704' },
//     { city: 'Barver', zip: '5448' },
//     { city: 'Basdahl', zip: '4766' },
//     { city: 'Basslitz', zip: '35249' },
//     { city: 'Bassum', zip: '4241' },
//     { city: 'Bassum-Neubruchhausen', zip: '4248' },
//     { city: 'Bassum-Nordwohlde', zip: '4249' },
//     { city: 'Basthorst', zip: '4159' },
//     { city: 'Battenberg Eder', zip: '6452' },
//     { city: 'Baumgarten Meckl', zip: '38462' },
//     { city: 'Baumholder', zip: '6783' },
//     { city: 'Baunach', zip: '9544' },
//     { city: 'Bautzen', zip: '3591' },
//     { city: 'Bawinkel', zip: '5963' },
//     { city: 'Bayerbach b Ergoldsbach', zip: '8774' },
//     { city: 'Bayerisch Eisenstein', zip: '9925' },
//     { city: 'Bayreuth', zip: '921' },
//     { city: 'Bayrischzell', zip: '8023' },
//     { city: 'Bebertal', zip: '39062' },
//     { city: 'Bebra', zip: '6622' },
//     { city: 'Bechenheim', zip: '6736' },
//     { city: 'Becherbach bei Kirn', zip: '6757' },
//     { city: 'Bechhofen a d Heide', zip: '9822' },
//     { city: 'Beckingen', zip: '6835' },
//     { city: 'Beckingen-Reimsbach', zip: '6832' },
//     { city: 'Beckum', zip: '2521' },
//     { city: 'Beckum-Neubeckum', zip: '2525' },
//     { city: 'Bedburg Erft', zip: '2272' },
//     { city: 'Beedenbostel', zip: '5145' },
//     { city: 'Beelen', zip: '2586' },
//     { city: 'Beelitz Mark', zip: '33204' },
//     { city: 'Beenz b Prenzlau', zip: '39856' },
//     { city: 'Beerfelde', zip: '33637' },
//     { city: 'Beerfelden', zip: '6068' },
//     { city: 'Beeskow', zip: '3366' },
//     { city: 'Beesten', zip: '5905' },
//     { city: 'Beetzendorf', zip: '39000' },
//     { city: 'Behrenhoff', zip: '38356' },
//     { city: 'Beilngries', zip: '8461' },
//     { city: 'Beilstein Württ', zip: '7062' },
//     { city: 'Beimerstetten', zip: '7348' },
//     { city: 'Belgern Sachs', zip: '34224' },
//     { city: 'Bellingen b Stendal', zip: '39365' },
//     { city: 'Belm', zip: '5406' },
//     { city: 'Belzig', zip: '33841' },
//     { city: 'Bendingbostel', zip: '4237' },
//     { city: 'Bendorf Rhein', zip: '2622' },
//     { city: 'Benediktbeuern', zip: '8857' },
//     { city: 'Benneckenstein Harz', zip: '39457' },
//     { city: 'Bennin', zip: '38843' },
//     { city: 'Bensberg', zip: '2204' },
//     { city: 'Benshausen', zip: '36843' },
//     { city: 'Bensheim', zip: '6251' },
//     { city: 'Benz Usedom', zip: '38379' },
//     { city: 'Beratzhausen', zip: '9493' },
//     { city: 'Berau', zip: '7747' },
//     { city: 'Berching', zip: '8462' },
//     { city: 'Berching-Holnstein', zip: '8460' },
//     { city: 'Berchtesgaden', zip: '8652' },
//     { city: 'Berg b Neumarkt i d Opf', zip: '9189' },
//     { city: 'Berg Oberfr', zip: '9293' },
//     { city: 'Berga Elster', zip: '36623' },
//     { city: 'Berge b Perleberg', zip: '38785' },
//     { city: 'Berge b Quakenbrück', zip: '5435' },
//     { city: 'Bergen auf Rügen', zip: '3838' },
//     { city: 'Bergen Dumme', zip: '5845' },
//     { city: 'Bergen Kr Celle', zip: '5051' },
//     { city: 'Bergen Vogtl', zip: '37463' },
//     { city: 'Bergenhusen', zip: '4885' },
//     { city: 'Bergen-Sülze', zip: '5054' },
//     { city: 'Bergheim Erft', zip: '2271' },
//     { city: 'Bergholz-Rehbrücke', zip: '33200' },
//     { city: 'Bergisch Gladbach', zip: '2202' },
//     { city: 'Bergkirchen Westf', zip: '5734' },
//     { city: 'Berkenbrück Kr Oder-Spree', zip: '33634' },
//     { city: 'Berkenthin', zip: '4544' },
//     { city: 'Berlin', zip: '30' },
//     { city: 'Berlstedt', zip: '36452' },
//     { city: 'Bernau Baden', zip: '7675' },
//     { city: 'Bernau Brandenb', zip: '3338' },
//     { city: 'Bernbeuren', zip: '8860' },
//     { city: 'Bernburg Saale', zip: '3471' },
//     { city: 'Berne', zip: '4406' },
//     { city: 'Bernitt', zip: '38464' },
//     { city: 'Bernkastel-Kues', zip: '6531' },
//     { city: 'Bernried Niederbay', zip: '9905' },
//     { city: 'Bernsdorf OL', zip: '35723' },
//     { city: 'Bernstadt a d Eigen', zip: '35874' },
//     { city: 'Bersenbrück', zip: '5439' },
//     { city: 'Beselich', zip: '6484' },
//     { city: 'Besigheim', zip: '7143' },
//     { city: 'Bessenbach', zip: '6095' },
//     { city: 'Bestensee', zip: '33763' },
//     { city: 'Bestwig', zip: '2904' },
//     { city: 'Bestwig-Ramsbeck', zip: '2905' },
//     { city: 'Bettenhausen Thür', zip: '36943' },
//     { city: 'Betzdorf', zip: '2741' },
//     { city: 'Betzendorf Kr Lünebeburg', zip: '4138' },
//     { city: 'Betzenstein', zip: '9244' },
//     { city: 'Beuren Hochwald', zip: '6586' },
//     { city: 'Beuron', zip: '7466' },
//     { city: 'Beverstedt', zip: '4747' },
//     { city: 'Beverungen', zip: '5273' },
//     { city: 'Bexbach', zip: '6826' },
//     { city: 'Biberach an der Riß', zip: '7351' },
//     { city: 'Bibertal', zip: '8226' },
//     { city: 'Biblis', zip: '6245' },
//     { city: 'Bickendorf', zip: '6569' },
//     { city: 'Bidingen', zip: '8348' },
//     { city: 'Biebergemünd', zip: '6050' },
//     { city: 'Biebertal', zip: '6409' },
//     { city: 'Biedenkopf', zip: '6461' },
//     { city: 'Biederitz', zip: '39292' },
//     { city: 'Bielefeld', zip: '521' },
//     { city: 'Bielefeld-Jöllenbeck', zip: '5206' },
//     { city: 'Bielefeld-Sennestadt', zip: '5205' },
//     { city: 'Bienenbüttel', zip: '5823' },
//     { city: 'Biesenthal Brandenb', zip: '3337' },
//     { city: 'Bietigheim-Bissingen', zip: '7142' },
//     { city: 'Bietikow', zip: '39858' },
//     { city: 'Billerbeck Westf', zip: '2543' },
//     { city: 'Billigheim Baden', zip: '6265' },
//     { city: 'Billigheim-Ingenheim', zip: '6349' },
//     { city: 'Binde', zip: '39036' },
//     { city: 'Bindlach', zip: '9208' },
//     { city: 'Bingen am Rhein', zip: '6721' },
//     { city: 'Binz Ostseebad', zip: '38393' },
//     { city: 'Birkenfeld b Würzburg', zip: '9398' },
//     { city: 'Birkenfeld Nahe', zip: '6782' },
//     { city: 'Birkenhainchen', zip: '35471' },
//     { city: 'Birkenwerder', zip: '3303' },
//     { city: 'Birresborn', zip: '6594' },
//     { city: 'Birstein', zip: '6054' },
//     { city: 'Birstein-Lichenroth', zip: '6668' },
//     { city: 'Bischoffen', zip: '6444' },
//     { city: 'Bischofsgrün', zip: '9276' },
//     { city: 'Bischofsheim a d Rhön', zip: '9772' },
//     { city: 'Bischofsheim b Rüsselsheim', zip: '6144' },
//     { city: 'Bischofsmais', zip: '9920' },
//     { city: 'Bischofswerda', zip: '3594' },
//     { city: 'Bisingen', zip: '7476' },
//     { city: 'Bismark Altmark', zip: '39089' },
//     { city: 'Bispingen', zip: '5194' },
//     { city: 'Bissendorf Kr Osnabrück', zip: '5402' },
//     { city: 'Bissingen Schwab', zip: '9084' },
//     { city: 'Bissingen-Unterringingen', zip: '9089' },
//     { city: 'Bitburg', zip: '6561' },
//     { city: 'Bitterfeld', zip: '3493' },
//     { city: 'Blankenburg Harz', zip: '3944' },
//     { city: 'Blankenförde', zip: '39829' },
//     { city: 'Blankenhain Thür', zip: '36459' },
//     { city: 'Blankenheim Ahr', zip: '2449' },
//     { city: 'Blankenheim b Sangerhausen', zip: '34659' },
//     { city: 'Blankenheim-Ahrhütte', zip: '2697' },
//     { city: 'Blankenrath', zip: '6545' },
//     { city: 'Blankensee b Neustrelitz', zip: '39826' },
//     { city: 'Blaubeuren', zip: '7344' },
//     { city: 'Blaufelden', zip: '7953' },
//     { city: 'Blaustein Württ', zip: '7304' },
//     { city: 'Bleckede', zip: '5852' },
//     { city: 'Bleckede-Barskamp', zip: '5854' },
//     { city: 'Bleckede-Brackede', zip: '5857' },
//     { city: 'Bleialf', zip: '6555' },
//     { city: 'Bleicherode', zip: '36338' },
//     { city: 'Blender', zip: '4233' },
//     { city: 'Blieskastel', zip: '6842' },
//     { city: 'Blieskastel-Altheim', zip: '6844' },
//     { city: 'Blomberg Lippe', zip: '5235' },
//     { city: 'Blomberg Ostfriesl', zip: '4977' },
//     { city: 'Blomberg-Grossenmarpe', zip: '5236' },
//     { city: 'Blönsdorf', zip: '33743' },
//     { city: 'Blowatz', zip: '38427' },
//     { city: 'Blumberg Baden', zip: '7702' },
//     { city: 'Blumberg Kr Barnim', zip: '33394' },
//     { city: 'Blumenhagen b Strasburg', zip: '39752' },
//     { city: 'Blumenthal b Pritzwalk', zip: '33984' },
//     { city: 'Blunk', zip: '4557' },
//     { city: 'Bobenheim-Roxheim', zip: '6239' },
//     { city: 'Bobenneukirchen', zip: '37434' },
//     { city: 'Bobingen', zip: '8234' },
//     { city: 'Bobitz', zip: '38424' },
//     { city: 'Böblingen', zip: '7031' },
//     { city: 'Bocholt', zip: '2871' },
//     { city: 'Bochum', zip: '234' },
//     { city: 'Bochum-Wattenscheid', zip: '2327' },
//     { city: 'Bockenem', zip: '5067' },
//     { city: 'Bodenburg', zip: '5060' },
//     { city: 'Bodenfelde', zip: '5572' },
//     { city: 'Bodenheim Rhein', zip: '6135' },
//     { city: 'Bodenkirchen', zip: '8745' },
//     { city: 'Bodenmais', zip: '9924' },
//     { city: 'Bodenwerder', zip: '5533' },
//     { city: 'Bodenwöhr', zip: '9434' },
//     { city: 'Bodman-Ludwigshafen', zip: '7773' },
//     { city: 'Bodnegg', zip: '7520' },
//     { city: 'Bogen Niederbay', zip: '9422' },
//     { city: 'Böhen', zip: '8338' },
//     { city: 'Böhmfeld', zip: '8406' },
//     { city: 'Bohmte', zip: '5471' },
//     { city: 'Bohmte-Hunteburg', zip: '5475' },
//     { city: 'Boitzenburg', zip: '39889' },
//     { city: 'Boizenburg Elbe', zip: '38847' },
//     { city: 'Bokhorst', zip: '4394' },
//     { city: 'Böklund', zip: '4623' },
//     { city: 'Boll Kr Göppingen', zip: '7164' },
//     { city: 'Bollendorf', zip: '6526' },
//     { city: 'Bönen', zip: '2383' },
//     { city: 'Bonese', zip: '39039' },
//     { city: 'Bonn', zip: '228' },
//     { city: 'Bonndorf im Schwarzwald', zip: '7703' },
//     { city: 'Boossen', zip: '33605' },
//     { city: 'Boostedt', zip: '4393' },
//     { city: 'Bopfingen', zip: '7362' },
//     { city: 'Boppard', zip: '6742' },
//     { city: 'Bordesholm', zip: '4322' },
//     { city: 'Borgentreich', zip: '5643' },
//     { city: 'Borgentreich-Borgholz', zip: '5645' },
//     { city: 'Börger', zip: '5953' },
//     { city: 'Borgholzhausen', zip: '5425' },
//     { city: 'Borken Hessen', zip: '5682' },
//     { city: 'Borken Westf', zip: '2861' },
//     { city: 'Borkenfriede', zip: '39777' },
//     { city: 'Borkheide', zip: '33845' },
//     { city: 'Borkum', zip: '4922' },
//     { city: 'Born a Darß', zip: '38234' },
//     { city: 'Borna Stadt', zip: '3433' },
//     { city: 'Bornheim Rheinl', zip: '2222' },
//     { city: 'Bornheim-Merten', zip: '2227' },
//     { city: 'Bornhöved', zip: '4323' },
//     { city: 'Börnicke Kr Havelland', zip: '33230' },
//     { city: 'Borsdorf', zip: '34291' },
//     { city: 'Borstel b Sulingen', zip: '4276' },
//     { city: 'Bosau', zip: '4527' },
//     { city: 'Bösel Oldenburg', zip: '4494' },
//     { city: 'Bötersen', zip: '4268' },
//     { city: 'Bottrop', zip: '2041' },
//     { city: 'Bottrop-Kirchhellen', zip: '2045' },
//     { city: 'Bous', zip: '6834' },
//     { city: 'Bovenden-Lenglern', zip: '5593' },
//     { city: 'Bovenden-Reyershausen', zip: '5594' },
//     { city: 'Boxberg Baden', zip: '7930' },
//     { city: 'Boxberg Sachs', zip: '35774' },
//     { city: 'Brachbach Sieg', zip: '2745' },
//     { city: 'Brackenheim', zip: '7135' },
//     { city: 'Brake Unterweser', zip: '4401' },
//     { city: 'Brakel Westf', zip: '5272' },
//     { city: 'Brakel-Gehrden', zip: '5648' },
//     { city: 'Bramsche Hase', zip: '5461' },
//     { city: 'Bramsche-Engter', zip: '5468' },
//     { city: 'Brandenburg an der Havel', zip: '3381' },
//     { city: 'Brand-Erbisdorf', zip: '37322' },
//     { city: 'Brandis b Wurzen', zip: '34292' },
//     { city: 'Brannenburg', zip: '8034' },
//     { city: 'Braubach', zip: '2627' },
//     { city: 'Braunfels', zip: '6442' },
//     { city: 'Braunlage', zip: '5520' },
//     { city: 'Braunlage-Hohegeiss', zip: '5583' },
//     { city: 'Bräunlingen', zip: '7707' },
//     { city: 'Braunsbach', zip: '7906' },
//     { city: 'Braunsbedra', zip: '34633' },
//     { city: 'Braunschweig', zip: '531' },
//     { city: 'Braunschweig-Wenden', zip: '5307' },
//     { city: 'Breckerfeld', zip: '2338' },
//     { city: 'Breddin', zip: '33972' },
//     { city: 'Bredenbek b Rendsburg', zip: '4334' },
//     { city: 'Bredenfelde b Strasburg', zip: '3964' },
//     { city: 'Bredereiche', zip: '33087' },
//     { city: 'Bredstedt', zip: '4671' },
//     { city: 'Breidenbach b Biedenkopf', zip: '6465' },
//     { city: 'Breisach am Rhein', zip: '7667' },
//     { city: 'Breitbrunn a Chiemsee', zip: '8054' },
//     { city: 'Breitenbach a Herzberg', zip: '6675' },
//     { city: 'Breitenberg Niederbay', zip: '8584' },
//     { city: 'Breitenbrunn Erzgeb', zip: '37756' },
//     { city: 'Breitenbrunn Oberpf', zip: '9495' },
//     { city: 'Breitenbrunn Schwab', zip: '8263' },
//     { city: 'Breitscheid Hess', zip: '2777' },
//     { city: 'Bremen', zip: '421' },
//     { city: 'Bremerhaven', zip: '471' },
//     { city: 'Bremervörde', zip: '4761' },
//     { city: 'Bremervörde-Bevern', zip: '4767' },
//     { city: 'Bremervörde-Iselersheim', zip: '4769' },
//     { city: 'Brennberg', zip: '9484' },
//     { city: 'Brensbach', zip: '6161' },
//     { city: 'Bretten', zip: '7252' },
//     { city: 'Bretzfeld', zip: '7946' },
//     { city: 'Breuberg', zip: '6165' },
//     { city: 'Brielow', zip: '33837' },
//     { city: 'Brieselang', zip: '33232' },
//     { city: 'Briesen b Cottbus', zip: '35606' },
//     { city: 'Briesen Mark', zip: '33607' },
//     { city: 'Brieskow-Finkenheerd', zip: '33609' },
//     { city: 'Briesnig', zip: '35696' },
//     { city: 'Brilon', zip: '2961' },
//     { city: 'Brilon-Alme', zip: '2964' },
//     { city: 'Brilon-Messinghausen', zip: '2963' },
//     { city: 'Brockel', zip: '4266' },
//     { city: 'Broderstorf', zip: '38204' },
//     { city: 'Brohl-Lützing', zip: '2633' },
//     { city: 'Brokstedt', zip: '4324' },
//     { city: 'Brome', zip: '5833' },
//     { city: 'Bruchhausen-Vilsen', zip: '4252' },
//     { city: 'Bruchmühlbach-Miesau', zip: '6372' },
//     { city: 'Bruchmühlen Westf', zip: '5226' },
//     { city: 'Bruchsal', zip: '7251' },
//     { city: 'Bruchsal-Untergrombach', zip: '7257' },
//     { city: 'Brück Brandenb', zip: '33844' },
//     { city: 'Bruckberg Niederbay', zip: '8765' },
//     { city: 'Bruckmühl Mangfall', zip: '8062' },
//     { city: 'Brüel', zip: '38483' },
//     { city: 'Brühl Rheinl', zip: '2232' },
//     { city: 'Brunau', zip: '39030' },
//     { city: 'Brunsbüttel', zip: '4852' },
//     { city: 'Brüssow b Pasewalk', zip: '39742' },
//     { city: 'Buch b Illertissen', zip: '7343' },
//     { city: 'Buchbach Oberbay', zip: '8086' },
//     { city: 'Büchel b Cochem', zip: '2678' },
//     { city: 'Büchen', zip: '4155' },
//     { city: 'Buchen Odenwald', zip: '6281' },
//     { city: 'Buchenberg b Kempten', zip: '8378' },
//     { city: 'Büchenbeuren', zip: '6543' },
//     { city: 'Buchholz in der Nordheide', zip: '4181' },
//     { city: 'Buchholz-Trelde', zip: '4186' },
//     { city: 'Buchloe', zip: '8241' },
//     { city: 'Bückeburg', zip: '5722' },
//     { city: 'Buckow Märk Schweiz', zip: '33433' },
//     { city: 'Büden', zip: '39224' },
//     { city: 'Budenheim', zip: '6139' },
//     { city: 'Büdesheim Eifel', zip: '6558' },
//     { city: 'Büdingen Hess', zip: '6042' },
//     { city: 'Büdingen-Eckartshausen', zip: '6048' },
//     { city: 'Büdlich', zip: '6509' },
//     { city: 'Bühl Baden', zip: '7223' },
//     { city: 'Bühlerzell', zip: '7974' },
//     { city: 'Bühl-Sand', zip: '7226' },
//     { city: 'Bühnsdorf', zip: '4550' },
//     { city: 'Bülkau', zip: '4754' },
//     { city: 'Bullay', zip: '6542' },
//     { city: 'Bunde', zip: '4953' },
//     { city: 'Bünde', zip: '5223' },
//     { city: 'Bundenthal', zip: '6394' },
//     { city: 'Burbach Siegerl', zip: '2736' },
//     { city: 'Büren', zip: '2951' },
//     { city: 'Büren-Harth', zip: '2958' },
//     { city: 'Büren-Wewelsburg', zip: '2955' },
//     { city: 'Burg auf Fehmarn', zip: '4371' },
//     { city: 'Burg b Magdeburg', zip: '3921' },
//     { city: 'Burg Dithmarschen', zip: '4825' },
//     { city: 'Burg Spreewald', zip: '35603' },
//     { city: 'Burg Stargard', zip: '39603' },
//     { city: 'Burgau Schwab', zip: '8222' },
//     { city: 'Burgbernheim', zip: '9843' },
//     { city: 'Burgbrohl', zip: '2636' },
//     { city: 'Burgdorf b Salzgitter', zip: '5347' },
//     { city: 'Burgdorf Kr Hannover', zip: '5136' },
//     { city: 'Burgdorf-Ehlershausen', zip: '5085' },
//     { city: 'Burgebrach', zip: '9546' },
//     { city: 'Bürgel', zip: '36692' },
//     { city: 'Burghammer', zip: '35727' },
//     { city: 'Burghaslach', zip: '9552' },
//     { city: 'Burghaun', zip: '6653' },
//     { city: 'Burghausen Salzach', zip: '8677' },
//     { city: 'Burgheim', zip: '8432' },
//     { city: 'Burgkirchen a d Alz', zip: '8679' },
//     { city: 'Burgkunstadt', zip: '9572' },
//     { city: 'Burglengenfeld', zip: '9471' },
//     { city: 'Burgoberbach', zip: '9805' },
//     { city: 'Burgpreppach', zip: '9534' },
//     { city: 'Burgsinn', zip: '9356' },
//     { city: 'Burgstädt', zip: '3724' },
//     { city: 'Burgthann', zip: '9183' },
//     { city: 'Burgwald Eder', zip: '6457' },
//     { city: 'Burgwedel', zip: '5139' },
//     { city: 'Burgwedel-Fuhrberg', zip: '5135' },
//     { city: 'Burgwindheim', zip: '9551' },
//     { city: 'Burkardroth', zip: '9734' },
//     { city: 'Burkau', zip: '35953' },
//     { city: 'Burkhardswalde-Munzig', zip: '35245' },
//     { city: 'Burladingen', zip: '7475' },
//     { city: 'Burladingen-Melchingen', zip: '7126' },
//     { city: 'Burow b Altentreptow', zip: '3965' },
//     { city: 'Burscheid Rheinl', zip: '2174' },
//     { city: 'Burtenbach', zip: '8285' },
//     { city: 'Buschow', zip: '33876' },
//     { city: 'Buseck', zip: '6408' },
//     { city: 'Büsum', zip: '4834' },
//     { city: 'Butjadingen-Burhave', zip: '4733' },
//     { city: 'Butjadingen-Stollhamm', zip: '4735' },
//     { city: 'Butjadingen-Tossens', zip: '4736' },
//     { city: 'Buttelstedt', zip: '36451' },
//     { city: 'Buttenheim', zip: '9545' },
//     { city: 'Buttenwiesen', zip: '8274' },
//     { city: 'Bütthard', zip: '9336' },
//     { city: 'Buttstädt', zip: '36373' },
//     { city: 'Butzbach', zip: '6033' },
//     { city: 'Bützow', zip: '38461' },
//     { city: 'Butzow b Brandenburg', zip: '33836' },
//     { city: 'Buxtehude', zip: '4161' },
//     { city: 'Cadenberge', zip: '4777' },
//     { city: 'Cadolzburg', zip: '9103' },
//     { city: 'Calau', zip: '3541' },
//     { city: 'Calbe Saale', zip: '39291' },
//     { city: 'Calden-Westuffeln', zip: '5677' },
//     { city: 'Calvörde', zip: '39051' },
//     { city: 'Calw', zip: '7051' },
//     { city: 'Cambs', zip: '3866' },
//     { city: 'Camburg', zip: '36421' },
//     { city: 'Cappeln Oldenburg', zip: '4478' },
//     { city: 'Caputh', zip: '33209' },
//     { city: 'Carlow', zip: '38873' },
//     { city: 'Carlsberg Pfalz', zip: '6356' },
//     { city: 'Carpin', zip: '39821' },
//     { city: 'Casekow', zip: '33331' },
//     { city: 'Castrop-Rauxel', zip: '2305' },
//     { city: 'Cavertitz', zip: '34363' },
//     { city: 'Celle', zip: '5141' },
//     { city: 'Celle-Scheuen', zip: '5086' },
//     { city: 'Cham', zip: '9971' },
//     { city: 'Chemnitz Sachs', zip: '371' },
//     { city: 'Chieming', zip: '8664' },
//     { city: 'Chorin', zip: '33366' },
//     { city: 'Christiansholm', zip: '4339' },
//     { city: 'Claussnitz b Chemnitz', zip: '37202' },
//     { city: 'Clausthal-Zellerfeld', zip: '5323' },
//     { city: 'Clenze', zip: '5844' },
//     { city: 'Cloppenburg', zip: '4471' },
//     { city: 'Cobbelsdorf', zip: '34923' },
//     { city: 'Coburg', zip: '9561' },
//     { city: 'Cochem', zip: '2671' },
//     { city: 'Coesfeld', zip: '2541' },
//     { city: 'Coesfeld-Lette', zip: '2546' },
//     { city: 'Cölbe-Schönstadt', zip: '6427' },
//     { city: 'Colbitz', zip: '39207' },
//     { city: 'Colditz', zip: '34381' },
//     { city: 'Collenberg', zip: '9376' },
//     { city: 'Colmberg', zip: '9803' },
//     { city: 'Colnrade', zip: '4434' },
//     { city: 'Cölpin', zip: '3966' },
//     { city: 'Coppenbrügge', zip: '5156' },
//     { city: 'Coppenbrügge-Bisperode', zip: '5159' },
//     { city: 'Cornberg', zip: '5650' },
//     { city: 'Coswig Anhalt', zip: '34903' },
//     { city: 'Coswig b Dresden', zip: '3523' },
//     { city: 'Cottbus', zip: '355' },
//     { city: 'Crailsheim', zip: '7951' },
//     { city: 'Cranzahl', zip: '37342' },
//     { city: 'Creglingen', zip: '7933' },
//     { city: 'Cremlingen', zip: '5306' },
//     { city: 'Creussen', zip: '9270' },
//     { city: 'Creuzburg', zip: '36926' },
//     { city: 'Crimmitschau', zip: '3762' },
//     { city: 'Crinitz', zip: '35324' },
//     { city: 'Crivitz', zip: '3863' },
//     { city: 'Crossen an der Elster', zip: '36693' },
//     { city: 'Crottendorf Sachs', zip: '37344' },
//     { city: 'Cumlosen', zip: '38794' },
//     { city: 'Cunewalde', zip: '35877' },
//     { city: 'Cuxhaven', zip: '4721' },
//     { city: 'Cuxhaven-Altenbruch', zip: '4722' },
//     { city: 'Cuxhaven-Altenwalde', zip: '4723' },
//     { city: 'Cuxhaven-Lüdingworth', zip: '4724' },
//     { city: 'Daaden', zip: '2743' },
//     { city: 'Dabel', zip: '38485' },
//     { city: 'Daberkow', zip: '39991' },
//     { city: 'Dabringhausen', zip: '2193' },
//     { city: 'Dachau', zip: '8131' },
//     { city: 'Dachsbach', zip: '9163' },
//     { city: 'Dachsenhausen', zip: '6776' },
//     { city: 'Dagebüll', zip: '4667' },
//     { city: 'Dahlem b Kall', zip: '2447' },
//     { city: 'Dahlen Sachs', zip: '34361' },
//     { city: 'Dahlenburg', zip: '5851' },
//     { city: 'Dahme Brandenb', zip: '35451' },
//     { city: 'Dahme Kr Ostholstein', zip: '4364' },
//     { city: 'Dahn', zip: '6391' },
//     { city: 'Dähre', zip: '39031' },
//     { city: 'Dallmin', zip: '38783' },
//     { city: 'Dambeck b Röbel', zip: '39922' },
//     { city: 'Damme Dümmer', zip: '5491' },
//     { city: 'Damp', zip: '4352' },
//     { city: 'Dänischenhagen', zip: '4349' },
//     { city: 'Dannenberg Elbe', zip: '5861' },
//     { city: 'Dannenwalde Kr Prignitz', zip: '33975' },
//     { city: 'Dargun', zip: '39959' },
//     { city: 'Darmstadt', zip: '6151' },
//     { city: 'Dasing', zip: '8205' },
//     { city: 'Dassel', zip: '5564' },
//     { city: 'Dassel-Markoldendorf', zip: '5562' },
//     { city: 'Dassow', zip: '38826' },
//     { city: 'Datteln', zip: '2363' },
//     { city: 'Daun', zip: '6592' },
//     { city: 'Dautphetal-Friedensdorf', zip: '6466' },
//     { city: 'Dautphetal-Mornshausen', zip: '6468' },
//     { city: 'Deggendorf', zip: '991' },
//     { city: 'Deggenhausertal', zip: '7555' },
//     { city: 'Deggingen', zip: '7334' },
//     { city: 'Deidesheim', zip: '6326' },
//     { city: 'Deining Oberpf', zip: '9184' },
//     { city: 'Deisslingen', zip: '7420' },
//     { city: 'Delbrück Westf', zip: '5250' },
//     { city: 'Delitzsch', zip: '34202' },
//     { city: 'Dellfeld', zip: '6336' },
//     { city: 'Delligsen', zip: '5187' },
//     { city: 'Delmenhorst', zip: '4221' },
//     { city: 'Demen', zip: '38488' },
//     { city: 'Demmin', zip: '3998' },
//     { city: 'Denkendorf Oberbay', zip: '8466' },
//     { city: 'Dentlein a Forst', zip: '9855' },
//     { city: 'Denzlingen', zip: '7666' },
//     { city: 'Derenburg', zip: '39453' },
//     { city: 'Dergenthin', zip: '38793' },
//     { city: 'Dermbach Rhön', zip: '36964' },
//     { city: 'Dessau Anh', zip: '340' },
//     { city: 'Dessow', zip: '33974' },
//     { city: 'Detern', zip: '4957' },
//     { city: 'Detmold', zip: '5231' },
//     { city: 'Dettelbach', zip: '9324' },
//     { city: 'Dettmannsdorf-Kölzow', zip: '38228' },
//     { city: 'Dettum', zip: '5333' },
//     { city: 'Deutschneudorf', zip: '37368' },
//     { city: 'Dieburg', zip: '6071' },
//     { city: 'Diedenshausen', zip: '2750' },
//     { city: 'Diedorf b Mühlhausen Thür', zip: '36024' },
//     { city: 'Diedrichshagen b Grevesmühlen', zip: '38822' },
//     { city: 'Diemelsee', zip: '5633' },
//     { city: 'Diemelstadt', zip: '5694' },
//     { city: 'Diepenau', zip: '5775' },
//     { city: 'Diepenau-Essern', zip: '5777' },
//     { city: 'Diepholz', zip: '5441' },
//     { city: 'Dierdorf', zip: '2689' },
//     { city: 'Dierhagen Ostseebad', zip: '38226' },
//     { city: 'Diesbar-Seusslitz', zip: '35267' },
//     { city: 'Diesdorf Altm', zip: '3902' },
//     { city: 'Dießen a Ammersee', zip: '8807' },
//     { city: 'Dietenheim', zip: '7347' },
//     { city: 'Dietenhofen', zip: '9824' },
//     { city: 'Dietersburg-Baumgarten', zip: '8565' },
//     { city: 'Dietfurt a d Altmühl', zip: '8464' },
//     { city: 'Dietmannsried', zip: '8374' },
//     { city: 'Dietramszell', zip: '8027' },
//     { city: 'Dietzhölztal', zip: '2774' },
//     { city: 'Diez', zip: '6432' },
//     { city: 'Dillenburg', zip: '2771' },
//     { city: 'Dillingen a d Donau', zip: '9071' },
//     { city: 'Dingelstädt Eichsfeld', zip: '36075' },
//     { city: 'Dingelstedt a Huy', zip: '39425' },
//     { city: 'Dingolfing', zip: '8731' },
//     { city: 'Dinkelsbühl', zip: '9851' },
//     { city: 'Dinkelscherben', zip: '8292' },
//     { city: 'Dinklage', zip: '4443' },
//     { city: 'Dinslaken', zip: '2064' },
//     { city: 'Dippmannsdorf', zip: '33846' },
//     { city: 'Dippoldiswalde', zip: '3504' },
//     { city: 'Dirlewang', zip: '8267' },
//     { city: 'Dirmstein', zip: '6238' },
//     { city: 'Dischingen', zip: '7327' },
//     { city: 'Dissen am Teutoburger Wald', zip: '5421' },
//     { city: 'Dittersdorf b Schleiz', zip: '36648' },
//     { city: 'Ditzingen', zip: '7156' },
//     { city: 'Döbeln', zip: '3431' },
//     { city: 'Doberlug-Kirchhain', zip: '35322' },
//     { city: 'Döbern NL', zip: '35600' },
//     { city: 'Dobitschen', zip: '34495' },
//     { city: 'Dobritz', zip: '39248' },
//     { city: 'Dockweiler', zip: '6595' },
//     { city: 'Dollart', zip: '4959' },
//     { city: 'Dolle', zip: '39364' },
//     { city: 'Dollenchen', zip: '35329' },
//     { city: 'Dollnstein', zip: '8422' },
//     { city: 'Dömitz', zip: '38758' },
//     { city: 'Dommitzsch', zip: '34223' },
//     { city: 'Domsühl', zip: '38728' },
//     { city: 'Donaueschingen', zip: '771' },
//     { city: 'Donaustauf', zip: '9403' },
//     { city: 'Donauwörth', zip: '906' },
//     { city: 'Donnersdorf', zip: '9528' },
//     { city: 'Dörentrup', zip: '5265' },
//     { city: 'Dorfen Stadt', zip: '8081' },
//     { city: 'Dormagen', zip: '2133' },
//     { city: 'Dornburg Hess', zip: '6436' },
//     { city: 'Dornburg Saale', zip: '36427' },
//     { city: 'Dorndorf Rhön', zip: '36963' },
//     { city: 'Dornhan', zip: '7455' },
//     { city: 'Dornstetten', zip: '7443' },
//     { city: 'Dornum Ostfriesl', zip: '4933' },
//     { city: 'Dörpen', zip: '4963' },
//     { city: 'Dörpstedt', zip: '4627' },
//     { city: 'Dorsten', zip: '2362' },
//     { city: 'Dorsten-Rhade', zip: '2866' },
//     { city: 'Dorsten-Wulfen', zip: '2369' },
//     { city: 'Dortmund', zip: '231' },
//     { city: 'Dorum', zip: '4742' },
//     { city: 'Dörverden', zip: '4234' },
//     { city: 'Dörverden-Westen', zip: '4239' },
//     { city: 'Dörzbach', zip: '7937' },
//     { city: 'Dötlingen', zip: '4433' },
//     { city: 'Dötlingen-Brettorf', zip: '4432' },
//     { city: 'Drachhausen', zip: '35609' },
//     { city: 'Drage Elbe', zip: '4177' },
//     { city: 'Drahnsdorf', zip: '35453' },
//     { city: 'Drangstedt', zip: '4704' },
//     { city: 'Dranse', zip: '33966' },
//     { city: 'Dransfeld', zip: '5502' },
//     { city: 'Drebber', zip: '5445' },
//     { city: 'Drebkau', zip: '35602' },
//     { city: 'Dreileben', zip: '39293' },
//     { city: 'Drense', zip: '39857' },
//     { city: 'Drensteinfurt', zip: '2508' },
//     { city: 'Drensteinfurt-Rinkerode', zip: '2538' },
//     { city: 'Drensteinfurt-Walstedde', zip: '2387' },
//     { city: 'Dresden', zip: '351' },
//     { city: 'Driedorf', zip: '2775' },
//     { city: 'Drochtersen', zip: '4143' },
//     { city: 'Drochtersen-Assel', zip: '4148' },
//     { city: 'Drognitz', zip: '36737' },
//     { city: 'Drolshagen-Bleche', zip: '2763' },
//     { city: 'Drönnewitz b Hagenow', zip: '38853' },
//     { city: 'Droyssig', zip: '34425' },
//     { city: 'Ducherow', zip: '39726' },
//     { city: 'Dudeldorf', zip: '6565' },
//     { city: 'Duderstadt', zip: '5527' },
//     { city: 'Duingen', zip: '5185' },
//     { city: 'Duisburg', zip: '203' },
//     { city: 'Duisburg-Homberg', zip: '2066' },
//     { city: 'Duisburg-Rheinhausen', zip: '2065' },
//     { city: 'Dülmen', zip: '2594' },
//     { city: 'Dülmen-Buldern', zip: '2590' },
//     { city: 'Dülmen-Rorup', zip: '2548' },
//     { city: 'Dümmer', zip: '3869' },
//     { city: 'Dunningen', zip: '7403' },
//     { city: 'Düren', zip: '2421' },
//     { city: 'Durmersheim', zip: '7245' },
//     { city: 'Dürrröhrsdorf-Dittersbach', zip: '35026' },
//     { city: 'Dürrwangen', zip: '9856' },
//     { city: 'Dürrweitzschen B Grimma', zip: '34386' },
//     { city: 'Düsseldorf', zip: '211' },
//     { city: 'Ebeleben', zip: '36020' },
//     { city: 'Eberbach Baden', zip: '6271' },
//     { city: 'Ebergötzen', zip: '5507' },
//     { city: 'Eberhardzell-Füramoos', zip: '7358' },
//     { city: 'Ebermannstadt', zip: '9194' },
//     { city: 'Ebern', zip: '9531' },
//     { city: 'Ebersbach an der Fils', zip: '7163' },
//     { city: 'Ebersbrunn Sachs', zip: '37607' },
//     { city: 'Ebersburg', zip: '6656' },
//     { city: 'Ebersdorf b Bremervörde', zip: '4765' },
//     { city: 'Eberswalde', zip: '3334' },
//     { city: 'Ebhausen', zip: '7458' },
//     { city: 'Ebrach Oberfr', zip: '9553' },
//     { city: 'Ebsdorfergrund', zip: '6424' },
//     { city: 'Ebstorf', zip: '5822' },
//     { city: 'Eching Niederbay', zip: '8709' },
//     { city: 'Echzell', zip: '6008' },
//     { city: 'Eckartsberga', zip: '34467' },
//     { city: 'Eckental', zip: '9126' },
//     { city: 'Eckernförde', zip: '4351' },
//     { city: 'Eddelak', zip: '4855' },
//     { city: 'Edemissen', zip: '5176' },
//     { city: 'Edemissen-Abbensen', zip: '5177' },
//     { city: 'Edenkoben', zip: '6323' },
//     { city: 'Edertal', zip: '5623' },
//     { city: 'Edewecht', zip: '4405' },
//     { city: 'Edewecht-Friedrichsfehn', zip: '4486' },
//     { city: 'Ediger-Eller', zip: '2675' },
//     { city: 'Efringen-Kirchen', zip: '7628' },
//     { city: 'Egeln', zip: '39268' },
//     { city: 'Egesheim', zip: '7429' },
//     { city: 'Egestorf Nordheide', zip: '4175' },
//     { city: 'Eggebek', zip: '4609' },
//     { city: 'Eggenfelden', zip: '8721' },
//     { city: 'Eggesin', zip: '39779' },
//     { city: 'Eggstätt', zip: '8056' },
//     { city: 'Eging a See', zip: '8544' },
//     { city: 'Egling a d Paar', zip: '8206' },
//     { city: 'Egling b Wolfratshausen', zip: '8176' },
//     { city: 'Egloffstein', zip: '9197' },
//     { city: 'Ehekirchen', zip: '8435' },
//     { city: 'Ehingen Donau', zip: '7391' },
//     { city: 'Ehingen Mittelfr', zip: '9835' },
//     { city: 'Ehingen-Dächingen', zip: '7395' },
//     { city: 'Ehningen', zip: '7034' },
//     { city: 'Ehra-Lessien', zip: '5377' },
//     { city: 'Ehrenberg Rhön', zip: '6683' },
//     { city: 'Ehrenburg', zip: '4275' },
//     { city: 'Ehrenfriedersdorf', zip: '37341' },
//     { city: 'Ehrenhain', zip: '34494' },
//     { city: 'Ehringshausen Dill', zip: '6443' },
//     { city: 'Ehringshausen-Katzenfurt', zip: '6449' },
//     { city: 'Eibelstadt', zip: '9303' },
//     { city: 'Eibenstock', zip: '37752' },
//     { city: 'Eich Rheinhess', zip: '6246' },
//     { city: 'Eichenbarleben', zip: '39206' },
//     { city: 'Eichenbühl-Riedern', zip: '9378' },
//     { city: 'Eichendorf', zip: '9952' },
//     { city: 'Eichendorf-Aufhausen', zip: '9956' },
//     { city: 'Eichenzell', zip: '6659' },
//     { city: 'Eichigt', zip: '37430' },
//     { city: 'Eichstätt Bay', zip: '8421' },
//     { city: 'Eichstetten', zip: '7663' },
//     { city: 'Eickendorf Kr Schönebeck', zip: '39297' },
//     { city: 'Eigeltingen', zip: '7774' },
//     { city: 'Eilenburg', zip: '3423' },
//     { city: 'Eilsleben', zip: '39409' },
//     { city: 'Eimke', zip: '5873' },
//     { city: 'Einbeck', zip: '5561' },
//     { city: 'Einbeck-Wenzen', zip: '5565' },
//     { city: 'Einsiedel b Chemnitz', zip: '37209' },
//     { city: 'Eisenach Thür', zip: '3691' },
//     { city: 'Eisenbach Hochschwarzwald', zip: '7657' },
//     { city: 'Eisenberg Pfalz', zip: '6351' },
//     { city: 'Eisenberg Thür', zip: '36691' },
//     { city: 'Eisenhüttenstadt', zip: '3364' },
//     { city: 'Eisfeld', zip: '3686' },
//     { city: 'Eiterfeld', zip: '6672' },
//     { city: 'Eitorf', zip: '2243' },
//     { city: 'Elbingerode Harz', zip: '39454' },
//     { city: 'Eldena', zip: '38755' },
//     { city: 'Ellenz-Poltersdorf', zip: '2673' },
//     { city: 'Ellerhoop', zip: '4120' },
//     { city: 'Ellrich', zip: '36332' },
//     { city: 'Ellwangen Jagst', zip: '7961' },
//     { city: 'Ellwangen-Röhlingen', zip: '7965' },
//     { city: 'Elmenhorst Vorpom', zip: '38327' },
//     { city: 'Elmshorn', zip: '4121' },
//     { city: 'Elmstein', zip: '6328' },
//     { city: 'Elsdorf Rheinl', zip: '2274' },
//     { city: 'Elsendorf Niederbay', zip: '8753' },
//     { city: 'Elsfleth', zip: '4404' },
//     { city: 'Elsfleth-Huntorf', zip: '4485' },
//     { city: 'Elster Elbe', zip: '35383' },
//     { city: 'Elsterberg b Plauen', zip: '36621' },
//     { city: 'Elsterwerda', zip: '3533' },
//     { city: 'Elstra', zip: '35793' },
//     { city: 'Eltmann', zip: '9522' },
//     { city: 'Eltville am Rhein', zip: '6123' },
//     { city: 'Elxleben b Arnstadt', zip: '36200' },
//     { city: 'Elzach', zip: '7682' },
//     { city: 'Elze Leine', zip: '5068' },
//     { city: 'Embsen Kr Lünebeburg', zip: '4134' },
//     { city: 'Emden Stadt', zip: '4921' },
//     { city: 'Emkendorf', zip: '4330' },
//     { city: 'Emlichheim', zip: '5943' },
//     { city: 'Emmelsbüll-Horsbüll', zip: '4665' },
//     { city: 'Emmelshausen', zip: '6747' },
//     { city: 'Emmendingen', zip: '7641' },
//     { city: 'Emmendorf', zip: '5875' },
//     { city: 'Emmerich', zip: '2822' },
//     { city: 'Emmerich-Elten', zip: '2828' },
//     { city: 'Emmerthal', zip: '5155' },
//     { city: 'Emmerthal-Börry', zip: '5157' },
//     { city: 'Emmingen-Liptingen', zip: '7465' },
//     { city: 'Empfingen', zip: '7485' },
//     { city: 'Emsbüren', zip: '5903' },
//     { city: 'Emsdetten', zip: '2572' },
//     { city: 'Emskirchen', zip: '9104' },
//     { city: 'Emstek', zip: '4473' },
//     { city: 'Emtinghausen', zip: '4295' },
//     { city: 'Emtmannsberg', zip: '9209' },
//     { city: 'Endingen Kaiserstuhl', zip: '7642' },
//     { city: 'Engden', zip: '5926' },
//     { city: 'Engelskirchen', zip: '2263' },
//     { city: 'Engen Hegau', zip: '7733' },
//     { city: 'Enger Westf', zip: '5224' },
//     { city: 'Enkenbach-Alsenborn', zip: '6303' },
//     { city: 'Ennepetal', zip: '2333' },
//     { city: 'Ennigerloh', zip: '2524' },
//     { city: 'Ennigerloh-Enniger', zip: '2528' },
//     { city: 'Ennigerloh-Westkirchen', zip: '2587' },
//     { city: 'Ensdorf Oberpf', zip: '9624' },
//     { city: 'Ense', zip: '2938' },
//     { city: 'Enzklösterle', zip: '7085' },
//     { city: 'Epfendorf', zip: '7404' },
//     { city: 'Eppelborn', zip: '6827' },
//     { city: 'Eppelsheim', zip: '6735' },
//     { city: 'Eppendorf Sachs', zip: '37293' },
//     { city: 'Eppingen', zip: '7262' },
//     { city: 'Eppstein', zip: '6198' },
//     { city: 'Erbach Donau', zip: '7305' },
//     { city: 'Erbach Odenw', zip: '6062' },
//     { city: 'Erbendorf', zip: '9682' },
//     { city: 'Erbenhausen Thür', zip: '36946' },
//     { city: 'Erding', zip: '8122' },
//     { city: 'Erfde', zip: '4333' },
//     { city: 'Erftstadt', zip: '2235' },
//     { city: 'Erfurt', zip: '361' },
//     { city: 'Ergersheim', zip: '9847' },
//     { city: 'Ergoldsbach', zip: '8771' },
//     { city: 'Ering', zip: '8573' },
//     { city: 'Erkelenz', zip: '2431' },
//     { city: 'Erkelenz-Lövenich', zip: '2435' },
//     { city: 'Erkheim', zip: '8336' },
//     { city: 'Erkner', zip: '3362' },
//     { city: 'Erlangen', zip: '9131' },
//     { city: 'Erlensee', zip: '6183' },
//     { city: 'Ermsleben', zip: '34743' },
//     { city: 'Ermstedt', zip: '36208' },
//     { city: 'Erndtebrück', zip: '2753' },
//     { city: 'Erolzheim', zip: '7354' },
//     { city: 'Ershausen', zip: '36082' },
//     { city: 'Erwitte', zip: '2943' },
//     { city: 'Erxleben b Haldensleben', zip: '39052' },
//     { city: 'Eschau', zip: '9374' },
//     { city: 'Eschede', zip: '5142' },
//     { city: 'Eschenbach i d Opf', zip: '9645' },
//     { city: 'Eschenburg', zip: '2770' },
//     { city: 'Eschershausen a d Lenne', zip: '5534' },
//     { city: 'Eschlkam', zip: '9948' },
//     { city: 'Eschwege', zip: '5651' },
//     { city: 'Eschweiler Rheinl', zip: '2403' },
//     { city: 'Esens', zip: '4971' },
//     { city: 'Eslarn', zip: '9653' },
//     { city: 'Eslohe Sauerland', zip: '2973' },
//     { city: 'Espelkamp', zip: '5772' },
//     { city: 'Espelkamp-Gestringen', zip: '5743' },
//     { city: 'Esselbach', zip: '9394' },
//     { city: 'Essen', zip: '201' },
//     { city: 'Essen Oldenburg', zip: '5434' },
//     { city: 'Essenbach', zip: '8703' },
//     { city: 'Essen-Kettwig', zip: '2054' },
//     { city: 'Essing', zip: '9447' },
//     { city: 'Essingen Württ', zip: '7365' },
//     { city: 'Estenfeld', zip: '9305' },
//     { city: 'Esterwegen', zip: '5955' },
//     { city: 'Estorf Kr Stade', zip: '4140' },
//     { city: 'Estorf Weser', zip: '5025' },
//     { city: 'Ettenheim', zip: '7822' },
//     { city: 'Ettenstatt', zip: '9148' },
//     { city: 'Ettlingen', zip: '7243' },
//     { city: 'Ettringen Wertach', zip: '8249' },
//     { city: 'Euerbach', zip: '9726' },
//     { city: 'Euerdorf', zip: '9704' },
//     { city: 'Eurasburg a d Loisach', zip: '8179' },
//     { city: 'Eurasburg b Augsburg', zip: '8208' },
//     { city: 'Euskirchen', zip: '2251' },
//     { city: 'Euskirchen-Flamersheim', zip: '2255' },
//     { city: 'Eussenheim-Hundsbach', zip: '9350' },
//     { city: 'Eutin', zip: '4521' },
//     { city: 'Everswinkel', zip: '2582' },
//     { city: 'Extertal', zip: '5262' },
//     { city: 'Extertal-Bremke', zip: '5754' },
//     { city: 'Eystrup', zip: '4254' },
//     { city: 'Fahrenbach Baden', zip: '6267' },
//     { city: 'Fahrland', zip: '33208' },
//     { city: 'Falkenberg Elster', zip: '35365' },
//     { city: 'Falkenberg Mark', zip: '33458' },
//     { city: 'Falkenberg Niederbay', zip: '8727' },
//     { city: 'Falkenberg Oberpf', zip: '9637' },
//     { city: 'Falkenhagen b Seelow', zip: '33603' },
//     { city: 'Falkenhagen Kr Prignitz', zip: '33986' },
//     { city: 'Falkenhain b Wurzen', zip: '34262' },
//     { city: 'Falkensee', zip: '3322' },
//     { city: 'Falkenstein Oberpf', zip: '9462' },
//     { city: 'Falkenstein Vogtl', zip: '3745' },
//     { city: 'Falkenthal', zip: '33088' },
//     { city: 'Fallingbostel', zip: '5162' },
//     { city: 'Fallingbostel-Dorfmark', zip: '5163' },
//     { city: 'Fassberg', zip: '5055' },
//     { city: 'Faßberg-Müden', zip: '5053' },
//     { city: 'Faulbach Unterfr', zip: '9392' },
//     { city: 'Faulenrost', zip: '39951' },
//     { city: 'Fedderwarden', zip: '4423' },
//     { city: 'Fehrbellin', zip: '33932' },
//     { city: 'Feldafing', zip: '8157' },
//     { city: 'Feldatal', zip: '6637' },
//     { city: 'Feldberg Meckl', zip: '39831' },
//     { city: 'Feldberg Schwarzwald', zip: '7676' },
//     { city: 'Feldberg-Altglashütten', zip: '7655' },
//     { city: 'Feldkirchen Niederbay', zip: '9420' },
//     { city: 'Feldkirchen-Westerham', zip: '8063' },
//     { city: 'Felgentreu', zip: '33734' },
//     { city: 'Fellheim', zip: '8335' },
//     { city: 'Felsberg Hess', zip: '5662' },
//     { city: 'Fensterbach', zip: '9438' },
//     { city: 'Ferdinandshof b Torgelow', zip: '39778' },
//     { city: 'Fermerswalde', zip: '35363' },
//     { city: 'Feucht', zip: '9128' },
//     { city: 'Feuchtwangen', zip: '9852' },
//     { city: 'Fichtelberg', zip: '9272' },
//     { city: 'Fichtenau', zip: '7962' },
//     { city: 'Fichtenwalde', zip: '33206' },
//     { city: 'Finnentrop-Rönkhausen', zip: '2395' },
//     { city: 'Finnentrop-Serkenrode', zip: '2724' },
//     { city: 'Finowfurt', zip: '3335' },
//     { city: 'Finsterwalde', zip: '3531' },
//     { city: 'Fintel', zip: '4265' },
//     { city: 'Fischach', zip: '8236' },
//     { city: 'Fischbach bei Dahn', zip: '6393' },
//     { city: 'Fischbachau', zip: '8028' },
//     { city: 'Fischbachtal', zip: '6166' },
//     { city: 'Fischen i Allgäu', zip: '8326' },
//     { city: 'Flachslanden', zip: '9829' },
//     { city: 'Fladungen', zip: '9778' },
//     { city: 'Flammersfeld', zip: '2685' },
//     { city: 'Flechtingen', zip: '39054' },
//     { city: 'Fleckeby', zip: '4354' },
//     { city: 'Flecken Zechlin', zip: '33923' },
//     { city: 'Fleetmark', zip: '39034' },
//     { city: 'Flensburg', zip: '461' },
//     { city: 'Flintbek', zip: '4347' },
//     { city: 'Flöha', zip: '3726' },
//     { city: 'Flonheim', zip: '6734' },
//     { city: 'Flörsbachtal', zip: '6057' },
//     { city: 'Flörsheim am Main', zip: '6145' },
//     { city: 'Floss', zip: '9603' },
//     { city: 'Fluorn-Winzeln', zip: '7402' },
//     { city: 'Forbach', zip: '7228' },
//     { city: 'Forbach-Hundsbach', zip: '7220' },
//     { city: 'Forchheim Oberfr', zip: '9191' },
//     { city: 'Forchtenberg', zip: '7947' },
//     { city: 'Förderstedt', zip: '39266' },
//     { city: 'Forst Lausitz', zip: '3562' },
//     { city: 'Forstern Oberbay', zip: '8124' },
//     { city: 'Frammersbach', zip: '9355' },
//     { city: 'Frankenau Hess', zip: '6455' },
//     { city: 'Frankenberg Eder', zip: '6451' },
//     { city: 'Frankenberg Sachs', zip: '37206' },
//     { city: 'Frankenhardt', zip: '7959' },
//     { city: 'Frankenstein Sachs', zip: '37321' },
//     { city: 'Frankenthal Pfalz', zip: '6233' },
//     { city: 'Frankfurt (Oder)', zip: '335' },
//     { city: 'Frankfurt am Main', zip: '69' },
//     { city: 'Frankfurt-Bergen-Enkheim', zip: '6109' },
//     { city: 'Frankleben', zip: '34637' },
//     { city: 'Frauenau', zip: '9926' },
//     { city: 'Frauenstein Sachs', zip: '37326' },
//     { city: 'Frechen', zip: '2234' },
//     { city: 'Freden Leine', zip: '5184' },
//     { city: 'Fredenbeck', zip: '4149' },
//     { city: 'Fredersdorf-Vogelsdorf', zip: '33439' },
//     { city: 'Freiamt', zip: '7645' },
//     { city: 'Freiberg Sachs', zip: '3731' },
//     { city: 'Freiburg Elbe', zip: '4779' },
//     { city: 'Freiburg im Breisgau', zip: '761' },
//     { city: 'Freiburg-Tiengen', zip: '7664' },
//     { city: 'Freiensteinau', zip: '6666' },
//     { city: 'Freienwill', zip: '4602' },
//     { city: 'Freigericht', zip: '6055' },
//     { city: 'Freihung', zip: '9646' },
//     { city: 'Freilassing', zip: '8654' },
//     { city: 'Freilingen Westerw', zip: '2666' },
//     { city: 'Freinsheim', zip: '6353' },
//     { city: 'Freisen', zip: '6855' },
//     { city: 'Freising', zip: '8161' },
//     { city: 'Frellstedt', zip: '5355' },
//     { city: 'Fremdingen', zip: '9086' },
//     { city: 'Frensdorf', zip: '9502' },
//     { city: 'Freren', zip: '5902' },
//     { city: 'Fretzdorf', zip: '33964' },
//     { city: 'Freudenberg Baden', zip: '9375' },
//     { city: 'Freudenberg Oberpf', zip: '9627' },
//     { city: 'Freudenberg Westf', zip: '2734' },
//     { city: 'Freudenberg-Boxtal', zip: '9377' },
//     { city: 'Freudenburg', zip: '6582' },
//     { city: 'Freudenstadt', zip: '7441' },
//     { city: 'Freyburg Unstrut', zip: '34464' },
//     { city: 'Freyenstein', zip: '33967' },
//     { city: 'Freystadt', zip: '9179' },
//     { city: 'Freystadt-Burggriesbach', zip: '8469' },
//     { city: 'Freyung', zip: '8551' },
//     { city: 'Fridolfing', zip: '8684' },
//     { city: 'Friedberg Hess', zip: '6031' },
//     { city: 'Friedeburg Ostfriesl', zip: '4465' },
//     { city: 'Friedeburg-Reepsholt', zip: '4468' },
//     { city: 'Friedenfels', zip: '9683' },
//     { city: 'Friedersdorf b Berlin', zip: '33767' },
//     { city: 'Friedewald Hess', zip: '6674' },
//     { city: 'Friedland b Beeskow', zip: '33676' },
//     { city: 'Friedland Kr Göttingen', zip: '5504' },
//     { city: 'Friedland Meckl', zip: '39601' },
//     { city: 'Friedrichroda', zip: '3623' },
//     { city: 'Friedrichsbrunn', zip: '39487' },
//     { city: 'Friedrichsdorf Taunus', zip: '6175' },
//     { city: 'Friedrichshafen', zip: '7541' },
//     { city: 'Friedrichskoog', zip: '4854' },
//     { city: 'Friedrichstadt', zip: '4881' },
//     { city: 'Friedrichswalde Brandenb', zip: '33367' },
//     { city: 'Friedrichswerth', zip: '36254' },
//     { city: 'Frielendorf', zip: '5684' },
//     { city: 'Friemar', zip: '36258' },
//     { city: 'Friesack', zip: '33235' },
//     { city: 'Friesenried', zip: '8347' },
//     { city: 'Friesoythe', zip: '4491' },
//     { city: 'Friesoythe-Gehlenberg', zip: '4493' },
//     { city: 'Friesoythe-Markhausen', zip: '4496' },
//     { city: 'Friesoythe-Thüle', zip: '4495' },
//     { city: 'Fritzlar', zip: '5622' },
//     { city: 'Frohburg', zip: '34348' },
//     { city: 'Fröndenberg-Langschede', zip: '2378' },
//     { city: 'Fronhausen', zip: '6426' },
//     { city: 'Fronreute', zip: '7505' },
//     { city: 'Frontenhausen', zip: '8732' },
//     { city: 'Frose', zip: '34741' },
//     { city: 'Fuchstal', zip: '8243' },
//     { city: 'Fulda', zip: '661' },
//     { city: 'Fuldatal', zip: '5607' },
//     { city: 'Fünfeichen', zip: '33654' },
//     { city: 'Fürfeld Kr Bad Kreuznach', zip: '6709' },
//     { city: 'Fürstenau b Bramsche', zip: '5901' },
//     { city: 'Fürstenberg Havel', zip: '33093' },
//     { city: 'Fürstenfeldbruck', zip: '8141' },
//     { city: 'Fürstenwalde Spree', zip: '3361' },
//     { city: 'Fürstenwerder', zip: '39859' },
//     { city: 'Fürstenzell', zip: '8502' },
//     { city: 'Furth i Wald', zip: '9973' },
//     { city: 'Fürth Odenw', zip: '6253' },
//     { city: 'Furtwangen im Schwarzwald', zip: '7723' },
//     { city: 'Füssen', zip: '8362' },
//     { city: 'Gablingen', zip: '8230' },
//     { city: 'Gadebusch', zip: '3886' },
//     { city: 'Gaggenau', zip: '7225' },
//     { city: 'Gaildorf', zip: '7971' },
//     { city: 'Gailingen', zip: '7734' },
//     { city: 'Gaimersheim', zip: '8458' },
//     { city: 'Gallin b Lübz', zip: '38732' },
//     { city: 'Gammelin', zip: '38850' },
//     { city: 'Gammelsdorf', zip: '8766' },
//     { city: 'Gammertingen', zip: '7574' },
//     { city: 'Ganderkesee', zip: '4222' },
//     { city: 'Ganderkesee-Bookholzberg', zip: '4223' },
//     { city: 'Gangelt', zip: '2454' },
//     { city: 'Gangkofen', zip: '8722' },
//     { city: 'Gangkofen-Kollbach', zip: '8735' },
//     { city: 'Ganzlin', zip: '38737' },
//     { city: 'Garbsen', zip: '5131' },
//     { city: 'Garching a d Alz', zip: '8634' },
//     { city: 'Gardelegen', zip: '3907' },
//     { city: 'Garding', zip: '4862' },
//     { city: 'Garlstedt', zip: '4795' },
//     { city: 'Garmisch-Partenkirchen', zip: '8821' },
//     { city: 'Garrel', zip: '4474' },
//     { city: 'Gars a Inn', zip: '8073' },
//     { city: 'Gartow Niedersachs', zip: '5846' },
//     { city: 'Gartz Oder', zip: '33332' },
//     { city: 'Garz Rügen', zip: '38304' },
//     { city: 'Gaschwitz', zip: '34299' },
//     { city: 'Gatersleben', zip: '39482' },
//     { city: 'Gau-Algesheim', zip: '6725' },
//     { city: 'Gaukönigshofen', zip: '9337' },
//     { city: 'Gau-Odernheim', zip: '6733' },
//     { city: 'Gebstedt', zip: '36463' },
//     { city: 'Gechingen', zip: '7056' },
//     { city: 'Gedern', zip: '6045' },
//     { city: 'Geeste', zip: '5907' },
//     { city: 'Geeste-Gross Hesepe', zip: '5937' },
//     { city: 'Geestgottberg', zip: '39397' },
//     { city: 'Geesthacht', zip: '4152' },
//     { city: 'Gefell b Schleiz', zip: '36649' },
//     { city: 'Gefrees', zip: '9254' },
//     { city: 'Gehlberg', zip: '36845' },
//     { city: 'Gehrden Han', zip: '5108' },
//     { city: 'Gehren Thür', zip: '36783' },
//     { city: 'Geilenkirchen', zip: '2451' },
//     { city: 'Geisa', zip: '36967' },
//     { city: 'Geiselhöring', zip: '9423' },
//     { city: 'Geiselwind', zip: '9556' },
//     { city: 'Geisenfeld', zip: '8452' },
//     { city: 'Geisenhausen', zip: '8743' },
//     { city: 'Geisingen Baden', zip: '7704' },
//     { city: 'Geisingen-Leipferdingen', zip: '7708' },
//     { city: 'Geislingen an der Steige', zip: '7331' },
//     { city: 'Geithain', zip: '34341' },
//     { city: 'Gelbensande', zip: '38201' },
//     { city: 'Geldern', zip: '2831' },
//     { city: 'Gelnhausen', zip: '6051' },
//     { city: 'Gelsenkirchen', zip: '209' },
//     { city: 'Geltendorf', zip: '8193' },
//     { city: 'Gelting Angeln', zip: '4643' },
//     { city: 'Gemmingen', zip: '7267' },
//     { city: 'Gemünden a Main', zip: '9351' },
//     { city: 'Gemünden Felda', zip: '6634' },
//     { city: 'Gemünden Hunsrück', zip: '6765' },
//     { city: 'Gemünden Wohra', zip: '6453' },
//     { city: 'Gengenbach', zip: '7803' },
//     { city: 'Gensingen', zip: '6727' },
//     { city: 'Genthin', zip: '3933' },
//     { city: 'Georgenberg', zip: '9658' },
//     { city: 'Georgensgmünd', zip: '9172' },
//     { city: 'Georgenthal Thür Wald', zip: '36253' },
//     { city: 'Georgsdorf', zip: '5946' },
//     { city: 'Georgsmarienhütte', zip: '5401' },
//     { city: 'Gera', zip: '365' },
//     { city: 'Gerabronn', zip: '7952' },
//     { city: 'Geratskirchen', zip: '8728' },
//     { city: 'Gerbstedt', zip: '34783' },
//     { city: 'Gerchsheim', zip: '9344' },
//     { city: 'Gerdau', zip: '5808' },
//     { city: 'Geringswalde', zip: '37382' },
//     { city: 'Germersheim', zip: '7274' },
//     { city: 'Gernrode Harz', zip: '39485' },
//     { city: 'Gernsbach', zip: '7224' },
//     { city: 'Gernsheim', zip: '6258' },
//     { city: 'Geroda Bay', zip: '9747' },
//     { city: 'Geroldshausen Unterfr', zip: '9366' },
//     { city: 'Gerolsbach', zip: '8445' },
//     { city: 'Gerolstein', zip: '6591' },
//     { city: 'Gerolzhofen', zip: '9382' },
//     { city: 'Gersdorf b Chemnitz', zip: '37203' },
//     { city: 'Gersdorf b Görlitz', zip: '35829' },
//     { city: 'Gersfeld Rhön', zip: '6654' },
//     { city: 'Gersheim', zip: '6843' },
//     { city: 'Gerstetten', zip: '7323' },
//     { city: 'Gerstungen', zip: '36922' },
//     { city: 'Gerswalde', zip: '39887' },
//     { city: 'Gerzen', zip: '8744' },
//     { city: 'Geschendorf', zip: '4553' },
//     { city: 'Gescher', zip: '2542' },
//     { city: 'Gesees', zip: '9201' },
//     { city: 'Geseke', zip: '2942' },
//     { city: 'Geslau', zip: '9867' },
//     { city: 'Gessertshausen', zip: '8238' },
//     { city: 'Gettorf', zip: '4346' },
//     { city: 'Gevelsberg', zip: '2332' },
//     { city: 'Geyer', zip: '37346' },
//     { city: 'Giebelstadt', zip: '9334' },
//     { city: 'Gieboldehausen', zip: '5528' },
//     { city: 'Gielde', zip: '5339' },
//     { city: 'Gielow', zip: '39957' },
//     { city: 'Giengen a d Brenz', zip: '7322' },
//     { city: 'Giersleben', zip: '34746' },
//     { city: 'Giessen', zip: '641' },
//     { city: 'Gifhorn', zip: '5371' },
//     { city: 'Gilching', zip: '8105' },
//     { city: 'Gillenfeld', zip: '6573' },
//     { city: 'Gilserberg', zip: '6696' },
//     { city: 'Gingst', zip: '38305' },
//     { city: 'Gladau', zip: '39342' },
//     { city: 'Gladbeck', zip: '2043' },
//     { city: 'Gladenbach', zip: '6462' },
//     { city: 'Glandorf', zip: '5426' },
//     { city: 'Glan-Münchweiler', zip: '6383' },
//     { city: 'Glashütte Sachs', zip: '35053' },
//     { city: 'Glasin', zip: '38429' },
//     { city: 'Glaubitz', zip: '35265' },
//     { city: 'Glauburg', zip: '6041' },
//     { city: 'Glauchau', zip: '3763' },
//     { city: 'Gleichen-Bremke', zip: '5592' },
//     { city: 'Gleichen-Rittmarshausen', zip: '5508' },
//     { city: 'Glienicke b Beeskow', zip: '33677' },
//     { city: 'Glienke', zip: '39606' },
//     { city: 'Globig-Bleddin', zip: '34927' },
//     { city: 'Glonn Kr Ebersberg', zip: '8093' },
//     { city: 'Glött', zip: '9075' },
//     { city: 'Glottertal', zip: '7684' },
//     { city: 'Glöwen', zip: '38787' },
//     { city: 'Glücksburg Ostsee', zip: '4631' },
//     { city: 'Glückstadt', zip: '4124' },
//     { city: 'Gnarrenburg', zip: '4763' },
//     { city: 'Gnarrenburg-Klenkendorf', zip: '4764' },
//     { city: 'Gnoien', zip: '39971' },
//     { city: 'Goch', zip: '2823' },
//     { city: 'Goch-Hassum', zip: '2827' },
//     { city: 'Göhren Rügen', zip: '38308' },
//     { city: 'Goldbach b Gotha', zip: '36255' },
//     { city: 'Goldbeck Altm', zip: '39388' },
//     { city: 'Goldberg Meckl', zip: '38736' },
//     { city: 'Goldenstedt', zip: '4444' },
//     { city: 'Gollin', zip: '39882' },
//     { city: 'Gollmitz b Calau', zip: '35435' },
//     { city: 'Golssen', zip: '35452' },
//     { city: 'Golzow b Brandenburg', zip: '33835' },
//     { city: 'Golzow b Seelow', zip: '33472' },
//     { city: 'Gomadingen', zip: '7385' },
//     { city: 'Gomaringen', zip: '7072' },
//     { city: 'Gommern', zip: '39200' },
//     { city: 'Gondershausen', zip: '6745' },
//     { city: 'Göppingen', zip: '7161' },
//     { city: 'Göppingen-Hohenstaufen', zip: '7165' },
//     { city: 'Görisried', zip: '8302' },
//     { city: 'Göritz b Prenzlau', zip: '39851' },
//     { city: 'Gorleben', zip: '5882' },
//     { city: 'Görlitz', zip: '3581' },
//     { city: 'Görmin', zip: '39992' },
//     { city: 'Görwihl', zip: '7754' },
//     { city: 'Görzig Kr Köthen', zip: '34975' },
//     { city: 'Görzke', zip: '33847' },
//     { city: 'Gosda b Klinge', zip: '35694' },
//     { city: 'Gosheim', zip: '7426' },
//     { city: 'Goslar', zip: '5321' },
//     { city: 'Goslar-Hahnenklee', zip: '5325' },
//     { city: 'Gossa', zip: '34955' },
//     { city: 'Gössenheim', zip: '9358' },
//     { city: 'Gößnitz Thür', zip: '34493' },
//     { city: 'Gößweinstein', zip: '9242' },
//     { city: 'Gotha Thür', zip: '3621' },
//     { city: 'Göttingen', zip: '551' },
//     { city: 'Goyatz', zip: '35478' },
//     { city: 'Graal-Müritz Seeheilbad', zip: '38206' },
//     { city: 'Graben-Neudorf', zip: '7255' },
//     { city: 'Grabenstätt Chiemsee', zip: '8661' },
//     { city: 'Grabow Meckl', zip: '38756' },
//     { city: 'Grabowhöfe', zip: '39926' },
//     { city: 'Grafenau Niederbay', zip: '8552' },
//     { city: 'Gräfenberg', zip: '9192' },
//     { city: 'Gräfendorf Bay', zip: '9357' },
//     { city: 'Gräfenhainichen', zip: '34953' },
//     { city: 'Grafenhausen Hochschwarzw', zip: '7748' },
//     { city: 'Gräfenroda', zip: '36205' },
//     { city: 'Gräfenthal', zip: '36703' },
//     { city: 'Grafenwöhr', zip: '9641' },
//     { city: 'Gräfinau-Angstedt', zip: '36785' },
//     { city: 'Grafing b München', zip: '8092' },
//     { city: 'Grafrath', zip: '8144' },
//     { city: 'Grainet', zip: '8585' },
//     { city: 'Grambow b Pasewalk', zip: '39749' },
//     { city: 'Grammendorf', zip: '38334' },
//     { city: 'Grammentin', zip: '39952' },
//     { city: 'Gramzow b Prenzlau', zip: '39861' },
//     { city: 'Gransee', zip: '3306' },
//     { city: 'Grasberg', zip: '4208' },
//     { city: 'Grasleben', zip: '5357' },
//     { city: 'Grassau Kr Traunstein', zip: '8641' },
//     { city: 'Grävenwiesbach', zip: '6086' },
//     { city: 'Grebbin', zip: '38720' },
//     { city: 'Grebenau', zip: '6646' },
//     { city: 'Grebenhain', zip: '6644' },
//     { city: 'Grebenstein', zip: '5674' },
//     { city: 'Grebin', zip: '4383' },
//     { city: 'Greding', zip: '8463' },
//     { city: 'Grefrath b Krefeld', zip: '2158' },
//     { city: 'Greifenhagen', zip: '34781' },
//     { city: 'Greifenstein-Beilstein', zip: '2779' },
//     { city: 'Greifenstein-Nenderoth', zip: '6477' },
//     { city: 'Greifenstein-Ulm', zip: '6478' },
//     { city: 'Greiffenberg', zip: '33334' },
//     { city: 'Greifswald', zip: '3834' },
//     { city: 'Greiz', zip: '3661' },
//     { city: 'Grenzach-Wyhlen', zip: '7624' },
//     { city: 'Gresenhorst', zip: '38224' },
//     { city: 'Grettstadt', zip: '9729' },
//     { city: 'Greussen', zip: '3636' },
//     { city: 'Greven Westf', zip: '2571' },
//     { city: 'Grevenbroich', zip: '2181' },
//     { city: 'Grevenbroich-Kapellen', zip: '2182' },
//     { city: 'Greven-Reckenfeld', zip: '2575' },
//     { city: 'Grevesmühlen', zip: '3881' },
//     { city: 'Grieben b Tangerhütte', zip: '39362' },
//     { city: 'Grieben Kr Oberhavel', zip: '33086' },
//     { city: 'Griesbach i Rottal', zip: '8532' },
//     { city: 'Griesheim Hess', zip: '6155' },
//     { city: 'Grimma', zip: '3437' },
//     { city: 'Grimmen', zip: '38326' },
//     { city: 'Gröbers', zip: '34605' },
//     { city: 'Gröbzig', zip: '34976' },
//     { city: 'Gröditz b Riesa', zip: '35263' },
//     { city: 'Groitzsch b Pegau', zip: '34296' },
//     { city: 'Grömitz', zip: '4562' },
//     { city: 'Grömitz-Cismar', zip: '4366' },
//     { city: 'Gronau Leine', zip: '5182' },
//     { city: 'Gronau Westfalen', zip: '2562' },
//     { city: 'Gronau-Epe', zip: '2565' },
//     { city: 'Gröningen Sachs-Ahn', zip: '39403' },
//     { city: 'Gross Ammensleben', zip: '39202' },
//     { city: 'Gross Behnitz', zip: '33239' },
//     { city: 'Gross Bisdorf', zip: '38332' },
//     { city: 'Groß Bützin', zip: '39976' },
//     { city: 'Groß Dölln', zip: '39883' },
//     { city: 'Groß Düngen', zip: '5064' },
//     { city: 'Gross Garz', zip: '39398' },
//     { city: 'Gross Glienicke', zip: '33201' },
//     { city: 'Gross Godems', zip: '38725' },
//     { city: 'Groß Grönau', zip: '4509' },
//     { city: 'Gross Ippener', zip: '4224' },
//     { city: 'Gross Kreutz', zip: '33207' },
//     { city: 'Gross Munzel', zip: '5035' },
//     { city: 'Gross Nemerow', zip: '39605' },
//     { city: 'Gross Neuendorf', zip: '33478' },
//     { city: 'Gross Oesingen', zip: '5838' },
//     { city: 'Gross Ossnig', zip: '35608' },
//     { city: 'Gross Pankow Kr Prignitz', zip: '33983' },
//     { city: 'Groß Plasten', zip: '39934' },
//     { city: 'Gross Roge', zip: '39978' },
//     { city: 'Gross Rosenburg', zip: '39294' },
//     { city: 'Groß Särchen', zip: '35726' },
//     { city: 'Gross Schönebeck Kr Barnim', zip: '33393' },
//     { city: 'Gross Warnow', zip: '38788' },
//     { city: 'Gross Wittensee', zip: '4356' },
//     { city: 'Gross Ziethen Kr Barnim', zip: '33364' },
//     { city: 'Grossaitingen', zip: '8203' },
//     { city: 'Grossalmerode', zip: '5604' },
//     { city: 'Grossbeeren', zip: '33701' },
//     { city: 'Grossberndten', zip: '36330' },
//     { city: 'Grossbodungen', zip: '36077' },
//     { city: 'Grossbothen', zip: '34384' },
//     { city: 'Grossbottwar', zip: '7148' },
//     { city: 'Grossbreitenbach', zip: '36781' },
//     { city: 'Grossbundenbach', zip: '6337' },
//     { city: 'Grossdubrau', zip: '35934' },
//     { city: 'Grossefehn', zip: '4943' },
//     { city: 'Grossefehn-Bagband', zip: '4946' },
//     { city: 'Grossefehn-Timmel', zip: '4945' },
//     { city: 'Grossenaspe', zip: '4327' },
//     { city: 'Grossenbrode', zip: '4367' },
//     { city: 'Grossenehrich', zip: '36370' },
//     { city: 'Grossengottern', zip: '36022' },
//     { city: 'Grossenhain Sachs', zip: '3522' },
//     { city: 'Grossenkneten', zip: '4435' },
//     { city: 'Grossenkneten-Huntlosen', zip: '4487' },
//     { city: 'Grossenlupnitz', zip: '36920' },
//     { city: 'Grossenwiehe', zip: '4604' },
//     { city: 'Grossenwörden', zip: '4775' },
//     { city: 'Grossfahner', zip: '36206' },
//     { city: 'Gross-Gerau', zip: '6152' },
//     { city: 'Grosshabersdorf', zip: '9105' },
//     { city: 'Grossharthau', zip: '35954' },
//     { city: 'Grosshartmannsdorf', zip: '37329' },
//     { city: 'Grossheide', zip: '4936' },
//     { city: 'Grosskorbetha', zip: '34446' },
//     { city: 'Grosskrotzenburg', zip: '6186' },
//     { city: 'Grossmehring', zip: '8407' },
//     { city: 'Grossostheim', zip: '6026' },
//     { city: 'Großpostwitz OL', zip: '35938' },
//     { city: 'Großräschen', zip: '35753' },
//     { city: 'Großröhrsdorf OL', zip: '35952' },
//     { city: 'Grossrosseln', zip: '6809' },
//     { city: 'Grossschirma', zip: '37328' },
//     { city: 'Großschönau Sachs', zip: '35841' },
//     { city: 'Grosssteinhausen', zip: '6339' },
//     { city: 'Gross-Umstadt', zip: '6078' },
//     { city: 'Grosswechsungen', zip: '36335' },
//     { city: 'Grosswenkheim', zip: '9766' },
//     { city: 'Grosswudicke', zip: '33873' },
//     { city: 'Grub a Forst', zip: '9560' },
//     { city: 'Grünberg Hess', zip: '6401' },
//     { city: 'Gründau', zip: '6058' },
//     { city: 'Grünenbach Allgäu', zip: '8383' },
//     { city: 'Grünhainichen', zip: '37294' },
//     { city: 'Grunow Kr Oder-Spree', zip: '33655' },
//     { city: 'Grünsfeld', zip: '9346' },
//     { city: 'Grünstadt', zip: '6359' },
//     { city: 'Gschwend b Gaildorf', zip: '7972' },
//     { city: 'Guben', zip: '3561' },
//     { city: 'Gudensberg', zip: '5603' },
//     { city: 'Gudow Lauenb', zip: '4547' },
//     { city: 'Gühlen-Glienicke', zip: '33929' },
//     { city: 'Gülze', zip: '38844' },
//     { city: 'Gummersbach', zip: '2261' },
//     { city: 'Gumtow', zip: '33977' },
//     { city: 'Gundelfingen a d Donau', zip: '9073' },
//     { city: 'Gundelsheim Württ', zip: '6269' },
//     { city: 'Güntersberge', zip: '39488' },
//     { city: 'Guntersblum', zip: '6249' },
//     { city: 'Günzburg', zip: '8221' },
//     { city: 'Gunzenhausen', zip: '9831' },
//     { city: 'Gunzenhausen-Cronheim', zip: '9836' },
//     { city: 'Gusborn', zip: '5865' },
//     { city: 'Güsen', zip: '39344' },
//     { city: 'Gustävel', zip: '38486' },
//     { city: 'Güsten Anh', zip: '39262' },
//     { city: 'Güstrow', zip: '3843' },
//     { city: 'Gutach-Bleibach', zip: '7685' },
//     { city: 'Gutenfürst', zip: '37433' },
//     { city: 'Gutengermendorf', zip: '33084' },
//     { city: 'Güterglück', zip: '39247' },
//     { city: 'Gütersloh', zip: '5241' },
//     { city: 'Gütersloh-Friedrichsdorf', zip: '5209' },
//     { city: 'Guttau', zip: '35932' },
//     { city: 'Gützkow b Greifswald', zip: '38353' },
//     { city: 'Guxhagen', zip: '5665' },
//     { city: 'Gyhum', zip: '4286' },
//     { city: 'Haag i OB', zip: '8072' },
//     { city: 'Haan Rheinl*1', zip: '2129' },
//     { city: 'Haarbach', zip: '8535' },
//     { city: 'Hachenburg', zip: '2662' },
//     { city: 'Hadamar', zip: '6433' },
//     { city: 'Hadmersleben', zip: '39408' },
//     { city: 'Hagen b Bremerhaven', zip: '4746' },
//     { city: 'Hagen Westf', zip: '2331' },
//     { city: 'Hagenbach Pfalz', zip: '7273' },
//     { city: 'Hagen-Dahl', zip: '2337' },
//     { city: 'Hagen-Hohenlimburg', zip: '2334' },
//     { city: 'Hagenow', zip: '3883' },
//     { city: 'Hagenwerder', zip: '35822' },
//     { city: 'Hagermarsch', zip: '4938' },
//     { city: 'Hahnbach', zip: '9664' },
//     { city: 'Hähnichen', zip: '35894' },
//     { city: 'Hahnstätten', zip: '6430' },
//     { city: 'Haidmühle', zip: '8556' },
//     { city: 'Haiger', zip: '2773' },
//     { city: 'Haigerloch', zip: '7474' },
//     { city: 'Haimhausen Oberbay', zip: '8133' },
//     { city: 'Haina Kloster', zip: '6456' },
//     { city: 'Hainichen Sachs', zip: '37207' },
//     { city: 'Haiterbach', zip: '7456' },
//     { city: 'Halberstadt', zip: '3941' },
//     { city: 'Halblech', zip: '8368' },
//     { city: 'Haldensleben', zip: '3904' },
//     { city: 'Halfing', zip: '8055' },
//     { city: 'Hallbergmoos', zip: '811' },
//     { city: 'Halle Saale', zip: '345' },
//     { city: 'Halle Westf', zip: '5201' },
//     { city: 'Hallenberg', zip: '2984' },
//     { city: 'Hallschlag', zip: '6557' },
//     { city: 'Haltern Westf', zip: '2364' },
//     { city: 'Haltern-Lippramsdorf', zip: '2360' },
//     { city: 'Halver', zip: '2353' },
//     { city: 'Hambergen', zip: '4793' },
//     { city: 'Hambühren', zip: '5084' },
//     { city: 'Hamburg', zip: '40' },
//     { city: 'Hamdorf b Rendsburg', zip: '4332' },
//     { city: 'Hameln', zip: '5151' },
//     { city: 'Hamm Sieg', zip: '2682' },
//     { city: 'Hamm Westf', zip: '2381' },
//     { city: 'Hammelburg', zip: '9732' },
//     { city: 'Hammersbach Hess', zip: '6185' },
//     { city: 'Hamminkeln', zip: '2852' },
//     { city: 'Hamminkeln-Brünen', zip: '2856' },
//     { city: 'Hamm-Rhynern', zip: '2385' },
//     { city: 'Hamm-Uentrop', zip: '2388' },
//     { city: 'Hanau', zip: '6181' },
//     { city: 'Handewitt', zip: '4608' },
//     { city: 'Hanerau-Hademarschen', zip: '4872' },
//     { city: 'Hangelsberg', zip: '33632' },
//     { city: 'Hankensbüttel', zip: '5832' },
//     { city: 'Hann. Münden', zip: '5541' },
//     { city: 'Hannover', zip: '511' },
//     { city: 'Hanstedt Nordheide', zip: '4184' },
//     { city: 'Harbke', zip: '39406' },
//     { city: 'Harburg Schwaben', zip: '9080' },
//     { city: 'Hardegsen', zip: '5505' },
//     { city: 'Hardheim Odenw', zip: '6283' },
//     { city: 'Haren Ems', zip: '5932' },
//     { city: 'Haren-Rütenbrock', zip: '5934' },
//     { city: 'Harpstedt', zip: '4244' },
//     { city: 'Harra', zip: '36642' },
//     { city: 'Harsefeld', zip: '4164' },
//     { city: 'Harsewinkel', zip: '5247' },
//     { city: 'Harsewinkel-Greffen', zip: '2588' },
//     { city: 'Harsum', zip: '5127' },
//     { city: 'Hartenholm', zip: '4195' },
//     { city: 'Hartenstein Mittelfr', zip: '9152' },
//     { city: 'Hartenstein Sachs', zip: '37605' },
//     { city: 'Hartha b Döbeln', zip: '34328' },
//     { city: 'Harzgerode', zip: '39484' },
//     { city: 'Hasbergen Kr Osnabrück', zip: '5405' },
//     { city: 'Hasborn', zip: '6574' },
//     { city: 'Haseldorf', zip: '4129' },
//     { city: 'Haselünne', zip: '5961' },
//     { city: 'Haslach im Kinzigtal', zip: '7832' },
//     { city: 'Hasselfelde', zip: '39459' },
//     { city: 'Hassfurt', zip: '9521' },
//     { city: 'Hassleben b Prenzlau', zip: '39884' },
//     { city: 'Hassloch', zip: '6324' },
//     { city: 'Hassmersheim', zip: '6266' },
//     { city: 'Hatten', zip: '4482' },
//     { city: 'Hatten-Sandkrug', zip: '4481' },
//     { city: 'Hattersheim a Main', zip: '6190' },
//     { city: 'Hattingen Ruhr', zip: '2324' },
//     { city: 'Hattorf am Harz', zip: '5584' },
//     { city: 'Hattstedt', zip: '4846' },
//     { city: 'Hatzfeld Eder', zip: '6467' },
//     { city: 'Hauenstein Pfalz', zip: '6392' },
//     { city: 'Haundorf', zip: '9837' },
//     { city: 'Haunetal', zip: '6673' },
//     { city: 'Hausach', zip: '7831' },
//     { city: 'Hausen Niederbay', zip: '9448' },
//     { city: 'Hausham', zip: '8026' },
//     { city: 'Hauzenberg', zip: '8586' },
//     { city: 'Havelberg', zip: '39387' },
//     { city: 'Havetoft', zip: '4603' },
//     { city: 'Havixbeck', zip: '2507' },
//     { city: 'Hayingen', zip: '7386' },
//     { city: 'Hayn Harz', zip: '34658' },
//     { city: 'Hechingen', zip: '7471' },
//     { city: 'Hechthausen', zip: '4774' },
//     { city: 'Heckelberg', zip: '33451' },
//     { city: 'Hedemünden', zip: '5545' },
//     { city: 'Hedersleben b Aschersleben', zip: '39481' },
//     { city: 'Heek', zip: '2568' },
//     { city: 'Heeslingen-Boitzen', zip: '4287' },
//     { city: 'Heide Holst', zip: '481' },
//     { city: 'Heideck', zip: '9177' },
//     { city: 'Heidelberg', zip: '6221' },
//     { city: 'Heiden Kr Borken', zip: '2867' },
//     { city: 'Heidenau Sachs', zip: '3529' },
//     { city: 'Heidenheim a d Brenz', zip: '7321' },
//     { city: 'Heidenheim Mittelfr', zip: '9833' },
//     { city: 'Heidmühlen', zip: '4320' },
//     { city: 'Heigenbrücken', zip: '6020' },
//     { city: 'Heilbronn Neckar', zip: '7131' },
//     { city: 'Heiligenberg Baden', zip: '7554' },
//     { city: 'Heiligengrabe', zip: '33962' },
//     { city: 'Heiligenhafen', zip: '4362' },
//     { city: 'Heiligenhaus', zip: '2056' },
//     { city: 'Heiligenstadt Heilbad', zip: '3606' },
//     { city: 'Heiligenstadt i Ofr', zip: '9198' },
//     { city: 'Heilsbronn', zip: '9872' },
//     { city: 'Heimbach Eifel', zip: '2446' },
//     { city: 'Heimbach Nahe', zip: '6789' },
//     { city: 'Heimbuchenthal', zip: '6092' },
//     { city: 'Heinsberg Rheinl', zip: '2452' },
//     { city: 'Heinsberg-Randerath', zip: '2453' },
//     { city: 'Helbra', zip: '34772' },
//     { city: 'Heldrungen', zip: '34673' },
//     { city: 'Helgoland', zip: '4725' },
//     { city: 'Hellenthal', zip: '2482' },
//     { city: 'Hellenthal-Rescheid', zip: '2448' },
//     { city: 'Helmbrechts', zip: '9252' },
//     { city: 'Helmstedt', zip: '5351' },
//     { city: 'Helmstedt-Barmke', zip: '5356' },
//     { city: 'Hemau', zip: '9491' },
//     { city: 'Hemer', zip: '2372' },
//     { city: 'Hemeringen', zip: '5158' },
//     { city: 'Hemmoor', zip: '4771' },
//     { city: 'Hengersberg Bay', zip: '9901' },
//     { city: 'Henneberg', zip: '36945' },
//     { city: 'Hennef Sieg', zip: '2242' },
//     { city: 'Hennef-Uckerath', zip: '2248' },
//     { city: 'Hennickendorf b Luckenwalde', zip: '33732' },
//     { city: 'Hennigsdorf', zip: '3302' },
//     { city: 'Henningen', zip: '39038' },
//     { city: 'Hennstedt b Itzehoe', zip: '4877' },
//     { city: 'Hennstedt Dithm', zip: '4836' },
//     { city: 'Henrichenburg', zip: '2367' },
//     { city: 'Henstedt-Ulzburg', zip: '4193' },
//     { city: 'Heppenheim Bergstraße', zip: '6252' },
//     { city: 'Herbertingen', zip: '7586' },
//     { city: 'Herbolzheim Breisgau', zip: '7643' },
//     { city: 'Herborn Hess', zip: '2772' },
//     { city: 'Herbrechtingen', zip: '7324' },
//     { city: 'Herbstein', zip: '6643' },
//     { city: 'Herbstein-Stockhausen', zip: '6647' },
//     { city: 'Herdecke', zip: '2330' },
//     { city: 'Herdorf', zip: '2744' },
//     { city: 'Herdwangen-Schönach', zip: '7557' },
//     { city: 'Herford', zip: '5221' },
//     { city: 'Hergatz', zip: '8385' },
//     { city: 'Hergensweiler', zip: '8388' },
//     { city: 'Heringen Helme', zip: '36333' },
//     { city: 'Heringen Werra', zip: '6624' },
//     { city: 'Heringsdorf Holst', zip: '4365' },
//     { city: 'Heringsdorf Seebad', zip: '38378' },
//     { city: 'Herleshausen', zip: '5654' },
//     { city: 'Hermannsburg', zip: '5052' },
//     { city: 'Hermeskeil', zip: '6503' },
//     { city: 'Hermsdorf Erzgeb', zip: '35057' },
//     { city: 'Hermsdorf Thür', zip: '36601' },
//     { city: 'Herne', zip: '2323' },
//     { city: 'Heroldsbach', zip: '9190' },
//     { city: 'Heroldstatt', zip: '7389' },
//     { city: 'Herrenberg', zip: '7032' },
//     { city: 'Herrieden', zip: '9825' },
//     { city: 'Herrischried', zip: '7764' },
//     { city: 'Herrnhut', zip: '35873' },
//     { city: 'Herrsching a Ammersee', zip: '8152' },
//     { city: 'Herrstein', zip: '6785' },
//     { city: 'Hersbruck', zip: '9151' },
//     { city: 'Herscheid Westf', zip: '2357' },
//     { city: 'Herten Westf', zip: '2366' },
//     { city: 'Herxheim bei Landau Pfalz', zip: '7276' },
//     { city: 'Herzberg am Harz', zip: '5521' },
//     { city: 'Herzberg Elster', zip: '3535' },
//     { city: 'Herzberg Mark', zip: '33926' },
//     { city: 'Herzberg-Sieber', zip: '5585' },
//     { city: 'Herzebrock-Clarholz', zip: '5245' },
//     { city: 'Herzfelde b Strausberg', zip: '33434' },
//     { city: 'Herzlake', zip: '5962' },
//     { city: 'Herzogenaurach', zip: '9132' },
//     { city: 'Herzogenrath', zip: '2406' },
//     { city: 'Herzogenrath-Kohlscheid', zip: '2407' },
//     { city: 'Herzsprung b Wittstock', zip: '33965' },
//     { city: 'Heßdorf Mittelfr', zip: '9135' },
//     { city: 'Hessen', zip: '39426' },
//     { city: 'Hesseneck', zip: '6276' },
//     { city: 'Hessisch Lichtenau', zip: '5602' },
//     { city: 'Hessisch Oldendorf', zip: '5152' },
//     { city: 'Hettstedt Sachs-Anh', zip: '3476' },
//     { city: 'Hetzdorf b Strasburg', zip: '39745' },
//     { city: 'Hetzerath Mosel', zip: '6508' },
//     { city: 'Heubach', zip: '7173' },
//     { city: 'Heubisch', zip: '36761' },
//     { city: 'Heuckewalde', zip: '34423' },
//     { city: 'Heudeber', zip: '39458' },
//     { city: 'Heusenstamm', zip: '6104' },
//     { city: 'Heusweiler', zip: '6806' },
//     { city: 'Heuthen', zip: '36084' },
//     { city: 'Heyda b Riesa', zip: '35266' },
//     { city: 'Hilchenbach', zip: '2733' },
//     { city: 'Hildburghausen', zip: '3685' },
//     { city: 'Hilden', zip: '2103' },
//     { city: 'Hilders', zip: '6681' },
//     { city: 'Hildesheim', zip: '5121' },
//     { city: 'Hilgermissen', zip: '4256' },
//     { city: 'Hilgertshausen-Tandern', zip: '8250' },
//     { city: 'Hille', zip: '5703' },
//     { city: 'Hillerse Kr Gifhorn', zip: '5373' },
//     { city: 'Hillesheim Eifel', zip: '6593' },
//     { city: 'Hilpoltstein', zip: '9174' },
//     { city: 'Hilter am Teutoburger Wald', zip: '5409' },
//     { city: 'Hilzingen', zip: '7739' },
//     { city: 'Himbergen', zip: '5828' },
//     { city: 'Himmelpfort', zip: '33089' },
//     { city: 'Himmelpforten', zip: '4144' },
//     { city: 'Hindelang', zip: '8324' },
//     { city: 'Hinte', zip: '4925' },
//     { city: 'Hinterhermsdorf', zip: '35974' },
//     { city: 'Hintersee', zip: '39776' },
//     { city: 'Hinterweidenthal', zip: '6396' },
//     { city: 'Hinterzarten', zip: '7652' },
//     { city: 'Hipstedt', zip: '4768' },
//     { city: 'Hirrlingen', zip: '7478' },
//     { city: 'Hirschaid', zip: '9543' },
//     { city: 'Hirschau Oberpf', zip: '9622' },
//     { city: 'Hirschberg Saale', zip: '36644' },
//     { city: 'Hirschfeld b Elsterwerda', zip: '35343' },
//     { city: 'Hirschfelde b Zittau', zip: '35843' },
//     { city: 'Hirschhorn Neckar', zip: '6272' },
//     { city: 'Hitzacker Elbe', zip: '5862' },
//     { city: 'Hitzacker-Wietzetze', zip: '5858' },
//     { city: 'Hochdorf Riß', zip: '7355' },
//     { city: 'Hochdorf-Assenheim', zip: '6231' },
//     { city: 'Höchheim', zip: '9764' },
//     { city: 'Hochheim am Main', zip: '6146' },
//     { city: 'Hochkirch', zip: '35939' },
//     { city: 'Hochspeyer', zip: '6305' },
//     { city: 'Höchst i Odw', zip: '6163' },
//     { city: 'Höchstadt a d Aisch', zip: '9193' },
//     { city: 'Höchstädt a d Donau', zip: '9074' },
//     { city: 'Hochstadt Pfalz', zip: '6347' },
//     { city: 'Höckendorf b Dippoldiswalde', zip: '35055' },
//     { city: 'Hockenheim', zip: '6205' },
//     { city: 'Hodenhagen', zip: '5164' },
//     { city: 'Hof Saale', zip: '9281' },
//     { city: 'Hofbieber', zip: '6657' },
//     { city: 'Hofbieber-Schwarzbach', zip: '6684' },
//     { city: 'Hofgeismar', zip: '5671' },
//     { city: 'Hofheim am Taunus', zip: '6192' },
//     { city: 'Hofheim i Ufr', zip: '9523' },
//     { city: 'Hofheim-Wallau', zip: '6122' },
//     { city: 'Hofkirchen Bay', zip: '8545' },
//     { city: 'Hohberg b Offenburg', zip: '7808' },
//     { city: 'Hohburg', zip: '34263' },
//     { city: 'Hohenahr', zip: '6446' },
//     { city: 'Hohenaspe', zip: '4893' },
//     { city: 'Hohenau Niederbay', zip: '8558' },
//     { city: 'Hohenberg-Krusemark', zip: '39394' },
//     { city: 'Hohenburg', zip: '9626' },
//     { city: 'Hohenfelde b Kiel', zip: '4385' },
//     { city: 'Hohenfels Oberpf', zip: '9472' },
//     { city: 'Hohenhameln', zip: '5128' },
//     { city: 'Hohenkirchen b Wismar', zip: '38428' },
//     { city: 'Höhenkirchen-Siegertsbrunn', zip: '8102' },
//     { city: 'Hohenlockstedt', zip: '4826' },
//     { city: 'Hohenmocker', zip: '39993' },
//     { city: 'Hohenmölsen', zip: '34441' },
//     { city: 'Hohennauen', zip: '33872' },
//     { city: 'Hohenpeissenberg', zip: '8805' },
//     { city: 'Hohenpriessnitz', zip: '34242' },
//     { city: 'Hohenroda Hess', zip: '6676' },
//     { city: 'Hohensaaten', zip: '33368' },
//     { city: 'Hohenseefeld', zip: '33744' },
//     { city: 'Hohenstein Württ', zip: '7387' },
//     { city: 'Hohenstein-Ernstthal', zip: '3723' },
//     { city: 'Hohenthann', zip: '8784' },
//     { city: 'Hohenwart Paar', zip: '8443' },
//     { city: 'Hohenwarth b Kötzing', zip: '9946' },
//     { city: 'Hohenwestedt', zip: '4871' },
//     { city: 'Hohenziatz', zip: '39226' },
//     { city: 'Hohenzieritz', zip: '39824' },
//     { city: 'Hohn b Rendsburg', zip: '4335' },
//     { city: 'Hohne b Celle', zip: '5083' },
//     { city: 'Hohnstein', zip: '35975' },
//     { city: 'Hohnstorf Elbe', zip: '4139' },
//     { city: 'Höhr-Grenzhausen', zip: '2624' },
//     { city: 'Holdorf Niedersachs', zip: '5494' },
//     { city: 'Holle b Hildesheim', zip: '5062' },
//     { city: 'Hollenstedt Nordheide', zip: '4165' },
//     { city: 'Hollfeld', zip: '9274' },
//     { city: 'Holm-Seppensen', zip: '4187' },
//     { city: 'Holsthum', zip: '6523' },
//     { city: 'Holthusen', zip: '3865' },
//     { city: 'Holtland', zip: '4950' },
//     { city: 'Holzappel', zip: '6439' },
//     { city: 'Holzdorf Elster', zip: '35389' },
//     { city: 'Holzendorf b Prenzlau', zip: '39853' },
//     { city: 'Holzengel', zip: '36379' },
//     { city: 'Holzgünz', zip: '8393' },
//     { city: 'Holzkirchen', zip: '8024' },
//     { city: 'Holzminden', zip: '5531' },
//     { city: 'Holzminden-Neuhaus', zip: '5536' },
//     { city: 'Holzwickede', zip: '2301' },
//     { city: 'Homberg Efze', zip: '5681' },
//     { city: 'Homberg Ohm', zip: '6633' },
//     { city: 'Homburg Saar', zip: '6841' },
//     { city: 'Homburg-Einöd', zip: '6848' },
//     { city: 'Hooge', zip: '4849' },
//     { city: 'Hoogstede', zip: '5944' },
//     { city: 'Hoppenrade b Güstrow', zip: '38451' },
//     { city: 'Hoppenrade Kr Prignitz', zip: '33982' },
//     { city: 'Hopsten', zip: '5458' },
//     { city: 'Hopsten-Schale', zip: '5457' },
//     { city: 'Horb am Neckar', zip: '7451' },
//     { city: 'Horb-Altheim', zip: '7486' },
//     { city: 'Horb-Dettingen', zip: '7482' },
//     { city: 'Horb-Mühringen', zip: '7483' },
//     { city: 'Horgau', zip: '8294' },
//     { city: 'Horgenzell', zip: '7504' },
//     { city: 'Horhausen Westerwald', zip: '2687' },
//     { city: 'Horka OL', zip: '35892' },
//     { city: 'Hornbach Pfalz', zip: '6338' },
//     { city: 'Horn-Bad Meinberg', zip: '5234' },
//     { city: 'Hornberg Schwarzwaldbahn', zip: '7833' },
//     { city: 'Hornburg Kr Wolfenbüttel', zip: '5334' },
//     { city: 'Horneburg Niederelbe', zip: '4163' },
//     { city: 'Hornow', zip: '35698' },
//     { city: 'Hörsingen', zip: '39055' },
//     { city: 'Horsmar', zip: '36023' },
//     { city: 'Horst b Grimmen', zip: '38333' },
//     { city: 'Horst Holstein', zip: '4126' },
//     { city: 'Horstedt Kr Rotenburg', zip: '4288' },
//     { city: 'Hörstel', zip: '5459' },
//     { city: 'Hörstel-Dreierwalde', zip: '5978' },
//     { city: 'Hörstel-Riesenbeck', zip: '5454' },
//     { city: 'Horstmar', zip: '2558' },
//     { city: 'Hosena', zip: '35756' },
//     { city: 'Hosenfeld', zip: '6650' },
//     { city: 'Hosskirch', zip: '7587' },
//     { city: 'Hötensleben', zip: '39405' },
//     { city: 'Hövelhof', zip: '5257' },
//     { city: 'Hövelhof-Espeln', zip: '5294' },
//     { city: 'Höxter', zip: '5271' },
//     { city: 'Höxter-Fürstenau', zip: '5277' },
//     { city: 'Höxter-Ottbergen', zip: '5275' },
//     { city: 'Höxter-Ovenhausen', zip: '5278' },
//     { city: 'Hoya', zip: '4251' },
//     { city: 'Hoyerswerda', zip: '3571' },
//     { city: 'Hückelhoven', zip: '2433' },
//     { city: 'Hückeswagen', zip: '2192' },
//     { city: 'Hude Oldenburg', zip: '4408' },
//     { city: 'Hude-Wüsting', zip: '4484' },
//     { city: 'Hüffenhardt', zip: '6268' },
//     { city: 'Huglfing', zip: '8802' },
//     { city: 'Hüllhorst', zip: '5744' },
//     { city: 'Hünfeld', zip: '6652' },
//     { city: 'Hünfelden', zip: '6438' },
//     { city: 'Hungen', zip: '6402' },
//     { city: 'Hünxe', zip: '2858' },
//     { city: 'Hürtgenwald', zip: '2429' },
//     { city: 'Hürth Rheinl', zip: '2233' },
//     { city: 'Husby', zip: '4634' },
//     { city: 'Husum Nordsee', zip: '4841' },
//     { city: 'Hutthurm', zip: '8505' },
//     { city: 'Ibbenbüren', zip: '5451' },
//     { city: 'Ichenhausen', zip: '8223' },
//     { city: 'Icking', zip: '8178' },
//     { city: 'Idar-Oberstein', zip: '6781' },
//     { city: 'Iden', zip: '39390' },
//     { city: 'Idstein', zip: '6126' },
//     { city: 'Iffezheim', zip: '7229' },
//     { city: 'Ihlienworth', zip: '4755' },
//     { city: 'Ihlow Kr Aurich', zip: '4929' },
//     { city: 'Ihlow-Riepe', zip: '4928' },
//     { city: 'Ihringen', zip: '7668' },
//     { city: 'Ilfeld', zip: '36331' },
//     { city: 'Illerkirchberg', zip: '7346' },
//     { city: 'Illertissen', zip: '7303' },
//     { city: 'Illingen Saar', zip: '6825' },
//     { city: 'Illmensee', zip: '7558' },
//     { city: 'Illschwang', zip: '9666' },
//     { city: 'Ilmenau Thür', zip: '3677' },
//     { city: 'Ilsede', zip: '5172' },
//     { city: 'Ilsenburg', zip: '39452' },
//     { city: 'Ilshofen', zip: '7904' },
//     { city: 'Immendingen', zip: '7462' },
//     { city: 'Immenhausen Hess', zip: '5673' },
//     { city: 'Immenstaad am Bodensee', zip: '7545' },
//     { city: 'Immenstadt i Allgäu', zip: '8323' },
//     { city: 'Inchenhofen', zip: '8257' },
//     { city: 'Inden', zip: '2465' },
//     { city: 'Ingelheim am Rhein', zip: '6132' },
//     { city: 'Ingolstadt Donau', zip: '841' },
//     { city: 'Ingolstadt-Zuchering', zip: '8450' },
//     { city: 'Inning a Ammersee', zip: '8143' },
//     { city: 'Insel Hiddensee', zip: '38300' },
//     { city: 'Insul', zip: '2695' },
//     { city: 'Inzell', zip: '8665' },
//     { city: 'Iphofen', zip: '9323' },
//     { city: 'Ippesheim', zip: '9339' },
//     { city: 'Ipsheim', zip: '9846' },
//     { city: 'Irrel', zip: '6525' },
//     { city: 'Irrhausen', zip: '6550' },
//     { city: 'Isen', zip: '8083' },
//     { city: 'Isenbüttel', zip: '5374' },
//     { city: 'Iserlohn', zip: '2371' },
//     { city: 'Iserlohn-Letmathe', zip: '2374' },
//     { city: 'Isny im Allgäu', zip: '7562' },
//     { city: 'Isny-Eisenbach', zip: '7569' },
//     { city: 'Isselburg', zip: '2874' },
//     { city: 'Isselburg-Werth', zip: '2873' },
//     { city: 'Isserstedt', zip: '36425' },
//     { city: 'Issum', zip: '2835' },
//     { city: 'Itterbeck', zip: '5948' },
//     { city: 'Itzehoe', zip: '4821' },
//     { city: 'Jabel b Waren', zip: '39929' },
//     { city: 'Jachenau', zip: '8043' },
//     { city: 'Jacobsdorf Mark', zip: '33608' },
//     { city: 'Jade', zip: '4454' },
//     { city: 'Jade-Schweiburg', zip: '4455' },
//     { city: 'Jagstzell', zip: '7967' },
//     { city: 'Jakobshagen', zip: '39885' },
//     { city: 'Jameln', zip: '5864' },
//     { city: 'Janisroda', zip: '34466' },
//     { city: 'Janneby', zip: '4607' },
//     { city: 'Jänschwalde', zip: '35607' },
//     { city: 'Jarmen', zip: '39997' },
//     { city: 'Jatznick', zip: '39741' },
//     { city: 'Jävenitz', zip: '39086' },
//     { city: 'Jeber-Bergfrieden', zip: '34907' },
//     { city: 'Jembke', zip: '5366' },
//     { city: 'Jemgum', zip: '4958' },
//     { city: 'Jemgum-Ditzum', zip: '4902' },
//     { city: 'Jena', zip: '3641' },
//     { city: 'Jerchel Altmark', zip: '39087' },
//     { city: 'Jerichow', zip: '39343' },
//     { city: 'Jerxheim', zip: '5354' },
//     { city: 'Jesberg', zip: '6695' },
//     { city: 'Jesewitz', zip: '34241' },
//     { city: 'Jessen Elster', zip: '3537' },
//     { city: 'Jesteburg', zip: '4183' },
//     { city: 'Jestetten', zip: '7745' },
//     { city: 'Jettingen-Scheppach', zip: '8225' },
//     { city: 'Jevenstedt', zip: '4337' },
//     { city: 'Jever', zip: '4461' },
//     { city: 'Joachimsthal', zip: '33361' },
//     { city: 'Jocketa', zip: '37439' },
//     { city: 'Johanngeorgenstadt', zip: '3773' },
//     { city: 'Johanniskirchen', zip: '8564' },
//     { city: 'Jöhstadt', zip: '37343' },
//     { city: 'Joldelund', zip: '4673' },
//     { city: 'Jördenstorf', zip: '39977' },
//     { city: 'Jork', zip: '4162' },
//     { city: 'Jossgrund', zip: '6059' },
//     { city: 'Jübar', zip: '39003' },
//     { city: 'Jübek', zip: '4625' },
//     { city: 'Jüchen', zip: '2165' },
//     { city: 'Jüchen-Otzenrath', zip: '2164' },
//     { city: 'Jüchsen', zip: '36947' },
//     { city: 'Juist', zip: '4935' },
//     { city: 'Jülich', zip: '2461' },
//     { city: 'Jungingen b Hechingen', zip: '7477' },
//     { city: 'Jünkerath', zip: '6597' },
//     { city: 'Jürgenshagen', zip: '38466' },
//     { city: 'Jürgenstorf Meckl', zip: '39955' },
//     { city: 'Jüterbog', zip: '3372' },
//     { city: 'Kaarssen', zip: '38845' },
//     { city: 'Kade', zip: '39347' },
//     { city: 'Kahl a Main', zip: '6188' },
//     { city: 'Kahla Thür', zip: '36424' },
//     { city: 'Kaisersbach', zip: '7184' },
//     { city: 'Kaisersesch', zip: '2653' },
//     { city: 'Kaiserslautern', zip: '631' },
//     { city: 'Kaisheim', zip: '9099' },
//     { city: 'Kakerbeck Sachs-Anh', zip: '39081' },
//     { city: 'Kalbach Rhön', zip: '9742' },
//     { city: 'Kalbe Milde', zip: '39080' },
//     { city: 'Kalefeld', zip: '5553' },
//     { city: 'Kalkar', zip: '2824' },
//     { city: 'Kalkhorst', zip: '38827' },
//     { city: 'Kall', zip: '2441' },
//     { city: 'Kalletal', zip: '5264' },
//     { city: 'Kalletal-Varenholz', zip: '5755' },
//     { city: 'Kallmünz', zip: '9473' },
//     { city: 'Kaltenkirchen Holst', zip: '4191' },
//     { city: 'Kaltennordheim', zip: '36966' },
//     { city: 'Kamen', zip: '2307' },
//     { city: 'Kamenz', zip: '3578' },
//     { city: 'Kamern', zip: '39382' },
//     { city: 'Kammerforst Thür', zip: '36028' },
//     { city: 'Kamp-Bornhofen', zip: '6773' },
//     { city: 'Kamp-Lintfort', zip: '2842' },
//     { city: 'Kandel', zip: '7275' },
//     { city: 'Kandern', zip: '7626' },
//     { city: 'Kappeln Schlei', zip: '4642' },
//     { city: 'Kappelrodeck', zip: '7842' },
//     { city: 'Karben', zip: '6039' },
//     { city: 'Karbow-Vietlübbe', zip: '38733' },
//     { city: 'Karby', zip: '4644' },
//     { city: 'Karlsbad', zip: '7202' },
//     { city: 'Karlshagen', zip: '38371' },
//     { city: 'Karlshuld', zip: '8454' },
//     { city: 'Karlsruhe', zip: '721' },
//     { city: 'Karlstadt', zip: '9353' },
//     { city: 'Karlstadt-Wiesenfeld', zip: '9359' },
//     { city: 'Karow b Lübz', zip: '38738' },
//     { city: 'Karstädt Kr Prignitz', zip: '38797' },
//     { city: 'Karwesee', zip: '33922' },
//     { city: 'Kasendorf-Azendorf', zip: '9220' },
//     { city: 'Kassel', zip: '561' },
//     { city: 'Kastellaun', zip: '6762' },
//     { city: 'Kastl b Amberg', zip: '9625' },
//     { city: 'Kastorf Holst', zip: '4501' },
//     { city: 'Katlenburg', zip: '5552' },
//     { city: 'Katzenelnbogen', zip: '6486' },
//     { city: 'Katzow', zip: '38373' },
//     { city: 'Kaub', zip: '6774' },
//     { city: 'Kaufbeuren', zip: '8341' },
//     { city: 'Kaufungen Hess', zip: '5605' },
//     { city: 'Kaulsdorf', zip: '36733' },
//     { city: 'Kavelstorf', zip: '38208' },
//     { city: 'Kayna', zip: '34426' },
//     { city: 'Kefenrod', zip: '6049' },
//     { city: 'Kehl', zip: '7851' },
//     { city: 'Kehl-Bodersweier', zip: '7853' },
//     { city: 'Kehl-Goldscheuer', zip: '7854' },
//     { city: 'Kehnert', zip: '39366' },
//     { city: 'Kelberg', zip: '2692' },
//     { city: 'Kelheim', zip: '9441' },
//     { city: 'Kelkheim Taunus', zip: '6195' },
//     { city: 'Kell am See', zip: '6589' },
//     { city: 'Kellinghusen', zip: '4822' },
//     { city: 'Kelsterbach', zip: '6107' },
//     { city: 'Keltern', zip: '7236' },
//     { city: 'Kemberg', zip: '34921' },
//     { city: 'Kemnath Stadt', zip: '9642' },
//     { city: 'Kemnitz b Greifswald', zip: '38352' },
//     { city: 'Kempen', zip: '2152' },
//     { city: 'Kempfeld', zip: '6786' },
//     { city: 'Kempten Allgäu', zip: '831' },
//     { city: 'Kenzingen', zip: '7644' },
//     { city: 'Kerken', zip: '2833' },
//     { city: 'Kerkwitz', zip: '35692' },
//     { city: 'Kerpen Rheinl-Türnich', zip: '2237' },
//     { city: 'Kerpen-Buir', zip: '2275' },
//     { city: 'Kerpen-Horrem', zip: '2273' },
//     { city: 'Kesseling', zip: '2647' },
//     { city: 'Ketzin', zip: '33233' },
//     { city: 'Kevelaer', zip: '2832' },
//     { city: 'Kiel', zip: '431' },
//     { city: 'Kienberg Oberbay', zip: '8628' },
//     { city: 'Kierspe', zip: '2359' },
//     { city: 'Kierspe-Rönsahl', zip: '2269' },
//     { city: 'Kindelbrück', zip: '36375' },
//     { city: 'Kinding', zip: '8467' },
//     { city: 'Kinsau', zip: '8869' },
//     { city: 'Kipfenberg', zip: '8465' },
//     { city: 'Kippenheim', zip: '7825' },
//     { city: 'Kipsdorf Kurort', zip: '35052' },
//     { city: 'Kirchanschöring', zip: '8685' },
//     { city: 'Kirchardt', zip: '7266' },
//     { city: 'Kirchbarkau', zip: '4302' },
//     { city: 'Kirchberg an der Jagst', zip: '7954' },
//     { city: 'Kirchberg Hunsrück', zip: '6763' },
//     { city: 'Kirchberg Sachs', zip: '37602' },
//     { city: 'Kirchberg Wald', zip: '9927' },
//     { city: 'Kirchdorf b Sulingen', zip: '4273' },
//     { city: 'Kirchdorf i Wald', zip: '9928' },
//     { city: 'Kirchdorf Poel', zip: '38425' },
//     { city: 'Kirchenlamitz', zip: '9285' },
//     { city: 'Kirchenthumbach', zip: '9647' },
//     { city: 'Kirchgellersen', zip: '4135' },
//     { city: 'Kirchhain', zip: '6422' },
//     { city: 'Kirchheilingen', zip: '36043' },
//     { city: 'Kirchheim i Schw', zip: '8266' },
//     { city: 'Kirchheim unter Teck', zip: '7021' },
//     { city: 'Kirchheimbolanden', zip: '6352' },
//     { city: 'Kirchhundem', zip: '2723' },
//     { city: 'Kirchlauter', zip: '9536' },
//     { city: 'Kirchlinteln', zip: '4236' },
//     { city: 'Kirchroth', zip: '9428' },
//     { city: 'Kirchseeon', zip: '8091' },
//     { city: 'Kirchtimke', zip: '4289' },
//     { city: 'Kirchweidach', zip: '8623' },
//     { city: 'Kirchzarten', zip: '7661' },
//     { city: 'Kirkel', zip: '6849' },
//     { city: 'Kirn Nahe', zip: '6752' },
//     { city: 'Kirschau', zip: '3592' },
//     { city: 'Kirtorf', zip: '6635' },
//     { city: 'Kisselbach', zip: '6766' },
//     { city: 'Kissenbrück', zip: '5337' },
//     { city: 'Kissing', zip: '8233' },
//     { city: 'Kisslegg', zip: '7563' },
//     { city: 'Kist', zip: '9306' },
//     { city: 'Kitzingen', zip: '9321' },
//     { city: 'Kläden b Stendal', zip: '39324' },
//     { city: 'Kladrum', zip: '38723' },
//     { city: 'Klanxbüll', zip: '4668' },
//     { city: 'Kleeth', zip: '39602' },
//     { city: 'Klein Berssen', zip: '5965' },
//     { city: 'Klein Bünzow', zip: '39724' },
//     { city: 'Kleinau', zip: '39399' },
//     { city: 'Kleinblittersdorf', zip: '6805' },
//     { city: 'Kleinich', zip: '6536' },
//     { city: 'Kleinlangheim', zip: '9325' },
//     { city: 'Kleinmachnow', zip: '33203' },
//     { city: 'Kleinneuhausen', zip: '36372' },
//     { city: 'Kleinow Kr Prignitz', zip: '38784' },
//     { city: 'Kleinschmalkalden', zip: '36849' },
//     { city: 'Kleinwelka', zip: '35935' },
//     { city: 'Kleptow', zip: '39854' },
//     { city: 'Klettbach', zip: '36209' },
//     { city: 'Klettenberg', zip: '36336' },
//     { city: 'Klettgau', zip: '7742' },
//     { city: 'Klettwitz', zip: '35754' },
//     { city: 'Kleve Niederrhein', zip: '2821' },
//     { city: 'Klietz', zip: '39327' },
//     { city: 'Klingenberg a Main', zip: '9372' },
//     { city: 'Klingenberg Sachs', zip: '35202' },
//     { city: 'Klingenthal Sachs', zip: '37467' },
//     { city: 'Klitsche', zip: '39348' },
//     { city: 'Klitten', zip: '35895' },
//     { city: 'Klöden', zip: '35388' },
//     { city: 'Klosterfelde', zip: '33396' },
//     { city: 'Klötze Altmark', zip: '3909' },
//     { city: 'Klüden', zip: '39056' },
//     { city: 'Klütz', zip: '38825' },
//     { city: 'Knau b Pößneck', zip: '36484' },
//     { city: 'Knetzgau', zip: '9527' },
//     { city: 'Knüllwald', zip: '5685' },
//     { city: 'Kobern-Gondorf', zip: '2607' },
//     { city: 'Koblenz a Rhein', zip: '261' },
//     { city: 'Kochel a See', zip: '8851' },
//     { city: 'Kochel-Walchensee', zip: '8858' },
//     { city: 'Köckte b Gardelegen', zip: '39004' },
//     { city: 'Kodersdorf', zip: '35825' },
//     { city: 'Kohlberg Oberpf', zip: '9608' },
//     { city: 'Kohren-Sahlis', zip: '34344' },
//     { city: 'Kolitzheim', zip: '9385' },
//     { city: 'Kölleda', zip: '3635' },
//     { city: 'Kollmar', zip: '4128' },
//     { city: 'Köln', zip: '221' },
//     { city: 'Köln-Porz', zip: '2203' },
//     { city: 'Kölschhausen', zip: '6440' },
//     { city: 'Komptendorf', zip: '35605' },
//     { city: 'Köngernheim', zip: '6737' },
//     { city: 'Königheim-Brehmen', zip: '9340' },
//     { city: 'Königs Wusterhausen', zip: '3375' },
//     { city: 'Königsbach-Stein', zip: '7232' },
//     { city: 'Königsberg i Bay', zip: '9525' },
//     { city: 'Königsbronn', zip: '7328' },
//     { city: 'Königsbrück', zip: '35795' },
//     { city: 'Königsbrunn b Augsburg', zip: '8231' },
//     { city: 'Königsee', zip: '36738' },
//     { city: 'Königsfeld Eifel', zip: '2646' },
//     { city: 'Königsfeld im Schwarzwald', zip: '7725' },
//     { city: 'Königsfeld Oberfr', zip: '9207' },
//     { city: 'Königshain b Görlitz', zip: '35826' },
//     { city: 'Königslutter am Elm', zip: '5353' },
//     { city: 'Königsmoor', zip: '4180' },
//     { city: 'Königsmoos', zip: '8433' },
//     { city: 'Königstein im Taunus', zip: '6174' },
//     { city: 'Königstein Oberpf', zip: '9665' },
//     { city: 'Königstein Sächs Schweiz', zip: '35021' },
//     { city: 'Königswartha', zip: '35931' },
//     { city: 'Königswinter', zip: '2223' },
//     { city: 'Königswinter-Oberpleis', zip: '2244' },
//     { city: 'Könitz', zip: '36732' },
//     { city: 'Konken', zip: '6384' },
//     { city: 'Könnern', zip: '34691' },
//     { city: 'Konradsreuth', zip: '9292' },
//     { city: 'Konstanz', zip: '7531' },
//     { city: 'Konz', zip: '6501' },
//     { city: 'Konzell', zip: '9963' },
//     { city: 'Korbach', zip: '5631' },
//     { city: 'Kordel', zip: '6505' },
//     { city: 'Körner', zip: '36025' },
//     { city: 'Korntal-Münchingen', zip: '7150' },
//     { city: 'Kornwestheim', zip: '7154' },
//     { city: 'Körperich', zip: '6566' },
//     { city: 'Koserow', zip: '38375' },
//     { city: 'Kößlarn', zip: '8536' },
//     { city: 'Kotelow', zip: '39607' },
//     { city: 'Köthen Anhalt', zip: '3496' },
//     { city: 'Kötzting', zip: '9941' },
//     { city: 'Krackow', zip: '39746' },
//     { city: 'Kraftsdorf', zip: '36606' },
//     { city: 'Kraichtal', zip: '7250' },
//     { city: 'Krakow am See', zip: '38457' },
//     { city: 'Kranenburg Niederrhein', zip: '2826' },
//     { city: 'Kranichfeld', zip: '36450' },
//     { city: 'Kratzeburg', zip: '39822' },
//     { city: 'Krauchenwies', zip: '7576' },
//     { city: 'Krautheim Jagst', zip: '6294' },
//     { city: 'Krefeld', zip: '2151' },
//     { city: 'Kreiensen', zip: '5563' },
//     { city: 'Kreischa b Dresden', zip: '35206' },
//     { city: 'Kremmen', zip: '33055' },
//     { city: 'Krempe', zip: '4824' },
//     { city: 'Krensitz', zip: '34295' },
//     { city: 'Kressberg', zip: '7957' },
//     { city: 'Kressbronn am Bodensee', zip: '7543' },
//     { city: 'Kreuth b Tegernsee', zip: '8029' },
//     { city: 'Kreuzau', zip: '2422' },
//     { city: 'Kreuztal', zip: '2732' },
//     { city: 'Kriegsfeld', zip: '6358' },
//     { city: 'Krien', zip: '39723' },
//     { city: 'Krieschow', zip: '35604' },
//     { city: 'Krippen', zip: '35028' },
//     { city: 'Kritzkow', zip: '38454' },
//     { city: 'Krögis', zip: '35244' },
//     { city: 'Kronach', zip: '9261' },
//     { city: 'Kronberg im Taunus', zip: '6173' },
//     { city: 'Kronprinzenkoog', zip: '4856' },
//     { city: 'Kröpelin', zip: '38292' },
//     { city: 'Kropp', zip: '4624' },
//     { city: 'Kroppach', zip: '2688' },
//     { city: 'Kroppenstedt', zip: '39264' },
//     { city: 'Kropstädt', zip: '34920' },
//     { city: 'Kröslin', zip: '38370' },
//     { city: 'Krumbach Schwaben', zip: '8282' },
//     { city: 'Krummesse', zip: '4508' },
//     { city: 'Krummhörn-Greetsiel', zip: '4926' },
//     { city: 'Krummhörn-Loquard', zip: '4927' },
//     { city: 'Krummhörn-Pewsum', zip: '4923' },
//     { city: 'Krün', zip: '8825' },
//     { city: 'Kuhfelde', zip: '39035' },
//     { city: 'Kühlungsborn Ostseebad', zip: '38293' },
//     { city: 'Kühren b Wurzen', zip: '34261' },
//     { city: 'Kulmbach', zip: '9221' },
//     { city: 'Külsheim Baden', zip: '9345' },
//     { city: 'Kunrau', zip: '39008' },
//     { city: 'Kunreuth', zip: '9199' },
//     { city: 'Künzelsau', zip: '7940' },
//     { city: 'Kupferzell', zip: '7944' },
//     { city: 'Küps', zip: '9264' },
//     { city: 'Kürten', zip: '2268' },
//     { city: 'Kürten-Dürscheid', zip: '2207' },
//     { city: 'Kusel', zip: '6381' },
//     { city: 'Kusey', zip: '39005' },
//     { city: 'Küstrin-Kietz', zip: '33479' },
//     { city: 'Kutenholz', zip: '4762' },
//     { city: 'Kyllburg', zip: '6563' },
//     { city: 'Kyritz Brandenb', zip: '33971' },
//     { city: 'Laaber', zip: '9498' },
//     { city: 'Laage', zip: '38459' },
//     { city: 'Laar Vechte', zip: '5947' },
//     { city: 'Laasow b Calau', zip: '35436' },
//     { city: 'Laatzen', zip: '5102' },
//     { city: 'Laboe', zip: '4343' },
//     { city: 'Ladbergen', zip: '5485' },
//     { city: 'Ladelund', zip: '4666' },
//     { city: 'Ladenburg', zip: '6203' },
//     { city: 'Laer Kr Steinfurt', zip: '2554' },
//     { city: 'Lage Lippe', zip: '5232' },
//     { city: 'Lägerdorf', zip: '4828' },
//     { city: 'Lähden', zip: '5964' },
//     { city: 'Lahnstein', zip: '2621' },
//     { city: 'Lahntal', zip: '6420' },
//     { city: 'Lahr Schwarzwald', zip: '7821' },
//     { city: 'Lahstedt', zip: '5174' },
//     { city: 'Laichingen', zip: '7333' },
//     { city: 'Lalendorf', zip: '38452' },
//     { city: 'Lalling', zip: '9904' },
//     { city: 'Lam Oberpf', zip: '9943' },
//     { city: 'Lambrecht Pfalz', zip: '6325' },
//     { city: 'Lamerdingen', zip: '8248' },
//     { city: 'Lampertheim', zip: '6206' },
//     { city: 'Lampertheim-Hüttenfeld', zip: '6256' },
//     { city: 'Lamspringe', zip: '5183' },
//     { city: 'Lamstedt', zip: '4773' },
//     { city: 'Landau a d Isar', zip: '9951' },
//     { city: 'Landau in der Pfalz', zip: '6341' },
//     { city: 'Landsberg a Lech', zip: '8191' },
//     { city: 'Landsberg Sachs-Anh', zip: '34602' },
//     { city: 'Landscheid', zip: '6575' },
//     { city: 'Landshut', zip: '871' },
//     { city: 'Landstuhl', zip: '6371' },
//     { city: 'Langballig', zip: '4636' },
//     { city: 'Langebrück', zip: '35201' },
//     { city: 'Langelsheim', zip: '5326' },
//     { city: 'Langen b Bremerhaven', zip: '4743' },
//     { city: 'Langen Hess', zip: '6103' },
//     { city: 'Langenau Württ', zip: '7345' },
//     { city: 'Langenberg Kr Gütersloh', zip: '5248' },
//     { city: 'Langenburg', zip: '7905' },
//     { city: 'Langenenslingen', zip: '7376' },
//     { city: 'Langeneß Hallig', zip: '4684' },
//     { city: 'Langenfeld Mittelfr', zip: '9164' },
//     { city: 'Langenfeld Rheinland', zip: '2173' },
//     { city: 'Langenhennersdorf', zip: '35032' },
//     { city: 'Langenhorn', zip: '4672' },
//     { city: 'Langenleuba-Niederhain', zip: '34497' },
//     { city: 'Langenlonsheim', zip: '6704' },
//     { city: 'Langen-Neuenwalde', zip: '4707' },
//     { city: 'Langenneufnach', zip: '8239' },
//     { city: 'Langenselbold', zip: '6184' },
//     { city: 'Langenweddingen', zip: '39205' },
//     { city: 'Langenwetzendorf', zip: '36625' },
//     { city: 'Langenzenn', zip: '9101' },
//     { city: 'Langeoog', zip: '4972' },
//     { city: 'Langerwehe', zip: '2423' },
//     { city: 'Langgöns-Niederkleen', zip: '6447' },
//     { city: 'Langhagen b Güstrow', zip: '38456' },
//     { city: 'Langlingen', zip: '5082' },
//     { city: 'Langquaid', zip: '9452' },
//     { city: 'Langwedel Holst', zip: '4329' },
//     { city: 'Langwedel Kr Verden', zip: '4232' },
//     { city: 'Langwedel-Etelsen', zip: '4235' },
//     { city: 'Lanz Brandenb', zip: '38780' },
//     { city: 'Lassahn', zip: '38858' },
//     { city: 'Lassan b Wolgast', zip: '38374' },
//     { city: 'Lastrup', zip: '4472' },
//     { city: 'Lastrup-Hemmelte', zip: '4477' },
//     { city: 'Lathen', zip: '5933' },
//     { city: 'Laubach Hess', zip: '6405' },
//     { city: 'Laucha Unstrut', zip: '34462' },
//     { city: 'Lauchhammer', zip: '3574' },
//     { city: 'Lauchheim', zip: '7363' },
//     { city: 'Lauda-Königshofen', zip: '9343' },
//     { city: 'Lauenau', zip: '5043' },
//     { city: 'Lauenbrück', zip: '4267' },
//     { city: 'Lauenburg Elbe', zip: '4153' },
//     { city: 'Lauenstein Sachs', zip: '35054' },
//     { city: 'Lauf a d Pegnitz', zip: '9123' },
//     { city: 'Laufach', zip: '6093' },
//     { city: 'Laufen Salzach', zip: '8682' },
//     { city: 'Lauffen am Neckar', zip: '7133' },
//     { city: 'Lauingen Donau', zip: '9072' },
//     { city: 'Laupheim', zip: '7392' },
//     { city: 'Lauscha', zip: '36702' },
//     { city: 'Lauschütz', zip: '35693' },
//     { city: 'Lauta b Hoyerswerda', zip: '35722' },
//     { city: 'Lauterbach Hessen', zip: '6641' },
//     { city: 'Lauterecken', zip: '6382' },
//     { city: 'Lauterhofen Oberpf', zip: '9186' },
//     { city: 'Lauterstein', zip: '7332' },
//     { city: 'Lautertal Odenwald', zip: '6254' },
//     { city: 'Lautrach', zip: '8394' },
//     { city: 'Lebach', zip: '6881' },
//     { city: 'Lebach-Steinbach', zip: '6888' },
//     { city: 'Lebus', zip: '33604' },
//     { city: 'Lebusa', zip: '35364' },
//     { city: 'Leck', zip: '4662' },
//     { city: 'Leer Ostfriesland', zip: '491' },
//     { city: 'Leezen', zip: '4552' },
//     { city: 'Legau', zip: '8330' },
//     { city: 'Legden', zip: '2566' },
//     { city: 'Lehesten Thür Wald', zip: '36653' },
//     { city: 'Lehnin', zip: '3382' },
//     { city: 'Lehrberg', zip: '9820' },
//     { city: 'Lehre', zip: '5308' },
//     { city: 'Lehre-Essenrode', zip: '5301' },
//     { city: 'Lehre-Wendhausen', zip: '5309' },
//     { city: 'Lehrte', zip: '5132' },
//     { city: 'Lehrte-Arpke', zip: '5175' },
//     { city: 'Leiblfing', zip: '9427' },
//     { city: 'Leichlingen Rheinland', zip: '2175' },
//     { city: 'Leidenborn', zip: '6559' },
//     { city: 'Leimen Pfalz', zip: '6397' },
//     { city: 'Leinburg', zip: '9120' },
//     { city: 'Leinefelde', zip: '3605' },
//     { city: 'Leinzell', zip: '7175' },
//     { city: 'Leipzig', zip: '341' },
//     { city: 'Leisnig', zip: '34321' },
//     { city: 'Leitzkau', zip: '39241' },
//     { city: 'Lembruch', zip: '5447' },
//     { city: 'Lemförde', zip: '5443' },
//     { city: 'Lemgo', zip: '5261' },
//     { city: 'Lemgo-Kirchheide', zip: '5266' },
//     { city: 'Lemgow', zip: '5883' },
//     { city: 'Lengede', zip: '5344' },
//     { city: 'Lengefeld Erzgeb', zip: '37367' },
//     { city: 'Lengenfeld Unterm Stein', zip: '36027' },
//     { city: 'Lengenfeld Vogtl', zip: '37606' },
//     { city: 'Lengerich Emsl', zip: '5904' },
//     { city: 'Lengerich Westf', zip: '5481' },
//     { city: 'Lenggries', zip: '8042' },
//     { city: 'Lenggries-Fall', zip: '8045' },
//     { city: 'Lennestadt', zip: '2721' },
//     { city: 'Lennestadt-Oedingen', zip: '2725' },
//     { city: 'Lenningen', zip: '7026' },
//     { city: 'Lensahn', zip: '4363' },
//     { city: 'Lenting', zip: '8456' },
//     { city: 'Lenzen (Elbe)', zip: '38792' },
//     { city: 'Lenzkirch', zip: '7653' },
//     { city: 'Leonberg Württ', zip: '7152' },
//     { city: 'Leopoldshöhe', zip: '5208' },
//     { city: 'Letschin', zip: '33475' },
//     { city: 'Letzlingen', zip: '39088' },
//     { city: 'Leuchtenberg', zip: '9659' },
//     { city: 'Leun', zip: '6473' },
//     { city: 'Leussow b Ludwigslust', zip: '38754' },
//     { city: 'Leutenberg', zip: '36734' },
//     { city: 'Leutershausen', zip: '9823' },
//     { city: 'Leutkirch im Allgäu', zip: '7561' },
//     { city: 'Leutkirch-Friesenhofen', zip: '7567' },
//     { city: 'Leverkusen', zip: '214' },
//     { city: 'Leverkusen-Opladen', zip: '2171' },
//     { city: 'Lich Hess', zip: '6404' },
//     { city: 'Lich-Eberstadt', zip: '6004' },
//     { city: 'Lichte', zip: '36701' },
//     { city: 'Lichtenau Baden', zip: '7227' },
//     { city: 'Lichtenau Mittelfr', zip: '9827' },
//     { city: 'Lichtenau Westf', zip: '5295' },
//     { city: 'Lichtenau-Atteln', zip: '5292' },
//     { city: 'Lichtenau-Kleinenberg', zip: '5647' },
//     { city: 'Lichtenberg Erzgeb', zip: '37323' },
//     { city: 'Lichtenfels Bay', zip: '9571' },
//     { city: 'Lichtenfels-Goddelsheim', zip: '5636' },
//     { city: 'Lichtenfels-Isling', zip: '9576' },
//     { city: 'Lichtenfels-Sachsenberg', zip: '6454' },
//     { city: 'Lichtenstein Sachs', zip: '37204' },
//     { city: 'Lichtenstein Württ', zip: '7129' },
//     { city: 'Liebenau Hess', zip: '5676' },
//     { city: 'Liebenau Kr Nieburg Weser', zip: '5023' },
//     { city: 'Liebenburg', zip: '5346' },
//     { city: 'Liebenwalde', zip: '33054' },
//     { city: 'Lieberose', zip: '33671' },
//     { city: 'Liebertwolkwitz', zip: '34297' },
//     { city: 'Liebstadt', zip: '35025' },
//     { city: 'Lienen', zip: '5483' },
//     { city: 'Lienen-Kattenvenne', zip: '5484' },
//     { city: 'Liepe Kr Barnim', zip: '33362' },
//     { city: 'Liepen b Anklam', zip: '39721' },
//     { city: 'Lietzen', zip: '33470' },
//     { city: 'Lilienthal', zip: '4298' },
//     { city: 'Limbach Baden', zip: '6287' },
//     { city: 'Limbach-Oberfrohna', zip: '3722' },
//     { city: 'Limburg a d Lahn', zip: '6431' },
//     { city: 'Lindau Anh', zip: '39246' },
//     { city: 'Lindau Bodensee', zip: '8382' },
//     { city: 'Lindau Harz', zip: '5556' },
//     { city: 'Linden Hess', zip: '6403' },
//     { city: 'Lindenberg i Allgäu', zip: '8381' },
//     { city: 'Lindenfels', zip: '6255' },
//     { city: 'Lindern Oldenburg', zip: '5957' },
//     { city: 'Lindhorst b Stadthagen', zip: '5725' },
//     { city: 'Lindlar', zip: '2266' },
//     { city: 'Lindow Mark', zip: '33933' },
//     { city: 'Lindstedt', zip: '39084' },
//     { city: 'Lingen (Ems)', zip: '591' },
//     { city: 'Linkenheim-Hochstetten', zip: '7247' },
//     { city: 'Linnich', zip: '2462' },
//     { city: 'Linsburg', zip: '5027' },
//     { city: 'Linz am Rhein', zip: '2644' },
//     { city: 'Lippetal-Herzfeld', zip: '2923' },
//     { city: 'Lippetal-Lippborg', zip: '2527' },
//     { city: 'Lippstadt', zip: '2941' },
//     { city: 'Lippstadt-Benninghausen', zip: '2945' },
//     { city: 'Lippstadt-Rebbeke', zip: '2948' },
//     { city: 'Lisberg', zip: '9549' },
//     { city: 'Litzendorf', zip: '9505' },
//     { city: 'Löbau', zip: '3585' },
//     { city: 'Lobenstein', zip: '36651' },
//     { city: 'Löbnitz B Delitzsch', zip: '34208' },
//     { city: 'Loburg', zip: '39245' },
//     { city: 'Löcknitz Vorpom', zip: '39754' },
//     { city: 'Löderburg', zip: '39265' },
//     { city: 'Löf', zip: '2605' },
//     { city: 'Löffingen', zip: '7654' },
//     { city: 'Lohkirchen', zip: '8637' },
//     { city: 'Lohmar Rheinland', zip: '2246' },
//     { city: 'Löhne', zip: '5732' },
//     { city: 'Lohne Oldenburg', zip: '4442' },
//     { city: 'Lohr a Main', zip: '9352' },
//     { city: 'Lohsa', zip: '35724' },
//     { city: 'Loitsche', zip: '39208' },
//     { city: 'Loitz b Demmin', zip: '39998' },
//     { city: 'Lollar', zip: '6406' },
//     { city: 'Lommatzsch', zip: '35241' },
//     { city: 'Löningen', zip: '5432' },
//     { city: 'Lonsee', zip: '7336' },
//     { city: 'Loose b Eckernförde', zip: '4358' },
//     { city: 'Lorch Rheingau', zip: '6726' },
//     { city: 'Lorch Württ', zip: '7172' },
//     { city: 'Lörrach', zip: '7621' },
//     { city: 'Lorup', zip: '5954' },
//     { city: 'Losheim am See', zip: '6872' },
//     { city: 'Lossburg', zip: '7446' },
//     { city: 'Löwenberg', zip: '33094' },
//     { city: 'Löwenstein Württ', zip: '7130' },
//     { city: 'Loxstedt', zip: '4744' },
//     { city: 'Loxstedt-Dedesdorf', zip: '4740' },
//     { city: 'Loxstedt-Donnern', zip: '4703' },
//     { city: 'Lübbecke', zip: '5741' },
//     { city: 'Lübben Spreewald', zip: '3546' },
//     { city: 'Lübbenau Spreewald', zip: '3542' },
//     { city: 'Lübeck', zip: '451' },
//     { city: 'Lübeck-Travemünde', zip: '4502' },
//     { city: 'Lübstorf', zip: '3867' },
//     { city: 'Lübtheen', zip: '38855' },
//     { city: 'Lübz', zip: '38731' },
//     { city: 'Lüchow Wendland', zip: '5841' },
//     { city: 'Lucka', zip: '34492' },
//     { city: 'Luckau Brandenb', zip: '3544' },
//     { city: 'Luckenwalde', zip: '3371' },
//     { city: 'Lückstedt', zip: '39391' },
//     { city: 'Lüdenscheid', zip: '2351' },
//     { city: 'Lüderitz', zip: '39361' },
//     { city: 'Lüdersdorf Kr Barnim', zip: '33365' },
//     { city: 'Lüdersdorf Meckl', zip: '38821' },
//     { city: 'Lüdershagen b Barth', zip: '38227' },
//     { city: 'Lüdinghausen', zip: '2591' },
//     { city: 'Ludwigsau Hess', zip: '6670' },
//     { city: 'Ludwigsburg Württ', zip: '7141' },
//     { city: 'Ludwigsfelde', zip: '3378' },
//     { city: 'Ludwigslust Meckl', zip: '3874' },
//     { city: 'Ludwigsstadt', zip: '9263' },
//     { city: 'Lugau Erzgeb', zip: '37295' },
//     { city: 'Lügde-Rischenau', zip: '5283' },
//     { city: 'Luhe-Wildenau', zip: '9607' },
//     { city: 'Luisenthal Thür', zip: '36257' },
//     { city: 'Lunden', zip: '4882' },
//     { city: 'Lüneburg', zip: '4131' },
//     { city: 'Lünen', zip: '2306' },
//     { city: 'Lünne', zip: '5906' },
//     { city: 'Lunzenau', zip: '37383' },
//     { city: 'Lutherstadt Eisleben', zip: '3475' },
//     { city: 'Lutherstadt Wittenberg', zip: '3491' },
//     { city: 'Lütjenburg', zip: '4381' },
//     { city: 'Lüttenmark', zip: '38842' },
//     { city: 'Lutter am Barenberge', zip: '5383' },
//     { city: 'Lützen', zip: '34444' },
//     { city: 'Lutzerath', zip: '2677' },
//     { city: 'Lützow', zip: '38874' },
//     { city: 'Lychen', zip: '39888' },
//     { city: 'Magdala', zip: '36454' },
//     { city: 'Magdeburg', zip: '391' },
//     { city: 'Mahlow', zip: '3379' },
//     { city: 'Mahlsdorf b Salzwedel', zip: '39032' },
//     { city: 'Mähring', zip: '9639' },
//     { city: 'Mainburg', zip: '8751' },
//     { city: 'Mainhardt', zip: '7903' },
//     { city: 'Mainleus', zip: '9229' },
//     { city: 'Mainz', zip: '6131' },
//     { city: 'Mainz-Kastel', zip: '6134' },
//     { city: 'Malchin', zip: '3994' },
//     { city: 'Malchow b Waren', zip: '39932' },
//     { city: 'Malente', zip: '4523' },
//     { city: 'Mallentin', zip: '38824' },
//     { city: 'Mallersdorf-Pfaffenberg', zip: '8772' },
//     { city: 'Malliss', zip: '38750' },
//     { city: 'Malsch Kr Karlsruhe', zip: '7246' },
//     { city: 'Malsch-Völkersbach', zip: '7204' },
//     { city: 'Mammendorf', zip: '8145' },
//     { city: 'Mamming', zip: '9955' },
//     { city: 'Manching', zip: '8459' },
//     { city: 'Mandelbachtal', zip: '6804' },
//     { city: 'Mandelbachtal-Ommersheim', zip: '6803' },
//     { city: 'Manderscheid Eifel', zip: '6572' },
//     { city: 'Mannheim*3', zip: '621' },
//     { city: 'Mansfeld Südharz', zip: '34782' },
//     { city: 'Marbach am Neckar', zip: '7144' },
//     { city: 'Marburg', zip: '6421' },
//     { city: 'March Breisgau', zip: '7665' },
//     { city: 'Mariaposching', zip: '9906' },
//     { city: 'Marienberg Sachs', zip: '3735' },
//     { city: 'Marienhafe', zip: '4934' },
//     { city: 'Marienheide', zip: '2264' },
//     { city: 'Marienmünster', zip: '5276' },
//     { city: 'Marienthal Kr Oberhavel', zip: '33080' },
//     { city: 'Markdorf', zip: '7544' },
//     { city: 'Markgröningen', zip: '7145' },
//     { city: 'Märkisch Buchholz', zip: '33765' },
//     { city: 'Markneukirchen', zip: '37422' },
//     { city: 'Markranstädt', zip: '34205' },
//     { city: 'Marksuhl', zip: '36925' },
//     { city: 'Markt Berolzheim', zip: '9146' },
//     { city: 'Markt Einersheim', zip: '9326' },
//     { city: 'Markt Erlbach', zip: '9106' },
//     { city: 'Markt Indersdorf', zip: '8136' },
//     { city: 'Markt Rettenbach', zip: '8392' },
//     { city: 'Markt Schwaben', zip: '8121' },
//     { city: 'Marktbreit', zip: '9332' },
//     { city: 'Marktheidenfeld', zip: '9391' },
//     { city: 'Marktl', zip: '8678' },
//     { city: 'Marktleugast', zip: '9255' },
//     { city: 'Marktoberdorf', zip: '8342' },
//     { city: 'Marktoffingen', zip: '9087' },
//     { city: 'Marktredwitz', zip: '9231' },
//     { city: 'Marktschellenberg', zip: '8650' },
//     { city: 'Marktzeuln', zip: '9574' },
//     { city: 'Marl', zip: '2365' },
//     { city: 'Marlow', zip: '38221' },
//     { city: 'Marne', zip: '4851' },
//     { city: 'Marnitz', zip: '38729' },
//     { city: 'Maroldsweisach', zip: '9532' },
//     { city: 'Marpingen', zip: '6853' },
//     { city: 'Marsberg', zip: '2992' },
//     { city: 'Marsberg-Bredelar', zip: '2991' },
//     { city: 'Marsberg-Canstein', zip: '2993' },
//     { city: 'Marsberg-Westheim', zip: '2994' },
//     { city: 'Marschacht', zip: '4176' },
//     { city: 'Martensdorf b Stralsund', zip: '38321' },
//     { city: 'Martfeld', zip: '4255' },
//     { city: 'Martinstein', zip: '6754' },
//     { city: 'Marxen Auetal', zip: '4185' },
//     { city: 'Marxheim', zip: '9097' },
//     { city: 'Marxzell', zip: '7248' },
//     { city: 'Marzahna', zip: '33747' },
//     { city: 'Massbach', zip: '9735' },
//     { city: 'Masserberg', zip: '36870' },
//     { city: 'Massing', zip: '8724' },
//     { city: 'Mauern Kr Freising', zip: '8764' },
//     { city: 'Maulbronn', zip: '7043' },
//     { city: 'Mauth', zip: '8557' },
//     { city: 'Maxdorf', zip: '6237' },
//     { city: 'Mayen', zip: '2651' },
//     { city: 'Mechernich', zip: '2443' },
//     { city: 'Mechernich-Eiserfey', zip: '2484' },
//     { city: 'Mechernich-Satzvey', zip: '2256' },
//     { city: 'Meckenheim Rheinl', zip: '2225' },
//     { city: 'Meckesheim', zip: '6226' },
//     { city: 'Medebach', zip: '2982' },
//     { city: 'Medelby', zip: '4605' },
//     { city: 'Medow b Anklam', zip: '39728' },
//     { city: 'Meeder', zip: '9566' },
//     { city: 'Meerane', zip: '3764' },
//     { city: 'Meerbusch-Büderich', zip: '2132' },
//     { city: 'Meerbusch-Lank', zip: '2150' },
//     { city: 'Meerbusch-Osterath', zip: '2159' },
//     { city: 'Meersburg', zip: '7532' },
//     { city: 'Mehltheuer Vogtl', zip: '37431' },
//     { city: 'Meine', zip: '5304' },
//     { city: 'Meinersdorf', zip: '3721' },
//     { city: 'Meinersen', zip: '5372' },
//     { city: 'Meinerzhagen', zip: '2354' },
//     { city: 'Meinerzhagen-Valbert', zip: '2358' },
//     { city: 'Meiningen', zip: '3693' },
//     { city: 'Meisenheim', zip: '6753' },
//     { city: 'Meissen', zip: '3521' },
//     { city: 'Meissner', zip: '5657' },
//     { city: 'Meitingen', zip: '8271' },
//     { city: 'Meldorf', zip: '4832' },
//     { city: 'Melle', zip: '5422' },
//     { city: 'Melle-Buer', zip: '5427' },
//     { city: 'Mellen', zip: '38781' },
//     { city: 'Melle-Neuenkirchen', zip: '5428' },
//     { city: 'Melle-Wellingholzhausen', zip: '5429' },
//     { city: 'Mellingen', zip: '36453' },
//     { city: 'Mellrichstadt', zip: '9776' },
//     { city: 'Melsungen', zip: '5661' },
//     { city: 'Memmingen', zip: '8331' },
//     { city: 'Menden Sauerland', zip: '2373' },
//     { city: 'Menden-Asbeck', zip: '2379' },
//     { city: 'Mendig', zip: '2652' },
//     { city: 'Mengen Württ', zip: '7572' },
//     { city: 'Mengerskirchen', zip: '6476' },
//     { city: 'Mengkofen', zip: '8733' },
//     { city: 'Menslage', zip: '5437' },
//     { city: 'Menteroda', zip: '36029' },
//     { city: 'Menz Kr Oberhavel', zip: '33082' },
//     { city: 'Meppen', zip: '5931' },
//     { city: 'Meppen-Apeldorn', zip: '5966' },
//     { city: 'Merkers', zip: '36969' },
//     { city: 'Merseburg Saale', zip: '3461' },
//     { city: 'Mertingen', zip: '9078' },
//     { city: 'Merzen', zip: '5466' },
//     { city: 'Merzig', zip: '6861' },
//     { city: 'Merzig-Silwingen', zip: '6869' },
//     { city: 'Meschede', zip: '291' },
//     { city: 'Meschede-Freienohl', zip: '2903' },
//     { city: 'Mesekenhagen', zip: '38351' },
//     { city: 'Messdorf', zip: '39083' },
//     { city: 'Messel', zip: '6159' },
//     { city: 'Messkirch', zip: '7575' },
//     { city: 'Messstetten-Oberdigisheim', zip: '7436' },
//     { city: 'Mestlin', zip: '38727' },
//     { city: 'Metelen', zip: '2556' },
//     { city: 'Metschow', zip: '39994' },
//     { city: 'Mettendorf', zip: '6522' },
//     { city: 'Mettingen Westf', zip: '5452' },
//     { city: 'Mettlach', zip: '6864' },
//     { city: 'Mettlach-Orscholz', zip: '6865' },
//     { city: 'Mettlach-Tünsdorf', zip: '6868' },
//     { city: 'Mettmann', zip: '2104' },
//     { city: 'Metzingen Württ', zip: '7123' },
//     { city: 'Meuselwitz Thür', zip: '3448' },
//     { city: 'Meyenburg Kr Prignitz', zip: '33968' },
//     { city: 'Michelsneukirchen', zip: '9467' },
//     { city: 'Michelstadt', zip: '6061' },
//     { city: 'Michelstadt-Vielbrunn', zip: '6066' },
//     { city: 'Michendorf', zip: '33205' },
//     { city: 'Mickhausen', zip: '8204' },
//     { city: 'Miesbach', zip: '8025' },
//     { city: 'Mieste', zip: '39082' },
//     { city: 'Miesterhorst', zip: '39006' },
//     { city: 'Mihla', zip: '36924' },
//     { city: 'Milmersdorf', zip: '39886' },
//     { city: 'Miltach', zip: '9944' },
//     { city: 'Miltenberg', zip: '9371' },
//     { city: 'Miltzow', zip: '38328' },
//     { city: 'Mindelheim', zip: '8261' },
//     { city: 'Minden Westf', zip: '571' },
//     { city: 'Mintraching', zip: '9406' },
//     { city: 'Mirow Kr Neustrelitz', zip: '39833' },
//     { city: 'Missen-Wilhams', zip: '8320' },
//     { city: 'Mistelgau', zip: '9279' },
//     { city: 'Mistelgau-Obernsees', zip: '9206' },
//     { city: 'Mistorf', zip: '38453' },
//     { city: 'Mittelneufnach', zip: '8262' },
//     { city: 'Mittenwald', zip: '8823' },
//     { city: 'Mittenwalde Mark', zip: '33764' },
//     { city: 'Mitterfels', zip: '9961' },
//     { city: 'Mitterteich', zip: '9633' },
//     { city: 'Mittweida', zip: '3727' },
//     { city: 'Mitwitz', zip: '9266' },
//     { city: 'Mochau-Lüttewitz', zip: '34325' },
//     { city: 'Möckern b Magdeburg', zip: '39221' },
//     { city: 'Möckmühl', zip: '6298' },
//     { city: 'Mockrehna', zip: '34244' },
//     { city: 'Modautal', zip: '6167' },
//     { city: 'Moers', zip: '2841' },
//     { city: 'Mögglingen', zip: '7174' },
//     { city: 'Möhnesee', zip: '2924' },
//     { city: 'Mohorn', zip: '35209' },
//     { city: 'Mohrkirch', zip: '4646' },
//     { city: 'Moitin', zip: '38297' },
//     { city: 'Molbergen', zip: '4475' },
//     { city: 'Molbergen-Peheim', zip: '4479' },
//     { city: 'Möllenhagen', zip: '39928' },
//     { city: 'Mölln Lauenb', zip: '4542' },
//     { city: 'Molzhain', zip: '2747' },
//     { city: 'Mömbris', zip: '6029' },
//     { city: 'Mommenheim', zip: '6138' },
//     { city: 'Mönchengladbach', zip: '2161' },
//     { city: 'Mönchengladbach-Rheydt', zip: '2166' },
//     { city: 'Mönchsdeggingen', zip: '9088' },
//     { city: 'Monheim Schwab', zip: '9091' },
//     { city: 'Mönkebude', zip: '39774' },
//     { city: 'Monschau', zip: '2472' },
//     { city: 'Monsheim', zip: '6243' },
//     { city: 'Mönsheim', zip: '7044' },
//     { city: 'Montabaur', zip: '2602' },
//     { city: 'Moorenweis', zip: '8146' },
//     { city: 'Moormerland', zip: '4954' },
//     { city: 'Moormerland-Oldersum', zip: '4924' },
//     { city: 'Moos Niederbay', zip: '9938' },
//     { city: 'Moosbach b Vohenstrauß', zip: '9656' },
//     { city: 'Moosburg a d Isar', zip: '8761' },
//     { city: 'Moosinning', zip: '8123' },
//     { city: 'Morbach Hunsrück', zip: '6533' },
//     { city: 'Mörfelden-Walldorf', zip: '6105' },
//     { city: 'Moringen', zip: '5554' },
//     { city: 'Möringen', zip: '39329' },
//     { city: 'Moringen-Fredelsloh', zip: '5555' },
//     { city: 'Moritzburg', zip: '35207' },
//     { city: 'Mörlenbach', zip: '6209' },
//     { city: 'Morsbach Sieg', zip: '2294' },
//     { city: 'Morschen', zip: '5664' },
//     { city: 'Mosbach Baden', zip: '6261' },
//     { city: 'Mosel', zip: '37604' },
//     { city: 'Möser', zip: '39222' },
//     { city: 'Mössingen', zip: '7473' },
//     { city: 'Motten', zip: '9748' },
//     { city: 'Möttingen', zip: '9083' },
//     { city: 'Much', zip: '2245' },
//     { city: 'Mücheln Geiseltal', zip: '34632' },
//     { city: 'Mücka', zip: '35893' },
//     { city: 'Mücke', zip: '6400' },
//     { city: 'Mudau', zip: '6284' },
//     { city: 'Müden Aller', zip: '5375' },
//     { city: 'Mügeln b Oschatz', zip: '34362' },
//     { city: 'Mühlacker', zip: '7041' },
//     { city: 'Mühlanger', zip: '34922' },
//     { city: 'Mühlberg Elbe', zip: '35342' },
//     { city: 'Mühldorf a Inn', zip: '8631' },
//     { city: 'Mühlen Eichsen', zip: '38871' },
//     { city: 'Mühlenbeck Kr Oberhavel', zip: '33056' },
//     { city: 'Mühlhausen Mittelfr', zip: '9548' },
//     { city: 'Mühlhausen Oberpf', zip: '9185' },
//     { city: 'Mühlhausen Thür', zip: '3601' },
//     { city: 'Mühlheim am Main', zip: '6108' },
//     { city: 'Mühlheim an der Donau', zip: '7463' },
//     { city: 'Mühlingen', zip: '7775' },
//     { city: 'Mühltroff', zip: '36645' },
//     { city: 'Mulda Sachs', zip: '37320' },
//     { city: 'Mulfingen Jagst', zip: '7938' },
//     { city: 'Mülheim Mosel', zip: '6534' },
//     { city: 'Mülheim-Kärlich', zip: '2630' },
//     { city: 'Müllheim Baden', zip: '7631' },
//     { city: 'Müllrose', zip: '33606' },
//     { city: 'Mülsen Skt Jacob', zip: '37601' },
//     { city: 'Münchberg', zip: '9251' },
//     { city: 'Müncheberg', zip: '33432' },
//     { city: 'Münchehofe Kr Dahme-Spreewald', zip: '33760' },
//     { city: 'München', zip: '89' },
//     { city: 'Münchenbernsdorf', zip: '36604' },
//     { city: 'Münchsmünster', zip: '8402' },
//     { city: 'Münchsteinach', zip: '9166' },
//     { city: 'Münchweiler an der Rodalb', zip: '6395' },
//     { city: 'Munderkingen', zip: '7393' },
//     { city: 'Mündersbach', zip: '2680' },
//     { city: 'Münnerstadt', zip: '9733' },
//     { city: 'Münsing Starnberger See', zip: '8177' },
//     { city: 'Münsingen', zip: '7381' },
//     { city: 'Münsingen-Buttenhausen', zip: '7383' },
//     { city: 'Munster', zip: '5192' },
//     { city: 'Münster', zip: '251' },
//     { city: 'Münster-Albachten', zip: '2536' },
//     { city: 'Münster-Hiltrup', zip: '2501' },
//     { city: 'Münster-Nienberge', zip: '2533' },
//     { city: 'Münster-Roxel', zip: '2534' },
//     { city: 'Münstertal Schwarzwald', zip: '7636' },
//     { city: 'Münster-Wolbeck', zip: '2506' },
//     { city: 'Murg', zip: '7763' },
//     { city: 'Murnau a Staffelsee', zip: '8841' },
//     { city: 'Murrhardt', zip: '7192' },
//     { city: 'Mustin Lauenburg', zip: '4546' },
//     { city: 'Mutterstadt', zip: '6234' },
//     { city: 'Mutzschen', zip: '34385' },
//     { city: 'Nabburg', zip: '9433' },
//     { city: 'Nagel', zip: '9236' },
//     { city: 'Nagold', zip: '7452' },
//     { city: 'Nagold-Hochdorf', zip: '7459' },
//     { city: 'Nahe', zip: '4535' },
//     { city: 'Nahrendorf', zip: '5855' },
//     { city: 'Naila', zip: '9282' },
//     { city: 'Namborn', zip: '6857' },
//     { city: 'Nandlstadt', zip: '8756' },
//     { city: 'Narsdorf', zip: '34346' },
//     { city: 'Nassau Lahn', zip: '2604' },
//     { city: 'Nassenfels', zip: '8424' },
//     { city: 'Nassenheide', zip: '33051' },
//     { city: 'Nastätten', zip: '6772' },
//     { city: 'Nauen Brandenb', zip: '3321' },
//     { city: 'Nauendorf Sachs-Anh', zip: '34603' },
//     { city: 'Naumburg Hess', zip: '5625' },
//     { city: 'Naumburg Saale', zip: '3445' },
//     { city: 'Naunhof b Grimma', zip: '34293' },
//     { city: 'Nauort', zip: '2601' },
//     { city: 'Nebra Unstrut', zip: '34461' },
//     { city: 'Nechlin', zip: '39740' },
//     { city: 'Neckargemünd', zip: '6223' },
//     { city: 'Neckargerach', zip: '6263' },
//     { city: 'Neckarsteinach', zip: '6229' },
//     { city: 'Neckarsulm', zip: '7132' },
//     { city: 'Neckartenzlingen', zip: '7127' },
//     { city: 'Neddenaverbergen', zip: '4238' },
//     { city: 'Nedlitz b Zerbst', zip: '39243' },
//     { city: 'Neenstetten', zip: '7340' },
//     { city: 'Neetze', zip: '5850' },
//     { city: 'Neheim-Hüsten', zip: '2932' },
//     { city: 'Nellingen Alb', zip: '7337' },
//     { city: 'Nennhausen', zip: '33878' },
//     { city: 'Nennslingen', zip: '9147' },
//     { city: 'Nentershausen Hess', zip: '6627' },
//     { city: 'Nentershausen Westerw', zip: '6485' },
//     { city: 'Nerchau', zip: '34382' },
//     { city: 'Neresheim', zip: '7326' },
//     { city: 'Nersingen', zip: '7308' },
//     { city: 'Neschwitz', zip: '35933' },
//     { city: 'Nesselwang', zip: '8361' },
//     { city: 'Netphen', zip: '2738' },
//     { city: 'Netphen-Deuz', zip: '2737' },
//     { city: 'Nettersheim', zip: '2486' },
//     { city: 'Nettersheim-Tondorf', zip: '2440' },
//     { city: 'Nettetal-Kaldenkirchen', zip: '2157' },
//     { city: 'Nettetal-Lobberich', zip: '2153' },
//     { city: 'Neu Darchau', zip: '5853' },
//     { city: 'Neu Lübbenau', zip: '35473' },
//     { city: 'Neu Wulmstorf-Elstorf', zip: '4168' },
//     { city: 'Neualbenreuth', zip: '9638' },
//     { city: 'Neubörger', zip: '4966' },
//     { city: 'Neubrandenburg', zip: '395' },
//     { city: 'Neubukow', zip: '38294' },
//     { city: 'Neuburg a d Donau', zip: '8431' },
//     { city: 'Neuburg a d Kammel', zip: '8283' },
//     { city: 'Neuburg a Inn', zip: '8507' },
//     { city: 'Neuburg-Steinhausen', zip: '38426' },
//     { city: 'Neudenau', zip: '6264' },
//     { city: 'Neudietendorf', zip: '36202' },
//     { city: 'Neudrossenfeld', zip: '9203' },
//     { city: 'Neuenbürg Württ', zip: '7082' },
//     { city: 'Neuendettelsau', zip: '9874' },
//     { city: 'Neuengeseke', zip: '2927' },
//     { city: 'Neuenhagen b Berlin', zip: '3342' },
//     { city: 'Neuenhaus Dinkel', zip: '5941' },
//     { city: 'Neuenhof Thür', zip: '36928' },
//     { city: 'Neuenkirchen b Bassum', zip: '4245' },
//     { city: 'Neuenkirchen b Bramsche', zip: '5465' },
//     { city: 'Neuenkirchen b Soltau', zip: '5195' },
//     { city: 'Neuenkirchen Dithm', zip: '4837' },
//     { city: 'Neuenkirchen Kr Steinfurt', zip: '5973' },
//     { city: 'Neuenkirchen Kr Vechta', zip: '5493' },
//     { city: 'Neuenmarkt', zip: '9227' },
//     { city: 'Neuenrade-Affeln', zip: '2394' },
//     { city: 'Neuenstadt am Kocher', zip: '7139' },
//     { city: 'Neuenstein Hess', zip: '6677' },
//     { city: 'Neuenstein Württ', zip: '7942' },
//     { city: 'Neuental', zip: '6693' },
//     { city: 'Neuerburg Eifel', zip: '6564' },
//     { city: 'Neufahrn b Freising', zip: '8165' },
//     { city: 'Neufahrn i NB', zip: '8773' },
//     { city: 'Neuffen', zip: '7025' },
//     { city: 'Neugersdorf Sachs', zip: '3586' },
//     { city: 'Neuhardenberg', zip: '33476' },
//     { city: 'Neuharlingersiel', zip: '4974' },
//     { city: 'Neuhaus a d Pegnitz', zip: '9156' },
//     { city: 'Neuhaus a Inn', zip: '8503' },
//     { city: 'Neuhaus a Rennweg', zip: '3679' },
//     { city: 'Neuhaus Elbe', zip: '38841' },
//     { city: 'Neuhaus Oste', zip: '4752' },
//     { city: 'Neuhäusel Westerw', zip: '2620' },
//     { city: 'Neuhausen auf den Fildern', zip: '7158' },
//     { city: 'Neuhausen Erzgeb', zip: '37361' },
//     { city: 'Neuhausen ob Eck', zip: '7467' },
//     { city: 'Neuhaus-Schierschnitz', zip: '36764' },
//     { city: 'Neuhof Kr Fulda', zip: '6655' },
//     { city: 'Neuhofen Pfalz', zip: '6236' },
//     { city: 'Neuhof-Hauswurz', zip: '6669' },
//     { city: 'Neu-Isenburg', zip: '6102' },
//     { city: 'Neukalen', zip: '39956' },
//     { city: 'Neukieritzsch', zip: '34342' },
//     { city: 'Neukirch b Tettnang', zip: '7528' },
//     { city: 'Neukirch Lausitz', zip: '35951' },
//     { city: 'Neukirchen Altmark', zip: '39396' },
//     { city: 'Neukirchen b Hl Blut', zip: '9947' },
//     { city: 'Neukirchen b Niebüll', zip: '4664' },
//     { city: 'Neukirchen b Sulzbach-Rosenberg', zip: '9663' },
//     { city: 'Neukirchen Knüll', zip: '6694' },
//     { city: 'Neukirchen-Balbini', zip: '9465' },
//     { city: 'Neukirchen-Vluyn', zip: '2845' },
//     { city: 'Neukloster', zip: '38422' },
//     { city: 'Neulehe', zip: '4968' },
//     { city: 'Neulewin', zip: '33452' },
//     { city: 'Neulingen Enzkreis', zip: '7237' },
//     { city: 'Neumagen-Dhron', zip: '6507' },
//     { city: 'Neumark Sachs', zip: '37600' },
//     { city: 'Neumarkt i d Opf', zip: '9181' },
//     { city: 'Neumarkt-Sankt Veit', zip: '8639' },
//     { city: 'Neumünster', zip: '4321' },
//     { city: 'Neunburg vorm Wald', zip: '9672' },
//     { city: 'Neunburg-Kemnath', zip: '9439' },
//     { city: 'Neunkirchen a Brand', zip: '9134' },
//     { city: 'Neunkirchen Saar', zip: '6821' },
//     { city: 'Neunkirchen Siegerl', zip: '2735' },
//     { city: 'Neunkirchen-Seelscheid', zip: '2247' },
//     { city: 'Neureichenau', zip: '8583' },
//     { city: 'Neuried Ortenaukreis', zip: '7807' },
//     { city: 'Neuruppin', zip: '3391' },
//     { city: 'Neusalza-Spremberg', zip: '35872' },
//     { city: 'Neusorg', zip: '9234' },
//     { city: 'Neuss', zip: '2131' },
//     { city: 'Neuss-Norf', zip: '2137' },
//     { city: 'Neustadt a d Aisch', zip: '9161' },
//     { city: 'Neustadt a d Donau', zip: '9445' },
//     { city: 'Neustadt a d Waldnaab', zip: '9602' },
//     { city: 'Neustadt a Kulm', zip: '9648' },
//     { city: 'Neustadt am Rübenberge', zip: '5032' },
//     { city: 'Neustadt an der Orla', zip: '36481' },
//     { city: 'Neustadt an der Weinstraße', zip: '6321' },
//     { city: 'Neustadt b Coburg', zip: '9568' },
//     { city: 'Neustadt Dosse', zip: '33970' },
//     { city: 'Neustadt Hessen', zip: '6692' },
//     { city: 'Neustadt i Sa', zip: '3596' },
//     { city: 'Neustadt in Holstein', zip: '4561' },
//     { city: 'Neustadt-Esperke', zip: '5073' },
//     { city: 'Neustadt-Glewe', zip: '38757' },
//     { city: 'Neustadt-Hagen', zip: '5034' },
//     { city: 'Neustadt-Lachen', zip: '6327' },
//     { city: 'Neustadt-Mandelsloh', zip: '5072' },
//     { city: 'Neustadt-Schneeren', zip: '5036' },
//     { city: 'Neustrelitz', zip: '3981' },
//     { city: 'Neutraubling', zip: '9401' },
//     { city: 'Neutrebbin', zip: '33474' },
//     { city: 'Neuwegersleben', zip: '39401' },
//     { city: 'Neuweiler Kr Calw', zip: '7055' },
//     { city: 'Neuwied', zip: '2631' },
//     { city: 'Neuzelle', zip: '33652' },
//     { city: 'Nidda', zip: '6043' },
//     { city: 'Nideggen', zip: '2427' },
//     { city: 'Nideggen-Embken', zip: '2425' },
//     { city: 'Nideggen-Schmidt', zip: '2474' },
//     { city: 'Niebüll', zip: '4661' },
//     { city: 'Niederaula', zip: '6625' },
//     { city: 'Niederbobritzsch', zip: '37325' },
//     { city: 'Niederbrombach', zip: '6787' },
//     { city: 'Niedereschach', zip: '7728' },
//     { city: 'Niedergörsdorf', zip: '33741' },
//     { city: 'Niederkassel', zip: '2208' },
//     { city: 'Niederkirchen', zip: '6363' },
//     { city: 'Niederndodeleben', zip: '39204' },
//     { city: 'Niedernhausen Taunus', zip: '6127' },
//     { city: 'Nieder-Olm', zip: '6136' },
//     { city: 'Niederorschel', zip: '36076' },
//     { city: 'Niederpöllnitz', zip: '36607' },
//     { city: 'Niederreifenberg', zip: '6082' },
//     { city: 'Nieder-Seifersdorf', zip: '35827' },
//     { city: 'Niederstetten Württ', zip: '7932' },
//     { city: 'Niederzier', zip: '2428' },
//     { city: 'Niefern-Öschelbronn', zip: '7233' },
//     { city: 'Nieheim', zip: '5274' },
//     { city: 'Nieheim-Himmighausen', zip: '5238' },
//     { city: 'Niemberg', zip: '34604' },
//     { city: 'Niemegk', zip: '33843' },
//     { city: 'Nienburg Saale', zip: '34721' },
//     { city: 'Nienburg Weser', zip: '5021' },
//     { city: 'Niesky', zip: '3588' },
//     { city: 'Nittenau', zip: '9436' },
//     { city: 'Nittendorf', zip: '9404' },
//     { city: 'Nitzahn', zip: '33877' },
//     { city: 'Nöbdenitz', zip: '34496' },
//     { city: 'Nohfelden', zip: '6852' },
//     { city: 'Nohn Eifel', zip: '2696' },
//     { city: 'Nonnweiler', zip: '6873' },
//     { city: 'Nonnweiler-Primstal', zip: '6875' },
//     { city: 'Norden', zip: '4931' },
//     { city: 'Nordendorf', zip: '8273' },
//     { city: 'Nordenham', zip: '4731' },
//     { city: 'Norderney', zip: '4932' },
//     { city: 'Nordhalben', zip: '9267' },
//     { city: 'Nordhastedt', zip: '4804' },
//     { city: 'Nordhausen Thür', zip: '3631' },
//     { city: 'Nordheim v d Rhön', zip: '9779' },
//     { city: 'Nordholz b Bremerhaven', zip: '4741' },
//     { city: 'Nordhorn', zip: '5921' },
//     { city: 'Nordkirchen', zip: '2596' },
//     { city: 'Nordleda', zip: '4758' },
//     { city: 'Nördlingen', zip: '9081' },
//     { city: 'Nordrach', zip: '7838' },
//     { city: 'Nordstemmen', zip: '5069' },
//     { city: 'Nordstrand', zip: '4842' },
//     { city: 'Nordwalde', zip: '2573' },
//     { city: 'Nörten-Hardenberg', zip: '5503' },
//     { city: 'Northeim', zip: '5551' },
//     { city: 'Nortorf b Neumünster', zip: '4392' },
//     { city: 'Nortrup', zip: '5436' },
//     { city: 'Nörvenich', zip: '2426' },
//     { city: 'Nossen', zip: '35242' },
//     { city: 'Nossendorf', zip: '39995' },
//     { city: 'Nossentiner Hütte', zip: '39927' },
//     { city: 'Nottuln', zip: '2502' },
//     { city: 'Nottuln-Appelhülsen', zip: '2509' },
//     { city: 'Nümbrecht', zip: '2293' },
//     { city: 'Nürnberg', zip: '911' },
//     { city: 'Nürtingen', zip: '7022' },
//     { city: 'Nußbach Pfalz', zip: '6364' },
//     { city: 'Nusse', zip: '4543' },
//     { city: 'Oberammergau', zip: '8822' },
//     { city: 'Oberau Loisach', zip: '8824' },
//     { city: 'Oberaudorf', zip: '8033' },
//     { city: 'Oberaula', zip: '6628' },
//     { city: 'Oberaurach', zip: '9529' },
//     { city: 'Oberbach Unterfr', zip: '9749' },
//     { city: 'Oberbaldingen', zip: '7706' },
//     { city: 'Obercunnersdorf b Löbau', zip: '35875' },
//     { city: 'Oberdachstetten', zip: '9845' },
//     { city: 'Oberderdingen', zip: '7045' },
//     { city: 'Oberderdingen-Flehingen', zip: '7258' },
//     { city: 'Oberdolling', zip: '8404' },
//     { city: 'Oberelsbach', zip: '9774' },
//     { city: 'Obergünzburg', zip: '8372' },
//     { city: 'Oberhaid Oberfr', zip: '9503' },
//     { city: 'Oberharmersbach', zip: '7837' },
//     { city: 'Oberhausen Rheinl', zip: '208' },
//     { city: 'Ober-Hilbersheim', zip: '6728' },
//     { city: 'Oberhof Thür', zip: '36842' },
//     { city: 'Oberkail', zip: '6567' },
//     { city: 'Oberkirch Baden', zip: '7802' },
//     { city: 'Oberkochen', zip: '7364' },
//     { city: 'Oberkotzau', zip: '9286' },
//     { city: 'Oberland', zip: '36878' },
//     { city: 'Obermarchtal', zip: '7375' },
//     { city: 'Obermaßfeld-Grimmenthal', zip: '36949' },
//     { city: 'Ober-Mörlen', zip: '6002' },
//     { city: 'Obernburg a Main', zip: '6022' },
//     { city: 'Oberndorf am Neckar', zip: '7423' },
//     { city: 'Oberndorf b Apolda', zip: '36465' },
//     { city: 'Oberndorf Oste', zip: '4772' },
//     { city: 'Oberneukirchen', zip: '8630' },
//     { city: 'Obernkirchen', zip: '5724' },
//     { city: 'Obernzell', zip: '8591' },
//     { city: 'Obernzenn', zip: '9844' },
//     { city: 'Oberpöring', zip: '9937' },
//     { city: 'Ober-Ramstadt', zip: '6154' },
//     { city: 'Oberried Breisgau', zip: '7602' },
//     { city: 'Oberrot b Gaildorf', zip: '7977' },
//     { city: 'Oberscheinfeld', zip: '9167' },
//     { city: 'Oberschneiding', zip: '9426' },
//     { city: 'Obersöchering', zip: '8847' },
//     { city: 'Obersontheim', zip: '7973' },
//     { city: 'Oberstaufen', zip: '8386' },
//     { city: 'Oberstaufen-Thalkirchdorf', zip: '8325' },
//     { city: 'Oberstdorf', zip: '8322' },
//     { city: 'Oberteuringen', zip: '7546' },
//     { city: 'Oberthal Saar', zip: '6854' },
//     { city: 'Oberthulba', zip: '9736' },
//     { city: 'Obertrubach', zip: '9245' },
//     { city: 'Oberursel Taunus', zip: '6171' },
//     { city: 'Oberviechtach', zip: '9671' },
//     { city: 'Oberviechtach-Pullenried', zip: '9677' },
//     { city: 'Oberweis', zip: '6527' },
//     { city: 'Oberweißbach Thür Wald', zip: '36705' },
//     { city: 'Oberwesel', zip: '6744' },
//     { city: 'Oberweser', zip: '5574' },
//     { city: 'Oberwiesenthal Kurort', zip: '37348' },
//     { city: 'Obing', zip: '8624' },
//     { city: 'Ochsenfurt', zip: '9331' },
//     { city: 'Ochsenhausen', zip: '7352' },
//     { city: 'Ochtendung', zip: '2625' },
//     { city: 'Ochtrup', zip: '2553' },
//     { city: 'Ockholm', zip: '4674' },
//     { city: 'Odelzhausen', zip: '8134' },
//     { city: 'Oderberg', zip: '33369' },
//     { city: 'Odernheim am Glan', zip: '6755' },
//     { city: 'Oderwitz', zip: '35842' },
//     { city: 'Odisheim', zip: '4756' },
//     { city: 'Oebisfelde', zip: '39002' },
//     { city: 'Oederan', zip: '37292' },
//     { city: 'Oehna Brandenb', zip: '33742' },
//     { city: 'Oelde', zip: '2522' },
//     { city: 'Oelde-Stromberg', zip: '2529' },
//     { city: 'Oelsnitz Erzgeb', zip: '37298' },
//     { city: 'Oelsnitz Vogtl', zip: '37421' },
//     { city: 'Oelzschau b Borna', zip: '34347' },
//     { city: 'Oepfershausen', zip: '36940' },
//     { city: 'Oer-Erkenschwick', zip: '2368' },
//     { city: 'Oerlinghausen', zip: '5202' },
//     { city: 'Oertzenhof b Strasburg', zip: '3967' },
//     { city: 'Oestrich-Winkel', zip: '6723' },
//     { city: 'Oettingen i Bay', zip: '9082' },
//     { city: 'Oetzen', zip: '5805' },
//     { city: 'Offenbach an der Queich', zip: '6348' },
//     { city: 'Offenburg', zip: '781' },
//     { city: 'Offenhausen Mittelfr', zip: '9158' },
//     { city: 'Offingen Donau', zip: '8224' },
//     { city: 'Öhningen', zip: '7735' },
//     { city: 'Ohrdruf', zip: '3624' },
//     { city: 'Öhringen', zip: '7941' },
//     { city: 'Öhringen-Ohrnberg', zip: '7948' },
//     { city: 'Olbernhau', zip: '37360' },
//     { city: 'Olching', zip: '8142' },
//     { city: 'Oldenburg (Oldb)', zip: '441' },
//     { city: 'Oldenburg in Holstein', zip: '4361' },
//     { city: 'Oldenswort', zip: '4864' },
//     { city: 'Oldsum', zip: '4683' },
//     { city: 'Olfen', zip: '2595' },
//     { city: 'Olpe Biggesee', zip: '2761' },
//     { city: 'Olsberg', zip: '2962' },
//     { city: 'Olsbrücken', zip: '6308' },
//     { city: 'Olzheim', zip: '6552' },
//     { city: 'Oppenau', zip: '7804' },
//     { city: 'Oppenheim', zip: '6133' },
//     { city: 'Oranienbaum', zip: '34904' },
//     { city: 'Oranienburg', zip: '3301' },
//     { city: 'Orlamünde', zip: '36423' },
//     { city: 'Ortenberg Hess', zip: '6046' },
//     { city: 'Ortenburg', zip: '8542' },
//     { city: 'Ortrand', zip: '35755' },
//     { city: 'Osann-Monzel', zip: '6535' },
//     { city: 'Oschatz', zip: '3435' },
//     { city: 'Oschersleben Bode', zip: '3949' },
//     { city: 'Osnabrück', zip: '541' },
//     { city: 'Ossling', zip: '35792' },
//     { city: 'Ossmannstedt', zip: '36462' },
//     { city: 'Ostbevern', zip: '2532' },
//     { city: 'Osten-Altendorf', zip: '4776' },
//     { city: 'Ostenfeld Husum', zip: '4845' },
//     { city: 'Osterburg Altmark', zip: '3937' },
//     { city: 'Ostercappeln', zip: '5473' },
//     { city: 'Ostercappeln-Venne', zip: '5476' },
//     { city: 'Osterfeld', zip: '34422' },
//     { city: 'Osterhever', zip: '4865' },
//     { city: 'Osterhofen', zip: '9932' },
//     { city: 'Osterhofen-Gergweis', zip: '8547' },
//     { city: 'Osterholz-Scharmbeck', zip: '4791' },
//     { city: 'Osternienburg', zip: '34973' },
//     { city: 'Osterode am Harz', zip: '5522' },
//     { city: 'Oster-Ohrstedt', zip: '4847' },
//     { city: 'Osterwieck', zip: '39421' },
//     { city: 'Ostheim v d Rhön', zip: '9777' },
//     { city: 'Osthofen', zip: '6242' },
//     { city: 'Ostrach', zip: '7585' },
//     { city: 'Ostramondra', zip: '36378' },
//     { city: 'Ostrau Saalkreis', zip: '34600' },
//     { city: 'Ostrau Sachs', zip: '34324' },
//     { city: 'Östringen-Odenheim', zip: '7259' },
//     { city: 'Ostritz', zip: '35823' },
//     { city: 'Ottendorf b Stadtroda', zip: '36426' },
//     { city: 'Ottendorf-Okrilla', zip: '35205' },
//     { city: 'Ottenstein Niedersachs', zip: '5286' },
//     { city: 'Otterbach Pfalz', zip: '6301' },
//     { city: 'Otterndorf', zip: '4751' },
//     { city: 'Ottersberg', zip: '4205' },
//     { city: 'Ottersberg-Fischerhude', zip: '4293' },
//     { city: 'Ottersberg-Posthausen', zip: '4297' },
//     { city: 'Ottobeuren', zip: '8332' },
//     { city: 'Ottrau', zip: '6639' },
//     { city: 'Ottweiler', zip: '6824' },
//     { city: 'Ottweiler-Fürth', zip: '6858' },
//     { city: 'Ovelgönne-Großenmeer', zip: '4483' },
//     { city: 'Ovelgönne-Strückhausen', zip: '4480' },
//     { city: 'Overath', zip: '2206' },
//     { city: 'Owschlag', zip: '4336' },
//     { city: 'Oybin Kurort', zip: '35844' },
//     { city: 'Oy-Mittelberg', zip: '8366' },
//     { city: 'Oyten', zip: '4207' },
//     { city: 'Pabstorf', zip: '39428' },
//     { city: 'Paderborn', zip: '5251' },
//     { city: 'Paderborn-Dahl', zip: '5293' },
//     { city: 'Paderborn-Schloss Neuhaus', zip: '5254' },
//     { city: 'Pähl', zip: '8808' },
//     { city: 'Pahlen', zip: '4803' },
//     { city: 'Painten', zip: '9499' },
//     { city: 'Palling', zip: '8629' },
//     { city: 'Palzem', zip: '6583' },
//     { city: 'Panschwitz-Kuckau', zip: '35796' },
//     { city: 'Papenburg', zip: '4961' },
//     { city: 'Papenburg-Aschendorf', zip: '4962' },
//     { city: 'Pappenheim Mittelfr', zip: '9143' },
//     { city: 'Parchen', zip: '39345' },
//     { city: 'Parchim', zip: '3871' },
//     { city: 'Parey Elbe', zip: '39349' },
//     { city: 'Parmen-Weggun', zip: '39855' },
//     { city: 'Parsau', zip: '5368' },
//     { city: 'Parsberg', zip: '9492' },
//     { city: 'Pasewalk', zip: '3973' },
//     { city: 'Passau', zip: '851' },
//     { city: 'Passow Kr Uckermark', zip: '33336' },
//     { city: 'Pattensen', zip: '5101' },
//     { city: 'Paulinenaue', zip: '33237' },
//     { city: 'Pausa Vogtl', zip: '37432' },
//     { city: 'Pausin', zip: '33231' },
//     { city: 'Päwesin', zip: '33838' },
//     { city: 'Pechern', zip: '35775' },
//     { city: 'Pegnitz', zip: '9241' },
//     { city: 'Pegnitz-Trockau', zip: '9246' },
//     { city: 'Peine', zip: '5171' },
//     { city: 'Peissenberg', zip: '8803' },
//     { city: 'Peitz', zip: '35601' },
//     { city: 'Pellworm', zip: '4844' },
//     { city: 'Penig', zip: '37381' },
//     { city: 'Penkun', zip: '39751' },
//     { city: 'Pennigsehl', zip: '5028' },
//     { city: 'Penzberg', zip: '8856' },
//     { city: 'Penzlin b Waren', zip: '3962' },
//     { city: 'Perl', zip: '6867' },
//     { city: 'Perleberg', zip: '3876' },
//     { city: 'Perlesreut', zip: '8555' },
//     { city: 'Perl-Nennig', zip: '6866' },
//     { city: 'Petershagen Weser', zip: '5707' },
//     { city: 'Petershagen-Friedewalde', zip: '5704' },
//     { city: 'Petershagen-Heimsen', zip: '5768' },
//     { city: 'Petershagen-Lahde', zip: '5702' },
//     { city: 'Petershagen-Windheim', zip: '5705' },
//     { city: 'Petershausen', zip: '8137' },
//     { city: 'Petkus', zip: '33745' },
//     { city: 'Petting', zip: '8686' },
//     { city: 'Pfaffendorfb Beeskow', zip: '33672' },
//     { city: 'Pfaffenhausen Schwab', zip: '8265' },
//     { city: 'Pfaffenhofen a d Ilm', zip: '8441' },
//     { city: 'Pfaffenhofen a d Roth', zip: '7302' },
//     { city: 'Pfaffing', zip: '8076' },
//     { city: 'Pfalzfeld', zip: '6746' },
//     { city: 'Pfalzgrafenweiler', zip: '7445' },
//     { city: 'Pfarrkirchen Niederbay', zip: '8561' },
//     { city: 'Pfarrweisach', zip: '9535' },
//     { city: 'Pfatter', zip: '9481' },
//     { city: 'Pfedelbach-Untersteinbach', zip: '7949' },
//     { city: 'Pfeffenhausen', zip: '8782' },
//     { city: 'Pfinztal', zip: '7240' },
//     { city: 'Pförring', zip: '8403' },
//     { city: 'Pforzen', zip: '8346' },
//     { city: 'Pforzheim', zip: '7231' },
//     { city: 'Pfreimd', zip: '9606' },
//     { city: 'Pfronstetten', zip: '7388' },
//     { city: 'Pfronten', zip: '8363' },
//     { city: 'Pfullendorf', zip: '7552' },
//     { city: 'Pfungstadt', zip: '6157' },
//     { city: 'Philippsburg', zip: '7256' },
//     { city: 'Philippsreut', zip: '8550' },
//     { city: 'Philippsthal Werra', zip: '6620' },
//     { city: 'Picher', zip: '38751' },
//     { city: 'Pielenhofen', zip: '9409' },
//     { city: 'Pilsting', zip: '9953' },
//     { city: 'Pinneberg', zip: '4101' },
//     { city: 'Pinnow Kr Uckermark', zip: '33335' },
//     { city: 'Pirmasens', zip: '6331' },
//     { city: 'Pirna', zip: '3501' },
//     { city: 'Plaaz', zip: '38455' },
//     { city: 'Plankenfels', zip: '9204' },
//     { city: 'Plate', zip: '3861' },
//     { city: 'Plattling', zip: '9931' },
//     { city: 'Plau am See', zip: '38735' },
//     { city: 'Plaue Thür', zip: '36207' },
//     { city: 'Plauen', zip: '3741' },
//     { city: 'Pleinfeld', zip: '9144' },
//     { city: 'Pleiskirchen', zip: '8635' },
//     { city: 'Plettenberg', zip: '2391' },
//     { city: 'Pleystein', zip: '9654' },
//     { city: 'Plochingen', zip: '7153' },
//     { city: 'Plön', zip: '4522' },
//     { city: 'Plößberg', zip: '9636' },
//     { city: 'Pluwig', zip: '6588' },
//     { city: 'Pocking', zip: '8531' },
//     { city: 'Pocking-Hartkirchen', zip: '8538' },
//     { city: 'Podelzig', zip: '33601' },
//     { city: 'Polch', zip: '2654' },
//     { city: 'Polle', zip: '5535' },
//     { city: 'Polsingen', zip: '9093' },
//     { city: 'Pommelsbrunn', zip: '9154' },
//     { city: 'Poppenhausen Unterfr', zip: '9725' },
//     { city: 'Poppenhausen Wasserkuppe', zip: '6658' },
//     { city: 'Pörnbach', zip: '8446' },
//     { city: 'Porta Westfalica', zip: '5706' },
//     { city: 'Poseritz', zip: '38307' },
//     { city: 'Pößneck', zip: '3647' },
//     { city: 'Postbauer-Heng', zip: '9188' },
//     { city: 'Potsdam', zip: '331' },
//     { city: 'Pottenstein', zip: '9243' },
//     { city: 'Pöttmes', zip: '8253' },
//     { city: 'Preetz Kr Plön', zip: '4342' },
//     { city: 'Premnitz', zip: '3386' },
//     { city: 'Prenzlau', zip: '3984' },
//     { city: 'Prerow Ostseebad', zip: '38233' },
//     { city: 'Pressath', zip: '9644' },
//     { city: 'Presseck', zip: '9222' },
//     { city: 'Pressig', zip: '9265' },
//     { city: 'Prettin', zip: '35386' },
//     { city: 'Pretzier', zip: '39037' },
//     { city: 'Pretzsch Elbe', zip: '34926' },
//     { city: 'Pretzschendorf', zip: '35058' },
//     { city: 'Preussisch Oldendorf', zip: '5742' },
//     { city: 'Preussisch Ströhen', zip: '5776' },
//     { city: 'Preusslitz', zip: '34722' },
//     { city: 'Priborn', zip: '39923' },
//     { city: 'Prien a Chiemsee', zip: '8051' },
//     { city: 'Prieros', zip: '33768' },
//     { city: 'Priessen', zip: '35327' },
//     { city: 'Prischwitz', zip: '35937' },
//     { city: 'Pritzerbe', zip: '33834' },
//     { city: 'Pritzier b Hagenow', zip: '38856' },
//     { city: 'Pritzwalk', zip: '3395' },
//     { city: 'Probstzella', zip: '36735' },
//     { city: 'Prödel', zip: '39242' },
//     { city: 'Prohn', zip: '38323' },
//     { city: 'Pronsfeld', zip: '6556' },
//     { city: 'Prosselsheim', zip: '9386' },
//     { city: 'Prötzel', zip: '33436' },
//     { city: 'Prüm', zip: '6551' },
//     { city: 'Puderbach Westerw', zip: '2684' },
//     { city: 'Pulheim', zip: '2238' },
//     { city: 'Pulsnitz', zip: '35955' },
//     { city: 'Pürgen', zip: '8196' },
//     { city: 'Putbus', zip: '38301' },
//     { city: 'Putlitz', zip: '33981' },
//     { city: 'Pyrbaum', zip: '9180' },
//     { city: 'Quakenbrück', zip: '5431' },
//     { city: 'Quedlinburg', zip: '3946' },
//     { city: 'Quellendorf', zip: '34977' },
//     { city: 'Querfurt', zip: '34771' },
//     { city: 'Quickborn Kr Pinneberg', zip: '4106' },
//     { city: 'Raben', zip: '33848' },
//     { city: 'Raben Steinfeld', zip: '3860' },
//     { city: 'Rabenau Hess', zip: '6407' },
//     { city: 'Rackwitz', zip: '34294' },
//     { city: 'Radbruch', zip: '4178' },
//     { city: 'Raddestorf', zip: '5765' },
//     { city: 'Radeberg', zip: '3528' },
//     { city: 'Radeburg', zip: '35208' },
//     { city: 'Radegast Kr Köthen', zip: '34978' },
//     { city: 'Radevormwald', zip: '2195' },
//     { city: 'Radolfzell am Bodensee', zip: '7732' },
//     { city: 'Raduhn', zip: '38722' },
//     { city: 'Raesfeld', zip: '2865' },
//     { city: 'Rägelin', zip: '33924' },
//     { city: 'Raguhn', zip: '34906' },
//     { city: 'Rahden Westf', zip: '5771' },
//     { city: 'Rain Lech', zip: '9090' },
//     { city: 'Rain Niederbay', zip: '9429' },
//     { city: 'Raisdorf', zip: '4307' },
//     { city: 'Rakow Vorpom', zip: '38331' },
//     { city: 'Ralingen', zip: '6585' },
//     { city: 'Ramsau b Berchtesgaden', zip: '8657' },
//     { city: 'Rangsdorf', zip: '33708' },
//     { city: 'Ransbach-Baumbach', zip: '2623' },
//     { city: 'Rantrum', zip: '4848' },
//     { city: 'Rasdorf', zip: '6651' },
//     { city: 'Rastatt', zip: '7222' },
//     { city: 'Rastdorf', zip: '5956' },
//     { city: 'Rastede', zip: '4402' },
//     { city: 'Rastenberg', zip: '36377' },
//     { city: 'Rastow', zip: '3868' },
//     { city: 'Ratekau', zip: '4504' },
//     { city: 'Rathenow', zip: '3385' },
//     { city: 'Ratingen', zip: '2102' },
//     { city: 'Ratzeburg', zip: '4541' },
//     { city: 'Rätzlingen Kr Uelzen', zip: '5804' },
//     { city: 'Rätzlingen Sachs-Anh', zip: '39057' },
//     { city: 'Raubling', zip: '8035' },
//     { city: 'Rauschenberg Hess', zip: '6425' },
//     { city: 'Ravensburg', zip: '751' },
//     { city: 'Ravenstein Baden', zip: '6297' },
//     { city: 'Rechenberg-Bienenmühle', zip: '37327' },
//     { city: 'Rechlin', zip: '39823' },
//     { city: 'Recke', zip: '5453' },
//     { city: 'Reckerscheid', zip: '2257' },
//     { city: 'Recklinghausen', zip: '2361' },
//     { city: 'Redefin', zip: '38854' },
//     { city: 'Redekin', zip: '39341' },
//     { city: 'Rees', zip: '2851' },
//     { city: 'Rees-Haldern', zip: '2850' },
//     { city: 'Rees-Mehr', zip: '2857' },
//     { city: 'Reetz b Perleberg', zip: '38782' },
//     { city: 'Regen', zip: '9921' },
//     { city: 'Regensburg', zip: '941' },
//     { city: 'Regenstauf', zip: '9402' },
//     { city: 'Regis-Breitingen', zip: '34343' },
//     { city: 'Regnitzlosau', zip: '9294' },
//     { city: 'Rehau', zip: '9283' },
//     { city: 'Rehburg-Loccum', zip: '5766' },
//     { city: 'Rehden', zip: '5446' },
//     { city: 'Reher Holst', zip: '4876' },
//     { city: 'Rehfelde', zip: '33435' },
//     { city: 'Rehlingen-Siersburg', zip: '6833' },
//     { city: 'Rehna', zip: '38872' },
//     { city: 'Reichelsheim Odenwald', zip: '6164' },
//     { city: 'Reichelsheim Wetterau', zip: '6035' },
//     { city: 'Reichenau Baden', zip: '7534' },
//     { city: 'Reichenbach OL', zip: '35828' },
//     { city: 'Reichenbach Vogtl', zip: '3765' },
//     { city: 'Reichenbach-Steegen', zip: '6385' },
//     { city: 'Reichenberg b Strausberg', zip: '33437' },
//     { city: 'Reichertshofen Oberbay', zip: '8453' },
//     { city: 'Reichshof-Brüchermühle', zip: '2296' },
//     { city: 'Reichshof-Eckenhagen', zip: '2265' },
//     { city: 'Reinfeld Holstein', zip: '4533' },
//     { city: 'Reinhardshagen', zip: '5544' },
//     { city: 'Reinheim Odenw', zip: '6162' },
//     { city: 'Reinholterode', zip: '36085' },
//     { city: 'Reinsberg Sachs', zip: '37324' },
//     { city: 'Reinstädt Thür', zip: '36422' },
//     { city: 'Reisbach Niederbay', zip: '8734' },
//     { city: 'Reischach Kr Altötting', zip: '8670' },
//     { city: 'Reit Im Winkl', zip: '8640' },
//     { city: 'Reitzenhain Erzgeb', zip: '37364' },
//     { city: 'Reken', zip: '2864' },
//     { city: 'Remagen', zip: '2642' },
//     { city: 'Remagen-Rolandseck', zip: '2228' },
//     { city: 'Remda', zip: '36744' },
//     { city: 'Remptendorf', zip: '36640' },
//     { city: 'Remscheid', zip: '2191' },
//     { city: 'Remseck am Neckar', zip: '7146' },
//     { city: 'Renchen', zip: '7843' },
//     { city: 'Rendsburg', zip: '4331' },
//     { city: 'Rengsdorf', zip: '2634' },
//     { city: 'Rennerod', zip: '2664' },
//     { city: 'Rennertshofen', zip: '8434' },
//     { city: 'Renningen', zip: '7159' },
//     { city: 'Rentwertshausen', zip: '36944' },
//     { city: 'Rerik Ostseebad', zip: '38296' },
//     { city: 'Rethem Aller', zip: '5165' },
//     { city: 'Rettenberg', zip: '8327' },
//     { city: 'Reuden b Zeitz', zip: '34424' },
//     { city: 'Reuth b Plauen', zip: '37435' },
//     { city: 'Reutlingen', zip: '7121' },
//     { city: 'Rhade b Zeven', zip: '4285' },
//     { city: 'Rhauderfehn', zip: '4952' },
//     { city: 'Rhauderfehn-Burlage', zip: '4967' },
//     { city: 'Rhaunen', zip: '6544' },
//     { city: 'Rheda-Wiedenbrück', zip: '5242' },
//     { city: 'Rhede Ems', zip: '4964' },
//     { city: 'Rhede Westf', zip: '2872' },
//     { city: 'Rheinau', zip: '7844' },
//     { city: 'Rheinbach', zip: '2226' },
//     { city: 'Rheinberg', zip: '2843' },
//     { city: 'Rheinberg-Orsoy', zip: '2844' },
//     { city: 'Rheinböllen', zip: '6764' },
//     { city: 'Rheinbrohl', zip: '2635' },
//     { city: 'Rheine', zip: '5971' },
//     { city: 'Rheine-Mesum', zip: '5975' },
//     { city: 'Rheinfelden Baden', zip: '7623' },
//     { city: 'Rheinsberg Mark', zip: '33931' },
//     { city: 'Rheinstetten', zip: '7242' },
//     { city: 'Rhens', zip: '2628' },
//     { city: 'Rhinow', zip: '33875' },
//     { city: 'Rhumspringe', zip: '5529' },
//     { city: 'Ribnitz-Damgarten', zip: '3821' },
//     { city: 'Richtenberg', zip: '38322' },
//     { city: 'Rickenbach Hotzenw', zip: '7765' },
//     { city: 'Rickling', zip: '4328' },
//     { city: 'Riedbach', zip: '9526' },
//     { city: 'Riede Kr Verden', zip: '4294' },
//     { city: 'Riedenburg', zip: '9442' },
//     { city: 'Riedlingen Württ', zip: '7371' },
//     { city: 'Riedstadt', zip: '6158' },
//     { city: 'Rieneck', zip: '9354' },
//     { city: 'Riesa', zip: '3525' },
//     { city: 'Rieseby', zip: '4355' },
//     { city: 'Rietberg', zip: '5244' },
//     { city: 'Rietberg-Mastholte', zip: '2944' },
//     { city: 'Rietschen', zip: '35772' },
//     { city: 'Rietzneuendorf-Friedrichshof', zip: '35477' },
//     { city: 'Rimpar', zip: '9365' },
//     { city: 'Ringenwalde b Templin', zip: '39881' },
//     { city: 'Ringgau', zip: '5659' },
//     { city: 'Ringstedt', zip: '4708' },
//     { city: 'Rinteln', zip: '5751' },
//     { city: 'Ritterhude', zip: '4292' },
//     { city: 'Rittersgrün', zip: '37757' },
//     { city: 'Röbel Müritz', zip: '39931' },
//     { city: 'Röblingen am See', zip: '34774' },
//     { city: 'Rochau', zip: '39328' },
//     { city: 'Rochlitz', zip: '3737' },
//     { city: 'Rockenhausen', zip: '6361' },
//     { city: 'Rödental', zip: '9563' },
//     { city: 'Rödermark', zip: '6074' },
//     { city: 'Rodershausen', zip: '6524' },
//     { city: 'Rodewald', zip: '5074' },
//     { city: 'Rodgau', zip: '6106' },
//     { city: 'Roding', zip: '9461' },
//     { city: 'Rödinghausen', zip: '5746' },
//     { city: 'Roding-Neubäu', zip: '9469' },
//     { city: 'Roetgen Eifel', zip: '2471' },
//     { city: 'Rogäsen', zip: '33832' },
//     { city: 'Roggenburg', zip: '7300' },
//     { city: 'Roggendorf', zip: '38876' },
//     { city: 'Rohr i NB', zip: '8783' },
//     { city: 'Rohr Mittelfr', zip: '9876' },
//     { city: 'Rohr Thür', zip: '36844' },
//     { city: 'Rohrdorf Kr Rosenheim', zip: '8032' },
//     { city: 'Röhrmoos', zip: '8139' },
//     { city: 'Röhrnbach', zip: '8582' },
//     { city: 'Rohrsen Kr Nienburg Weser', zip: '5024' },
//     { city: 'Roitzsch b Bitterfeld', zip: '34954' },
//     { city: 'Rolofshagen', zip: '38325' },
//     { city: 'Römerstein', zip: '7382' },
//     { city: 'Römhild', zip: '36948' },
//     { city: 'Rommerskirchen', zip: '2183' },
//     { city: 'Romrod', zip: '6636' },
//     { city: 'Rönnebeck Sachs-Ahn', zip: '39392' },
//     { city: 'Ronneburg Thür', zip: '36602' },
//     { city: 'Ronnenberg', zip: '5109' },
//     { city: 'Ronsberg', zip: '8306' },
//     { city: 'Rosbach v d Höhe', zip: '6003' },
//     { city: 'Rosbach-Rodheim', zip: '6007' },
//     { city: 'Rosche', zip: '5803' },
//     { city: 'Rosdorf Kr Göttingen', zip: '5509' },
//     { city: 'Roseburg', zip: '4158' },
//     { city: 'Rosenberg Baden', zip: '6295' },
//     { city: 'Rosendahl-Darfeld', zip: '2545' },
//     { city: 'Rosendahl-Osterwick', zip: '2547' },
//     { city: 'Rosenfeld', zip: '7428' },
//     { city: 'Rosengarten Kr Harburg', zip: '4108' },
//     { city: 'Rosenheim Oberbay', zip: '8031' },
//     { city: 'Rosenthal Hess', zip: '6458' },
//     { city: 'Rosenthal Sächs Schweiz', zip: '35033' },
//     { city: 'Rositz', zip: '34498' },
//     { city: 'Röslau', zip: '9238' },
//     { city: 'Rösrath', zip: '2205' },
//     { city: 'Rossdorf Rhön', zip: '36968' },
//     { city: 'Roßhaupten Forggensee', zip: '8367' },
//     { city: 'Rossla', zip: '34651' },
//     { city: 'Roßlau Elbe', zip: '34901' },
//     { city: 'Rossleben', zip: '34672' },
//     { city: 'Rosstal Mittelfr', zip: '9127' },
//     { city: 'Rosswein', zip: '34322' },
//     { city: 'Rostock', zip: '381' },
//     { city: 'Rot Am See-Brettheim', zip: '7958' },
//     { city: 'Rotenburg a d Fulda', zip: '6623' },
//     { city: 'Rotenburg Wümme', zip: '4261' },
//     { city: 'Roth Mittelfr', zip: '9171' },
//     { city: 'Rötha', zip: '34206' },
//     { city: 'Rothemühl', zip: '39772' },
//     { city: 'Röthenbach Allgäu', zip: '8384' },
//     { city: 'Rothenberg Odenw', zip: '6275' },
//     { city: 'Rothenburg ob der Tauber', zip: '9861' },
//     { city: 'Rothenburg OL', zip: '35891' },
//     { city: 'Rothenfels Unterfr', zip: '9393' },
//     { city: 'Rothenkirchen Vogtl', zip: '37462' },
//     { city: 'Rothenklempenow', zip: '39744' },
//     { city: 'Rothenschirmbach', zip: '34776' },
//     { city: 'Röthlein', zip: '9723' },
//     { city: 'Rott a Inn', zip: '8039' },
//     { city: 'Rottenbach', zip: '36739' },
//     { city: 'Rottenbuch Oberbay', zip: '8867' },
//     { city: 'Rottenburg a d Laaber', zip: '8781' },
//     { city: 'Rottenburg am Neckar', zip: '7472' },
//     { city: 'Rottenburg-Ergenzingen', zip: '7457' },
//     { city: 'Rottenburg-Oberroning', zip: '8785' },
//     { city: 'Rottendorf Unterfr', zip: '9302' },
//     { city: 'Rottershausen', zip: '9738' },
//     { city: 'Rotthalmünster', zip: '8533' },
//     { city: 'Röttingen Unterfr', zip: '9338' },
//     { city: 'Rottleberode', zip: '34653' },
//     { city: 'Rottweil', zip: '741' },
//     { city: 'Rötz', zip: '9976' },
//     { city: 'Rübenau', zip: '37366' },
//     { city: 'Rückersdorf b Finsterwalde', zip: '35325' },
//     { city: 'Rückholz', zip: '8369' },
//     { city: 'Rudersberg Württ', zip: '7183' },
//     { city: 'Rüdersdorf b Berlin', zip: '33638' },
//     { city: 'Ruderting', zip: '8509' },
//     { city: 'Rüdesheim am Rhein', zip: '6722' },
//     { city: 'Rudolstadt', zip: '3672' },
//     { city: 'Rugendorf', zip: '9223' },
//     { city: 'Rügland', zip: '9828' },
//     { city: 'Rühen', zip: '5367' },
//     { city: 'Ruhla', zip: '36929' },
//     { city: 'Ruhland', zip: '35752' },
//     { city: 'Ruhmannsfelden', zip: '9929' },
//     { city: 'Ruhpolding', zip: '8663' },
//     { city: 'Rülzheim', zip: '7272' },
//     { city: 'Runkel', zip: '6482' },
//     { city: 'Ruppichteroth', zip: '2295' },
//     { city: 'Rüsselsheim', zip: '6142' },
//     { city: 'Rüthen', zip: '2952' },
//     { city: 'Rüthen-Oestereiden', zip: '2954' },
//     { city: 'Saal a d Saale', zip: '9762' },
//     { city: 'Saal Vorpom', zip: '38223' },
//     { city: 'Saalburg Thür', zip: '36647' },
//     { city: 'Saalfeld Saale', zip: '3671' },
//     { city: 'Saarbrücken', zip: '681' },
//     { city: 'Saarbrücken-Ensheim', zip: '6893' },
//     { city: 'Saarburg', zip: '6581' },
//     { city: 'Saarlouis', zip: '6831' },
//     { city: 'Saarwellingen', zip: '6838' },
//     { city: 'Sachsenheim Württ', zip: '7147' },
//     { city: 'Sadenbeck', zip: '33989' },
//     { city: 'Saerbeck', zip: '2574' },
//     { city: 'Sagard', zip: '38302' },
//     { city: 'Salem Baden', zip: '7553' },
//     { city: 'Salmtal', zip: '6578' },
//     { city: 'Salzbergen', zip: '5976' },
//     { city: 'Salzgitter', zip: '5341' },
//     { city: 'Salzgitter-Üfingen', zip: '5300' },
//     { city: 'Salzhausen', zip: '4172' },
//     { city: 'Salzhemmendorf', zip: '5153' },
//     { city: 'Salzhemmendorf-Wallensen', zip: '5186' },
//     { city: 'Salzkotten', zip: '5258' },
//     { city: 'Salzmünde', zip: '34609' },
//     { city: 'Salzwedel', zip: '3901' },
//     { city: 'Samtens', zip: '38306' },
//     { city: 'Sandau Elbe', zip: '39383' },
//     { city: 'Sandberg Unterfr', zip: '9701' },
//     { city: 'Sande Kr Friesl', zip: '4422' },
//     { city: 'Sandersleben', zip: '34785' },
//     { city: 'Sandhausen Baden', zip: '6224' },
//     { city: 'Sandstedt', zip: '4702' },
//     { city: 'Sangerhausen', zip: '3464' },
//     { city: 'Sanitz b Rostock', zip: '38209' },
//     { city: 'Sankt Andreasberg', zip: '5582' },
//     { city: 'Sankt Englmar', zip: '9965' },
//     { city: 'Sankt Julian', zip: '6387' },
//     { city: 'Sankt Margarethen Holst', zip: '4858' },
//     { city: 'Sankt Michaelisdonn', zip: '4853' },
//     { city: 'Sankt Peter-Ording', zip: '4863' },
//     { city: 'Sankt Wolfgang', zip: '8085' },
//     { city: 'Sarnow b Anklam', zip: '39722' },
//     { city: 'Sarstedt', zip: '5066' },
//     { city: 'Sarzbüttel', zip: '4806' },
//     { city: 'Sassenberg', zip: '2583' },
//     { city: 'Sassenburg-Grussendorf', zip: '5379' },
//     { city: 'Sassenburg-Platendorf', zip: '5378' },
//     { city: 'Sassnitz', zip: '38392' },
//     { city: 'Saterland', zip: '4492' },
//     { city: 'Saterland-Ramsloh', zip: '4498' },
//     { city: 'Satow b Bad Doberan', zip: '38295' },
//     { city: 'Satrup', zip: '4633' },
//     { city: 'Sauensiek', zip: '4169' },
//     { city: 'Sauerlach', zip: '8104' },
//     { city: 'Sauldorf', zip: '7777' },
//     { city: 'Saulgau', zip: '7581' },
//     { city: 'Sayda', zip: '37365' },
//     { city: 'Schafflund', zip: '4639' },
//     { city: 'Schafstädt', zip: '34636' },
//     { city: 'Schafstedt', zip: '4805' },
//     { city: 'Schalkau', zip: '36766' },
//     { city: 'Schalksmühle', zip: '2355' },
//     { city: 'Schapbach', zip: '7839' },
//     { city: 'Scharbeutz-Haffkrug', zip: '4563' },
//     { city: 'Scharbeutz-Pönitz', zip: '4524' },
//     { city: 'Scharnebeck', zip: '4136' },
//     { city: 'Schashagen', zip: '4564' },
//     { city: 'Schauenburg', zip: '5601' },
//     { city: 'Scheden', zip: '5546' },
//     { city: 'Scheessel', zip: '4263' },
//     { city: 'Schefflenz', zip: '6293' },
//     { city: 'Scheibenberg', zip: '37349' },
//     { city: 'Scheinfeld', zip: '9162' },
//     { city: 'Schelklingen', zip: '7394' },
//     { city: 'Schelklingen-Hütten', zip: '7384' },
//     { city: 'Schellerten', zip: '5123' },
//     { city: 'Schemmerhofen', zip: '7356' },
//     { city: 'Schenefeld Mittelholst', zip: '4892' },
//     { city: 'Schenklengsfeld', zip: '6629' },
//     { city: 'Schermbeck', zip: '2853' },
//     { city: 'Schesslitz', zip: '9542' },
//     { city: 'Schieder-Schwalenberg', zip: '5282' },
//     { city: 'Schiedungen', zip: '36337' },
//     { city: 'Schierke', zip: '39455' },
//     { city: 'Schierling', zip: '9451' },
//     { city: 'Schiffdorf', zip: '4706' },
//     { city: 'Schiffdorf-Geestenseth', zip: '4749' },
//     { city: 'Schifferstadt', zip: '6235' },
//     { city: 'Schildau Gneisenaustadt', zip: '34221' },
//     { city: 'Schillingsfürst', zip: '9868' },
//     { city: 'Schiltach', zip: '7836' },
//     { city: 'Schiltberg', zip: '8259' },
//     { city: 'Schinne', zip: '39320' },
//     { city: 'Schkeuditz', zip: '34204' },
//     { city: 'Schkölen Thür', zip: '36694' },
//     { city: 'Schladen', zip: '5335' },
//     { city: 'Schlagsdorf b Gadebusch', zip: '38875' },
//     { city: 'Schlangenbad', zip: '6129' },
//     { city: 'Schleching', zip: '8649' },
//     { city: 'Schleiden Eifel', zip: '2445' },
//     { city: 'Schleiden-Dreiborn', zip: '2485' },
//     { city: 'Schleiden-Gemünd', zip: '2444' },
//     { city: 'Schleife', zip: '35773' },
//     { city: 'Schleiz', zip: '3663' },
//     { city: 'Schlepzig', zip: '35472' },
//     { city: 'Schlesen', zip: '4303' },
//     { city: 'Schleswig', zip: '4621' },
//     { city: 'Schleusingen', zip: '36841' },
//     { city: 'Schlieben', zip: '35361' },
//     { city: 'Schliengen', zip: '7635' },
//     { city: 'Schlitz', zip: '6642' },
//     { city: 'Schloss Holte-Stukenbrock', zip: '5207' },
//     { city: 'Schlossvippach', zip: '36371' },
//     { city: 'Schlotheim', zip: '36021' },
//     { city: 'Schluchsee', zip: '7656' },
//     { city: 'Schlüchtern', zip: '6661' },
//     { city: 'Schlüsselfeld-Aschbach', zip: '9555' },
//     { city: 'Schmalkalden', zip: '3683' },
//     { city: 'Schmallenberg', zip: '2972' },
//     { city: 'Schmallenberg-Bödefeld', zip: '2977' },
//     { city: 'Schmallenberg-Dorlar', zip: '2971' },
//     { city: 'Schmallenberg-Fredeburg', zip: '2974' },
//     { city: 'Schmallenberg-Oberkirchen', zip: '2975' },
//     { city: 'Schmelz Saar', zip: '6887' },
//     { city: 'Schmidmühlen', zip: '9474' },
//     { city: 'Schmiedefeld a Rennsteig', zip: '36782' },
//     { city: 'Schmitten Taunus', zip: '6084' },
//     { city: 'Schmölln b Prenzlau', zip: '39862' },
//     { city: 'Schmölln Thür', zip: '34491' },
//     { city: 'Schnackenburg', zip: '5840' },
//     { city: 'Schnaitsee', zip: '8074' },
//     { city: 'Schnaittach', zip: '9153' },
//     { city: 'Schneeberg Erzgeb', zip: '3772' },
//     { city: 'Schnega', zip: '5842' },
//     { city: 'Schneidlingen', zip: '39267' },
//     { city: 'Schnelldorf', zip: '7950' },
//     { city: 'Schneverdingen', zip: '5193' },
//     { city: 'Schneverdingen-Heber', zip: '5199' },
//     { city: 'Schneverdingen-Wintermoor', zip: '5198' },
//     { city: 'Schöffengrund', zip: '6445' },
//     { city: 'Schöfweg', zip: '9908' },
//     { city: 'Schollene', zip: '39389' },
//     { city: 'Schöllkrippen', zip: '6024' },
//     { city: 'Schöllnach', zip: '9903' },
//     { city: 'Schömberg b Balingen', zip: '7427' },
//     { city: 'Schömberg b Neuenbürg', zip: '7084' },
//     { city: 'Schönau a d Brend', zip: '9775' },
//     { city: 'Schönau im Schwarzwald', zip: '7673' },
//     { city: 'Schönau Niederbay', zip: '8726' },
//     { city: 'Schönau Odenw', zip: '6228' },
//     { city: 'Schönbeck Meckl', zip: '3968' },
//     { city: 'Schönberg Holstein', zip: '4344' },
//     { city: 'Schönberg Meckl', zip: '38828' },
//     { city: 'Schönberg Niederbay', zip: '8554' },
//     { city: 'Schönborn Kr Elbe-Elster', zip: '35326' },
//     { city: 'Schönbrunn b Hildburghaus', zip: '36874' },
//     { city: 'Schondorf a Ammersee', zip: '8192' },
//     { city: 'Schönebeck Elbe', zip: '3928' },
//     { city: 'Schöneck', zip: '6187' },
//     { city: 'Schöneck Vogtl', zip: '37464' },
//     { city: 'Schönecken', zip: '6553' },
//     { city: 'Schönenberg-Kübelberg', zip: '6373' },
//     { city: 'Schönermark b Prenzlau', zip: '39852' },
//     { city: 'Schönewalde b Herzberg', zip: '35362' },
//     { city: 'Schönfeld b Großenhain', zip: '35248' },
//     { city: 'Schongau', zip: '8861' },
//     { city: 'Schönhausen Elbe', zip: '39323' },
//     { city: 'Schönheide Erzgeb', zip: '37755' },
//     { city: 'Schöningen', zip: '5352' },
//     { city: 'Schönkirchen', zip: '4348' },
//     { city: 'Schönsee', zip: '9674' },
//     { city: 'Schöntal Jagst', zip: '7943' },
//     { city: 'Schönthal Oberpf', zip: '9978' },
//     { city: 'Schonungen-Marktsteinach', zip: '9727' },
//     { city: 'Schönwalde am Bungsberg', zip: '4528' },
//     { city: 'Schönwalde b Lübben', zip: '35474' },
//     { city: 'Schopfheim', zip: '7622' },
//     { city: 'Schopfheim-Gersbach', zip: '7620' },
//     { city: 'Schopfloch Mittelfr', zip: '9857' },
//     { city: 'Schopp', zip: '6307' },
//     { city: 'Schöppenstedt', zip: '5332' },
//     { city: 'Schöppingen', zip: '2555' },
//     { city: 'Schorndorf Württ', zip: '7181' },
//     { city: 'Schotten Hess', zip: '6044' },
//     { city: 'Schramberg', zip: '7422' },
//     { city: 'Schrecksbach', zip: '6698' },
//     { city: 'Schrobenhausen', zip: '8252' },
//     { city: 'Schrozberg', zip: '7935' },
//     { city: 'Schrozberg-Bartenstein', zip: '7936' },
//     { city: 'Schrozberg-Spielbach', zip: '7939' },
//     { city: 'Schulenberg im Oberharz', zip: '5329' },
//     { city: 'Schulzendorf Kr Oberhavel', zip: '33083' },
//     { city: 'Schuttertal', zip: '7826' },
//     { city: 'Schüttorf', zip: '5923' },
//     { city: 'Schwaan', zip: '3844' },
//     { city: 'Schwabach', zip: '9122' },
//     { city: 'Schwabenheim an der Selz', zip: '6130' },
//     { city: 'Schwabhausen b Dachau', zip: '8138' },
//     { city: 'Schwäbisch Gmünd', zip: '7171' },
//     { city: 'Schwäbisch Hall', zip: '791' },
//     { city: 'Schwäbisch Hall-Sulzdorf', zip: '7907' },
//     { city: 'Schwabmünchen', zip: '8232' },
//     { city: 'Schwabsoien', zip: '8868' },
//     { city: 'Schwabstedt', zip: '4884' },
//     { city: 'Schwaförden', zip: '4277' },
//     { city: 'Schwaigern', zip: '7138' },
//     { city: 'Schwalenberg', zip: '5284' },
//     { city: 'Schwalmstadt', zip: '6691' },
//     { city: 'Schwalmtal Niederrhein', zip: '2163' },
//     { city: 'Schwalmtal-Renzendorf', zip: '6638' },
//     { city: 'Schwalmtal-Storndorf', zip: '6630' },
//     { city: 'Schwanau', zip: '7824' },
//     { city: 'Schwandorf', zip: '9431' },
//     { city: 'Schwanebeck Sachs-Anh', zip: '39424' },
//     { city: 'Schwanewede', zip: '4209' },
//     { city: 'Schwanewede-Aschwarden', zip: '4296' },
//     { city: 'Schwanfeld', zip: '9384' },
//     { city: 'Schwanstetten', zip: '9170' },
//     { city: 'Schwarme', zip: '4258' },
//     { city: 'Schwarmstedt', zip: '5071' },
//     { city: 'Schwarz b Neustrelitz', zip: '39827' },
//     { city: 'Schwarzach Niederbay', zip: '9962' },
//     { city: 'Schwarze Pumpe', zip: '3564' },
//     { city: 'Schwarzenbach a d Saale', zip: '9284' },
//     { city: 'Schwarzenbach a Wald', zip: '9289' },
//     { city: 'Schwarzenbek', zip: '4151' },
//     { city: 'Schwarzenberg', zip: '3774' },
//     { city: 'Schwarzenborn Knüll', zip: '5686' },
//     { city: 'Schwarzenfeld', zip: '9435' },
//     { city: 'Schwedeneck', zip: '4308' },
//     { city: 'Schwedt/Oder', zip: '3332' },
//     { city: 'Schwegenheim', zip: '6344' },
//     { city: 'Schweich', zip: '6502' },
//     { city: 'Schweigen-Rechtenbach', zip: '6342' },
//     { city: 'Schweinfurt', zip: '9721' },
//     { city: 'Schweinsberg Hess', zip: '6429' },
//     { city: 'Schweitenkirchen', zip: '8444' },
//     { city: 'Schwelm', zip: '2336' },
//     { city: 'Schwendi', zip: '7353' },
//     { city: 'Schwenningen a Neckar', zip: '7720' },
//     { city: 'Schwenningen Baden', zip: '7579' },
//     { city: 'Schwepnitz', zip: '35797' },
//     { city: 'Schwerin Meckl', zip: '385' },
//     { city: 'Schweringen', zip: '4257' },
//     { city: 'Schwerte', zip: '2304' },
//     { city: 'Schwetzingen', zip: '6202' },
//     { city: 'Schwindegg', zip: '8082' },
//     { city: 'Schwinkendorf', zip: '39953' },
//     { city: 'Schwittersdorf', zip: '34773' },
//     { city: 'Sebnitz', zip: '35971' },
//     { city: 'Seckach', zip: '6292' },
//     { city: 'Seedorf b Bad Segeberg', zip: '4555' },
//     { city: 'Seedorf Lauenb', zip: '4545' },
//     { city: 'Seeg', zip: '8364' },
//     { city: 'Seegrehna', zip: '34928' },
//     { city: 'Seehausen Altmark', zip: '39386' },
//     { city: 'Seehausen b Prenzlau', zip: '39863' },
//     { city: 'Seehausen Börde', zip: '39407' },
//     { city: 'Seeheim-Jugenheim', zip: '6257' },
//     { city: 'Seelbach Schutter', zip: '7823' },
//     { city: 'Seelingstädt b Gera', zip: '36608' },
//     { city: 'Seelow', zip: '3346' },
//     { city: 'Seelze', zip: '5137' },
//     { city: 'Seeon-Seebruck', zip: '8667' },
//     { city: 'Seesen', zip: '5381' },
//     { city: 'Seesen-Groß Rhüden', zip: '5384' },
//     { city: 'Seeshaupt', zip: '8801' },
//     { city: 'Seestermühe', zip: '4125' },
//     { city: 'Seevetal', zip: '4105' },
//     { city: 'Seewald', zip: '7448' },
//     { city: 'Segeletz', zip: '33978' },
//     { city: 'Sehestedt Eider', zip: '4357' },
//     { city: 'Sehnde', zip: '5138' },
//     { city: 'Seiffen Erzgeb', zip: '37362' },
//     { city: 'Seilershof', zip: '33085' },
//     { city: 'Seitschen', zip: '35930' },
//     { city: 'Selb', zip: '9287' },
//     { city: 'Selbitz Oberfr', zip: '9280' },
//     { city: 'Selent', zip: '4384' },
//     { city: 'Selfkant', zip: '2456' },
//     { city: 'Seligenstadt', zip: '6182' },
//     { city: 'Sellin Ostseebad', zip: '38303' },
//     { city: 'Selm', zip: '2592' },
//     { city: 'Selmsdorf', zip: '38823' },
//     { city: 'Selsingen', zip: '4284' },
//     { city: 'Selters Taunus', zip: '6483' },
//     { city: 'Selters Westferwald', zip: '2626' },
//     { city: 'Semlow', zip: '38222' },
//     { city: 'Semmenstedt', zip: '5336' },
//     { city: 'Senden Iller', zip: '7307' },
//     { city: 'Senden Westf', zip: '2597' },
//     { city: 'Sendenhorst', zip: '2526' },
//     { city: 'Sendenhorst-Albersloh', zip: '2535' },
//     { city: 'Senden-Ottmarsbocholt', zip: '2598' },
//     { city: 'Senftenberg', zip: '3573' },
//     { city: 'Senzke', zip: '33238' },
//     { city: 'Sesslach', zip: '9569' },
//     { city: 'Seßlach-Gemünda', zip: '9567' },
//     { city: 'Seubersdorf i d Opf', zip: '9497' },
//     { city: 'Seyda', zip: '35387' },
//     { city: 'Sibbesse', zip: '5065' },
//     { city: 'Sickte', zip: '5305' },
//     { city: 'Siedenbollentin', zip: '3969' },
//     { city: 'Siedenburg', zip: '4272' },
//     { city: 'Siegbach', zip: '2778' },
//     { city: 'Siegburg', zip: '2241' },
//     { city: 'Siegen', zip: '271' },
//     { city: 'Siegenburg', zip: '9444' },
//     { city: 'Siegsdorf Kr Traunstein', zip: '8662' },
//     { city: 'Siek Kr Stormarn', zip: '4107' },
//     { city: 'Sielenbach', zip: '8258' },
//     { city: 'Sien', zip: '6788' },
//     { city: 'Sievershütten', zip: '4194' },
//     { city: 'Siggelkow', zip: '38724' },
//     { city: 'Sigmaringen', zip: '7571' },
//     { city: 'Sigmaringen-Gutenstein', zip: '7570' },
//     { city: 'Simbach a Inn', zip: '8571' },
//     { city: 'Simbach Niederbay', zip: '9954' },
//     { city: 'Simmelsdorf', zip: '9155' },
//     { city: 'Simmerath', zip: '2473' },
//     { city: 'Simmern Hunsrück', zip: '6761' },
//     { city: 'Simmersdorf', zip: '35695' },
//     { city: 'Simmersfeld', zip: '7484' },
//     { city: 'Simmershofen', zip: '9848' },
//     { city: 'Simonswald', zip: '7683' },
//     { city: 'Singen Hohentwiel', zip: '7731' },
//     { city: 'Sinntal-Altengronau', zip: '6665' },
//     { city: 'Sinntal-Sterbfritz', zip: '6664' },
//     { city: 'Sinsheim', zip: '7261' },
//     { city: 'Sinsheim-Hilsbach', zip: '7260' },
//     { city: 'Sittensen', zip: '4282' },
//     { city: 'Sitzendorf', zip: '36730' },
//     { city: 'Soest', zip: '2921' },
//     { city: 'Soest-Ostönnen', zip: '2928' },
//     { city: 'Sögel', zip: '5952' },
//     { city: 'Sohland Spree', zip: '35936' },
//     { city: 'Söhlde', zip: '5129' },
//     { city: 'Söhrewald', zip: '5608' },
//     { city: 'Solingen*1', zip: '212' },
//     { city: 'Söllmnitz', zip: '36695' },
//     { city: 'Solnhofen', zip: '9145' },
//     { city: 'Soltau', zip: '5191' },
//     { city: 'Soltau-Emmingen', zip: '5190' },
//     { city: 'Soltau-Frielingen', zip: '5197' },
//     { city: 'Soltendieck', zip: '5874' },
//     { city: 'Sömmerda', zip: '3634' },
//     { city: 'Sommerhausen', zip: '9333' },
//     { city: 'Sondershausen', zip: '3632' },
//     { city: 'Sonneberg Thür', zip: '3675' },
//     { city: 'Sonnefeld', zip: '9562' },
//     { city: 'Sonnenbühl', zip: '7128' },
//     { city: 'Sonnewalde', zip: '35323' },
//     { city: 'Sonsbeck', zip: '2838' },
//     { city: 'Sontheim a d Brenz', zip: '7325' },
//     { city: 'Sonthofen', zip: '8321' },
//     { city: 'Sontra', zip: '5653' },
//     { city: 'Sörup', zip: '4635' },
//     { city: 'Sottrum Kr Rotenburg', zip: '4264' },
//     { city: 'Spaichingen', zip: '7424' },
//     { city: 'Spalt', zip: '9175' },
//     { city: 'Spangenberg', zip: '5663' },
//     { city: 'Spantekow', zip: '39727' },
//     { city: 'Speicher', zip: '6562' },
//     { city: 'Speichersdorf', zip: '9275' },
//     { city: 'Spelle', zip: '5977' },
//     { city: 'Spenge', zip: '5225' },
//     { city: 'Sperenberg', zip: '33703' },
//     { city: 'Speyer', zip: '6232' },
//     { city: 'Spiegelau', zip: '8553' },
//     { city: 'Spiegelberg', zip: '7194' },
//     { city: 'Spiekeroog', zip: '4976' },
//     { city: 'Spornitz', zip: '38726' },
//     { city: 'Spraitbach', zip: '7176' },
//     { city: 'Sprakensehl', zip: '5837' },
//     { city: 'Spreenhagen', zip: '33633' },
//     { city: 'Spremberg', zip: '3563' },
//     { city: 'Sprendlingen Rheinhess', zip: '6701' },
//     { city: 'Springe Deister', zip: '5041' },
//     { city: 'Springe-Bennigsen', zip: '5045' },
//     { city: 'Springe-Eldagsen', zip: '5044' },
//     { city: 'Sprockhövel-Haßlinghausen', zip: '2339' },
//     { city: 'St Blasien', zip: '7672' },
//     { city: 'St Georgen im Schwarzwald', zip: '7724' },
//     { city: 'St Goar', zip: '6741' },
//     { city: 'St Goarshausen', zip: '6771' },
//     { city: 'St Ingbert', zip: '6894' },
//     { city: 'St Johann Württ', zip: '7122' },
//     { city: 'St Märgen', zip: '7669' },
//     { city: 'St Peter Schwarzw', zip: '7660' },
//     { city: 'St Wendel', zip: '6851' },
//     { city: 'St Wendel-Niederkirchen', zip: '6856' },
//     { city: 'Stäbelow', zip: '38207' },
//     { city: 'Stade', zip: '4141' },
//     { city: 'Stade-Bützfleth', zip: '4146' },
//     { city: 'Stadelhofen', zip: '9504' },
//     { city: 'Stadland-Rodenkirchen', zip: '4732' },
//     { city: 'Stadland-Schwei', zip: '4737' },
//     { city: 'Stadland-Seefeld', zip: '4734' },
//     { city: 'Stadt Wehlen', zip: '35024' },
//     { city: 'Stadtallendorf', zip: '6428' },
//     { city: 'Stadthagen', zip: '5721' },
//     { city: 'Stadtilm', zip: '3629' },
//     { city: 'Stadtlauringen', zip: '9724' },
//     { city: 'Stadtlengsfeld', zip: '36965' },
//     { city: 'Stadtlohn', zip: '2563' },
//     { city: 'Stadtoldendorf', zip: '5532' },
//     { city: 'Stadtroda', zip: '36428' },
//     { city: 'Stadtsteinach', zip: '9225' },
//     { city: 'Staffelstein Oberfr', zip: '9573' },
//     { city: 'Stafstedt', zip: '4875' },
//     { city: 'Stahnsdorf', zip: '3329' },
//     { city: 'Stallwang', zip: '9964' },
//     { city: 'Stammbach', zip: '9256' },
//     { city: 'Stammham b Ingolstadt', zip: '8405' },
//     { city: 'Stamsried', zip: '9466' },
//     { city: 'Standenbühl', zip: '6357' },
//     { city: 'Starnberg', zip: '8151' },
//     { city: 'Stassfurt', zip: '3925' },
//     { city: 'Stauchitz', zip: '35268' },
//     { city: 'Staufen im Breisgau', zip: '7633' },
//     { city: 'Staufenberg Niedersachs', zip: '5543' },
//     { city: 'Staven', zip: '39608' },
//     { city: 'Stavenhagen Reuterstadt', zip: '39954' },
//     { city: 'Stechow Brandenb', zip: '33874' },
//     { city: 'Steimbke', zip: '5026' },
//     { city: 'Steinach Thür', zip: '36762' },
//     { city: 'Steinau an der Straße', zip: '6663' },
//     { city: 'Steinau-Marjoss', zip: '6660' },
//     { city: 'Steinau-Ulmbach', zip: '6667' },
//     { city: 'Steinbach-Hallenberg', zip: '36847' },
//     { city: 'Steinbergkirche', zip: '4632' },
//     { city: 'Steinburg Kr Storman', zip: '4534' },
//     { city: 'Steinen Kr Lörrach', zip: '7627' },
//     { city: 'Steinfeld Oldenburg', zip: '5492' },
//     { city: 'Steinfurt-Borghorst', zip: '2552' },
//     { city: 'Steinfurt-Burgsteinfurt', zip: '2551' },
//     { city: 'Steingaden Oberbay', zip: '8862' },
//     { city: 'Steinhagen Westf', zip: '5204' },
//     { city: 'Steinheid', zip: '36704' },
//     { city: 'Steinheim am Albuch', zip: '7329' },
//     { city: 'Steinheim Westf', zip: '5233' },
//     { city: 'Steinhöfel Kr Oder-Spree', zip: '33636' },
//     { city: 'Steinhöring', zip: '8094' },
//     { city: 'Steinhorst Lauenb', zip: '4536' },
//     { city: 'Steinhorst Niedersachs', zip: '5148' },
//     { city: 'Steinkirchen Kr Stade', zip: '4142' },
//     { city: 'Stein-Neukirch', zip: '2667' },
//     { city: 'Steinsdorf b Jessen', zip: '35384' },
//     { city: 'Steinsdorf Brandenb', zip: '33657' },
//     { city: 'Steisslingen', zip: '7738' },
//     { city: 'Stelle Kr Harburg', zip: '4174' },
//     { city: 'Stemwede-Dielingen', zip: '5474' },
//     { city: 'Stemwede-Levern', zip: '5745' },
//     { city: 'Stemwede-Wehdem', zip: '5773' },
//     { city: 'Stendal', zip: '3931' },
//     { city: 'Stepenitz', zip: '33969' },
//     { city: 'Stephanskirchen Simssee', zip: '8036' },
//     { city: 'Stephansposching', zip: '9935' },
//     { city: 'Sternberg', zip: '3847' },
//     { city: 'Sterup', zip: '4637' },
//     { city: 'Stetten am kalten Markt', zip: '7573' },
//     { city: 'Steutz', zip: '39244' },
//     { city: 'Steyerberg', zip: '5764' },
//     { city: 'Steyerberg-Voigtei', zip: '5769' },
//     { city: 'Stockach', zip: '7771' },
//     { city: 'Stockelsdorf-Curau', zip: '4505' },
//     { city: 'Stockelsdorf-Krumbeck', zip: '4506' },
//     { city: 'Stockstadt a Main', zip: '6027' },
//     { city: 'Stödtlen', zip: '7964' },
//     { city: 'Stoetze', zip: '5872' },
//     { city: 'Stolberg Harz', zip: '34654' },
//     { city: 'Stolberg Rheinl', zip: '2402' },
//     { city: 'Stolberg-Gressenich', zip: '2409' },
//     { city: 'Stollberg Erzgeb', zip: '37296' },
//     { city: 'Stolpe/Oder', zip: '33338' },
//     { city: 'Stolpen', zip: '35973' },
//     { city: 'Stolzenau', zip: '5761' },
//     { city: 'Storkow Mark', zip: '33678' },
//     { city: 'Stößen', zip: '34445' },
//     { city: 'Stötten a Auerberg', zip: '8349' },
//     { city: 'Stotternheim', zip: '36204' },
//     { city: 'Stöttwang', zip: '8345' },
//     { city: 'Straach', zip: '34929' },
//     { city: 'Straelen', zip: '2834' },
//     { city: 'Straelen-Herongen', zip: '2839' },
//     { city: 'Stralsund', zip: '3831' },
//     { city: 'Strasburg', zip: '39753' },
//     { city: 'Strassberg Harz', zip: '39489' },
//     { city: 'Strasskirchen', zip: '9424' },
//     { city: 'Straßlach-Dingharting', zip: '8170' },
//     { city: 'Straubing', zip: '9421' },
//     { city: 'Straufhain-Streufdorf', zip: '36875' },
//     { city: 'Straupitz', zip: '35475' },
//     { city: 'Strausberg', zip: '3341' },
//     { city: 'Straussfurt', zip: '36376' },
//     { city: 'Strehla', zip: '35264' },
//     { city: 'Ströbeck', zip: '39427' },
//     { city: 'Stromberg Hunsrück', zip: '6724' },
//     { city: 'Struppen', zip: '35020' },
//     { city: 'Struth b Mühlhausen Thür', zip: '36026' },
//     { city: 'Strüth Taunus', zip: '6775' },
//     { city: 'Stubben b Bremerhaven', zip: '4748' },
//     { city: 'Stuer', zip: '39924' },
//     { city: 'Stühlingen', zip: '7744' },
//     { city: 'Stuhr-Heiligenrode', zip: '4206' },
//     { city: 'Stülpe', zip: '33733' },
//     { city: 'Stutensee', zip: '7249' },
//     { city: 'Stuttgart', zip: '711' },
//     { city: 'Stützerbach', zip: '36784' },
//     { city: 'Südbrookmerland', zip: '4942' },
//     { city: 'Süderbrarup', zip: '4641' },
//     { city: 'Suderburg', zip: '5826' },
//     { city: 'Süderhastedt', zip: '4830' },
//     { city: 'Süderlügum', zip: '4663' },
//     { city: 'Süderstapel', zip: '4883' },
//     { city: 'Südlohn', zip: '2862' },
//     { city: 'Sugenheim', zip: '9165' },
//     { city: 'Suhl', zip: '3681' },
//     { city: 'Suhl-Dietzhausen', zip: '36846' },
//     { city: 'Suhlendorf', zip: '5820' },
//     { city: 'Sülfeld Holst', zip: '4537' },
//     { city: 'Sulingen', zip: '4271' },
//     { city: 'Sulz am Neckar', zip: '7454' },
//     { city: 'Sulzbach a Main', zip: '6028' },
//     { city: 'Sulzbach an der Murr', zip: '7193' },
//     { city: 'Sulzbach Saar', zip: '6897' },
//     { city: 'Sulzbach-Laufen', zip: '7976' },
//     { city: 'Sulzbach-Rosenberg', zip: '9661' },
//     { city: 'Sulzberg Allgäu', zip: '8376' },
//     { city: 'Sulzburg', zip: '7634' },
//     { city: 'Sulzdorf a d Lederhecke', zip: '9763' },
//     { city: 'Sulzemoos', zip: '8135' },
//     { city: 'Sulzfeld Baden', zip: '7269' },
//     { city: 'Sünching', zip: '9480' },
//     { city: 'Sundern Sauerland', zip: '2933' },
//     { city: 'Sundern-Allendorf', zip: '2393' },
//     { city: 'Sundern-Altenhellefeld', zip: '2934' },
//     { city: 'Sundern-Hachen', zip: '2935' },
//     { city: 'Süplingen', zip: '39053' },
//     { city: 'Surwold', zip: '4965' },
//     { city: 'Süsel-Bujendorf', zip: '4529' },
//     { city: 'Süßen', zip: '7162' },
//     { city: 'Sustrum', zip: '5939' },
//     { city: 'Syke', zip: '4242' },
//     { city: 'Syke-Heiligenfelde', zip: '4240' },
//     { city: 'Sylda', zip: '34742' },
//     { city: 'Sylt', zip: '4651' },
//     { city: 'Taarstedt', zip: '4622' },
//     { city: 'Tabarz Thür Wald', zip: '36259' },
//     { city: 'Tacherting- Peterskirchen', zip: '8622' },
//     { city: 'Taching-Tengling', zip: '8687' },
//     { city: 'Tagmersheim', zip: '9094' },
//     { city: 'Talheim Kr Tuttlingen', zip: '7464' },
//     { city: 'Talkau', zip: '4156' },
//     { city: 'Tambach-Dietharz Thür Wald', zip: '36252' },
//     { city: 'Tangeln', zip: '39007' },
//     { city: 'Tangerhütte', zip: '3935' },
//     { city: 'Tangermünde', zip: '39322' },
//     { city: 'Tangstedt Bz Hamburg', zip: '4109' },
//     { city: 'Tann Niederbay', zip: '8572' },
//     { city: 'Tann Rhön', zip: '6682' },
//     { city: 'Tanna b Schleiz', zip: '36646' },
//     { city: 'Tannenbergsthal Vogtl', zip: '37465' },
//     { city: 'Tännesberg', zip: '9655' },
//     { city: 'Tannheim Württ', zip: '8395' },
//     { city: 'Tantow', zip: '33333' },
//     { city: 'Tapfheim', zip: '9070' },
//     { city: 'Tarmstedt', zip: '4283' },
//     { city: 'Tarnow b Bützow', zip: '38450' },
//     { city: 'Tarp', zip: '4638' },
//     { city: 'Tauberbischofsheim', zip: '9341' },
//     { city: 'Taucha b Leipzig', zip: '34298' },
//     { city: 'Tauche', zip: '33675' },
//     { city: 'Taufkirchen Vils', zip: '8084' },
//     { city: 'Taunusstein', zip: '6128' },
//     { city: 'Tauscha b Großenhain', zip: '35240' },
//     { city: 'Tecklenburg', zip: '5482' },
//     { city: 'Tecklenburg-Brochterbeck', zip: '5455' },
//     { city: 'Tegernau Baden', zip: '7629' },
//     { city: 'Tegernsee', zip: '8022' },
//     { city: 'Teicha Sachs-Anh', zip: '34606' },
//     { city: 'Teichel', zip: '36743' },
//     { city: 'Teichwolframsdorf', zip: '36624' },
//     { city: 'Teisendorf', zip: '8666' },
//     { city: 'Teisnach', zip: '9923' },
//     { city: 'Teistungen', zip: '36071' },
//     { city: 'Telgte', zip: '2504' },
//     { city: 'Tellingstedt', zip: '4838' },
//     { city: 'Teltow', zip: '3328' },
//     { city: 'Templin', zip: '3987' },
//     { city: 'Tengen', zip: '7736' },
//     { city: 'Tennenbronn', zip: '7729' },
//     { city: 'Terpt', zip: '35456' },
//     { city: 'Tessin b Rostock', zip: '38205' },
//     { city: 'Teterow', zip: '3996' },
//     { city: 'Tettau Kr Kronach', zip: '9269' },
//     { city: 'Tettenweis', zip: '8534' },
//     { city: 'Tettnang', zip: '7542' },
//     { city: 'Teuchern', zip: '34443' },
//     { city: 'Teufelsmoor', zip: '4796' },
//     { city: 'Teupitz', zip: '33766' },
//     { city: 'Teuschnitz', zip: '9268' },
//     { city: 'Teutschenthal', zip: '34601' },
//     { city: 'Tewswoos', zip: '38759' },
//     { city: 'Thale', zip: '3947' },
//     { city: 'Thaleischweiler-Fröschen', zip: '6334' },
//     { city: 'Thalfang', zip: '6504' },
//     { city: 'Thalmassing', zip: '9453' },
//     { city: 'Thalmässing', zip: '9173' },
//     { city: 'Thannhausen Schwab', zip: '8281' },
//     { city: 'Tharandt', zip: '35203' },
//     { city: 'Thedinghausen', zip: '4204' },
//     { city: 'Theessen', zip: '39223' },
//     { city: 'Theilenhofen', zip: '9834' },
//     { city: 'Themar', zip: '36873' },
//     { city: 'Thierstein', zip: '9235' },
//     { city: 'Thimmendorf', zip: '36643' },
//     { city: 'Thomasburg', zip: '5859' },
//     { city: 'Thum Sachs', zip: '37297' },
//     { city: 'Thüngen', zip: '9360' },
//     { city: 'Thürkow', zip: '39975' },
//     { city: 'Thurnau', zip: '9228' },
//     { city: 'Thurnau-Alladorf', zip: '9271' },
//     { city: 'Thyrnau', zip: '8501' },
//     { city: 'Tiefenbach Oberpf', zip: '9673' },
//     { city: 'Tiefenbronn', zip: '7234' },
//     { city: 'Tiengen Hochrhein', zip: '7741' },
//     { city: 'Timmendorfer Strand', zip: '4503' },
//     { city: 'Tirschenreuth', zip: '9631' },
//     { city: 'Titisee-Neustadt', zip: '7651' },
//     { city: 'Titting', zip: '8423' },
//     { city: 'Tittling', zip: '8504' },
//     { city: 'Tittmoning', zip: '8683' },
//     { city: 'Titz', zip: '2463' },
//     { city: 'Todenbüttel', zip: '4874' },
//     { city: 'Todesfelde', zip: '4558' },
//     { city: 'Todtmoos', zip: '7674' },
//     { city: 'Todtnau', zip: '7671' },
//     { city: 'Tonna', zip: '36042' },
//     { city: 'Tönning', zip: '4861' },
//     { city: 'Töpchin', zip: '33769' },
//     { city: 'Töpen', zip: '9295' },
//     { city: 'Töplitz', zip: '33202' },
//     { city: 'Torfhaus', zip: '5320' },
//     { city: 'Torgau', zip: '3421' },
//     { city: 'Torgelow b Ueckermünde', zip: '3976' },
//     { city: 'Törpin', zip: '39996' },
//     { city: 'Tostedt', zip: '4182' },
//     { city: 'Traben-Trarbach', zip: '6541' },
//     { city: 'Traitsching', zip: '9974' },
//     { city: 'Trappstadt', zip: '9765' },
//     { city: 'Traunreut', zip: '8669' },
//     { city: 'Traunstein', zip: '861' },
//     { city: 'Trautskirchen', zip: '9107' },
//     { city: 'Trebatsch', zip: '33674' },
//     { city: 'Trebbin', zip: '33731' },
//     { city: 'Trebel', zip: '5848' },
//     { city: 'Trebnitz b Müncheberg', zip: '33477' },
//     { city: 'Trebsen Mulde', zip: '34383' },
//     { city: 'Trebur', zip: '6147' },
//     { city: 'Treffurt', zip: '36923' },
//     { city: 'Treia', zip: '4626' },
//     { city: 'Treis-Karden', zip: '2672' },
//     { city: 'Trendelburg', zip: '5675' },
//     { city: 'Trent', zip: '38309' },
//     { city: 'Treuchtlingen', zip: '9142' },
//     { city: 'Treuen Vogtl', zip: '37468' },
//     { city: 'Treuenbrietzen', zip: '33748' },
//     { city: 'Triberg im Schwarzwald', zip: '7722' },
//     { city: 'Tribsees', zip: '38320' },
//     { city: 'Triebes', zip: '36622' },
//     { city: 'Triefenstein', zip: '9395' },
//     { city: 'Triepkendorf', zip: '39820' },
//     { city: 'Trier', zip: '651' },
//     { city: 'Triftern', zip: '8562' },
//     { city: 'Trinwillershagen', zip: '38225' },
//     { city: 'Trippstadt', zip: '6306' },
//     { city: 'Triptis', zip: '36482' },
//     { city: 'Trittau', zip: '4154' },
//     { city: 'Trochtelfingen Hohenz', zip: '7124' },
//     { city: 'Trossingen', zip: '7425' },
//     { city: 'Trostberg', zip: '8621' },
//     { city: 'Trulben', zip: '6335' },
//     { city: 'Trusetal', zip: '36840' },
//     { city: 'Tübingen', zip: '7071' },
//     { city: 'Tucheim', zip: '39346' },
//     { city: 'Tuntenhausen', zip: '8067' },
//     { city: 'Tuntenhausen-Schönau', zip: '8065' },
//     { city: 'Türkheim Wertach', zip: '8245' },
//     { city: 'Tussenhausen', zip: '8268' },
//     { city: 'Tüßling', zip: '8633' },
//     { city: 'Tutow', zip: '39999' },
//     { city: 'Tuttlingen', zip: '7461' },
//     { city: 'Tutzing', zip: '8158' },
//     { city: 'Twist', zip: '5936' },
//     { city: 'Twistetal', zip: '5695' },
//     { city: 'Twistringen', zip: '4243' },
//     { city: 'Twistringen-Heiligenloh', zip: '4246' },
//     { city: 'Twist-Schöninghsdorf', zip: '5935' },
//     { city: 'Überherrn', zip: '6836' },
//     { city: 'Überlingen Bodensee', zip: '7551' },
//     { city: 'Übersee', zip: '8642' },
//     { city: 'Uchte', zip: '5763' },
//     { city: 'Üchtelhausen', zip: '9720' },
//     { city: 'Uckro', zip: '35454' },
//     { city: 'Uder', zip: '36083' },
//     { city: 'Üdersdorf', zip: '6596' },
//     { city: 'Ueckermünde', zip: '39771' },
//     { city: 'Uedem', zip: '2825' },
//     { city: 'Uelsen', zip: '5942' },
//     { city: 'Uelzen', zip: '581' },
//     { city: 'Uersfeld', zip: '2657' },
//     { city: 'Uetersen', zip: '4122' },
//     { city: 'Uettingen', zip: '9369' },
//     { city: 'Uetze', zip: '5173' },
//     { city: 'Uetze-Hänigsen', zip: '5147' },
//     { city: 'Uffenheim', zip: '9842' },
//     { city: 'Uffing a Staffelsee', zip: '8846' },
//     { city: 'Uhldingen-Mühlhofen', zip: '7556' },
//     { city: 'Ühlingen-Birkendorf', zip: '7743' },
//     { city: 'Uhlstädt', zip: '36742' },
//     { city: 'Uhyst Spree', zip: '35728' },
//     { city: 'Ulm Donau', zip: '731' },
//     { city: 'Ulmen', zip: '2676' },
//     { city: 'Ulrichstein', zip: '6645' },
//     { city: 'Undeloh', zip: '4189' },
//     { city: 'Unna', zip: '2303' },
//     { city: 'Unna-Hemmerde', zip: '2308' },
//     { city: 'Unseburg', zip: '39263' },
//     { city: 'Unsleben', zip: '9773' },
//     { city: 'Unteregg b Mindelheim', zip: '8269' },
//     { city: 'Unterellen', zip: '36927' },
//     { city: 'Untergriesbach', zip: '8593' },
//     { city: 'Untergröningen', zip: '7975' },
//     { city: 'Unterloquitz', zip: '36731' },
//     { city: 'Unterlüß', zip: '5827' },
//     { city: 'Untermerzbach', zip: '9533' },
//     { city: 'Unterpleichfeld', zip: '9367' },
//     { city: 'Unterreichenbach Kr Calw', zip: '7235' },
//     { city: 'Unterschneidheim', zip: '7966' },
//     { city: 'Untersiemau', zip: '9565' },
//     { city: 'Untersteinbach Unterfr', zip: '9554' },
//     { city: 'Unterthingau', zip: '8377' },
//     { city: 'Uplengen', zip: '4956' },
//     { city: 'Ursensollen', zip: '9628' },
//     { city: 'Urspringen b Lohr', zip: '9396' },
//     { city: 'Usedom', zip: '38372' },
//     { city: 'Usingen', zip: '6081' },
//     { city: 'Uslar', zip: '5571' },
//     { city: 'Uslar-Volpriehausen', zip: '5573' },
//     { city: 'Uthmöden', zip: '39058' },
//     { city: 'Uttenweiler', zip: '7374' },
//     { city: 'Utting a Ammersee', zip: '8806' },
//     { city: 'Vacha', zip: '36962' },
//     { city: 'Vaihingen an der Enz', zip: '7042' },
//     { city: 'Varel Jadebusen', zip: '4451' },
//     { city: 'Varel-Altjührden', zip: '4456' },
//     { city: 'Varrel b Sulingen', zip: '4274' },
//     { city: 'Vaterstetten', zip: '8106' },
//     { city: 'Vechelde', zip: '5302' },
//     { city: 'Vechta', zip: '4441' },
//     { city: 'Vechta-Langförden', zip: '4447' },
//     { city: 'Velbert', zip: '2051' },
//     { city: 'Velbert-Langenberg', zip: '2052' },
//     { city: 'Velbert-Neviges', zip: '2053' },
//     { city: 'Velburg', zip: '9182' },
//     { city: 'Velden Vils', zip: '8742' },
//     { city: 'Velen', zip: '2863' },
//     { city: 'Velgast', zip: '38324' },
//     { city: 'Vellahn', zip: '38848' },
//     { city: 'Velpke', zip: '5364' },
//     { city: 'Velten', zip: '3304' },
//     { city: 'Ventschow', zip: '38484' },
//     { city: 'Verden Aller', zip: '4231' },
//     { city: 'Verden-Walle', zip: '4230' },
//     { city: 'Veringenstadt', zip: '7577' },
//     { city: 'Verl', zip: '5246' },
//     { city: 'Versmold', zip: '5423' },
//     { city: 'Vetschau', zip: '35433' },
//     { city: 'Vettelschoss', zip: '2645' },
//     { city: 'Vettweiss', zip: '2424' },
//     { city: 'Viechtach', zip: '9942' },
//     { city: 'Vienenburg', zip: '5324' },
//     { city: 'Viereck', zip: '39748' },
//     { city: 'Viernheim', zip: '6204' },
//     { city: 'Viersen', zip: '2162' },
//     { city: 'Viesecke', zip: '38796' },
//     { city: 'Vieselbach', zip: '36203' },
//     { city: 'Vilgertshofen', zip: '8194' },
//     { city: 'Villenbach', zip: '8296' },
//     { city: 'Villingen i Schwarzw', zip: '7721' },
//     { city: 'Villmar-Aumenau', zip: '6474' },
//     { city: 'Vilsbiburg', zip: '8741' },
//     { city: 'Vilseck', zip: '9662' },
//     { city: 'Vilsheim', zip: '8706' },
//     { city: 'Vilshofen Niederbay', zip: '8541' },
//     { city: 'Vilshofen-Pleinting', zip: '8549' },
//     { city: 'Vilshofen-Sandbach', zip: '8548' },
//     { city: 'Vinzelberg', zip: '39325' },
//     { city: 'Viöl', zip: '4843' },
//     { city: 'Virneburg', zip: '2656' },
//     { city: 'Visbek Kr Vechta', zip: '4445' },
//     { city: 'Visselhövede', zip: '4262' },
//     { city: 'Visselhövede-Wittorf', zip: '4260' },
//     { city: 'Vlotho', zip: '5733' },
//     { city: 'Vlotho-Exter', zip: '5228' },
//     { city: 'Voerde Niederrhein', zip: '2855' },
//     { city: 'Vogtareuth', zip: '8038' },
//     { city: 'Vogtsburg im Kaiserstuhl', zip: '7662' },
//     { city: 'Vohburg a d Donau', zip: '8457' },
//     { city: 'Vohenstrauss', zip: '9651' },
//     { city: 'Vöhl', zip: '5635' },
//     { city: 'Vöhrenbach', zip: '7727' },
//     { city: 'Vöhringen Iller', zip: '7306' },
//     { city: 'Volkach', zip: '9381' },
//     { city: 'Volkenschwand', zip: '8754' },
//     { city: 'Volkenshagen', zip: '38202' },
//     { city: 'Völklingen', zip: '6898' },
//     { city: 'Völklingen-Lauterbach', zip: '6802' },
//     { city: 'Volkmarsen', zip: '5693' },
//     { city: 'Vollrathsruhe', zip: '39933' },
//     { city: 'Völpke', zip: '39402' },
//     { city: 'Voltlage', zip: '5467' },
//     { city: 'Vorbach', zip: '9205' },
//     { city: 'Vörden Kr Vechta', zip: '5495' },
//     { city: 'Vorderweidenthal', zip: '6398' },
//     { city: 'Vreden', zip: '2564' },
//     { city: 'Waakirchen', zip: '8021' },
//     { city: 'Waal', zip: '8246' },
//     { city: 'Wabern Hess', zip: '5683' },
//     { city: 'Wachtendonk', zip: '2836' },
//     { city: 'Wächtersbach', zip: '6053' },
//     { city: 'Wacken', zip: '4827' },
//     { city: 'Waddeweitz', zip: '5849' },
//     { city: 'Wadern', zip: '6871' },
//     { city: 'Wadern-Nunkirchen', zip: '6874' },
//     { city: 'Wadersloh', zip: '2523' },
//     { city: 'Wadersloh-Diestedde', zip: '2520' },
//     { city: 'Wagenfeld', zip: '5444' },
//     { city: 'Wagenfeld-Ströhen', zip: '5774' },
//     { city: 'Waghäusel', zip: '7254' },
//     { city: 'Waging a See', zip: '8681' },
//     { city: 'Wahlstedt', zip: '4554' },
//     { city: 'Wahrenholz', zip: '5835' },
//     { city: 'Waiblingen', zip: '7151' },
//     { city: 'Waibstadt', zip: '7263' },
//     { city: 'Waidhaus', zip: '9652' },
//     { city: 'Waischenfeld', zip: '9202' },
//     { city: 'Wald Hohenz', zip: '7578' },
//     { city: 'Wald Oberpf', zip: '9463' },
//     { city: 'Waldböckelheim', zip: '6758' },
//     { city: 'Waldbreitbach', zip: '2638' },
//     { city: 'Waldbröl', zip: '2291' },
//     { city: 'Waldbrunn Odenw', zip: '6274' },
//     { city: 'Waldbrunn Westerwald', zip: '6479' },
//     { city: 'Waldburg Württ', zip: '7529' },
//     { city: 'Walddrehna', zip: '35455' },
//     { city: 'Waldeck-Sachsenhausen', zip: '5634' },
//     { city: 'Waldems', zip: '6087' },
//     { city: 'Waldenbuch', zip: '7157' },
//     { city: 'Waldenburg Sachs', zip: '37608' },
//     { city: 'Walderbach', zip: '9464' },
//     { city: 'Waldfeucht', zip: '2455' },
//     { city: 'Waldfischbach-Burgalben', zip: '6333' },
//     { city: 'Waldheim Sachs', zip: '34327' },
//     { city: 'Waldkappel', zip: '5656' },
//     { city: 'Waldkirch Breisgau', zip: '7681' },
//     { city: 'Waldkirchen Niederbay', zip: '8581' },
//     { city: 'Waldkraiburg', zip: '8638' },
//     { city: 'Wald-Michelbach', zip: '6207' },
//     { city: 'Waldmünchen', zip: '9972' },
//     { city: 'Waldmünchen-Geigant', zip: '9975' },
//     { city: 'Waldrach', zip: '6500' },
//     { city: 'Waldsassen', zip: '9632' },
//     { city: 'Waldshut', zip: '7751' },
//     { city: 'Waldsolms', zip: '6085' },
//     { city: 'Waldthurn', zip: '9657' },
//     { city: 'Walkendorf', zip: '39972' },
//     { city: 'Walkenried', zip: '5525' },
//     { city: 'Walldorf Baden', zip: '6227' },
//     { city: 'Walldürn', zip: '6282' },
//     { city: 'Walldürn-Altheim', zip: '6285' },
//     { city: 'Walldürn-Rippberg', zip: '6286' },
//     { city: 'Wallendorf Luppe', zip: '34639' },
//     { city: 'Wallenfels', zip: '9262' },
//     { city: 'Wallenhorst', zip: '5407' },
//     { city: 'Wallerfangen', zip: '6837' },
//     { city: 'Wallerfing', zip: '9936' },
//     { city: 'Wallersdorf', zip: '9933' },
//     { city: 'Wallhalben', zip: '6375' },
//     { city: 'Wallhausen Nahe', zip: '6706' },
//     { city: 'Wallhausen Sachs-Anh', zip: '34656' },
//     { city: 'Wallhausen Württ', zip: '7955' },
//     { city: 'Wallmerod', zip: '6435' },
//     { city: 'Wallstawe', zip: '39033' },
//     { city: 'Walschleben', zip: '36201' },
//     { city: 'Walsleben b Neuruppin', zip: '33920' },
//     { city: 'Walsrode', zip: '5161' },
//     { city: 'Walsrode-Kirchboitzen', zip: '5166' },
//     { city: 'Walsrode-Stellichte', zip: '5168' },
//     { city: 'Walsrode-Westenholz', zip: '5167' },
//     { city: 'Waltenhofen', zip: '8303' },
//     { city: 'Waltenhofen-Oberdorf', zip: '8379' },
//     { city: 'Waltershausen Thür', zip: '3622' },
//     { city: 'Walting Kr Eichstätt', zip: '8426' },
//     { city: 'Waltrop', zip: '2309' },
//     { city: 'Walzbachtal', zip: '7203' },
//     { city: 'Wanderup', zip: '4606' },
//     { city: 'Wandlitz', zip: '33397' },
//     { city: 'Wanfried', zip: '5655' },
//     { city: 'Wangels', zip: '4382' },
//     { city: 'Wangen im Allgäu', zip: '7522' },
//     { city: 'Wangen-Leupolz', zip: '7506' },
//     { city: 'Wangerland', zip: '4463' },
//     { city: 'Wangerland-Hooksiel', zip: '4425' },
//     { city: 'Wangerland-Horumersiel', zip: '4426' },
//     { city: 'Wangerooge', zip: '4469' },
//     { city: 'Wankendorf', zip: '4326' },
//     { city: 'Wanna', zip: '4757' },
//     { city: 'Wanne-Eickel', zip: '2325' },
//     { city: 'Wanzer', zip: '39395' },
//     { city: 'Wanzleben', zip: '39209' },
//     { city: 'Warburg', zip: '5641' },
//     { city: 'Warburg-Scherfede', zip: '5642' },
//     { city: 'Wardenburg', zip: '4407' },
//     { city: 'Waren Müritz', zip: '3991' },
//     { city: 'Warendorf', zip: '2581' },
//     { city: 'Warendorf-Hoetmar', zip: '2585' },
//     { city: 'Warendorf-Milte', zip: '2584' },
//     { city: 'Warin', zip: '38482' },
//     { city: 'Warmensteinach', zip: '9277' },
//     { city: 'Warmsen', zip: '5767' },
//     { city: 'Warstein', zip: '2902' },
//     { city: 'Warstein-Allagen', zip: '2925' },
//     { city: 'Wartenberg Oberbay', zip: '8762' },
//     { city: 'Wartmannsroth', zip: '9737' },
//     { city: 'Wassenberg', zip: '2432' },
//     { city: 'Wasserburg a Inn', zip: '8071' },
//     { city: 'Wasserleben', zip: '39451' },
//     { city: 'Wassertrüdingen', zip: '9832' },
//     { city: 'Wasungen', zip: '36941' },
//     { city: 'Wathlingen', zip: '5144' },
//     { city: 'Waxweiler', zip: '6554' },
//     { city: 'Wechmar', zip: '36256' },
//     { city: 'Wechselburg', zip: '37384' },
//     { city: 'Wedel', zip: '4103' },
//     { city: 'Wedemark', zip: '5130' },
//     { city: 'Weener', zip: '4951' },
//     { city: 'Weesenstein', zip: '35027' },
//     { city: 'Weeze', zip: '2837' },
//     { city: 'Wefensleben', zip: '39400' },
//     { city: 'Weferlingen', zip: '39061' },
//     { city: 'Wegberg', zip: '2434' },
//     { city: 'Wegberg-Rödgen', zip: '2436' },
//     { city: 'Wegeleben', zip: '39423' },
//     { city: 'Wegenstedt', zip: '39059' },
//     { city: 'Wegscheid Niederbay', zip: '8592' },
//     { city: 'Wehr Baden', zip: '7762' },
//     { city: 'Wehretal', zip: '5658' },
//     { city: 'Weibern', zip: '2655' },
//     { city: 'Weibersbrunn', zip: '6094' },
//     { city: 'Weichensdorf', zip: '33673' },
//     { city: 'Weida', zip: '36603' },
//     { city: 'Weiden i d Opf', zip: '961' },
//     { city: 'Weidenbach b Gerolstein', zip: '6599' },
//     { city: 'Weidenbach Mittelfr', zip: '9826' },
//     { city: 'Weidenberg', zip: '9278' },
//     { city: 'Weidenthal Pfalz', zip: '6329' },
//     { city: 'Weierbach', zip: '6784' },
//     { city: 'Weiherhammer', zip: '9605' },
//     { city: 'Weihmichl-Unterneuhausen', zip: '8708' },
//     { city: 'Weikersheim', zip: '7934' },
//     { city: 'Weil Der Stadt', zip: '7033' },
//     { city: 'Weil Kr Landsberg a Lech', zip: '8195' },
//     { city: 'Weilburg', zip: '6471' },
//     { city: 'Weilerbach', zip: '6374' },
//     { city: 'Weiler-Simmerberg', zip: '8387' },
//     { city: 'Weilerswist', zip: '2254' },
//     { city: 'Weilheim an der Teck', zip: '7023' },
//     { city: 'Weilheim i OB', zip: '881' },
//     { city: 'Weilheim Kr Waldshut', zip: '7755' },
//     { city: 'Weilmünster', zip: '6472' },
//     { city: 'Weilmünster-Wolfenhausen', zip: '6475' },
//     { city: 'Weilrod', zip: '6083' },
//     { city: 'Weimar Thür', zip: '3643' },
//     { city: 'Weinböhla', zip: '35243' },
//     { city: 'Weingarten Baden', zip: '7244' },
//     { city: 'Weinheim Bergstr', zip: '6201' },
//     { city: 'Weinsberg', zip: '7134' },
//     { city: 'Weischlitz', zip: '37436' },
//     { city: 'Weiskirchen Saar', zip: '6876' },
//     { city: 'Weismain', zip: '9575' },
//     { city: 'Weissenberg Sachs', zip: '35876' },
//     { city: 'Weißenborn-Lüderode', zip: '36072' },
//     { city: 'Weißenburg i Bay', zip: '9141' },
//     { city: 'Weissenburg-Suffersheim', zip: '9149' },
//     { city: 'Weissenfels Sachs-Anh', zip: '3443' },
//     { city: 'Weissenhorn', zip: '7309' },
//     { city: 'Weissensberg', zip: '8389' },
//     { city: 'Weissensee', zip: '36374' },
//     { city: 'Weissenstadt', zip: '9253' },
//     { city: 'Weissenthurm', zip: '2637' },
//     { city: 'Weisswasser', zip: '3576' },
//     { city: 'Weisweil Breisgau', zip: '7646' },
//     { city: 'Weiterstadt', zip: '6150' },
//     { city: 'Weitnau', zip: '8375' },
//     { city: 'Welden b Augsburg', zip: '8293' },
//     { city: 'Welle Nordheide', zip: '4188' },
//     { city: 'Wellen Mosel', zip: '6584' },
//     { city: 'Wellheim', zip: '8427' },
//     { city: 'Welschbillig', zip: '6506' },
//     { city: 'Welschen Ennest', zip: '2764' },
//     { city: 'Welschneudorf', zip: '2608' },
//     { city: 'Welsleben', zip: '39296' },
//     { city: 'Welver', zip: '2384' },
//     { city: 'Welzheim', zip: '7182' },
//     { city: 'Welzow', zip: '35751' },
//     { city: 'Wemding', zip: '9092' },
//     { city: 'Wendeburg', zip: '5303' },
//     { city: 'Wendelstein', zip: '9129' },
//     { city: 'Wenden Südsauerland', zip: '2762' },
//     { city: 'Wendisch Rietz', zip: '33679' },
//     { city: 'Wendlingen am Neckar', zip: '7024' },
//     { city: 'Wennigsen Deister', zip: '5103' },
//     { city: 'Wensin', zip: '4559' },
//     { city: 'Wenzenbach', zip: '9407' },
//     { city: 'Werbach-Gamburg', zip: '9348' },
//     { city: 'Werbach-Wenkheim', zip: '9349' },
//     { city: 'Werben Elbe', zip: '39393' },
//     { city: 'Werbig b Jüterbog', zip: '33746' },
//     { city: 'Werdau Sachs', zip: '3761' },
//     { city: 'Werder Havel', zip: '3327' },
//     { city: 'Werdohl', zip: '2392' },
//     { city: 'Werl', zip: '2922' },
//     { city: 'Werlte', zip: '5951' },
//     { city: 'Wermelskirchen', zip: '2196' },
//     { city: 'Wermsdorf', zip: '34364' },
//     { city: 'Wernberg-Köblitz', zip: '9604' },
//     { city: 'Werne', zip: '2389' },
//     { city: 'Werneck', zip: '9722' },
//     { city: 'Werneuchen', zip: '33398' },
//     { city: 'Wernigerode', zip: '3943' },
//     { city: 'Wernshausen', zip: '36848' },
//     { city: 'Wershofen', zip: '2694' },
//     { city: 'Wertach*4', zip: '8365' },
//     { city: 'Wertheim', zip: '9342' },
//     { city: 'Wertheim-Dertingen', zip: '9397' },
//     { city: 'Werther Westf', zip: '5203' },
//     { city: 'Wertingen', zip: '8272' },
//     { city: 'Wesel', zip: '281' },
//     { city: 'Wesel-Bislich', zip: '2859' },
//     { city: 'Wesel-Büderich', zip: '2803' },
//     { city: 'Wesenberg Meckl', zip: '39832' },
//     { city: 'Wesendorf Kr Gifhorn', zip: '5376' },
//     { city: 'Weseram', zip: '33831' },
//     { city: 'Wesselburen', zip: '4833' },
//     { city: 'Wesseling Rheinl', zip: '2236' },
//     { city: 'Wessling', zip: '8153' },
//     { city: 'Wessobrunn', zip: '8809' },
//     { city: 'Westendorf b Kaufbeuren', zip: '8344' },
//     { city: 'Westensee', zip: '4305' },
//     { city: 'Westerau', zip: '4539' },
//     { city: 'Westerburg Westerw', zip: '2663' },
//     { city: 'Westerholt Ostfriesl', zip: '4975' },
//     { city: 'Westerhorn', zip: '4127' },
//     { city: 'Westerkappeln', zip: '5404' },
//     { city: 'Westerkappeln-Velpe', zip: '5456' },
//     { city: 'Westerstede', zip: '4488' },
//     { city: 'Westerstede-Ocholt', zip: '4409' },
//     { city: 'Westfehmarn', zip: '4372' },
//     { city: 'Westhofen Rheinhess', zip: '6244' },
//     { city: 'Westoverledingen', zip: '4955' },
//     { city: 'Wetter Hessen', zip: '6423' },
//     { city: 'Wetter Ruhr', zip: '2335' },
//     { city: 'Wettin', zip: '34607' },
//     { city: 'Wettringen Kr Steinfurt', zip: '2557' },
//     { city: 'Wettringen Mittelfr', zip: '9869' },
//     { city: 'Wettrup', zip: '5909' },
//     { city: 'Wetzlar', zip: '6441' },
//     { city: 'Wewelsfleth', zip: '4829' },
//     { city: 'Weyarn', zip: '8020' },
//     { city: 'Weyerbusch', zip: '2686' },
//     { city: 'Weyhe b Bremen', zip: '4203' },
//     { city: 'Wickede Ruhr', zip: '2377' },
//     { city: 'Wieda', zip: '5586' },
//     { city: 'Wiedensahl', zip: '5726' },
//     { city: 'Wiefelstede-Spohle', zip: '4458' },
//     { city: 'Wiehl', zip: '2262' },
//     { city: 'Wienhausen', zip: '5149' },
//     { city: 'Wieren', zip: '5825' },
//     { city: 'Wiesau', zip: '9634' },
//     { city: 'Wiesbaden', zip: '611' },
//     { city: 'Wiesen Unterfr', zip: '6096' },
//     { city: 'Wiesenburg Mark', zip: '33849' },
//     { city: 'Wiesenfelden', zip: '9966' },
//     { city: 'Wiesensteig', zip: '7335' },
//     { city: 'Wiesentheid', zip: '9383' },
//     { city: 'Wiesenttal', zip: '9196' },
//     { city: 'Wiesloch', zip: '6222' },
//     { city: 'Wiesmoor', zip: '4944' },
//     { city: 'Wiesmoor-Marcardsmoor', zip: '4948' },
//     { city: 'Wietmarschen', zip: '5925' },
//     { city: 'Wietmarschen-Lohne', zip: '5908' },
//     { city: 'Wietze', zip: '5146' },
//     { city: 'Wietzen', zip: '5022' },
//     { city: 'Wietzendorf', zip: '5196' },
//     { city: 'Wiggensbach', zip: '8370' },
//     { city: 'Wilburgstetten', zip: '9853' },
//     { city: 'Wildberg b Altentreptow', zip: '39604' },
//     { city: 'Wildberg Brandenb', zip: '33928' },
//     { city: 'Wildberg Württ', zip: '7054' },
//     { city: 'Wildbergerhütte', zip: '2297' },
//     { city: 'Wildeck-Hönebach', zip: '6678' },
//     { city: 'Wildeck-Obersuhl', zip: '6626' },
//     { city: 'Wildenfels', zip: '37603' },
//     { city: 'Wildeshausen', zip: '4431' },
//     { city: 'Wildflecken', zip: '9745' },
//     { city: 'Wildpoldsried', zip: '8304' },
//     { city: 'Wilhelmsdorf Württ', zip: '7503' },
//     { city: 'Wilhelmsfeld', zip: '6220' },
//     { city: 'Wilhelmshaven', zip: '4421' },
//     { city: 'Wilhelmsthal Oberfr', zip: '9260' },
//     { city: 'Wilhermsdorf', zip: '9102' },
//     { city: 'Willebadessen', zip: '5646' },
//     { city: 'Willebadessen-Peckelsheim', zip: '5644' },
//     { city: 'Willich', zip: '2154' },
//     { city: 'Willich-Anrath', zip: '2156' },
//     { city: 'Willingen Upland', zip: '5632' },
//     { city: 'Willingshausen', zip: '6697' },
//     { city: 'Willstätt', zip: '7852' },
//     { city: 'Wilnsdorf', zip: '2739' },
//     { city: 'Wilsdruff', zip: '35204' },
//     { city: 'Wilster', zip: '4823' },
//     { city: 'Wilsum', zip: '5945' },
//     { city: 'Windbergen', zip: '4859' },
//     { city: 'Windeck Sieg', zip: '2292' },
//     { city: 'Windesheim', zip: '6707' },
//     { city: 'Windischeschenbach', zip: '9681' },
//     { city: 'Windorf-Otterskirchen', zip: '8546' },
//     { city: 'Windsbach', zip: '9871' },
//     { city: 'Wingst', zip: '4778' },
//     { city: 'Winklarn', zip: '9676' },
//     { city: 'Winnenden', zip: '7195' },
//     { city: 'Winningen Mosel', zip: '2606' },
//     { city: 'Winningen Sachs-Anh', zip: '34745' },
//     { city: 'Winnweiler', zip: '6302' },
//     { city: 'Winsen Aller', zip: '5143' },
//     { city: 'Winsen Luhe', zip: '4171' },
//     { city: 'Winsen-Meissendorf', zip: '5056' },
//     { city: 'Winsen-Tönnhausen', zip: '4179' },
//     { city: 'Winterbach Soonwald', zip: '6756' },
//     { city: 'Winterberg Westf', zip: '2981' },
//     { city: 'Winterberg-Niedersfeld', zip: '2985' },
//     { city: 'Winterberg-Siedlinghausen', zip: '2983' },
//     { city: 'Winterlingen', zip: '7434' },
//     { city: 'Wipperfürth', zip: '2267' },
//     { city: 'Wippra', zip: '34775' },
//     { city: 'Wirdum', zip: '4920' },
//     { city: 'Wischhafen', zip: '4770' },
//     { city: 'Wismar Meckl', zip: '3841' },
//     { city: 'Wissen', zip: '2742' },
//     { city: 'Wittelshofen', zip: '9854' },
//     { city: 'Witten', zip: '2302' },
//     { city: 'Wittenberge', zip: '3877' },
//     { city: 'Wittenburg', zip: '38852' },
//     { city: 'Wittgensdorf b Chemnitz', zip: '37200' },
//     { city: 'Wittibreut', zip: '8574' },
//     { city: 'Wittichenau', zip: '35725' },
//     { city: 'Wittighausen', zip: '9347' },
//     { city: 'Wittingen', zip: '5831' },
//     { city: 'Wittingen-Knesebeck', zip: '5834' },
//     { city: 'Wittingen-Ohrdorf', zip: '5839' },
//     { city: 'Wittingen-Radenbeck', zip: '5836' },
//     { city: 'Wittislingen', zip: '9076' },
//     { city: 'Wittlich', zip: '6571' },
//     { city: 'Wittmannsdorf-Bückchen', zip: '35476' },
//     { city: 'Wittmund', zip: '4462' },
//     { city: 'Wittmund-Ardorf', zip: '4466' },
//     { city: 'Wittmund-Burhafe', zip: '4973' },
//     { city: 'Wittmund-Carolinensiel', zip: '4464' },
//     { city: 'Wittmund-Funnix', zip: '4467' },
//     { city: 'Wittorf Kr Lünebeburg', zip: '4133' },
//     { city: 'Wittstock Dosse', zip: '3394' },
//     { city: 'Witzenhausen', zip: '5542' },
//     { city: 'Witzin', zip: '38481' },
//     { city: 'Wöbbelin', zip: '38753' },
//     { city: 'Wöhrden Dithm', zip: '4839' },
//     { city: 'Wokuhl', zip: '39825' },
//     { city: 'Woldegk', zip: '3963' },
//     { city: 'Wolfach', zip: '7834' },
//     { city: 'Wolfegg', zip: '7527' },
//     { city: 'Wolfen', zip: '3494' },
//     { city: 'Wolfenbüttel', zip: '5331' },
//     { city: 'Wölfersheim', zip: '6036' },
//     { city: 'Wolfhagen', zip: '5692' },
//     { city: 'Wolframs-Eschenbach', zip: '9875' },
//     { city: 'Wolfratshausen', zip: '8171' },
//     { city: 'Wolfsburg', zip: '5361' },
//     { city: 'Wolfsburg-Fallersleben', zip: '5362' },
//     { city: 'Wolfsburg-Neindorf', zip: '5365' },
//     { city: 'Wolfsburg-Vorsfelde', zip: '5363' },
//     { city: 'Wolfshagen b Perleberg', zip: '38789' },
//     { city: 'Wolfstein Pfalz', zip: '6304' },
//     { city: 'Wolgast', zip: '3836' },
//     { city: 'Wolkenburg Mulde', zip: '37609' },
//     { city: 'Wolkenstein', zip: '37369' },
//     { city: 'Wolkramshausen', zip: '36334' },
//     { city: 'Wollin b Brandenburg', zip: '33833' },
//     { city: 'Wöllstadt', zip: '6034' },
//     { city: 'Wöllstein Rheinhess', zip: '6703' },
//     { city: 'Wolmirstedt', zip: '39201' },
//     { city: 'Wolnzach', zip: '8442' },
//     { city: 'Wolpertswende', zip: '7502' },
//     { city: 'Wolsfeld', zip: '6568' },
//     { city: 'Wölsickendorf/Wollenberg', zip: '33454' },
//     { city: 'Wolterdingen Schwarzw', zip: '7705' },
//     { city: 'Worbis', zip: '36074' },
//     { city: 'Wörlitz', zip: '34905' },
//     { city: 'Worms', zip: '6241' },
//     { city: 'Worms-Pfeddersheim', zip: '6247' },
//     { city: 'Wormstedt', zip: '36464' },
//     { city: 'Worpswede', zip: '4792' },
//     { city: 'Worpswede-Ostersode', zip: '4794' },
//     { city: 'Wörrstadt', zip: '6732' },
//     { city: 'Wörth a d Donau', zip: '9482' },
//     { city: 'Wörth a d Isar', zip: '8702' },
//     { city: 'Wörth am Rhein', zip: '7271' },
//     { city: 'Wörth-Büchelberg', zip: '7277' },
//     { city: 'Wörth-Schaidt', zip: '6340' },
//     { city: 'Wredenhagen', zip: '39925' },
//     { city: 'Wremen', zip: '4705' },
//     { city: 'Wrestedt', zip: '5802' },
//     { city: 'Wriedel', zip: '5829' },
//     { city: 'Wriezen', zip: '33456' },
//     { city: 'Wrohm', zip: '4802' },
//     { city: 'Wulfen Sachs-Anh', zip: '34979' },
//     { city: 'Wulfersdorf b Wittstock', zip: '33963' },
//     { city: 'Wülfershausen Unterfr', zip: '9728' },
//     { city: 'Wülfrath', zip: '2058' },
//     { city: 'Wulfsen', zip: '4173' },
//     { city: 'Wünnenberg', zip: '2953' },
//     { city: 'Wünnenberg-Haaren', zip: '2957' },
//     { city: 'Wünsdorf', zip: '33702' },
//     { city: 'Wunsiedel', zip: '9232' },
//     { city: 'Wunstorf', zip: '5031' },
//     { city: 'Wunstorf-Grossenheidorn', zip: '5033' },
//     { city: 'Wuppertal', zip: '202' },
//     { city: 'Wurmannsquick', zip: '8725' },
//     { city: 'Würselen', zip: '2405' },
//     { city: 'Wurzbach', zip: '36652' },
//     { city: 'Würzburg', zip: '931' },
//     { city: 'Wurzen', zip: '3425' },
//     { city: 'Wüstenrot', zip: '7945' },
//     { city: 'Wusterhausen Dosse', zip: '33979' },
//     { city: 'Wusterhusen', zip: '38354' },
//     { city: 'Wustermark', zip: '33234' },
//     { city: 'Wusterwitz', zip: '33839' },
//     { city: 'Wüstheuterode', zip: '36087' },
//     { city: 'Wustrau-Altfriesack', zip: '33925' },
//     { city: 'Wustrow Kr Mecklenburg-Strelitz', zip: '39828' },
//     { city: 'Wustrow Ostseebad', zip: '38220' },
//     { city: 'Wustrow Wendland', zip: '5843' },
//     { city: 'Wutach', zip: '7709' },
//     { city: 'Wutha-Farnroda', zip: '36921' },
//     { city: 'Wutike', zip: '33976' },
//     { city: 'Wutöschingen', zip: '7746' },
//     { city: 'Wyk auf Föhr', zip: '4681' },
//     { city: 'Wymeer', zip: '4903' },
//     { city: 'Xanten', zip: '2801' },
//     { city: 'Xanten-Marienbaum', zip: '2804' },
//     { city: 'Zaberfeld', zip: '7046' },
//     { city: 'Zahna', zip: '34924' },
//     { city: 'Zapfendorf', zip: '9547' },
//     { city: 'Zarrentin Meckl', zip: '38851' },
//     { city: 'Zechin', zip: '33473' },
//     { city: 'Zechlinerhütte', zip: '33921' },
//     { city: 'Zehdenick', zip: '3307' },
//     { city: 'Zehlendorf Kr Oberhavel', zip: '33053' },
//     { city: 'Zehna', zip: '38458' },
//     { city: 'Zehren Sachs', zip: '35247' },
//     { city: 'Zeil a Main', zip: '9524' },
//     { city: 'Zeitlofs', zip: '9746' },
//     { city: 'Zeitlofs-Detter', zip: '9744' },
//     { city: 'Zeitz', zip: '3441' },
//     { city: 'Zell am Harmersbach', zip: '7835' },
//     { city: 'Zell im Wiesental', zip: '7625' },
//     { city: 'Zell Oberfr', zip: '9257' },
//     { city: 'Zell Oberpf', zip: '9468' },
//     { city: 'Zella-Mehlis', zip: '3682' },
//     { city: 'Zellingen', zip: '9364' },
//     { city: 'Zeltingen-Rachtig', zip: '6532' },
//     { city: 'Zemmer', zip: '6580' },
//     { city: 'Zenting', zip: '9907' },
//     { city: 'Zerbst', zip: '3923' },
//     { city: 'Zerf', zip: '6587' },
//     { city: 'Zernien', zip: '5863' },
//     { city: 'Zernitz b Neustadt Dosse', zip: '33973' },
//     { city: 'Zerpenschleuse', zip: '33395' },
//     { city: 'Zerrenthin', zip: '39743' },
//     { city: 'Zetel', zip: '4453' },
//     { city: 'Zetel-Neuenburg', zip: '4452' },
//     { city: 'Zeulenroda', zip: '36628' },
//     { city: 'Zeuthen', zip: '33762' },
//     { city: 'Zeven', zip: '4281' },
//     { city: 'Zichtau', zip: '39085' },
//     { city: 'Ziegendorf', zip: '38721' },
//     { city: 'Ziegenhain Sachs', zip: '35246' },
//     { city: 'Ziegenrück', zip: '36483' },
//     { city: 'Ziemetshausen', zip: '8284' },
//     { city: 'Zierenberg', zip: '5606' },
//     { city: 'Zierzow b Ludwigslust', zip: '38752' },
//     { city: 'Ziesar', zip: '33830' },
//     { city: 'Ziltendorf', zip: '33653' },
//     { city: 'Zingst Ostseebad', zip: '38232' },
//     { city: 'Zinnitz', zip: '35439' },
//     { city: 'Zinnowitz', zip: '38377' },
//     { city: 'Zirchow', zip: '38376' },
//     { city: 'Zittau', zip: '3583' },
//     { city: 'Zöblitz', zip: '37363' },
//     { city: 'Zodel', zip: '35820' },
//     { city: 'Zollchow b Rathenow', zip: '33870' },
//     { city: 'Zolling', zip: '8167' },
//     { city: 'Zörbig', zip: '34956' },
//     { city: 'Zöschen', zip: '34638' },
//     { city: 'Zossen Brandenb', zip: '3377' },
//     { city: 'Zschopau', zip: '3725' },
//     { city: 'Zuchau', zip: '39295' },
//     { city: 'Zülpich', zip: '2252' },
//     { city: 'Züsedom', zip: '39747' },
//     { city: 'Zusmarshausen', zip: '8291' },
//     { city: 'Züssow', zip: '38355' },
//     { city: 'Zweibrücken', zip: '6332' },
//     { city: 'Zwenkau', zip: '34203' },
//     { city: 'Zwickau', zip: '375' },
//     { city: 'Zwiedorf', zip: '39600' },
//     { city: 'Zwiefalten', zip: '7373' },
//     { city: 'Zwiesel', zip: '9922' },
//     { city: 'Zwochau', zip: '34207' },
//     { city: 'Zwönitz', zip: '37754' }

// ];
const citiesAndZips = [
    { city: 'Bedburg-Hau', zip: '47551'},
    { city: 'Alsdorf', zip: '52477'},
    { city: 'Roetgen', zip: '52159'},
    { city: 'Monschau', zip: '52156'},
    { city: 'Simmerath', zip: '52152'},
    { city: 'Niederzier', zip: '52382'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Neukirchen-Vluyn', zip: '47506'},
    { city: 'Dudeldorf', zip: '54647'},
    { city: 'Pluwig', zip: '54316'},
    { city: 'Duisburg', zip: '47139'},
    { city: 'Pulheim', zip: '50259'},
    { city: 'Düsseldorf', zip: '40468'},
    { city: 'Mehren u.a.', zip: '54552'},
    { city: 'Düsseldorf', zip: '40470'},
    { city: 'Düsseldorf', zip: '40599'},
    { city: 'Gusenburg', zip: '54413'},
    { city: 'Mülheim an der Ruhr', zip: '45475'},
    { city: 'Köln', zip: '50739'},
    { city: 'Tholey', zip: '66636'},
    { city: 'Saarbrücken', zip: '66117'},
    { city: 'Köln', zip: '50968'},
    { city: 'Gevenich', zip: '56825'},
    { city: 'Bonn', zip: '53125'},
    { city: 'Brücken, Oberbrombach u.a.', zip: '55767'},
    { city: 'Rosendahl', zip: '48720'},
    { city: 'Titisee-Neustadt', zip: '79822'},
    { city: 'Driedorf', zip: '35759'},
    { city: 'Rastatt', zip: '76437'},
    { city: 'Bissendorf', zip: '49143'},
    { city: 'Oldenburg', zip: '26122'},
    { city: 'Baden-Baden', zip: '76532'},
    { city: 'Küssaberg', zip: '79790'},
    { city: 'Mainz-Kastel', zip: '55252'},
    { city: 'Rheinzabern', zip: '76764'},
    { city: 'Dillenburg', zip: '35684'},
    { city: 'Karlsruhe', zip: '76189'},
    { city: 'Alsheim', zip: '67577'},
    { city: 'Stadland', zip: '26936'},
    { city: 'Schwegenheim', zip: '67365'},
    { city: 'Lippstadt', zip: '59557'},
    { city: 'Dötlingen', zip: '27801'},
    { city: 'Rüthen', zip: '59602'},
    { city: 'Limburgerhof', zip: '67117'},
    { city: 'Steimel', zip: '57614'},
    { city: 'Dürrholz', zip: '56307'},
    { city: 'Kindsbach', zip: '66862'},
    { city: 'Waldböckelheim', zip: '55596'},
    { city: 'Eitelborn', zip: '56337'},
    { city: 'Hirschhorn', zip: '67732'},
    { city: 'Bornich, Patersberg', zip: '56348'},
    { city: 'Nußbach', zip: '67759'},
    { city: 'Malsburg-Marzell', zip: '79429'},
    { city: 'Kaub', zip: '56349'},
    { city: 'Otterberg', zip: '67697'},
    { city: 'Mettingen', zip: '49497'},
    { city: 'Bad Ems Umland', zip: '56132'},
    { city: 'Lorch', zip: '65391'},
    { city: 'Hachenburg', zip: '57627'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Lienen', zip: '49536'},
    { city: 'Steinbach, Weitersweiler, Bennhausen, Mörsfeld, Würzweiler, Ruppertsecken u.a.', zip: '67808'},
    { city: 'Waldleiningen, Fischbach', zip: '67693'},
    { city: 'Münchweiler an der Alsenz', zip: '67728'},
    { city: 'Ense', zip: '59469'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Diez, Hambach, Aull', zip: '65582'},
    { city: 'Birlenbach', zip: '65626'},
    { city: 'Frankenstein, Neidenfels, Frankeneck', zip: '67468'},
    { city: 'Wallertheim', zip: '55578'},
    { city: 'Möhnesee', zip: '59519'},
    { city: 'Arnsberg', zip: '59823'},
    { city: 'Wilnsdorf', zip: '57234'},
    { city: 'Albisheim (Pfrimm)', zip: '67308'},
    { city: 'Nordrach', zip: '77787'},
    { city: 'Wachenheim an der Weinstraße', zip: '67157'},
    { city: 'Surwold', zip: '26903'},
    { city: 'Langeoog', zip: '26465'},
    { city: 'Bottenbach', zip: '66504'},
    { city: 'Waldesch, Hünenfeld', zip: '56323'},
    { city: 'Lüdenscheid', zip: '58515'},
    { city: 'Münster', zip: '48159'},
    { city: 'Mendig', zip: '56743'},
    { city: 'Berglangenbach, Ruschberg u.a.', zip: '55776'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Polch', zip: '56751'},
    { city: 'Osterrönfeld', zip: '24783'},
    { city: 'Eislingen/Fils', zip: '73054'},
    { city: 'Ottenbach', zip: '73113'},
    { city: 'Schenklengsfeld', zip: '36277'},
    { city: 'Laupheim', zip: '88471'},
    { city: 'Bovenden', zip: '37120'},
    { city: 'Hannover', zip: '30629'},
    { city: 'Wietzendorf', zip: '29649'},
    { city: 'Argenbühl', zip: '88260'},
    { city: 'Hildesheim', zip: '31137'},
    { city: 'Arnis, Marienhof', zip: '24399'},
    { city: 'Bartholomä', zip: '73566'},
    { city: 'Göttingen', zip: '37075'},
    { city: 'Sandberg', zip: '97657'},
    { city: 'Hamburg', zip: '20359'},
    { city: 'Aalen', zip: '73434'},
    { city: 'Nordheim v.d. Rhön', zip: '97647'},
    { city: 'Wahlstedt', zip: '23812'},
    { city: 'Kiel', zip: '24113'},
    { city: 'Aalen', zip: '73433'},
    { city: 'Waigolshausen', zip: '97534'},
    { city: 'Hamburg', zip: '22159'},
    { city: 'Heidenheim an der Brenz', zip: '89520'},
    { city: 'Marksuhl, Krauthausen u.a.', zip: '99819'},
    { city: 'Niederstotzingen', zip: '89168'},
    { city: 'Marksuhl, Krauthausen u.a.', zip: '99819'},
    { city: 'Hattorf', zip: '37197'},
    { city: 'Trunkelsberg', zip: '87779'},
    { city: 'Holzgünz', zip: '87752'},
    { city: 'Sontheim an der Brenz', zip: '89567'},
    { city: 'Syrgenstein', zip: '89428'},
    { city: 'Schmalensee', zip: '24638'},
    { city: 'Walldorf', zip: '98639'},
    { city: 'Goslar', zip: '38644'},
    { city: 'Kammeltal', zip: '89358'},
    { city: 'Selent', zip: '24238'},
    { city: 'Amerdingen', zip: '86735'},
    { city: 'Geiselwind', zip: '96160'},
    { city: 'Röfingen', zip: '89365'},
    { city: 'Trittau', zip: '22946'},
    { city: 'Apfeltrach', zip: '87742'},
    { city: 'Dietersheim', zip: '91463'},
    { city: 'Braunschweig', zip: '38114'},
    { city: 'Ludwigshafen am Rhein', zip: '67061'},
    { city: 'Preußisch Oldendorf', zip: '32361'},
    { city: 'Salzkotten', zip: '33154'},
    { city: 'Wetzlar', zip: '35585'},
    { city: 'Einhausen', zip: '64683'},
    { city: 'Bösingen', zip: '78662'},
    { city: 'Remchingen', zip: '75196'},
    { city: 'Walzbachtal', zip: '75045'},
    { city: 'Hövelhof', zip: '33161'},
    { city: 'Weinheim', zip: '69469'},
    { city: 'Bremen', zip: '28719'},
    { city: 'Beverstedt', zip: '27616'},
    { city: 'Frankfurt am Main', zip: '60594'},
    { city: 'Bad Vilbel', zip: '61118'},
    { city: 'Bad Lippspringe', zip: '33175'},
    { city: 'Wöllstadt', zip: '61206'},
    { city: 'Bahrenborstel, Barenburg, Kirchdorf', zip: '27245'},
    { city: 'Heusenstamm', zip: '63150'},
    { city: 'Minden', zip: '32429'},
    { city: 'Bad Oeynhausen', zip: '32547'},
    { city: 'Brensbach', zip: '64395'},
    { city: 'Otzberg', zip: '64853'},
    { city: 'Steyerberg', zip: '31595'},
    { city: 'Sindelfingen', zip: '71069'},
    { city: 'Lunden', zip: '25774'},
    { city: 'Magstadt', zip: '71106'},
    { city: 'Bremen', zip: '28325'},
    { city: 'Neuhaus (Oste)', zip: '21785'},
    { city: 'Tarmstedt, Breddorf u.a.', zip: '27412'},
    { city: 'Oberriexingen', zip: '71739'},
    { city: 'Massenbachhausen', zip: '74252'},
    { city: 'Neustadt', zip: '35279'},
    { city: 'Schotten', zip: '63679'},
    { city: 'Mildstedt', zip: '25866'},
    { city: 'Wiedensahl', zip: '31719'},
    { city: 'Nordhastedt', zip: '25785'},
    { city: 'Kornwestheim', zip: '70806'},
    { city: 'Hösbach', zip: '63768'},
    { city: 'Ludwigsburg', zip: '71640'},
    { city: 'Walldürn', zip: '74731'},
    { city: 'Waldaschaff, Waldaschaffer Forst', zip: '63857'},
    { city: 'Waiblingen', zip: '71332'},
    { city: 'Pohle, Lauenau, Messenkamp, Hülsede etc', zip: '31867'},
    { city: 'Hardheim', zip: '74736'},
    { city: 'Kirchheim unter Teck', zip: '73230'},
    { city: 'Markt Erlbach', zip: '91459'},
    { city: 'Rügland', zip: '91622'},
    { city: 'Cremlingen', zip: '38162'},
    { city: 'Remlingen', zip: '38319'},
    { city: 'Lehre', zip: '38165'},
    { city: 'Bad Bodenteich', zip: '29389'},
    { city: 'Ornbau', zip: '91737'},
    { city: 'Lichtenau', zip: '91586'},
    { city: 'Huisheim', zip: '86685'},
    { city: 'Stettfeld', zip: '96188'},
    { city: 'Biberbach', zip: '86485'},
    { city: 'Großfahner, Dachwig u.a.', zip: '99100'},
    { city: 'Fuchstal', zip: '86925'},
    { city: 'Untermerzbach', zip: '96190'},
    { city: 'Oberottmarshausen', zip: '86507'},
    { city: 'Augsburg', zip: '86179'},
    { city: 'Heroldsbach', zip: '91336'},
    { city: 'Ballenstedt, Harzgerode', zip: '06493'},
    { city: 'Nürnberg', zip: '90441'},
    { city: 'Dannewerk', zip: '24867'},
    { city: 'Reichenbach an der Fils', zip: '73262'},
    { city: 'Bad Salzschlirf', zip: '36364'},
    { city: 'Körle', zip: '34327'},
    { city: 'Todenbüttel', zip: '24819'},
    { city: 'Aichelberg', zip: '73101'},
    { city: 'Halvesbostel', zip: '21646'},
    { city: 'Bad Boll', zip: '73087'},
    { city: 'Spangenberg', zip: '34286'},
    { city: 'Gruibingen', zip: '73344'},
    { city: 'Steinfeld', zip: '97854'},
    { city: 'Elmshorn', zip: '25336'},
    { city: 'Assamstadt', zip: '97959'},
    { city: 'Berg b.Neumarkt i.d.OPf.', zip: '92348'},
    { city: 'Schwerin', zip: '19053'},
    { city: 'Glashütten', zip: '95496'},
    { city: 'Manching', zip: '85077'},
    { city: 'Oberschleißheim', zip: '85764'},
    { city: 'München', zip: '80634'},
    { city: 'Paunzhausen', zip: '85307'},
    { city: 'Allershausen', zip: '85391'},
    { city: 'Eching', zip: '85386'},
    { city: 'München', zip: '80538'},
    { city: 'Magdeburg', zip: '39112'},
    { city: 'Karsdorf', zip: '06638'},
    { city: 'Helmbrechts', zip: '95233'},
    { city: 'Neubiberg', zip: '85579'},
    { city: 'Kirchdorf a.d. Amper', zip: '85414'},
    { city: 'Sulzbach-Rosenberg', zip: '92237'},
    { city: 'Gmund a. Tegernsee', zip: '83703'},
    { city: 'Salzatal', zip: '06198'},
    { city: 'Fichtelberg', zip: '95686'},
    { city: 'Attenhofen', zip: '84091'},
    { city: 'Irschenberg', zip: '83737'},
    { city: 'Moosburg a.d. Isar', zip: '85368'},
    { city: 'Rieden', zip: '92286'},
    { city: 'Kirschkau, Pausa-Mühltroff', zip: '07919'},
    { city: 'Tangermünde', zip: '39590'},
    { city: 'Sinzing', zip: '93161'},
    { city: 'Schkopau', zip: '06258'},
    { city: 'Bad Feilnbach', zip: '83075'},
    { city: 'Forstern', zip: '85659'},
    { city: 'Hohenthann', zip: '84098'},
    { city: 'Maitenbeth', zip: '83558'},
    { city: 'Gumtow, Kyritz u.a.', zip: '16866'},
    { city: 'Haag i. OB', zip: '83527'},
    { city: 'Milower Land, Schollene, Nennhausen u.a.', zip: '14715'},
    { city: 'Nußdorf a. Inn', zip: '83131'},
    { city: 'Zeitlarn', zip: '93197'},
    { city: 'Dessau-Roßlau', zip: '06842'},
    { city: 'Rhinow', zip: '14728'},
    { city: 'Gräfenhainichen', zip: '06772'},
    { city: 'Gößnitz', zip: '04639'},
    { city: 'Leipzig', zip: '04275'},
    { city: 'Lichtentanne', zip: '08115'},
    { city: 'Leipzig', zip: '04347'},
    { city: 'Leipzig', zip: '04299'},
    { city: 'Crinitzberg', zip: '08147'},
    { city: 'Lehnin', zip: '14797'},
    { city: 'Weiding', zip: '92557'},
    { city: 'Feichten a.d. Alz', zip: '84550'},
    { city: 'Lauter-Bernsbach', zip: '08315'},
    { city: 'Chemnitz', zip: '09224'},
    { city: 'Fridolfing', zip: '83413'},
    { city: 'Blaibach', zip: '93476'},
    { city: 'Plattling', zip: '94447'},
    { city: 'Oberwiesenthal', zip: '09484'},
    { city: 'Osterhofen', zip: '94486'},
    { city: 'Demmin', zip: '17109'},
    { city: 'Rakow', zip: '18516'},
    { city: 'Aldersbach', zip: '94501'},
    { city: 'Potsdam', zip: '14482'},
    { city: 'Lalling', zip: '94551'},
    { city: 'Bayerbach', zip: '94137'},
    { city: 'Pockau-Lengefeld (Lengefeld)', zip: '09514'},
    { city: 'Garz/ Rügen', zip: '18574'},
    { city: 'Gingst', zip: '18569'},
    { city: 'Brand-Erbisdorf, Großhartmannsdorf', zip: '09618'},
    { city: 'Thurmansbang', zip: '94169'},
    { city: 'Neubrandenburg', zip: '17036'},
    { city: 'Berlin Wilmersdorf', zip: '10713'},
    { city: 'Berlin Charlottenburg', zip: '10625'},
    { city: 'Berlin Lankwitz', zip: '12247'},
    { city: 'Weißenborn, Oberschöna', zip: '09600'},
    { city: 'Grafenau', zip: '94481'},
    { city: 'Erfurt', zip: '99099'},
    { city: 'Eurasburg', zip: '86495'},
    { city: 'Nürnberg', zip: '90461'},
    { city: 'Nürnberg', zip: '90489'},
    { city: 'Murnau a. Staffelsee', zip: '82418'},
    { city: 'Rohrenfels', zip: '86701'},
    { city: 'Pampow', zip: '19075'},
    { city: 'Hiltpoltstein', zip: '91355'},
    { city: 'Kasendorf', zip: '95359'},
    { city: 'Roßleben-Wiehe, Gehofen', zip: '06571'},
    { city: 'Germering', zip: '82110'},
    { city: 'Prezelle', zip: '29491'},
    { city: 'Ottensoos', zip: '91242'},
    { city: 'Hettstedt, Endorf', zip: '06333'},
    { city: 'Stolpen, Dürrröhrsdorf-Dittersbach', zip: '01833'},
    { city: 'Biesendahlshof, Berkholz-Meyenburg', zip: '16306'},
    { city: 'Burkau', zip: '01906'},
    { city: 'Weißenberg, Hochkirch u.a.', zip: '02627'},
    { city: 'Treplin, Jacobsdorf, Frankfurt (Oder)', zip: '15236'},
    { city: 'Forst/ Lausitz', zip: '03149'},
    { city: 'Ebersbach-Neugersdorf', zip: '02727'},
    { city: 'Salzweg', zip: '94121'},
    { city: 'Hohenau', zip: '94545'},
    { city: 'Finsterwalde', zip: '03238'},
    { city: 'Moritzburg', zip: '01468'},
    { city: 'Anklam', zip: '17389'},
    { city: 'Ruhland', zip: '01945'},
    { city: 'Karlshagen', zip: '17449'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Bawinkel', zip: '49844'},
    { city: 'Andervenne, Beesten, Freren, Messingen, Thuine', zip: '49832'},
    { city: 'Holm', zip: '25488'},
    { city: 'Elmshorn', zip: '25337'},
    { city: 'Kosel, Rieseby u.a.', zip: '24354'},
    { city: 'Merklingen', zip: '89188'},
    { city: 'Wartmannsroth', zip: '97797'},
    { city: 'Schemmerhofen', zip: '88433'},
    { city: 'Osterby', zip: '24367'},
    { city: 'Rosdorf', zip: '37124'},
    { city: 'Waldbüttelbrunn', zip: '97297'},
    { city: 'Brokstedt', zip: '24616'},
    { city: 'Gelting', zip: '24395'},
    { city: 'Obersontheim', zip: '74423'},
    { city: 'Hamburg', zip: '22549'},
    { city: 'Hamburg', zip: '21079'},
    { city: 'Würzburg', zip: '97072'},
    { city: 'Elfershausen', zip: '97725'},
    { city: 'Freden (Leine)', zip: '31084'},
    { city: 'Neumünster', zip: '24539'},
    { city: 'Gerbrunn', zip: '97218'},
    { city: 'Neu-Ulm', zip: '89233'},
    { city: 'Werneck', zip: '97440'},
    { city: 'Groß Kummerfeld', zip: '24626'},
    { city: 'Tangstedt', zip: '22889'},
    { city: 'Dänischenhagen', zip: '24229'},
    { city: 'Kaltennordheim', zip: '36452'},
    { city: 'Wulfsen', zip: '21445'},
    { city: 'Kiel', zip: '24159'},
    { city: 'Bargfeld-Stegen', zip: '23863'},
    { city: 'Garstedt', zip: '21441'},
    { city: 'Wienhausen', zip: '29342'},
    { city: 'Heimertingen', zip: '87751'},
    { city: 'Ahrensburg', zip: '22926'},
    { city: 'Grafenrheinfeld', zip: '97506'},
    { city: 'Burgdorf', zip: '38272'},
    { city: 'Rödelsee', zip: '97348'},
    { city: 'Wittenborn', zip: '23829'},
    { city: 'Oberstreu', zip: '97640'},
    { city: 'Winsen', zip: '21423'},
    { city: 'Kempten (Allgäu)', zip: '87439'},
    { city: 'Zöschingen', zip: '89447'},
    { city: 'Reppenstedt, Lüneburg', zip: '21391'},
    { city: 'Hoisdorf', zip: '22961'},
    { city: 'Lasbek', zip: '23847'},
    { city: 'Breitenbrunn', zip: '87739'},
    { city: 'Mühlhausen, Unstruttal', zip: '99974'},
    { city: 'Herrieden', zip: '91567'},
    { city: 'Scheinfeld', zip: '91443'},
    { city: 'Linau', zip: '22959'},
    { city: 'Eggenthal', zip: '87653'},
    { city: 'Biebesheim am Rhein', zip: '64584'},
    { city: 'Hattersheim', zip: '65795'},
    { city: 'Mannheim', zip: '68165'},
    { city: 'Bad Homburg v.d. Höhe', zip: '61350'},
    { city: 'Mannheim', zip: '68259'},
    { city: 'Rahden', zip: '32369'},
    { city: 'Altensteig', zip: '72213'},
    { city: 'Frankfurt am Main', zip: '60529'},
    { city: 'Edingen-Neckarhausen', zip: '68535'},
    { city: 'Seeheim-Jugenheim', zip: '64342'},
    { city: 'Büsingen am Hochrhein', zip: '78266'},
    { city: 'Osterholz-Scharmbeck', zip: '27711'},
    { city: 'Lage', zip: '32791'},
    { city: 'Paderborn', zip: '33098'},
    { city: 'Gailingen am Hochrhein', zip: '78262'},
    { city: 'Schönau', zip: '69250'},
    { city: 'Offenbach am Main', zip: '63071'},
    { city: 'Niederdorfelden', zip: '61138'},
    { city: 'Vöhl', zip: '34516'},
    { city: 'Obertshausen', zip: '63179'},
    { city: 'Bremen', zip: '28205'},
    { city: 'Bredstedt, Breklum u.a.', zip: '25821'},
    { city: 'Zaberfeld', zip: '74374'},
    { city: 'Oldenswort', zip: '25870'},
    { city: 'Bremen', zip: '28355'},
    { city: 'Fridingen an der Donau', zip: '78567'},
    { city: 'Leck', zip: '25917'},
    { city: 'Eberbach', zip: '69412'},
    { city: 'Stinstedt', zip: '21772'},
    { city: 'Kahl am Main', zip: '63796'},
    { city: 'Sindelfingen', zip: '71069'},
    { city: 'Högel', zip: '25858'},
    { city: 'Schwieberdingen', zip: '71701'},
    { city: 'Stuttgart', zip: '70197'},
    { city: 'Konstanz', zip: '78465'},
    { city: 'Waldenbuch', zip: '71111'},
    { city: 'Niedernberg', zip: '63843'},
    { city: 'Feldatal', zip: '36325'},
    { city: 'Sonnenbühl', zip: '72820'},
    { city: 'Stuttgart', zip: '70469'},
    { city: 'Stuttgart', zip: '70439'},
    { city: 'Haselund', zip: '25855'},
    { city: 'Kleinwallstadt', zip: '63839'},
    { city: 'Großheubach', zip: '63920'},
    { city: 'Besigheim', zip: '74354'},
    { city: 'Bessenbach', zip: '63856'},
    { city: 'Schneeberg', zip: '63936'},
    { city: 'Handewitt', zip: '24983'},
    { city: 'Bürgstadt', zip: '63927'},
    { city: 'Wolfschlugen', zip: '72649'},
    { city: 'Hohenstein', zip: '72531'},
    { city: 'Treia, Ahrenviölfeld', zip: '24896'},
    { city: 'Oeversee', zip: '24988'},
    { city: 'Suthfeld', zip: '31555'},
    { city: 'Oberaula', zip: '36280'},
    { city: 'Kremperheide', zip: '25569'},
    { city: 'Owen', zip: '73277'},
    { city: 'Nortrup', zip: '49638'},
    { city: 'Langenlonsheim', zip: '55450'},
    { city: 'Gundelfingen, Heuweiler', zip: '79194'},
    { city: 'Hohberg', zip: '77749'},
    { city: 'Freiburg im Breisgau', zip: '79106'},
    { city: 'Warendorf', zip: '48231'},
    { city: 'Albersweiler, Silz u.a.', zip: '76857'},
    { city: 'Helgoland', zip: '27498'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Nisterau u.a.', zip: '56472'},
    { city: 'Glottertal', zip: '79286'},
    { city: 'Altendiez', zip: '65624'},
    { city: 'Billigheim-Ingenheim, Birkweiler', zip: '76831'},
    { city: 'Hadamar', zip: '65589'},
    { city: 'Oberkirch', zip: '77704'},
    { city: 'Niederneisen', zip: '65629'},
    { city: 'St. Blasien, Ibach', zip: '79837'},
    { city: 'Limburg', zip: '65554'},
    { city: 'Limburg', zip: '65550'},
    { city: 'Steinweiler', zip: '76872'},
    { city: 'Ostercappeln', zip: '49179'},
    { city: 'Walluf', zip: '65396'},
    { city: 'Baden-Baden', zip: '76532'},
    { city: 'Bad Peterstal-Griesbach', zip: '77740'},
    { city: 'Oldenburg (Oldenburg)', zip: '26123'},
    { city: 'Kuppenheim', zip: '76456'},
    { city: 'Dillenburg', zip: '35685'},
    { city: 'Dillenburg', zip: '35683'},
    { city: 'Melle', zip: '49324'},
    { city: 'Elsfleth', zip: '26931'},
    { city: 'Schenkenzell', zip: '77773'},
    { city: 'Weilrod', zip: '61276'},
    { city: 'Unterkirnach', zip: '78089'},
    { city: 'Loffenau', zip: '76597'},
    { city: 'Ludwigshafen am Rhein', zip: '67065'},
    { city: 'Hosenfeld', zip: '36154'},
    { city: 'Faulbach', zip: '97906'},
    { city: 'Großsolt', zip: '24991'},
    { city: 'Partenstein', zip: '97846'},
    { city: 'Langenargen', zip: '88085'},
    { city: 'Hohenlockstedt', zip: '25551'},
    { city: 'Sinntal', zip: '36391'},
    { city: 'Erlenbach b. Marktheidenfeld', zip: '97837'},
    { city: 'Zeitlofs', zip: '97799'},
    { city: 'Helmstadt', zip: '97264'},
    { city: 'Marienheide', zip: '51709'},
    { city: 'Dortmund', zip: '44141'},
    { city: 'Rieschweiler-Mühlbach', zip: '66509'},
    { city: 'Leiningen', zip: '56291'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Koblenz', zip: '56076'},
    { city: 'Pirmasens', zip: '66953'},
    { city: 'Binzen', zip: '79589'},
    { city: 'Lindern (Oldenburg)', zip: '49699'},
    { city: 'Braubach', zip: '56338'},
    { city: 'Mertloch, Welling u.a.', zip: '56753'},
    { city: 'Rheinbrohl', zip: '56598'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Aurich', zip: '26605'},
    { city: 'Quedlinburg', zip: '06484'},
    { city: 'Grafrath', zip: '82284'},
    { city: 'Unterleinleiter', zip: '91364'},
    { city: 'Weimar', zip: '99428'},
    { city: 'Gräfenberg', zip: '91322'},
    { city: 'Rudolstadt', zip: '07407'},
    { city: 'Mitwitz', zip: '96268'},
    { city: 'Egloffstein', zip: '91349'},
    { city: 'Kalbe', zip: '39624'},
    { city: 'Gößweinstein', zip: '91327'},
    { city: 'Ingolstadt', zip: '85049'},
    { city: 'Feldafing', zip: '82340'},
    { city: 'Gauting', zip: '82131'},
    { city: 'Simmelsdorf', zip: '91245'},
    { city: 'Planegg/Krailling', zip: '82152'},
    { city: 'Betzenstein', zip: '91282'},
    { city: 'Kirchdorf', zip: '93348'},
    { city: 'Aßling', zip: '85617'},
    { city: 'Walpertskirchen', zip: '85469'},
    { city: 'Jerichow', zip: '39319'},
    { city: 'Gera', zip: '07545'},
    { city: 'Schierling', zip: '84069'},
    { city: 'Rostock', zip: '18055'},
    { city: 'Wenzenbach', zip: '93173'},
    { city: 'Prutting', zip: '83134'},
    { city: 'Altfraunhofen', zip: '84169'},
    { city: 'Baierbach', zip: '84171'},
    { city: 'Elsteraue', zip: '06729'},
    { city: 'Bernhardswald', zip: '93170'},
    { city: 'Soyen', zip: '83564'},
    { city: 'Gars a. Inn', zip: '83536'},
    { city: 'Neunburg vorm Wald', zip: '92431'},
    { city: 'Crimmitschau', zip: '08451'},
    { city: 'Wörth an der Donau', zip: '93086'},
    { city: 'Leipzig', zip: '04157'},
    { city: 'Rettenbach', zip: '93191'},
    { city: 'Zwickau', zip: '08056'},
    { city: 'Eslarn', zip: '92693'},
    { city: 'Trostberg', zip: '83308'},
    { city: 'Schönthal', zip: '93488'},
    { city: 'Cham', zip: '93413'},
    { city: 'Parkstetten', zip: '94365'},
    { city: 'Massing', zip: '84323'},
    { city: 'Penig', zip: '09322'},
    { city: 'Haselbach', zip: '94354'},
    { city: 'Surberg', zip: '83362'},
    { city: 'Schwarzenberg/Erzgeb.', zip: '08340'},
    { city: 'Chemnitz', zip: '09117'},
    { city: 'Thum', zip: '09419'},
    { city: 'Torgau', zip: '04861'},
    { city: 'Haarbach', zip: '94542'},
    { city: 'Samtens', zip: '18573'},
    { city: 'Ludwigsfelde', zip: '14974'},
    { city: 'Ortenburg', zip: '94496'},
    { city: 'Eging a. See', zip: '94535'},
    { city: 'Kirchham', zip: '94148'},
    { city: 'Berlin Dahlem', zip: '14195'},
    { city: 'Berlin Zehlendorf', zip: '14167'},
    { city: 'Freiberg', zip: '09599'},
    { city: 'Berlin Charlottenburg', zip: '14059'},
    { city: 'Spiegelau', zip: '94518'},
    { city: 'Berlin Hermsdorf', zip: '13467'},
    { city: 'Berlin Moabit', zip: '10553'},
    { city: 'Berlin Charlottenburg', zip: '10623'},
    { city: 'Neuhaus a. Inn', zip: '94152'},
    { city: 'Berlin Neukölln', zip: '12053'},
    { city: 'Kröv', zip: '54536'},
    { city: 'Gelsenkirchen', zip: '45892'},
    { city: 'Gelsenkirchen', zip: '45879'},
    { city: 'Bonn', zip: '53175'},
    { city: 'Ediger-Eller', zip: '56814'},
    { city: 'Bonn', zip: '53113'},
    { city: 'Ochtrup', zip: '48607'},
    { city: 'Birkenfeld u.a.', zip: '55765'},
    { city: 'Bonn', zip: '53173'},
    { city: 'Wuppertal', zip: '42107'},
    { city: 'Remscheid', zip: '42855'},
    { city: 'Lohmar', zip: '53797'},
    { city: 'Herne', zip: '44628'},
    { city: 'Bochum', zip: '44803'},
    { city: 'Burgbrohl', zip: '56659'},
    { city: 'Weeze', zip: '47652'},
    { city: 'Roetgen', zip: '52159'},
    { city: 'Monschau', zip: '52156'},
    { city: 'Aldenhoven', zip: '52457'},
    { city: 'Rheinberg', zip: '47495'},
    { city: 'Rehlingen-Siersburg', zip: '66780'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Neuss', zip: '41472'},
    { city: 'Zerf', zip: '54314'},
    { city: 'Duisburg', zip: '47167'},
    { city: 'Düsseldorf', zip: '40233'},
    { city: 'Dormagen', zip: '41539'},
    { city: 'Malborn', zip: '54426'},
    { city: 'Köln', zip: '50667'},
    { city: 'Essen', zip: '45145'},
    { city: 'Malborn', zip: '54426'},
    { city: 'Saarbrücken', zip: '66133'},
    { city: 'Ingolstadt', zip: '85057'},
    { city: 'Apolda', zip: '99510'},
    { city: 'Ilmmünster', zip: '85304'},
    { city: 'Bad Tölz, Wackersberg', zip: '83646'},
    { city: 'Dietramszell', zip: '83623'},
    { city: 'München', zip: '80992'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'Neuenmarkt', zip: '95339'},
    { city: 'Münchsmünster', zip: '85126'},
    { city: 'Neustadt/ Orla', zip: '07806'},
    { city: 'Neustadt a.d. Donau', zip: '93333'},
    { city: 'Zolling', zip: '85406'},
    { city: 'Oberding', zip: '85445'},
    { city: 'Marzling', zip: '85417'},
    { city: 'Leupoldsgrün', zip: '95191'},
    { city: 'Satow', zip: '18239'},
    { city: 'Südliches Anhalt, Köthen', zip: '06388'},
    { city: 'Südliches Anhalt u.a.', zip: '06369'},
    { city: 'Kulmain', zip: '95508'},
    { city: 'Halle/ Saale', zip: '06120'},
    { city: 'Saal a.d. Donau', zip: '93342'},
    { city: 'Steinbach-Hallenberg', zip: '98587'},
    { city: 'Klein Wesenberg', zip: '23860'},
    { city: 'Braunschweig', zip: '38102'},
    { city: 'Sassenburg', zip: '38524'},
    { city: 'Lübeck', zip: '23560'},
    { city: 'Braunlage', zip: '38700'},
    { city: 'Unterschwaningen', zip: '91743'},
    { city: 'Hopferau', zip: '87659'},
    { city: 'Schöppenstedt', zip: '38170'},
    { city: 'Lisberg', zip: '96170'},
    { city: 'Schönwalde am Bungsberg', zip: '23744'},
    { city: 'Oberhof', zip: '98559'},
    { city: 'Lübeck', zip: '23569'},
    { city: 'Lechbruck', zip: '86983'},
    { city: 'Tosterglope', zip: '21371'},
    { city: 'Aurachtal', zip: '91086'},
    { city: 'Ilmenau', zip: '98693'},
    { city: 'Bamberg', zip: '96049'},
    { city: 'Königslutter am Elm', zip: '38154'},
    { city: 'Beierstedt', zip: '38382'},
    { city: 'Niederschönenfeld', zip: '86694'},
    { city: 'Prittriching', zip: '86931'},
    { city: 'Wildsteig', zip: '82409'},
    { city: 'Staffelstein', zip: '96231'},
    { city: 'Fürth', zip: '90765'},
    { city: 'Kindelbrück', zip: '99638'},
    { city: 'Peißenberg', zip: '82380'},
    { city: 'Berlin Neukölln', zip: '12059'},
    { city: 'Berlin Lichtenberg', zip: '10369'},
    { city: 'Freyung', zip: '94078'},
    { city: 'Berlin Köpenik', zip: '12555'},
    { city: 'Dresden', zip: '01156'},
    { city: 'Radebeul', zip: '01445'},
    { city: 'Märkisch Buchholz', zip: '15748'},
    { city: 'Heidenau', zip: '01809'},
    { city: 'Dresden', zip: '01237'},
    { city: 'Löcknitz, Rothenklempenow', zip: '17321'},
    { city: 'Schleife', zip: '02959'},
    { city: 'Weißwasser, Boxberg', zip: '02943'},
    { city: 'Hähnichen, Horka, Kodersdorf', zip: '02923'},
    { city: 'Egeln, Borne, Wolmirsleben u.a.', zip: '39435'},
    { city: 'Hersbruck', zip: '91217'},
    { city: 'Bad Heilbrunn', zip: '83670'},
    { city: 'München', zip: '80689'},
    { city: 'München', zip: '80687'},
    { city: 'Hohenkammer', zip: '85411'},
    { city: 'Staßfurt', zip: '39418'},
    { city: 'Gesees', zip: '95494'},
    { city: 'Ranis', zip: '07389'},
    { city: 'Warin', zip: '19417'},
    { city: 'Geisenfeld', zip: '85290'},
    { city: 'Taufkirchen', zip: '82024'},
    { city: 'Kastl', zip: '92280'},
    { city: 'Stammbach', zip: '95236'},
    { city: 'Bernburg (Saale)', zip: '06406'},
    { city: 'Münchberg', zip: '95213'},
    { city: 'Rochau', zip: '39579'},
    { city: 'Rudelzhausen', zip: '84104'},
    { city: 'Selbitz', zip: '95152'},
    { city: 'Schönebeck (Elbe)', zip: '39217'},
    { city: 'Finsing', zip: '85464'},
    { city: 'Vaterstetten', zip: '85591'},
    { city: 'Train', zip: '93358'},
    { city: 'Feldkirchen-Westerham', zip: '83620'},
    { city: 'Marnitz, Siggelkow', zip: '19376'},
    { city: 'Kirchseeon', zip: '85614'},
    { city: 'Polling', zip: '82398'},
    { city: 'Heiligenstadt i. OFr.', zip: '91332'},
    { city: 'Sielenbach', zip: '86577'},
    { city: 'Wallgau', zip: '82499'},
    { city: 'Alling', zip: '82239'},
    { city: 'Lemgow', zip: '29485'},
    { city: 'Hilgertshausen-Tandern', zip: '86567'},
    { city: 'Seeland', zip: '06467'},
    { city: 'Schlehdorf', zip: '82444'},
    { city: 'Waidhofen', zip: '86579'},
    { city: 'Wilhelmsthal', zip: '96352'},
    { city: 'Schwerin', zip: '19061'},
    { city: 'Teuchern', zip: '06682'},
    { city: 'Halle/ Saale', zip: '06118'},
    { city: 'Schwaan u.a.', zip: '18258'},
    { city: 'Rott a. Inn', zip: '83543'},
    { city: 'Dessau-Roßlau', zip: '06847'},
    { city: 'Rostock, Gelbensande, Rövershagen u.a.', zip: '18182'},
    { city: 'Elsteraue', zip: '06729'},
    { city: 'Tirschenreuth', zip: '95643'},
    { city: 'Buchbach', zip: '84428'},
    { city: 'Meuselwitz', zip: '04610'},
    { city: 'Bayerbach bei Ergoldsbach', zip: '84092'},
    { city: 'Ampfing', zip: '84539'},
    { city: 'Markkleeberg', zip: '04416'},
    { city: 'Dieterskirchen', zip: '92542'},
    { city: 'Marquartstein', zip: '83250'},
    { city: 'Altenmarkt a.d. Alz', zip: '83352'},
    { city: 'Roding', zip: '93426'},
    { city: 'Ruhpolding', zip: '83324'},
    { city: 'Vachendorf', zip: '83377'},
    { city: 'Brandis', zip: '04821'},
    { city: 'Barth', zip: '18356'},
    { city: 'Zandt', zip: '93499'},
    { city: 'Lugau/Erzgeb.', zip: '09385'},
    { city: 'Erlbach', zip: '84567'},
    { city: 'Fehrbellin, Temnitzquell, Märkisch Linden u.a.', zip: '16818'},
    { city: 'Viechtach', zip: '94234'},
    { city: 'Hohenwarth', zip: '93480'},
    { city: 'Sehma', zip: '09465'},
    { city: 'Nuthe-Urstromtal', zip: '14947'},
    { city: 'Bischofsmais', zip: '94253'},
    { city: 'Ering', zip: '94140'},
    { city: 'Börnichen, Gornau', zip: '09437'},
    { city: 'Hofkirchen', zip: '94544'},
    { city: 'Oederan', zip: '09569'},
    { city: 'Rinchnach', zip: '94269'},
    { city: 'Berlin Zehlendorf', zip: '14163'},
    { city: 'Berlin Zehlendorf', zip: '14169'},
    { city: 'Tiefenbach', zip: '94113'},
    { city: 'Gingst', zip: '18569'},
    { city: 'Berlin Mariendorf', zip: '12105'},
    { city: 'Ruderting', zip: '94161'},
    { city: 'Berlin Gesundbrunnen', zip: '13359'},
    { city: 'Berlin Tempelhof', zip: '12099'},
    { city: 'Berlin Prenzlauer Berg', zip: '10439'},
    { city: 'Berlin Neukölln', zip: '12049'},
    { city: 'Hennstedt', zip: '25581'},
    { city: 'Otter', zip: '21259'},
    { city: 'Wrist', zip: '25563'},
    { city: 'Untermünkheim', zip: '74547'},
    { city: 'Moringen', zip: '37186'},
    { city: 'Hannover', zip: '30459'},
    { city: 'Hannover', zip: '30165'},
    { city: 'Bebra', zip: '36179'},
    { city: 'Fitzbek', zip: '25579'},
    { city: 'Hannover', zip: '30163'},
    { city: 'Donzdorf', zip: '73072'},
    { city: 'Hofbieber', zip: '36145'},
    { city: 'Sehestedt', zip: '24814'},
    { city: 'Burgwedel', zip: '30938'},
    { city: 'Stoltebüll', zip: '24409'},
    { city: 'Giesen', zip: '31180'},
    { city: 'Geroda', zip: '97779'},
    { city: 'Blumenthal', zip: '24241'},
    { city: 'Munster', zip: '29633'},
    { city: 'Hamburg', zip: '20459'},
    { city: 'Hamburg', zip: '20148'},
    { city: 'Herleshausen', zip: '37293'},
    { city: 'Ballendorf', zip: '89177'},
    { city: 'Hamburg', zip: '22309'},
    { city: 'Illertissen', zip: '89257'},
    { city: 'Altusried', zip: '87452'},
    { city: 'Börnhöved', zip: '24619'},
    { city: 'Woringen', zip: '87789'},
    { city: 'Ellenberg', zip: '73488'},
    { city: 'Meiningen', zip: '98617'},
    { city: 'Wörnitz', zip: '91637'},
    { city: 'Peine', zip: '31224'},
    { city: 'Seth', zip: '23845'},
    { city: 'Böhen', zip: '87736'},
    { city: 'Wiesenbach', zip: '86519'},
    { city: 'Kempten (Allgäu)', zip: '87437'},
    { city: 'Sulzberg', zip: '87477'},
    { city: 'Mönchsroth', zip: '91614'},
    { city: 'Ruhla', zip: '99842'},
    { city: 'Grabfeld', zip: '98631'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Fuhlenhagen', zip: '21493'},
    { city: 'Goslar', zip: '38690'},
    { city: 'Walkenried', zip: '37445'},
    { city: 'Schöffengrund', zip: '35641'},
    { city: 'Altlußheim', zip: '68804'},
    { city: 'Oberursel (Taunus)', zip: '61440'},
    { city: 'Nordenham', zip: '26954'},
    { city: 'Hallig Hooge', zip: '25859'},
    { city: 'Lübbecke', zip: '32312'},
    { city: 'Frankfurt am Main', zip: '65936'},
    { city: 'Bielefeld', zip: '33729'},
    { city: 'Egenhausen', zip: '72227'},
    { city: 'Süderoog, Pellworm', zip: '25849'},
    { city: 'Darmstadt', zip: '64285'},
    { city: 'Leopoldshöhe', zip: '33818'},
    { city: 'Frankfurt am Main', zip: '60435'},
    { city: 'Frankfurt am Main', zip: '60318'},
    { city: 'Rosenthal', zip: '35119'},
    { city: 'Zuzenhausen', zip: '74939'},
    { city: 'Emmingen-Liptingen', zip: '78576'},
    { city: 'Porta Westfalica', zip: '32457'},
    { city: 'Meßstetten', zip: '72469'},
    { city: 'Kronprinzenkoog, Marne u.a.', zip: '25709'},
    { city: 'Schwenningen', zip: '72477'},
    { city: 'Bad Wildungen', zip: '34537'},
    { city: 'Hemmingen', zip: '71282'},
    { city: 'Rottenburg am Neckar', zip: '72108'},
    { city: 'Cadenberge', zip: '21781'},
    { city: 'Extertal', zip: '32699'},
    { city: 'Löchgau', zip: '74369'},
    { city: 'Hennstedt', zip: '25779'},
    { city: 'Joldelund', zip: '25862'},
    { city: 'Leingarten', zip: '74211'},
    { city: 'Osten', zip: '21756'},
    { city: 'Estorf', zip: '21727'},
    { city: 'Trochtelfingen', zip: '72818'},
    { city: 'Stapel', zip: '25879'},
    { city: 'Krombach', zip: '63829'},
    { city: 'Hettingen', zip: '72513'},
    { city: 'Delve', zip: '25788'},
    { city: 'Rohrsen', zip: '31627'},
    { city: 'Heemsen', zip: '31622'},
    { city: 'Beckedorf', zip: '31699'},
    { city: 'Eggebek, Langstedt, Sollerup, Süderhackstedt', zip: '24852'},
    { city: 'Bermatingen', zip: '88697'},
    { city: 'Brevörde, Polle, Vahlbruch', zip: '37647'},
    { city: 'Leutenbach', zip: '71397'},
    { city: 'Felsberg', zip: '34587'},
    { city: 'Wilhelmsdorf', zip: '88271'},
    { city: 'Plochingen', zip: '73207'},
    { city: 'Borsfleth', zip: '25376'},
    { city: 'Oldendorf', zip: '25588'},
    { city: 'Woltersdorf, Müssen u.a.', zip: '21516'},
    { city: 'Aichen', zip: '86479'},
    { city: 'Burgwindheim', zip: '96154'},
    { city: 'Deiningen', zip: '86738'},
    { city: 'Sand a. Main', zip: '97522'},
    { city: 'Berkenthin', zip: '23919'},
    { city: 'Thomasburg', zip: '21401'},
    { city: 'Harburg', zip: '86655'},
    { city: 'Lübeck', zip: '23566'},
    { city: 'Amt Neuhaus, Stapel', zip: '19273'},
    { city: 'Ingenried', zip: '86980'},
    { city: 'Wehringen', zip: '86517'},
    { city: 'Burggen', zip: '86977'},
    { city: 'Gerach', zip: '96161'},
    { city: 'Meeder', zip: '96484'},
    { city: 'Räbke', zip: '38375'},
    { city: 'Söllingen', zip: '38387'},
    { city: 'Parsau', zip: '38470'},
    { city: 'Königsbrunn', zip: '86343'},
    { city: 'Augsburg', zip: '86169'},
    { city: 'Waddeweitz', zip: '29496'},
    { city: 'Fürth', zip: '90768'},
    { city: 'Merching', zip: '86504'},
    { city: 'Erlangen', zip: '91056'},
    { city: 'Erfurt', zip: '99094'},
    { city: 'Hausen', zip: '91353'},
    { city: 'Höttingen', zip: '91798'},
    { city: 'Petersdorf', zip: '86574'},
    { city: 'Erlangen', zip: '91052'},
    { city: 'Baiersdorf', zip: '91083'},
    { city: 'Grub a. Forst', zip: '96271'},
    { city: 'Lützkampen', zip: '54617'},
    { city: 'Stolberg (Rhld.)', zip: '52223'},
    { city: 'Eschweiler', zip: '52249'},
    { city: 'Geldern', zip: '47608'},
    { city: 'Arzfeld', zip: '54687'},
    { city: 'Monschau', zip: '52156'},
    { city: 'Wincheringen', zip: '54457'},
    { city: 'Bocholt', zip: '46395'},
    { city: 'Konz', zip: '54329'},
    { city: 'Wesel', zip: '46483'},
    { city: 'Bergheim', zip: '50127'},
    { city: 'Trier', zip: '54292'},
    { city: 'Bergheim', zip: '50129'},
    { city: 'Überherrn', zip: '66802'},
    { city: 'Üxheim', zip: '54579'},
    { city: 'Kenn', zip: '54344'},
    { city: 'Düsseldorf', zip: '40221'},
    { city: 'Duisburg', zip: '47269'},
    { city: 'Düsseldorf', zip: '40213'},
    { city: 'Düsseldorf', zip: '40227'},
    { city: 'Mülheim an der Ruhr', zip: '45476'},
    { city: 'Neumagen-Dhron', zip: '54347'},
    { city: 'Köln', zip: '50823'},
    { city: 'Köln', zip: '50672'},
    { city: 'Ulmen', zip: '56766'},
    { city: 'Reken', zip: '48734'},
    { city: 'Köln', zip: '50999'},
    { city: 'Illingen', zip: '66557'},
    { city: 'Marpingen', zip: '66646'},
    { city: 'Köln', zip: '51065'},
    { city: 'Gelsenkirchen', zip: '45894'},
    { city: 'Velbert', zip: '42551'},
    { city: 'Bonn', zip: '53123'},
    { city: 'Solingen', zip: '42655'},
    { city: 'Vogtsburg im Kaiserstuhl', zip: '79235'},
    { city: 'Sasbach am Kaiserstuhl', zip: '79361'},
    { city: 'Koblenz', zip: '56068'},
    { city: 'Niederburg', zip: '55432'},
    { city: 'Waldfischbach-Burgalben', zip: '67714'},
    { city: 'Höhr-Grenzhausen', zip: '56203'},
    { city: 'Rodenbach', zip: '67688'},
    { city: 'Kleinmaischeid', zip: '56271'},
    { city: 'Rheinhausen', zip: '79365'},
    { city: 'Dahn', zip: '66994'},
    { city: 'Obermoschel, Schiersfeld', zip: '67823'},
    { city: 'Katzwinkel (Sieg)', zip: '57581'},
    { city: 'Berlin Neukölln', zip: '12045'},
    { city: 'Berlin Neukölln', zip: '12057'},
    { city: 'Berlin Buch', zip: '13125'},
    { city: 'Berlin', zip: '12557'},
    { city: 'Berlin Mahlsdorf', zip: '12623'},
    { city: 'Dresden', zip: '01139'},
    { city: 'Elstra, Oßling u.a.', zip: '01920'},
    { city: 'Großröhrsdorf, Bretnig-Hauswalde', zip: '01900'},
    { city: 'Cottbus', zip: '03046'},
    { city: 'Lohsa', zip: '02999'},
    { city: 'Cottbus', zip: '03053'},
    { city: 'Großschönau', zip: '02779'},
    { city: 'Reichenbach, Vierkirchen', zip: '02894'},
    { city: 'Battweiler u.a.', zip: '66484'},
    { city: 'Dortmund', zip: '44139'},
    { city: 'Mülheim-Kärlich', zip: '56218'},
    { city: 'Oberlahr', zip: '57641'},
    { city: 'Hagen', zip: '58093'},
    { city: 'Greven', zip: '48268'},
    { city: 'Pirmasens', zip: '66955'},
    { city: 'Freiburg im Breisgau', zip: '79106'},
    { city: 'Finnentrop', zip: '57413'},
    { city: 'Weitefeld', zip: '57586'},
    { city: 'Kreuztal', zip: '57223'},
    { city: 'Bad Marienberg (Westerwald)', zip: '56470'},
    { city: 'Schlangenbad', zip: '65388'},
    { city: 'Achern (Abweichung Exklaven)', zip: '77855'},
    { city: 'Schönborn', zip: '56370'},
    { city: 'Ottersweier', zip: '77833'},
    { city: 'Zell am Harmersbach', zip: '77736'},
    { city: 'Bühl', zip: '77815'},
    { city: 'Albig', zip: '55234'},
    { city: 'Albbruck', zip: '79774'},
    { city: 'Schollbrunn', zip: '97852'},
    { city: 'Stade', zip: '21680'},
    { city: 'Breiholz, Tackesdorf-Nord', zip: '24797'},
    { city: 'Kassel, Fuldatal', zip: '34233'},
    { city: 'Schlierbach', zip: '73278'},
    { city: 'Melsungen', zip: '34212'},
    { city: 'Fellen', zip: '97778'},
    { city: 'Schleswig', zip: '24837'},
    { city: 'Esselbach', zip: '97839'},
    { city: 'Murrhardt', zip: '71540'},
    { city: 'Bad Hersfeld, Ludwigsau', zip: '36251'},
    { city: 'Ravensburg', zip: '88213'},
    { city: 'Karlstadt', zip: '97753'},
    { city: 'Wiesbaden', zip: '65199'},
    { city: 'Wadersloh', zip: '59329'},
    { city: 'Weilheim', zip: '79809'},
    { city: 'Lohne', zip: '49393'},
    { city: 'Venningen', zip: '67482'},
    { city: 'Sasbach', zip: '77880'},
    { city: 'Vöhrenbach', zip: '78147'},
    { city: 'Ellerstadt', zip: '67158'},
    { city: 'Worms', zip: '67551'},
    { city: 'Trebur', zip: '65468'},
    { city: 'Solingen', zip: '42659'},
    { city: 'Saarbrücken', zip: '66131'},
    { city: 'Odenthal', zip: '51519'},
    { city: 'Bell', zip: '56745'},
    { city: 'Wuppertal', zip: '42105'},
    { city: 'Kirkel', zip: '66459'},
    { city: 'Bochum', zip: '44801'},
    { city: 'Breitscheid, Dattenberg, Hausen, Hümmerich, Kasbach-Ohlenberg, Roßbach u.a.', zip: '53547'},
    { city: 'Witten', zip: '58455'},
    { city: 'Neunkirchen-Seelscheid', zip: '53819'},
    { city: 'Kastellaun', zip: '56288'},
    { city: 'Plaidt', zip: '56637'},
    { city: 'Breckerfeld', zip: '58339'},
    { city: 'Pronsfeld', zip: '54597'},
    { city: 'Bettingen', zip: '54646'},
    { city: 'Düren', zip: '52353'},
    { city: 'Alpen', zip: '46519'},
    { city: 'Grevenbroich', zip: '41516'},
    { city: 'Krefeld', zip: '47800'},
    { city: 'Meerbusch', zip: '40668'},
    { city: 'Trier', zip: '54295'},
    { city: 'Frechen', zip: '50226'},
    { city: 'Raesfeld', zip: '46348'},
    { city: 'Düsseldorf', zip: '40479'},
    { city: 'Düsseldorf', zip: '40477'},
    { city: 'Bous', zip: '66359'},
    { city: 'Düsseldorf', zip: '40235'},
    { city: 'Düsseldorf', zip: '40597'},
    { city: 'Köln', zip: '50939'},
    { city: 'Bausendorf', zip: '54538'},
    { city: 'Bottrop', zip: '46238'},
    { city: 'Köln', zip: '50667'},
    { city: 'Thalfang', zip: '54424'},
    { city: 'Lutzerath', zip: '56826'},
    { city: 'Gusenburg', zip: '54413'},
    { city: 'Grafschaft', zip: '53501'},
    { city: 'Velbert', zip: '42549'},
    { city: 'Bad Bertrich', zip: '56864'},
    { city: 'Marl', zip: '45768'},
    { city: 'Hartheim', zip: '79258'},
    { city: 'Wolfstein', zip: '67752'},
    { city: 'Lüdenscheid', zip: '58511'},
    { city: 'Bacharach, Breitscheid', zip: '55422'},
    { city: 'Stromberg', zip: '55442'},
    { city: 'Bahlingen am Kaiserstuhl', zip: '79353'},
    { city: 'Nußbach', zip: '67759'},
    { city: 'Halver', zip: '58553'},
    { city: 'Neuwied', zip: '56564'},
    { city: 'Hagen', zip: '58095'},
    { city: 'Simmertal', zip: '55618'},
    { city: 'Dortmund', zip: '44328'},
    { city: 'Bad Bellingen', zip: '79415'},
    { city: 'Hagen', zip: '58119'},
    { city: 'Riesweiler', zip: '55499'},
    { city: 'Werne', zip: '59368'},
    { city: 'Neitersen', zip: '57638'},
    { city: 'Saerbeck', zip: '48369'},
    { city: 'Essen', zip: '45289'},
    { city: 'Spiesen-Elversberg', zip: '66583'},
    { city: 'Bonn', zip: '53227'},
    { city: 'Wuppertal', zip: '42109'},
    { city: 'Herne', zip: '44652'},
    { city: 'Blieskastel', zip: '66440'},
    { city: 'Emden', zip: '26721'},
    { city: 'Neunkirchen', zip: '66539'},
    { city: 'Recklinghausen', zip: '45663'},
    { city: 'Bexbach', zip: '66450'},
    { city: 'Blankenrath u.a.', zip: '56865'},
    { city: 'Bochum', zip: '44805'},
    { city: 'Beltheim', zip: '56290'},
    { city: 'Herschweiler-Pettersheim', zip: '66909'},
    { city: 'Angelburg', zip: '35719'},
    { city: 'Villingen-Schwenningen', zip: '78050'},
    { city: 'Fluorn-Winzeln', zip: '78737'},
    { city: 'Winterberg', zip: '59955'},
    { city: 'Frankfurt am Main', zip: '65931'},
    { city: 'Waghäusel', zip: '68753'},
    { city: 'Hüttenberg', zip: '35625'},
    { city: 'Enger', zip: '32130'},
    { city: 'Ilvesheim', zip: '68549'},
    { city: 'Steinbach (Taunus)', zip: '61449'},
    { city: 'Cuxhaven', zip: '27476'},
    { city: 'Schloß Holte-Stukenbrock', zip: '33758'},
    { city: 'Bickenbach', zip: '64404'},
    { city: 'Forst', zip: '76694'},
    { city: 'Bad Schönborn', zip: '76669'},
    { city: 'Löhne', zip: '32584'},
    { city: 'Pforzheim', zip: '75172'},
    { city: 'Gießen', zip: '35396'},
    { city: 'Delmenhorst', zip: '27755'},
    { city: 'Augustdorf', zip: '32832'},
    { city: 'Wanna', zip: '21776'},
    { city: 'Gaiberg', zip: '69251'},
    { city: 'Schlangen', zip: '33189'},
    { city: 'Deilingen', zip: '78586'},
    { city: 'Grasellenbach', zip: '64689'},
    { city: 'Lobbach', zip: '74931'},
    { city: 'Amöneburg', zip: '35287'},
    { city: 'Altdorf', zip: '71155'},
    { city: 'Ahrenshöft', zip: '25853'},
    { city: 'Großostheim', zip: '63762'},
    { city: 'Horstedt', zip: '25860'},
    { city: 'Jesberg', zip: '34632'},
    { city: 'Gründau', zip: '63584'},
    { city: 'Überlingen', zip: '88662'},
    { city: 'Wörth a.Main', zip: '63939'},
    { city: 'Rantrum', zip: '25873'},
    { city: 'Aschaffenburg', zip: '63739'},
    { city: 'Gedern', zip: '63688'},
    { city: 'Willingshausen', zip: '34628'},
    { city: 'Gemmrigheim', zip: '74376'},
    { city: 'Linsengericht', zip: '63589'},
    { city: 'Stuttgart', zip: '70176'},
    { city: 'Hechthausen', zip: '21755'},
    { city: 'Reutlingen', zip: '72762'},
    { city: 'Stuttgart/Leinfelden-Echterdingen', zip: '70629'},
    { city: 'Leidersbach', zip: '63849'},
    { city: 'Heilbronn', zip: '74076'},
    { city: 'Bad Emstal', zip: '34308'},
    { city: 'Frickingen', zip: '88699'},
    { city: 'Reutlingen', zip: '72766'},
    { city: 'Stuttgart', zip: '70374'},
    { city: 'Remseck am Neckar', zip: '71686'},
    { city: 'Wischhafen', zip: '21737'},
    { city: 'Hagenburg', zip: '31558'},
    { city: 'Kirchlinteln', zip: '27308'},
    { city: 'Abstatt', zip: '74232'},
    { city: 'Treia, Ahrenviölfeld', zip: '24896'},
    { city: 'Habichtswald', zip: '34317'},
    { city: 'Beilstein', zip: '71717'},
    { city: 'Kohlberg', zip: '72664'},
    { city: 'Rethem (Aller), Häuslingen, Frankenfeld', zip: '27336'},
    { city: 'Schwaikheim', zip: '71409'},
    { city: 'Ahlerstedt', zip: '21702'},
    { city: 'Bad Saulgau, Allmannsweiler', zip: '88348'},
    { city: 'Königseggwald', zip: '88376'},
    { city: 'Rodewald', zip: '31637'},
    { city: 'Wartenberg', zip: '36367'},
    { city: 'Hoßkirch', zip: '88374'},
    { city: 'Rosengarten', zip: '74538'},
    { city: 'Witzenhausen', zip: '37217'},
    { city: 'Hannover', zip: '30169'},
    { city: 'Berghülen', zip: '89180'},
    { city: 'Motten', zip: '97786'},
    { city: 'Bad Bramstedt', zip: '24576'},
    { city: 'Isernhagen', zip: '30916'},
    { city: 'Hamburg', zip: '22609'},
    { city: 'Loose', zip: '24366'},
    { city: 'Riedenberg', zip: '97792'},
    { city: 'Bühlerzell', zip: '74426'},
    { city: 'Hamburg', zip: '22769'},
    { city: 'Hildesheim', zip: '31141'},
    { city: 'Bieberehren', zip: '97243'},
    { city: 'Melsdorf', zip: '24109'},
    { city: 'Norderstedt', zip: '22851'},
    { city: 'Großharrie', zip: '24625'},
    { city: 'Jagstzell', zip: '73489'},
    { city: 'Krayenberggemeinde, Frauensee', zip: '36460'},
    { city: 'Toppenstedt', zip: '21442'},
    { city: 'Heidenheim an der Brenz', zip: '89518'},
    { city: 'Hamburg', zip: '22117'},
    { city: 'Kellmünz a.d. Iller', zip: '89293'},
    { city: 'Bastheim', zip: '97654'},
    { city: 'Lahstedt', zip: '31246'},
    { city: 'Kiel', zip: '24146'},
    { city: 'Hattorf', zip: '37197'},
    { city: 'Dittelbrunn', zip: '97456'},
    { city: 'Üchtelhausen', zip: '97532'},
    { city: 'Günzburg', zip: '89312'},
    { city: 'Lauben', zip: '87761'},
    { city: 'Langlingen', zip: '29364'},
    { city: 'Westerheim', zip: '87784'},
    { city: 'Nehms', zip: '23813'},
    { city: 'Deisenhausen', zip: '86489'},
    { city: 'Sulzheim', zip: '97529'},
    { city: 'Bad Liebenstein', zip: '36448'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Wutha-Farnroda', zip: '99848'},
    { city: 'Lasbek', zip: '23847'},
    { city: 'Kirchheim am Ries', zip: '73467'},
    { city: 'Burtenbach', zip: '89349'},
    { city: 'Lütjenburg', zip: '24321'},
    { city: 'Unterthingau', zip: '87647'},
    { city: 'Pronstorf', zip: '23820'},
    { city: 'Scharnebeck, Echem, Lüdersburg, Rullstorf', zip: '21379'},
    { city: 'Tabarz/ Thür. Wald', zip: '99891'},
    { city: 'Lengenwang', zip: '87663'},
    { city: 'Bidingen', zip: '87651'},
    { city: 'Ziethen', zip: '23911'},
    { city: 'Höchstadt a.d.Aisch', zip: '91315'},
    { city: 'Oberharz am Brocken', zip: '38899'},
    { city: 'Hurlach', zip: '86857'},
    { city: 'Rattelsdorf', zip: '96179'},
    { city: 'Augsburg', zip: '86157'},
    { city: 'Scheuring', zip: '86937'},
    { city: 'Erfurt', zip: '99092'},
    { city: 'Augsburg', zip: '86154'},
    { city: 'Ebensfeld', zip: '96250'},
    { city: 'Bamberg', zip: '96050'},
    { city: 'Tagmersheim', zip: '86704'},
    { city: 'Katzhütte', zip: '98746'},
    { city: 'Erfurt', zip: '99097'},
    { city: 'Sömmerda', zip: '99610'},
    { city: 'Freiburg im Breisgau', zip: '79115'},
    { city: 'Nastätten u.a.', zip: '56355'},
    { city: 'Schwarzengraben, St. Alban, Gerbach', zip: '67813'},
    { city: 'Wehr', zip: '79664'},
    { city: 'Lotte', zip: '49504'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Offenburg', zip: '77652'},
    { city: 'Herrischried', zip: '79737'},
    { city: 'Berghaupten', zip: '77791'},
    { city: 'Bad Schwalbach', zip: '65307'},
    { city: 'Elzach, Biederbach', zip: '79215'},
    { city: 'Winden im Elztal', zip: '79297'},
    { city: 'Oberrod u.a.', zip: '56479'},
    { city: 'Frankweiler', zip: '76833'},
    { city: 'Rhodt u.a.', zip: '76835'},
    { city: 'Dinklage', zip: '49413'},
    { city: 'Neustadt an der Weinstraße', zip: '67433'},
    { city: 'Insheim', zip: '76865'},
    { city: 'Berg', zip: '76768'},
    { city: 'Hatzenbühl', zip: '76770'},
    { city: 'Hatten', zip: '26209'},
    { city: 'Weisenheim am Sand', zip: '67256'},
    { city: 'Hillesheim', zip: '67586'},
    { city: 'Bad Laasphe', zip: '57334'},
    { city: 'Rülzheim', zip: '76761'},
    { city: 'Eschenburg', zip: '35713'},
    { city: 'Nackenheim', zip: '55299'},
    { city: 'Hochheim am Main', zip: '65239'},
    { city: 'Lippstadt', zip: '59558'},
    { city: 'Ludwigshafen am Rhein', zip: '67069'},
    { city: 'Bad Herrenalb', zip: '76332'},
    { city: 'Hamdorf', zip: '24805'},
    { city: 'Breitenbach am Herzberg', zip: '36287'},
    { city: 'Sulzbach an der Murr', zip: '71560'},
    { city: 'Lichtenwald', zip: '73669'},
    { city: 'Grünendeich', zip: '21720'},
    { city: 'Göppingen', zip: '73035'},
    { city: 'Neubrunn', zip: '97277'},
    { city: 'Fleckeby u.a.', zip: '24357'},
    { city: 'Langenhagen', zip: '30855'},
    { city: 'Kaulsdorf', zip: '07338'},
    { city: 'Schäftlarn', zip: '82069'},
    { city: 'Schwerin', zip: '19055'},
    { city: 'Baar-Ebenhausen', zip: '85107'},
    { city: 'Ingolstadt', zip: '85053'},
    { city: 'Pommelsbrunn', zip: '91224'},
    { city: 'Kösching', zip: '85092'},
    { city: 'Schraplau, Farnstädt', zip: '06279'},
    { city: 'Etzelwang', zip: '92268'},
    { city: 'Oberdolling', zip: '85129'},
    { city: 'München', zip: '80802'},
    { city: 'München', zip: '81927'},
    { city: 'Hemau', zip: '93155'},
    { city: 'Möckern, Schermen, Nedlitz u.a.', zip: '39291'},
    { city: 'Gefell', zip: '07926'},
    { city: 'Weyarn', zip: '83629'},
    { city: 'Bernitt, Qualitz, Warnow, Zernin u.a.', zip: '18249'},
    { city: 'Hermsdorf', zip: '07629'},
    { city: 'Crossen, Heideland u.a.', zip: '07613'},
    { city: 'Ebnath', zip: '95683'},
    { city: 'Oberaudorf', zip: '83080'},
    { city: 'Gumtow, Kyritz u.a.', zip: '16866'},
    { city: 'Plauen', zip: '08523'},
    { city: 'Windischeschenbach', zip: '92670'},
    { city: 'Söchtenau', zip: '83139'},
    { city: 'Adlkofen', zip: '84166'},
    { city: 'Dessau-Roßlau', zip: '06842'},
    { city: 'Waldsassen', zip: '95652'},
    { city: 'Bad Endorf', zip: '83093'},
    { city: 'Bitterfeld-Wolfen', zip: '06803'},
    { city: 'Bitterfeld-Wolfen', zip: '06808'},
    { city: 'Nossentiner Hütte', zip: '17214'},
    { city: 'Neukirchen/Pleiße', zip: '08459'},
    { city: 'Leipzig', zip: '04277'},
    { city: 'Neualbenreuth', zip: '95698'},
    { city: 'Muldenhammer', zip: '08262'},
    { city: 'Aholfing', zip: '94345'},
    { city: 'Stamsried', zip: '93491'},
    { city: 'Stützengrün', zip: '08328'},
    { city: 'Frontenhausen', zip: '84160'},
    { city: 'Eibenstock', zip: '08309'},
    { city: 'Waldenburg', zip: '08396'},
    { city: 'Waren/ Müritz', zip: '17192'},
    { city: 'Wurzen', zip: '04808'},
    { city: 'Fehrbellin', zip: '16833'},
    { city: 'Halsbach', zip: '84553'},
    { city: 'Wallersdorf', zip: '94522'},
    { city: 'Runding', zip: '93486'},
    { city: 'Niederwinkling', zip: '94559'},
    { city: 'Grünhain-Beierfeld', zip: '08344'},
    { city: 'Neuruppin', zip: '16827'},
    { city: 'Grafenwiesen', zip: '93479'},
    { city: 'Julbach', zip: '84387'},
    { city: 'Potsdam', zip: '14469'},
    { city: 'Drebach', zip: '09430'},
    { city: 'Großrückerswalde', zip: '09518'},
    { city: 'Gingst', zip: '18569'},
    { city: 'Berlin Hakenfelde', zip: '13587'},
    { city: 'Hennigsdorf', zip: '16761'},
    { city: 'Lommatzsch', zip: '01623'},
    { city: 'Riesa', zip: '01589'},
    { city: 'Halsbrücke', zip: '09633'},
    { city: 'Tittling', zip: '94104'},
    { city: 'Berlin Lichtenberg', zip: '10367'},
    { city: 'Sassnitz', zip: '18546'},
    { city: 'Grainet', zip: '94143'},
    { city: 'Altenberg', zip: '01773'},
    { city: 'Altenberg', zip: '01778'},
    { city: 'Karlshagen', zip: '17449'},
    { city: 'Lübbenau/ Spreewald', zip: '03222'},
    { city: 'Zeschdorf, Podelzig, Lebus', zip: '15326'},
    { city: 'Briesen, Rauen u.a.', zip: '15518'},
    { city: 'Großschönau', zip: '02799'},
    { city: 'Krauschwitz, Weißkeißel', zip: '02957'},
    { city: 'Jonsdorf', zip: '02796'},
    { city: 'Weilheim i. OB', zip: '82362'},
    { city: 'Nürnberg', zip: '90409'},
    { city: 'Nürnberg', zip: '90478'},
    { city: 'Eching a. Ammersee', zip: '82279'},
    { city: 'Oschersleben (Bode)', zip: '39387'},
    { city: 'Nassenfels', zip: '85128'},
    { city: 'Haldensleben, Flechtingen, Bülstringen u.a.', zip: '39345'},
    { city: 'Egweil', zip: '85116'},
    { city: 'Sulzemoos', zip: '85254'},
    { city: 'Sulzemoos', zip: '85259'},
    { city: 'Erdweg', zip: '85253'},
    { city: 'Buttstädt, Großbrembach, Kleinbrembach', zip: '99628'},
    { city: 'Weißenbrunn', zip: '96369'},
    { city: 'Arnstein', zip: '06456'},
    { city: 'Allstedt', zip: '06542'},
    { city: 'Gartow', zip: '29471'},
    { city: 'Penzberg', zip: '82377'},
    { city: 'Böhmfeld', zip: '85113'},
    { city: 'Weißenfels, Stößen', zip: '06667'},
    { city: 'Selb', zip: '95100'},
    { city: 'Lützen', zip: '06686'},
    { city: 'Großkarolinenfeld', zip: '83109'},
    { city: 'Höchstädt', zip: '95186'},
    { city: 'Krummennaab', zip: '92703'},
    { city: 'Ergolding, Landshut', zip: '84030'},
    { city: 'Neufahrn i. NB', zip: '84088'},
    { city: 'Neubeuern', zip: '83115'},
    { city: 'Bitterfeld-Wolfen', zip: '06766'},
    { city: 'Roggentin, Broderstorf u.a.', zip: '18184'},
    { city: 'Schwindegg', zip: '84419'},
    { city: 'Bruck i.d. OPf.', zip: '92436'},
    { city: 'Zwenkau', zip: '04442'},
    { city: 'Muldestausee', zip: '06774'},
    { city: 'Wörth a.d. Isar', zip: '84109'},
    { city: 'Schönberg', zip: '84573'},
    { city: 'Zwickau', zip: '08066'},
    { city: 'Gottfrieding', zip: '84177'},
    { city: 'Niemegk', zip: '14823'},
    { city: 'Oberschneiding', zip: '94363'},
    { city: 'Colditz', zip: '04680'},
    { city: 'Oberlungwitz', zip: '09353'},
    { city: 'Breitenbrunn/Erzgeb.', zip: '08359'},
    { city: 'Neuruppin', zip: '16816'},
    { city: 'Rheinsberg', zip: '16831'},
    { city: 'Schwarzach', zip: '94374'},
    { city: 'Bernried', zip: '94505'},
    { city: 'Burkhardtsdorf', zip: '09235'},
    { city: 'Eschlkam', zip: '93458'},
    { city: 'Buchhofen', zip: '94533'},
    { city: 'Penzlin', zip: '17217'},
    { city: 'Falkensee', zip: '14612'},
    { city: 'Berlin Wilhelmstadt', zip: '13593'},
    { city: 'Berlin Falkenhagener Feld', zip: '13589'},
    { city: 'Dranske', zip: '18556'},
    { city: 'Frauenau', zip: '94258'},
    { city: 'Berlin Westend', zip: '14050'},
    { city: 'Fürstenzell', zip: '94081'},
    { city: 'Berlin Reinickendorf', zip: '13509'},
    { city: 'Schönberg', zip: '94513'},
    { city: 'Berlin Lichtenfelde', zip: '12207'},
    { city: 'Berlin-West', zip: '10823'},
    { city: 'Berlin Mitte', zip: '10178'},
    { city: 'Golßen', zip: '15938'},
    { city: 'Schönefeld', zip: '12529'},
    { city: 'Kulmbach', zip: '95326'},
    { city: 'Dachau', zip: '85221'},
    { city: 'Wismar, Groß Krankow u.a.', zip: '23966'},
    { city: 'Neudrossenfeld', zip: '95512'},
    { city: 'Wismar, Groß Krankow u.a.', zip: '23966'},
    { city: 'Pilsach', zip: '92367'},
    { city: 'Altmannstein', zip: '93336'},
    { city: 'Jena', zip: '07743'},
    { city: 'Bayreuth', zip: '95448'},
    { city: 'München', zip: '80469'},
    { city: 'München', zip: '80807'},
    { city: 'München', zip: '81669'},
    { city: 'Welsleben, Biere, Eickendorf u.a.', zip: '39221'},
    { city: 'Domsühl, Mestlin, Obere Warnow u.a.', zip: '19374'},
    { city: 'Mainburg', zip: '84048'},
    { city: 'Kühlungsborn', zip: '18225'},
    { city: 'Vilseck', zip: '92249'},
    { city: 'Magdeburg', zip: '39114'},
    { city: 'Moosach', zip: '85665'},
    { city: 'Mauern', zip: '85419'},
    { city: 'Erding', zip: '85435'},
    { city: 'Kirschkau, Pausa-Mühltroff', zip: '07919'},
    { city: 'Ensdorf', zip: '92266'},
    { city: 'Inchenhofen', zip: '86570'},
    { city: 'Schrobenhausen', zip: '86529'},
    { city: 'Mittenwald', zip: '82481'},
    { city: 'Pöcking', zip: '82343'},
    { city: 'Ingolstadt', zip: '85051'},
    { city: 'Föhr', zip: '25938'},
    { city: 'Bürstadt', zip: '68642'},
    { city: 'Brigachtal', zip: '78086'},
    { city: 'Barver, Dickel, Hemsloh, Rehden, Wetschen, Wehrblecker Heide', zip: '49453'},
    { city: 'Mannheim', zip: '68161'},
    { city: 'Wehrheim', zip: '61273'},
    { city: 'Neuweiler', zip: '75389'},
    { city: 'Horb am Neckar', zip: '72160'},
    { city: 'Frankfurt am Main', zip: '65934'},
    { city: 'Bielefeld', zip: '33719'},
    { city: 'Frankfurt am Main', zip: '60489'},
    { city: 'Lahntal', zip: '35094'},
    { city: 'Schiffdorf', zip: '27619'},
    { city: 'Frankfurt am Main', zip: '60437'},
    { city: 'Schriesheim', zip: '69198'},
    { city: 'Pforzheim', zip: '75173'},
    { city: 'Wiesloch', zip: '69168'},
    { city: 'Ritterhude', zip: '27721'},
    { city: 'Sulzfeld', zip: '75056'},
    { city: 'Egesheim', zip: '78592'},
    { city: 'Grafenau', zip: '71120'},
    { city: 'Haina', zip: '35114'},
    { city: 'Oberzent', zip: '64760'},
    { city: 'Steißlingen', zip: '78256'},
    { city: 'Minden', zip: '32423'},
    { city: 'Hanau', zip: '63450'},
    { city: 'Helmstadt-Bargen', zip: '74921'},
    { city: 'Böblingen', zip: '71034'},
    { city: 'Weil im Schönbuch', zip: '71093'},
    { city: 'Helpsen, Seggebruch', zip: '31691'},
    { city: 'Kleinostheim', zip: '63801'},
    { city: 'Kefenrod', zip: '63699'},
    { city: 'Pliezhausen', zip: '72124'},
    { city: 'Auetal', zip: '31749'},
    { city: 'Reichenau', zip: '78479'},
    { city: 'Bietigheim-Bissingen', zip: '74321'},
    { city: 'Eystrup, Hassel u.a.', zip: '27324'},
    { city: 'Pfullendorf', zip: '88630'},
    { city: 'Konstanz', zip: '78465'},
    { city: 'Stuttgart', zip: '70190'},
    { city: 'Buchen', zip: '74722'},
    { city: 'Zierenberg', zip: '34289'},
    { city: 'Walldürn', zip: '74731'},
    { city: 'Calden', zip: '34379'},
    { city: 'Trendelburg', zip: '34388'},
    { city: 'Dellstedt', zip: '25786'},
    { city: 'Jossgrund', zip: '63637'},
    { city: 'Höpfingen', zip: '74746'},
    { city: 'Künzell', zip: '36093'},
    { city: 'Aukrug, Wiedenborstel', zip: '24613'},
    { city: 'Süßen', zip: '73079'},
    { city: 'Neu Wulmstorf', zip: '21629'},
    { city: 'Himmelstadt', zip: '97267'},
    { city: 'Sulzbach-Laufen', zip: '74429'},
    { city: 'Tangstedt', zip: '25499'},
    { city: 'Höchberg', zip: '97204'},
    { city: 'Hausen b. Würzburg', zip: '97262'},
    { city: 'Hamburg', zip: '22081'},
    { city: 'Euerbach', zip: '97502'},
    { city: 'Aalen', zip: '73432'},
    { city: 'Schnelldorf', zip: '91625'},
    { city: 'Hamburg', zip: '22147'},
    { city: 'Barsbüttel', zip: '22885'},
    { city: 'Kiel', zip: '24148'},
    { city: 'Bad Grönenbach', zip: '87730'},
    { city: 'Hamburg', zip: '21039'},
    { city: 'Dietmannsried', zip: '87463'},
    { city: 'Sülfeld', zip: '23867'},
    { city: 'Bad Segeberg', zip: '23795'},
    { city: 'Seth', zip: '23845'},
    { city: 'Wendeburg', zip: '38176'},
    { city: 'Müden (Aller)', zip: '38539'},
    { city: 'Marktbergel', zip: '91613'},
    { city: 'Donnersdorf', zip: '97499'},
    { city: 'Ummern', zip: '29369'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Finningen', zip: '89435'},
    { city: 'Sollstedt', zip: '99759'},
    { city: 'Ehingen', zip: '91725'},
    { city: 'Rammingen', zip: '86871'},
    { city: 'Isenbüttel', zip: '38550'},
    { city: 'Lübeck', zip: '23556'},
    { city: 'Alerheim', zip: '86733'},
    { city: 'Dachsbach', zip: '91462'},
    { city: 'Suhl', zip: '98528'},
    { city: 'Schwangau', zip: '87645'},
    { city: 'Viereth-Trunstadt', zip: '96191'},
    { city: 'Stoetze', zip: '29597'},
    { city: 'Zernien', zip: '29499'},
    { city: 'Vellahn', zip: '19260'},
    { city: 'Thaining', zip: '86943'},
    { city: 'Friedberg', zip: '86316'},
    { city: 'Klötze, Apenburg-Winterfeld', zip: '38486'},
    { city: 'Bayersoien', zip: '82435'},
    { city: 'Moorenweis', zip: '82272'},
    { city: 'Erlangen', zip: '91054'},
    { city: 'Fuldabrück', zip: '34277'},
    { city: 'Unlingen', zip: '88527'},
    { city: 'Oberweser', zip: '34399'},
    { city: 'Haseldorf', zip: '25489'},
    { city: 'Hann. Münden, Gutsbezirk Reinhardswald', zip: '34346'},
    { city: 'Tauberbischofsheim', zip: '97941'},
    { city: 'Lüerdissen', zip: '37635'},
    { city: 'Neuenkirchen', zip: '29643'},
    { city: 'Grünkraut', zip: '88287'},
    { city: 'Lindau (Bodensee)', zip: '88131'},
    { city: 'Berlin Neukölln', zip: '12059'},
    { city: 'Weinböhla', zip: '01689'},
    { city: 'Werneuchen', zip: '16356'},
    { city: 'Wildau', zip: '15745'},
    { city: 'Eberswalde', zip: '16225'},
    { city: 'Dresden', zip: '01187'},
    { city: 'Haidmühle', zip: '94145'},
    { city: 'Dresden', zip: '01189'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Spreenhagen', zip: '15528'},
    { city: 'Wolgast', zip: '17438'},
    { city: 'Liebstadt', zip: '01825'},
    { city: 'Bahretal', zip: '01819'},
    { city: 'Blankensee, Grambow u.a.', zip: '17322'},
    { city: 'Seelow, Lietzen u.a.', zip: '15306'},
    { city: 'Bautzen', zip: '02625'},
    { city: 'Brieskow-Finkenheerd', zip: '15295'},
    { city: 'Oderwitz', zip: '02791'},
    { city: 'Mönchengladbach', zip: '41169'},
    { city: 'Saarburg', zip: '54439'},
    { city: 'Pronsfeld', zip: '54597'},
    { city: 'Willich', zip: '47877'},
    { city: 'Bocholt', zip: '46399'},
    { city: 'Langsur', zip: '54308'},
    { city: 'Krefeld', zip: '47805'},
    { city: 'Pelm, Neroth u.a.', zip: '54570'},
    { city: 'Walsdorf, Nohn u.a.', zip: '54578'},
    { city: 'Düsseldorf', zip: '40545'},
    { city: 'Euskirchen', zip: '53879'},
    { city: 'Kell am See', zip: '54427'},
    { city: 'Köln', zip: '50769'},
    { city: 'Schmelz', zip: '66839'},
    { city: 'Mülheim an der Ruhr', zip: '45481'},
    { city: 'Düsseldorf', zip: '40627'},
    { city: 'Trittenheim', zip: '54349'},
    { city: 'Köln', zip: '50825'},
    { city: 'Dorsten', zip: '46286'},
    { city: 'Gladbeck', zip: '45966'},
    { city: 'Köln', zip: '50735'},
    { city: 'Essen', zip: '45149'},
    { city: 'Leverkusen', zip: '51377'},
    { city: 'Gelsenkirchen', zip: '45899'},
    { city: 'Sulzbach/Saar', zip: '66280'},
    { city: 'Dortmund', zip: '44225'},
    { city: 'Münster', zip: '48161'},
    { city: 'Schalksmühle', zip: '58579'},
    { city: 'Urmitz', zip: '56220'},
    { city: 'Kleinmaischeid', zip: '56271'},
    { city: 'Wangerland', zip: '26434'},
    { city: 'Nentershausen, Hübingen, Niederelbert u.a.', zip: '56412'},
    { city: 'Nauroth', zip: '57583'},
    { city: 'Quakenbrück', zip: '49610'},
    { city: 'Siegen', zip: '57078'},
    { city: 'Albig', zip: '55234'},
    { city: 'Nisterau u.a.', zip: '56472'},
    { city: 'Ockenheim', zip: '55437'},
    { city: 'Osnabrück', zip: '49078'},
    { city: 'Gehrde', zip: '49596'},
    { city: 'Sassenberg', zip: '48336'},
    { city: 'Gau-Algesheim', zip: '55435'},
    { city: 'Billigheim-Ingenheim, Birkweiler', zip: '76831'},
    { city: 'Eltville am Rhein', zip: '65347'},
    { city: 'Hilchenbach', zip: '57271'},
    { city: 'Laufenburg (Baden)', zip: '79725'},
    { city: 'Lindenberg', zip: '67473'},
    { city: 'Dierdorf', zip: '56269'},
    { city: 'Urbar (bei Koblenz)', zip: '56182'},
    { city: 'Spay', zip: '56322'},
    { city: 'Uplengen', zip: '26670'},
    { city: 'Hamm', zip: '59077'},
    { city: 'Ehrenkirchen', zip: '79238'},
    { city: 'Obermoschel, Schiersfeld', zip: '67823'},
    { city: 'Merzen, Neuenkirchen', zip: '49586'},
    { city: 'Bornich, Patersberg', zip: '56348'},
    { city: 'Nassau', zip: '56377'},
    { city: 'Hinterweidenthal', zip: '66999'},
    { city: 'Rhaunen', zip: '55624'},
    { city: 'Bochum', zip: '44894'},
    { city: 'Much', zip: '53804'},
    { city: 'Lonnig', zip: '56295'},
    { city: 'Herdecke', zip: '58313'},
    { city: 'Neustadt (Wied)', zip: '53577'},
    { city: 'Hennweiler', zip: '55619'},
    { city: 'Essen', zip: '45276'},
    { city: 'Köln', zip: '51145'},
    { city: 'Sankt Wendel', zip: '66606'},
    { city: 'Ottweiler', zip: '66564'},
    { city: 'Ediger-Eller', zip: '56814'},
    { city: 'Cochem', zip: '56812'},
    { city: 'Irmenach', zip: '56843'},
    { city: 'Wuppertal', zip: '42279'},
    { city: 'Emsbüren', zip: '48488'},
    { city: 'Remscheid', zip: '42897'},
    { city: 'Neustadt an der Weinstraße', zip: '67435'},
    { city: 'Beselich', zip: '65614'},
    { city: 'Bad Sassendorf', zip: '59505'},
    { city: 'Kindenheim', zip: '67271'},
    { city: 'Mainz', zip: '55122'},
    { city: 'Ovelgönne', zip: '26939'},
    { city: 'Halle/ Saale', zip: '06122'},
    { city: 'Marktleuthen', zip: '95168'},
    { city: 'Bruckberg', zip: '84079'},
    { city: 'Pettendorf', zip: '93186'},
    { city: 'Kohlberg', zip: '92702'},
    { city: 'Weißenfels', zip: '06688'},
    { city: 'Rostock, Papendorf u.a.', zip: '18059'},
    { city: 'Raubling', zip: '83064'},
    { city: 'Weiden in der OPf., Theisseil', zip: '92637'},
    { city: 'Regensburg', zip: '93047'},
    { city: 'Plauen', zip: '08523'},
    { city: 'Stulln', zip: '92551'},
    { city: 'Schkeuditz', zip: '04435'},
    { city: 'Babensham', zip: '83547'},
    { city: 'Neustadt (Dosse) u.a.', zip: '16845'},
    { city: 'Wredenhagen', zip: '17209'},
    { city: 'Bitterfeld-Wolfen', zip: '06749'},
    { city: 'Lengenfeld', zip: '08485'},
    { city: 'Sanitz', zip: '18190'},
    { city: 'Rackwitz', zip: '04519'},
    { city: 'Leipzig', zip: '04177'},
    { city: 'Zell', zip: '93199'},
    { city: 'Kraiburg a. Inn', zip: '84559'},
    { city: 'Grabowhöfe, Moltzow u.a.', zip: '17194'},
    { city: 'Klingenthal/Sa.', zip: '08248'},
    { city: 'Leipzig', zip: '04288'},
    { city: 'Wittenberg', zip: '06886'},
    { city: 'Frohburg', zip: '04654'},
    { city: 'Zingst a. Darß', zip: '18374'},
    { city: 'Tittmoning', zip: '84529'},
    { city: 'Möllenbeck', zip: '17237'},
    { city: 'Chemnitz', zip: '09122'},
    { city: 'Dallgow-Döberitz', zip: '14624'},
    { city: 'Hengersberg', zip: '94491'},
    { city: 'Iggensbach', zip: '94547'},
    { city: 'Großschirma', zip: '09603'},
    { city: 'Teltow', zip: '14513'},
    { city: 'Berlin Frohnau', zip: '13465'},
    { city: 'Berlin Wilmersdorf', zip: '10717'},
    { city: 'Lichtenberg/Erzgeb.', zip: '09638'},
    { city: 'Berlin Schöneberg', zip: '10779'},
    { city: 'Blankenfelde-Mahlow', zip: '15831'},
    { city: 'Nünchritz, Glaubitz', zip: '01612'},
    { city: 'Greifswald', zip: '17491'},
    { city: 'Berlin Neukölln', zip: '12051'},
    { city: 'Berlin Weißensee', zip: '13088'},
    { city: 'Berlin Teltowkanal III', zip: '12489'},
    { city: 'Berlin', zip: '12685'},
    { city: 'Berlin', zip: '12679'},
    { city: 'Berlin Hellersdorf', zip: '12627'},
    { city: 'Dresden', zip: '01257'},
    { city: 'Radeberg, Wachau', zip: '01454'},
    { city: 'Pirna, Struppen, Dohma', zip: '01796'},
    { city: 'Vogelsang-Warsin, Meiersberg, Mönkebude u.a.', zip: '17375'},
    { city: 'Wehlen', zip: '01829'},
    { city: 'Senftenberg', zip: '01996'},
    { city: 'Cottbus', zip: '03044'},
    { city: 'Treplin, Jacobsdorf, Frankfurt (Oder)', zip: '15236'},
    { city: 'Treplin, Jacobsdorf, Frankfurt (Oder)', zip: '15236'},
    { city: 'Jänschwalde', zip: '03197'},
    { city: 'Frankfurt/ Oder', zip: '15232'},
    { city: 'Krauschwitz, Weißkeißel', zip: '02957'},
    { city: 'Hamm', zip: '59069'},
    { city: 'Niederfischbach', zip: '57572'},
    { city: 'Bad Kreuznach', zip: '55543'},
    { city: 'Enkenbach-Alsenborn', zip: '67677'},
    { city: 'Freiburg im Breisgau', zip: '79102'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Kirchzarten', zip: '79199'},
    { city: 'Daaden', zip: '57567'},
    { city: 'Sprendlingen', zip: '55576'},
    { city: 'Arnsberg', zip: '59755'},
    { city: 'Cappeln (Oldenburg)', zip: '49692'},
    { city: 'Osnabrück', zip: '49082'},
    { city: 'Siegen', zip: '57074'},
    { city: 'Hinterzarten', zip: '79856'},
    { city: 'Eslohe', zip: '59889'},
    { city: 'Aachen', zip: '52070'},
    { city: 'Üttfeld', zip: '54619'},
    { city: 'Stolberg', zip: '52224'},
    { city: 'Uedem', zip: '47589'},
    { city: 'Kevelaer-Kervenheim', zip: '47627'},
    { city: 'Jülich', zip: '52428'},
    { city: 'Ferschweiler', zip: '54668'},
    { city: 'Isselburg', zip: '46419'},
    { city: 'Mönchengladbach', zip: '41238'},
    { city: 'Bitburg', zip: '54634'},
    { city: 'Badem, Gindorf, Neidenbach', zip: '54657'},
    { city: 'Trier', zip: '54294'},
    { city: 'Pelm, Neroth u.a.', zip: '54570'},
    { city: 'Trier', zip: '54296'},
    { city: 'Kerpen', zip: '50170'},
    { city: 'Pellingen', zip: '54331'},
    { city: 'Duisburg', zip: '47228'},
    { city: 'Osburg, Gusterath, Farschweiler, Kasel u.a.', zip: '54317'},
    { city: 'Waldrach', zip: '54320'},
    { city: 'Reifferscheid, Kaltenborn, Wershofen u.a.', zip: '53520'},
    { city: 'Weilerswist', zip: '53919'},
    { city: 'Düsseldorf', zip: '40210'},
    { city: 'Düsseldorf', zip: '40211'},
    { city: 'Mülheim an der Ruhr', zip: '45472'},
    { city: 'Gescher', zip: '48712'},
    { city: 'Essen', zip: '45131'},
    { city: 'Mülheim (Mosel)', zip: '54486'},
    { city: 'Wuppertal', zip: '42329'},
    { city: 'Legden', zip: '48739'},
    { city: 'Steinwenden u.a.', zip: '66879'},
    { city: 'Lünen', zip: '44532'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Bergkamen', zip: '59192'},
    { city: 'Kamp-Bornhofen-Filsen', zip: '56341'},
    { city: 'Münster', zip: '48151'},
    { city: 'Großmaischeid', zip: '56276'},
    { city: 'Schallbach', zip: '79597'},
    { city: 'Bergneustadt', zip: '51702'},
    { city: 'Grenzach-Wyhlen', zip: '79639'},
    { city: 'Krickenbach', zip: '67706'},
    { city: 'Mammelzen', zip: '57636'},
    { city: 'Fachbach, Exklave Lahnstein', zip: '56133'},
    { city: 'Schopp', zip: '67707'},
    { city: 'Nußbach', zip: '67759'},
    { city: 'Kaiserslautern', zip: '67661'},
    { city: 'Werdohl', zip: '58791'},
    { city: 'Hachenburg', zip: '57627'},
    { city: 'Schopfheim', zip: '79650'},
    { city: 'Freiburg im Breisgau', zip: '79108'},
    { city: 'Alsenz', zip: '67821'},
    { city: 'Attendorn', zip: '57439'},
    { city: 'Belm', zip: '49191'},
    { city: 'Lenzkirch', zip: '79853'},
    { city: 'Mengerskirchen', zip: '35794'},
    { city: 'Villmar', zip: '65606'},
    { city: 'Oldenburg (Oldenburg)', zip: '26127'},
    { city: 'Flörsheim-Dalsheim', zip: '67592'},
    { city: 'Mainz', zip: '55128'},
    { city: 'Erwitte', zip: '59597'},
    { city: 'Offstein', zip: '67591'},
    { city: 'Worms', zip: '67550'},
    { city: 'Schramberg', zip: '78144'},
    { city: 'Lauchringen', zip: '79787'},
    { city: 'Unterkirnach', zip: '78089'},
    { city: 'Unterkirnach', zip: '78089'},
    { city: 'Vettelschloß, Kretzhaus (Linz am Rhein)', zip: '53560'},
    { city: 'Bochum', zip: '44892'},
    { city: 'Münstermaifeld', zip: '56294'},
    { city: 'Dortmund', zip: '44379'},
    { city: 'Kobern-Gondorf', zip: '56330'},
    { city: 'Selm', zip: '59379'},
    { city: 'Ediger-Eller', zip: '56814'},
    { city: 'Solingen', zip: '42651'},
    { city: 'Peterswald-Löffelscheid u.a.', zip: '56858'},
    { city: 'Recklinghausen', zip: '45661'},
    { city: 'Emden', zip: '26725'},
    { city: 'Peterswald-Löffelscheid u.a.', zip: '56858'},
    { city: 'Pommern', zip: '56829'},
    { city: 'Henfenfeld', zip: '91239'},
    { city: 'Dorf Mecklenburg, Lübow u.a.', zip: '23972'},
    { city: 'Geretsried', zip: '82538'},
    { city: 'Velden/Hartenstein', zip: '91235'},
    { city: 'Lauterhofen', zip: '92283'},
    { city: 'Eckartsberga', zip: '06648'},
    { city: 'Glashütten', zip: '95496'},
    { city: 'Wurzbach', zip: '07343'},
    { city: 'München', zip: '81479'},
    { city: 'Ernsgaden', zip: '85119'},
    { city: 'München', zip: '80797'},
    { city: 'Unterhaching', zip: '82008'},
    { city: 'Dornburg-Camburg u.a.', zip: '07774'},
    { city: 'Magdeburg', zip: '39124'},
    { city: 'Au in der Hallertau', zip: '84072'},
    { city: 'Issigau', zip: '95188'},
    { city: 'Kemnath', zip: '95478'},
    { city: 'Bad Kohlgrub', zip: '82433'},
    { city: 'Bilzingsleben Kannawurf Oldisleben', zip: '06578'},
    { city: 'Kirchehrenbach', zip: '91356'},
    { city: 'Udestedt, Mönchenholzhausen u.a.', zip: '99198'},
    { city: 'Leutenbach', zip: '91359'},
    { city: 'Thalmässing', zip: '91177'},
    { city: 'Bad Berka u.a.', zip: '99438'},
    { city: 'Ohlstadt', zip: '82441'},
    { city: 'Boltenhagen', zip: '23946'},
    { city: 'Maisach', zip: '82216'},
    { city: 'Falkenstein', zip: '06543'},
    { city: 'Weßling', zip: '82234'},
    { city: 'Wismar, Groß Krankow u.a.', zip: '23966'},
    { city: 'Bad Kleinen u.a.', zip: '23996'},
    { city: 'Thurnau', zip: '95349'},
    { city: 'Haldensleben', zip: '39340'},
    { city: 'Göppingen', zip: '73037'},
    { city: 'Birenbach', zip: '73102'},
    { city: 'Gschwend', zip: '74417'},
    { city: 'Braunsbach', zip: '74542'},
    { city: 'Hamburg', zip: '22589'},
    { city: 'Hettstadt', zip: '97265'},
    { city: 'Hamburg', zip: '21149'},
    { city: 'Ummendorf', zip: '88444'},
    { city: 'Witzenhausen', zip: '37215'},
    { city: 'Jesteburg', zip: '21266'},
    { city: 'Northeim', zip: '37154'},
    { city: 'Hamburg', zip: '22527'},
    { city: 'Ulm', zip: '89081'},
    { city: 'Ulm', zip: '89081'},
    { city: 'Hamburg', zip: '21077'},
    { city: 'Göttingen', zip: '37077'},
    { city: 'Hamburg', zip: '22453'},
    { city: 'Gelchsheim, Sonderhofen', zip: '97255'},
    { city: 'Unterbreizbach', zip: '36414'},
    { city: 'Kiel', zip: '24107'},
    { city: 'Gaukönigshofen', zip: '97253'},
    { city: 'Hamburg', zip: '20249'},
    { city: 'Brackel', zip: '21438'},
    { city: 'Hamburg', zip: '22177'},
    { city: 'Hamburg', zip: '22111'},
    { city: 'Kiel', zip: '24145'},
    { city: 'Nüdlingen', zip: '97720'},
    { city: 'Hamburg', zip: '22045'},
    { city: 'Peine', zip: '31226'},
    { city: 'Tiefenort', zip: '36469'},
    { city: 'Fichtenau', zip: '74579'},
    { city: 'Oberroth', zip: '89294'},
    { city: 'Baddeckenstedt', zip: '38271'},
    { city: 'Küllstedt', zip: '37359'},
    { city: 'Maßbach', zip: '97711'},
    { city: 'Rodeberg, Dünwald u.a.', zip: '99976'},
    { city: 'Breitungen/Werra', zip: '98597'},
    { city: 'Ichenhausen', zip: '89335'},
    { city: 'Rödelsee', zip: '97348'},
    { city: 'Elmenhorst', zip: '23869'},
    { city: 'Gochsheim', zip: '97469'},
    { city: 'Bad Oldesloe', zip: '23843'},
    { city: 'Barchfeld-Immelborn', zip: '36456'},
    { city: 'Wiesentheid', zip: '97353'},
    { city: 'Großhansdorf', zip: '22927'},
    { city: 'Reppenstedt, Lüneburg', zip: '21391'},
    { city: 'Haverlah', zip: '38275'},
    { city: 'Seth', zip: '23845'},
    { city: 'Altenau, Schulenberg', zip: '38707'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Fremdingen', zip: '86742'},
    { city: 'Schwülper', zip: '38179'},
    { city: 'Ebrach', zip: '96157'},
    { city: 'Floh-Seligenthal', zip: '98593'},
    { city: 'Geesthacht', zip: '21502'},
    { city: 'Eppishausen', zip: '87745'},
    { city: 'Holzheim', zip: '89438'},
    { city: 'Wassertrüdingen', zip: '91717'},
    { city: 'Karlsruhe', zip: '76131'},
    { city: 'Marxzell', zip: '76359'},
    { city: 'Stutensee', zip: '76297'},
    { city: 'Niedereschach', zip: '78078'},
    { city: 'Villingendorf', zip: '78667'},
    { city: 'Mannheim', zip: '68229'},
    { city: 'Schömberg', zip: '75328'},
    { city: 'Darmstadt', zip: '64297'},
    { city: 'Nußloch', zip: '69226'},
    { city: 'Nagold', zip: '72202'},
    { city: 'Frankfurt am Main', zip: '60389'},
    { city: 'Bremen', zip: '28239'},
    { city: 'Nordstrand, Elisabeth-Sophien-Koog, Südfall', zip: '25845'},
    { city: 'Knittlingen', zip: '75438'},
    { city: 'Offenbach am Main', zip: '63071'},
    { city: 'Offenbach am Main', zip: '63071'},
    { city: 'Böttingen', zip: '78583'},
    { city: 'Warmsen', zip: '31606'},
    { city: 'Mahlstetten', zip: '78601'},
    { city: 'Reiskirchen', zip: '35447'},
    { city: 'Altenbeken', zip: '33184'},
    { city: 'Neckarbischofsheim', zip: '74924'},
    { city: 'Mühlingen', zip: '78357'},
    { city: 'Karlstein am Main', zip: '63791'},
    { city: 'Breuberg', zip: '64747'},
    { city: 'Sindelfingen', zip: '71063'},
    { city: 'Eddelak, Averlak, Dingen, Ramhusen', zip: '25715'},
    { city: 'Stuttgart', zip: '70563'},
    { city: 'Heilbronn', zip: '74080'},
    { city: 'Aerzen', zip: '31855'},
    { city: 'Offenau', zip: '74254'},
    { city: 'Ostenfeld', zip: '25872'},
    { city: 'Winnert', zip: '25887'},
    { city: 'Stuttgart', zip: '70188'},
    { city: 'Jörl', zip: '24992'},
    { city: 'Oedheim', zip: '74229'},
    { city: 'Wanderup', zip: '24997'},
    { city: 'Nürtingen', zip: '72622'},
    { city: 'Großbettlingen', zip: '72663'},
    { city: 'Stetten', zip: '88719'},
    { city: 'Bad Münder am Deister', zip: '31848'},
    { city: 'Baunatal', zip: '34225'},
    { city: 'Homberg', zip: '34576'},
    { city: 'Deggenhausertal', zip: '88693'},
    { city: 'Ottenstein', zip: '31868'},
    { city: 'Riedlingen', zip: '88499'},
    { city: 'Scheeßel', zip: '27383'},
    { city: 'Bad Wörishofen', zip: '86825'},
    { city: 'Bad Colberg-Heldburg', zip: '98663'},
    { city: 'Ebern', zip: '96106'},
    { city: 'Sickte, Dettum u.a.', zip: '38173'},
    { city: 'Hainsfarth', zip: '86744'},
    { city: 'Sterley', zip: '23883'},
    { city: 'Heidenheim', zip: '91719'},
    { city: 'Ratekau', zip: '23626'},
    { city: 'Langenzenn', zip: '90579'},
    { city: 'Treuchtlingen', zip: '91757'},
    { city: 'Oberreichenbach', zip: '91097'},
    { city: 'Otting', zip: '86700'},
    { city: 'Blankenburg, Oberharz am Brocken', zip: '38889'},
    { city: 'Schnega', zip: '29465'},
    { city: 'Rühen', zip: '38471'},
    { city: 'Großenseebach', zip: '91091'},
    { city: 'Röttenbach', zip: '91341'},
    { city: 'Ballenstedt, Harzgerode', zip: '06493'},
    { city: 'Oberasbach', zip: '90522'},
    { city: 'Röttenbach', zip: '91187'},
    { city: 'Jameln', zip: '29479'},
    { city: 'Lübtheen', zip: '19249'},
    { city: 'Buttenheim', zip: '96155'},
    { city: 'Kassel', zip: '34119'},
    { city: 'Ravensburg', zip: '88213'},
    { city: 'Stadtoldendorf u.a.', zip: '37627'},
    { city: 'Salzhemmendorf', zip: '31020'},
    { city: 'Kaufungen', zip: '34260'},
    { city: 'Reinhardshagen', zip: '34359'},
    { city: 'Schaalby, Geelbek', zip: '24882'},
    { city: 'Karbach', zip: '97842'},
    { city: 'Jork', zip: '21635'},
    { city: 'Weida, Harth-Pöllnitz, Wünschendorf', zip: '07570'},
    { city: 'Goldberg', zip: '19399'},
    { city: 'Wartenberg', zip: '85456'},
    { city: 'Kabelsketal', zip: '06184'},
    { city: 'Milower Land, Schollene, Nennhausen u.a.', zip: '14715'},
    { city: 'Neuensalz', zip: '08541'},
    { city: 'Leipzig', zip: '04249'},
    { city: 'Raguhn-Jeßnitz', zip: '06800'},
    { city: 'Reichenbach', zip: '93189'},
    { city: 'Leipzig', zip: '04129'},
    { city: 'Nobitz, Göhren, Windischleuba', zip: '04603'},
    { city: 'Perkam', zip: '94368'},
    { city: 'Michelsneukirchen', zip: '93185'},
    { city: 'Grabenstätt', zip: '83355'},
    { city: 'Töging a. Inn', zip: '84513'},
    { city: 'Winhöring', zip: '84543'},
    { city: 'Kirchweidach', zip: '84558'},
    { city: 'Weiding', zip: '93495'},
    { city: 'Dommitzsch', zip: '04880'},
    { city: 'Furth i. Wald', zip: '93437'},
    { city: 'Stavenhagen', zip: '17153'},
    { city: 'Oberpöring', zip: '94562'},
    { city: 'Chemnitz', zip: '09116'},
    { city: 'Deggendorf', zip: '94469'},
    { city: 'Chemnitz', zip: '09120'},
    { city: 'Schlettau', zip: '09487'},
    { city: 'Mügeln', zip: '04769'},
    { city: 'Neukirchen b. Hl. Blut', zip: '93453'},
    { city: 'Zachenberg', zip: '94239'},
    { city: 'Simbach a. Inn', zip: '84359'},
    { city: 'Bad Birnbach', zip: '84364'},
    { city: 'Stralsund', zip: '18439'},
    { city: 'Berlin Gatow', zip: '14089'},
    { city: 'Stralsund', zip: '18439'},
    { city: 'Bentzin', zip: '17129'},
    { city: 'Bergen/ Rügen', zip: '18528'},
    { city: 'Berlin Steglitz', zip: '12165'},
    { city: 'Berlin Schöneberg', zip: '10789'},
    { city: 'Berlin Wedding', zip: '13349'},
    { city: 'Berlin', zip: '10825'},
    { city: 'Gröditz, Wülknitz, Röderaue', zip: '01609'},
    { city: 'Berlin Schöneberg', zip: '10781'},
    { city: 'Blankenfelde-Mahlow', zip: '15831'},
    { city: 'Wandlitz', zip: '16348'},
    { city: 'Berlin Französisch Buchholz', zip: '13127'},
    { city: 'Karlsburg', zip: '17495'},
    { city: 'Fürsteneck', zip: '94142'},
    { city: 'Remlingen', zip: '97280'},
    { city: 'Fulda', zip: '36037'},
    { city: 'Bergatreute', zip: '88368'},
    { city: 'Greußenheim', zip: '97259'},
    { city: 'Hannover', zip: '30159'},
    { city: 'Eberhardzell', zip: '88436'},
    { city: 'Kummerfeld', zip: '25495'},
    { city: 'Gnutz', zip: '24622'},
    { city: 'Hannover', zip: '30655'},
    { city: 'Großalmerode', zip: '37247'},
    { city: 'Thüngershem', zip: '97291'},
    { city: 'Oberthulba', zip: '97723'},
    { city: 'Warder', zip: '24646'},
    { city: 'Witzenhausen', zip: '37214'},
    { city: 'Lehrte', zip: '31275'},
    { city: 'Harsum', zip: '31177'},
    { city: 'Bad Gandersheim', zip: '37581'},
    { city: 'Harmstorf', zip: '21228'},
    { city: 'Kiel', zip: '24107'},
    { city: 'Neumünster', zip: '24534'},
    { city: 'Vacha, Unterbreizbach', zip: '36404'},
    { city: 'Mielkendorf', zip: '24247'},
    { city: 'Ulm', zip: '89073'},
    { city: 'Rottendorf', zip: '97228'},
    { city: 'Neenstetten', zip: '89189'},
    { city: 'Hamburg', zip: '20097'},
    { city: 'Balzheim', zip: '88481'},
    { city: 'Satteldorf', zip: '74589'},
    { city: 'Sievershütten', zip: '24641'},
    { city: 'Hohenroth', zip: '97618'},
    { city: 'Hamburg, Oststeinbek', zip: '22113'},
    { city: 'Weitnau', zip: '87480'},
    { city: 'Hamburg', zip: '21035'},
    { city: 'Kronburg', zip: '87758'},
    { city: 'Edemissen', zip: '31234'},
    { city: 'Obernbreit', zip: '97342'},
    { city: 'Leipheim', zip: '89340'},
    { city: 'Bergrheinfeld', zip: '97493'},
    { city: 'Eicklingen', zip: '29358'},
    { city: 'Wiggensbach', zip: '87487'},
    { city: 'Ammersbek', zip: '22949'},
    { city: 'Rammingen', zip: '89192'},
    { city: 'Niederrieden', zip: '87767'},
    { city: 'Giengen an der Brenz', zip: '89537'},
    { city: 'Kettershausen', zip: '86498'},
    { city: 'Schwebheim', zip: '97525'},
    { city: 'Rettenberg', zip: '87549'},
    { city: 'Tensfeld', zip: '23824'},
    { city: 'Bad Hindelang', zip: '87541'},
    { city: 'Seedorf', zip: '23823'},
    { city: 'Lauingen (Donau)', zip: '89415'},
    { city: 'Oberdachstetten', zip: '91617'},
    { city: 'Wildpoldsried', zip: '87499'},
    { city: 'Aidhausen', zip: '97491'},
    { city: 'Römhild', zip: '98630'},
    { city: 'Hankensbüttel, Obernholz, Dedelstorf', zip: '29386'},
    { city: 'Friesenried', zip: '87654'},
    { city: 'Baudenbach', zip: '91460'},
    { city: 'Großengottern, Heroldishausen', zip: '99991'},
    { city: 'Waldfeucht, Heinsberg', zip: '52525'},
    { city: 'Aachen', zip: '52076'},
    { city: 'Aachen', zip: '52064'},
    { city: 'Pronsfeld', zip: '54597'},
    { city: 'Pronsfeld', zip: '54597'},
    { city: 'Rees', zip: '46459'},
    { city: 'Rittersdorf u.a.', zip: '54636'},
    { city: 'Viersen', zip: '41747'},
    { city: 'Kreuzau', zip: '52372'},
    { city: 'Pellingen', zip: '54331'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Serrig', zip: '54455'},
    { city: 'Bergheim', zip: '50126'},
    { city: 'Hillesheim', zip: '54576'},
    { city: 'Schweich', zip: '54338'},
    { city: 'Schillingen', zip: '54429'},
    { city: 'Großrosseln', zip: '66352'},
    { city: 'Düsseldorf', zip: '40591'},
    { city: 'Düsseldorf', zip: '40629'},
    { city: 'Juist, Memmert', zip: '26571'},
    { city: 'Nonnweiler', zip: '66620'},
    { city: 'Essen', zip: '45219'},
    { city: 'Köln', zip: '50737'},
    { city: 'Maring-Noviand', zip: '54484'},
    { city: 'Meckenheim', zip: '53340'},
    { city: 'Köln', zip: '50996'},
    { city: 'Emden', zip: '26723'},
    { city: 'Saarbrücken', zip: '66130'},
    { city: 'Niederwörresbach', zip: '55758'},
    { city: 'Bonn', zip: '53225'},
    { city: 'Velbert', zip: '42555'},
    { city: 'Hattingen', zip: '45527'},
    { city: 'Bruchhausen, Unkel', zip: '53572'},
    { city: 'Bullay, Alf, Zell', zip: '56859'},
    { city: 'Ramstein-Miesenbach', zip: '66877'},
    { city: 'Thaleischweiler-Fröschen', zip: '66987'},
    { city: 'Koblenz', zip: '56070'},
    { city: 'Weilerbach u.a.', zip: '67685'},
    { city: 'Pirmasens', zip: '66955'},
    { city: 'Pfaffenhofen a.d. Ilm', zip: '85276'},
    { city: 'Rugendorf', zip: '95365'},
    { city: 'Reichertshausen', zip: '85293'},
    { city: 'Bad Bibra, Finne u.a.', zip: '06647'},
    { city: 'München', zip: '81377'},
    { city: 'Erxleben, Nordgermersleben u.a.', zip: '39343'},
    { city: 'München', zip: '80335'},
    { city: 'Staßfurt', zip: '39443'},
    { city: 'Stendal', zip: '39576'},
    { city: 'München', zip: '81541'},
    { city: 'Aschheim', zip: '85609'},
    { city: 'Ursensollen', zip: '92289'},
    { city: 'Essing', zip: '93343'},
    { city: 'Baldham', zip: '85598'},
    { city: 'Hausham', zip: '83734'},
    { city: 'Schliersee', zip: '83727'},
    { city: 'Frauenstein', zip: '09623'},
    { city: 'Hermsdorf/Erzgeb.', zip: '01776'},
    { city: 'Uckerland, Groß Luckow, Schönhausen', zip: '17337'},
    { city: 'Crinitz', zip: '03246'},
    { city: 'Dresden', zip: '01307'},
    { city: 'Schwarzheide N.L.', zip: '01987'},
    { city: 'Dresden', zip: '01328'},
    { city: 'Altdöbern, Luckaitztal', zip: '03229'},
    { city: 'Lauta', zip: '02991'},
    { city: 'Drebkau', zip: '03116'},
    { city: 'Cottbus', zip: '03051'},
    { city: 'Neuzelle', zip: '15898'},
    { city: 'Döbern', zip: '03159'},
    { city: 'Roth', zip: '91154'},
    { city: 'Schwanebeck, Gröningen, Kroppenstedt', zip: '39397'},
    { city: 'Nennslingen', zip: '91790'},
    { city: 'Wattendorf', zip: '96196'},
    { city: 'Andechs', zip: '82346'},
    { city: 'Weismain', zip: '96260'},
    { city: 'Döschnitz, Sitzendorf, Rohrbach', zip: '07429'},
    { city: 'Nürnberg-Feucht, Feuchter Forst', zip: '90537'},
    { city: 'Bergheim', zip: '86673'},
    { city: 'Küps', zip: '96328'},
    { city: 'Stockheim', zip: '96342'},
    { city: 'Gerolsbach', zip: '85302'},
    { city: 'Berngau', zip: '92361'},
    { city: 'Mönchweiler', zip: '78087'},
    { city: 'Mannheim', zip: '68159'},
    { city: 'Altrip', zip: '67122'},
    { city: 'Glatten', zip: '72293'},
    { city: 'Straubenhardt', zip: '75334'},
    { city: 'Grömbach', zip: '72294'},
    { city: 'Bromskirchen, Hallenberg', zip: '59969'},
    { city: 'Wetzlar', zip: '35584'},
    { city: 'Keltern', zip: '75210'},
    { city: 'Wörnersberg', zip: '72299'},
    { city: 'Sankt Leon-Rot', zip: '68789'},
    { city: 'Erzhausen', zip: '64390'},
    { city: 'Talheim', zip: '78607'},
    { city: 'Aldingen', zip: '78554'},
    { city: 'Darmstadt', zip: '64283'},
    { city: 'Frankfurt am Main', zip: '60596'},
    { city: 'Bremen', zip: '28717'},
    { city: 'Frankfurt am Main', zip: '60313'},
    { city: 'Denkingen', zip: '78588'},
    { city: 'Buseck', zip: '35418'},
    { city: 'Bad Salzuflen', zip: '32108'},
    { city: 'Offenbach am Main', zip: '63067'},
    { city: 'Detmold', zip: '32758'},
    { city: 'Mauer', zip: '69256'},
    { city: 'Allendorf', zip: '35469'},
    { city: 'Reinheim', zip: '64354'},
    { city: 'Wurmberg', zip: '75449'},
    { city: 'Schönbrunn', zip: '69436'},
    { city: 'Ammerbuch', zip: '72119'},
    { city: 'Neuhausen ob Eck', zip: '78579'},
    { city: 'Borstel', zip: '27246'},
    { city: 'Bremen', zip: '28329'},
    { city: 'Gilserberg', zip: '34630'},
    { city: 'Obrigheim', zip: '74847'},
    { city: 'Straßberg', zip: '72479'},
    { city: 'Liebenau', zip: '31618'},
    { city: 'Hohenfels', zip: '78355'},
    { city: 'Hemmoor', zip: '21745'},
    { city: 'Freigericht', zip: '63579'},
    { city: 'Blender', zip: '27337'},
    { city: 'Schieder-Schwalenberg', zip: '32816'},
    { city: 'Neufra', zip: '72419'},
    { city: 'Kirchentellinsfurt', zip: '72138'},
    { city: 'Stuttgart', zip: '70439'},
    { city: 'Stuttgart', zip: '70178'},
    { city: 'Altenriet', zip: '72657'},
    { city: 'Konstanz', zip: '78464'},
    { city: 'Tellingstedt', zip: '25782'},
    { city: 'Reutlingen', zip: '72760'},
    { city: 'Reutlingen', zip: '72764'},
    { city: 'Salem', zip: '88682'},
    { city: 'Neckartailfingen', zip: '72666'},
    { city: 'Brachttal', zip: '63636'},
    { city: 'Heuerßen', zip: '31700'},
    { city: 'Neuenstadt am Kocher', zip: '74196'},
    { city: 'Köngen', zip: '73257'},
    { city: 'Edermünde', zip: '34295'},
    { city: 'Fredenbeck', zip: '21717'},
    { city: 'Grebenstein', zip: '34393'},
    { city: 'Bollingstedt, Jübek', zip: '24855'},
    { city: 'Deizisau', zip: '73779'},
    { city: 'Neuhütten', zip: '97843'},
    { city: 'Erkenbrechtsweiler', zip: '73268'},
    { city: 'Barendorf, Vastorf', zip: '21397'},
    { city: 'Braunschweig', zip: '38106'},
    { city: 'Neuhof a.d.Zenn', zip: '90616'},
    { city: 'Tapfheim', zip: '86660'},
    { city: 'Tambach-Dietharz/ Thür.', zip: '99897'},
    { city: 'Sarkwitz', zip: '23629'},
    { city: 'Jengen', zip: '86860'},
    { city: 'Gunzenhausen', zip: '91710'},
    { city: 'Kutzenhausen', zip: '86500'},
    { city: 'Semmenstedt', zip: '38327'},
    { city: 'Breitbrunn', zip: '96151'},
    { city: 'Nordhausen', zip: '99734'},
    { city: 'Buchloe', zip: '86807'},
    { city: 'Stöttwang', zip: '87677'},
    { city: 'Oberhof', zip: '98559'},
    { city: 'Tappenbeck', zip: '38479'},
    { city: 'Wolfsburg', zip: '38448'},
    { city: 'Denklingen', zip: '86920'},
    { city: 'Gablingen', zip: '86456'},
    { city: 'Neuendettelsau', zip: '91564'},
    { city: 'Stadtbergen', zip: '86391'},
    { city: 'Badersleben u.a.', zip: '38836'},
    { city: 'Schleusegrund', zip: '98667'},
    { city: 'Schongau', zip: '86956'},
    { city: 'Hitzacker (Elbe)', zip: '29456'},
    { city: 'Grafhorst', zip: '38462'},
    { city: 'Heßdorf', zip: '91093'},
    { city: 'Baar', zip: '86674'},
    { city: 'Mörnsheim', zip: '91804'},
    { city: 'Georgensgmünd', zip: '91166'},
    { city: 'Erfurt', zip: '99095'},
    { city: 'Windach', zip: '86949'},
    { city: 'Rockhausen, Klettbach', zip: '99102'},
    { city: 'Uttenreuth, Marloffstein', zip: '91080'},
    { city: 'Olsbrücken', zip: '67737'},
    { city: 'Saterland', zip: '26683'},
    { city: 'Forchheim', zip: '79362'},
    { city: 'Herscheid', zip: '58849'},
    { city: 'Sankt Goarshausen u.a.', zip: '56346'},
    { city: 'Lahr/Schwarzwald', zip: '77933'},
    { city: 'Kehl', zip: '77694'},
    { city: 'Westerkappeln', zip: '49492'},
    { city: 'Bad Kreuznach', zip: '55545'},
    { city: 'Hausen im Wiesental', zip: '79688'},
    { city: 'Burgschwalbach', zip: '65558'},
    { city: 'Zetel', zip: '26340'},
    { city: 'Bad Bergzabern u.a.', zip: '76887'},
    { city: 'Sippersfeld', zip: '67729'},
    { city: 'Gensingen', zip: '55457'},
    { city: 'Kirchhundem', zip: '57399'},
    { city: 'Wallenhorst', zip: '49134'},
    { city: 'Beckum', zip: '59269'},
    { city: 'Lichtenau', zip: '77839'},
    { city: 'Landau in der Pfalz', zip: '76829'},
    { city: 'Sankt Peter', zip: '79271'},
    { city: 'Limburg', zip: '65549'},
    { city: 'Eltville am Rhein', zip: '65343'},
    { city: 'Dachsberg', zip: '79875'},
    { city: 'Ravenstein', zip: '74747'},
    { city: 'Neuenstein (Hessen)', zip: '36286'},
    { city: 'Seelze', zip: '30926'},
    { city: 'Oberweser', zip: '34399'},
    { city: 'Albershausen', zip: '73095'},
    { city: 'Obersinn', zip: '97791'},
    { city: 'Wedemark', zip: '30900'},
    { city: 'Künzelsau, Ingelfingen', zip: '74653'},
    { city: 'Dransfeld u.a.', zip: '37127'},
    { city: 'Kirrweiler (Pfalz)', zip: '67489'},
    { city: 'Offstein', zip: '67591'},
    { city: 'Gundersheim', zip: '67598'},
    { city: 'Friedelsheim', zip: '67159'},
    { city: 'Neuburg am Rhein', zip: '76776'},
    { city: 'Gundheim', zip: '67599'},
    { city: 'Bechtheim', zip: '67595'},
    { city: 'Dillenburg', zip: '35687'},
    { city: 'Dorn-Dürkheim', zip: '67585'},
    { city: 'Lambsheim', zip: '67245'},
    { city: 'Maxdorf', zip: '67133'},
    { city: 'Wiesbaden', zip: '55246'},
    { city: 'Gimbsheim', zip: '67578'},
    { city: 'Eggingen', zip: '79805'},
    { city: 'Schwörstadt', zip: '79739'},
    { city: 'Guldental', zip: '55452'},
    { city: 'Freiburg im Breisgau', zip: '79117'},
    { city: 'Hackenheim', zip: '55546'},
    { city: 'Nistertal, Enspel', zip: '57647'},
    { city: 'Bad Dürkheim', zip: '67098'},
    { city: 'Buchenbach', zip: '79256'},
    { city: 'Ockenheim', zip: '55437'},
    { city: 'Maikammer', zip: '67487'},
    { city: 'Gommersheim', zip: '67377'},
    { city: 'Hünfelden', zip: '65597'},
    { city: 'Versmold', zip: '33775'},
    { city: 'Aachen', zip: '52066'},
    { city: 'Wassenberg', zip: '41849'},
    { city: 'Kalkar', zip: '47546'},
    { city: 'Mönchengladbach', zip: '41063'},
    { city: 'Nörvenich', zip: '52388'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Losheim', zip: '66679'},
    { city: 'Kerpen', zip: '50169'},
    { city: 'Duisburg', zip: '47055'},
    { city: 'Oberhausen', zip: '46147'},
    { city: 'Düsseldorf', zip: '40472'},
    { city: 'Stadtlohn', zip: '48703'},
    { city: 'Mehren u.a.', zip: '54552'},
    { city: 'Köln', zip: '51107'},
    { city: 'Hagen', zip: '58091'},
    { city: 'Dortmund', zip: '44145'},
    { city: 'Tiefenbach u.a.', zip: '55471'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Neuwied', zip: '56566'},
    { city: 'Dortmund', zip: '44269'},
    { city: 'Mittelbrunn, Queidersbach u.a.', zip: '66851'},
    { city: 'Hopsten', zip: '48496'},
    { city: 'Schliengen', zip: '79418'},
    { city: 'Lautenbach', zip: '77794'},
    { city: 'Wiesbaden', zip: '65201'},
    { city: 'Breitscheid', zip: '35767'},
    { city: 'Kindenheim', zip: '67271'},
    { city: 'Steinfeld', zip: '49439'},
    { city: 'Grafenhausen', zip: '79865'},
    { city: 'Erpolzheim', zip: '67167'},
    { city: 'Niederkirchen bei Deidesheim', zip: '67150'},
    { city: 'Halle (Westfalen)', zip: '33790'},
    { city: 'Oppenheim', zip: '55276'},
    { city: 'Lüdenscheid', zip: '58507'},
    { city: 'Münster', zip: '48147'},
    { city: 'Fröndenberg/Ruhr', zip: '58730'},
    { city: 'Vinningen, Trulben, Ruppertsweiler u.a.', zip: '66957'},
    { city: 'Telgte', zip: '48291'},
    { city: 'Hinterweidenthal', zip: '66999'},
    { city: 'Lengerich', zip: '49525'},
    { city: 'Bollschweil', zip: '79283'},
    { city: 'Norheim u.a.', zip: '55585'},
    { city: 'Singhofen', zip: '56379'},
    { city: 'Haren', zip: '49733'},
    { city: 'Schalkenbach, Königsfeld, Dedenbach', zip: '53426'},
    { city: 'Bochum', zip: '44869'},
    { city: 'Remagen', zip: '53424'},
    { city: 'Bonn', zip: '53179'},
    { city: 'Dersum', zip: '26906'},
    { city: 'Jemgum', zip: '26844'},
    { city: 'Schwanebeck, Gröningen, Kroppenstedt', zip: '39397'},
    { city: 'Heideck', zip: '91180'},
    { city: 'Quedlinburg, Ballenstedt', zip: '06485'},
    { city: 'Harsleben', zip: '38829'},
    { city: 'Schwaigen', zip: '82445'},
    { city: 'Stadelhofen', zip: '96187'},
    { city: 'Rockhausen, Klettbach', zip: '99102'},
    { city: 'Mammendorf', zip: '82291'},
    { city: 'Kranichfeld u.a.', zip: '99448'},
    { city: 'Pretzfeld', zip: '91362'},
    { city: 'Barnekow, Gägelow u.a.', zip: '23968'},
    { city: 'Jachenau', zip: '83676'},
    { city: 'Altdorf bei Nürnberg', zip: '90518'},
    { city: 'Berg', zip: '82335'},
    { city: 'Gröbenzell', zip: '82194'},
    { city: 'Adelebsen', zip: '37139'},
    { city: 'Fichtenberg', zip: '74427'},
    { city: 'Böel', zip: '24401'},
    { city: 'Wangen im Allgäu', zip: '88239'},
    { city: 'Altheim', zip: '89605'},
    { city: 'Allmendingen', zip: '89604'},
    { city: 'Donzdorf', zip: '73072'},
    { city: 'Cornberg', zip: '36219'},
    { city: 'Hamburg', zip: '21147'},
    { city: 'Langenburg', zip: '74595'},
    { city: 'Scheidegg', zip: '88175'},
    { city: 'Hamburg', zip: '22547'},
    { city: 'Göttingen', zip: '37081'},
    { city: 'Philippsthal', zip: '36269'},
    { city: 'Burgrieden', zip: '88483'},
    { city: 'Waabs', zip: '24369'},
    { city: 'Göttingen', zip: '37083'},
    { city: 'Seevetal', zip: '21218'},
    { city: 'Neumünster', zip: '24537'},
    { city: 'Ulm', zip: '89075'},
    { city: 'Schmalfeld', zip: '24640'},
    { city: 'Neumünster', zip: '24536'},
    { city: 'Hamburg', zip: '21073'},
    { city: 'Hamburg', zip: '22453'},
    { city: 'Neu-Ulm', zip: '89231'},
    { city: 'Hamburg', zip: '22085'},
    { city: 'Kürnach', zip: '97273'},
    { city: 'Wallhausen', zip: '74599'},
    { city: 'Seulingen, Waake u.a.', zip: '37136'},
    { city: 'Heiligenstadt', zip: '37308'},
    { city: 'Hamburg', zip: '22399'},
    { city: 'Celle', zip: '29227'},
    { city: 'Kronshagen', zip: '24119'},
    { city: 'Lautrach', zip: '87763'},
    { city: 'Geldersheim', zip: '97505'},
    { city: 'Börnhöved', zip: '24619'},
    { city: 'Rothenburg ob der Tauber', zip: '91541'},
    { city: 'Hamburg', zip: '21033'},
    { city: 'Eschede', zip: '29348'},
    { city: 'Fellheim', zip: '87748'},
    { city: 'Unterroth', zip: '89299'},
    { city: 'Kiel', zip: '24149'},
    { city: 'Waltenhofen', zip: '87448'},
    { city: 'Röthlein', zip: '97520'},
    { city: 'Lachendorf', zip: '29331'},
    { city: 'Sehlde', zip: '38279'},
    { city: 'Schwarzach a. Main', zip: '97359'},
    { city: 'Leinefelde-Worbis, Wingerode, Hausen', zip: '37327'},
    { city: 'Breitenthal', zip: '86488'},
    { city: 'Lauben', zip: '87493'},
    { city: 'Vechelde', zip: '38159'},
    { city: 'Erkheim', zip: '87746'},
    { city: 'Witzhave', zip: '22969'},
    { city: 'Handorf', zip: '21447'},
    { city: 'Geesthacht', zip: '21502'},
    { city: 'Aurach', zip: '91589'},
    { city: 'Schwienau', zip: '29593'},
    { city: 'Markt Bibart', zip: '91477'},
    { city: 'Langlingen', zip: '29364'},
    { city: 'Wertach', zip: '87497'},
    { city: 'Kammlach', zip: '87754'},
    { city: 'Didderse', zip: '38530'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Riesbürg', zip: '73469'},
    { city: 'Langfurth', zip: '91731'},
    { city: 'Dorstadt, Flöthe, Börßum u.a.', zip: '38312'},
    { city: 'Sandesneben u.a.', zip: '23898'},
    { city: 'Grebin', zip: '24329'},
    { city: 'Balzhausen', zip: '86483'},
    { city: 'Neustadt a.d.Aisch', zip: '91413'},
    { city: 'Braunlage', zip: '37444'},
    { city: 'Zeulenroda-Triebes, Langenwolschendorf', zip: '07937'},
    { city: 'Hof', zip: '95028'},
    { city: 'Regnitzlosau', zip: '95194'},
    { city: 'Altenstadt a.d. Waldnaab', zip: '92665'},
    { city: 'Maxhütte-Haidhof', zip: '93142'},
    { city: 'Schechen', zip: '83135'},
    { city: 'Rechtmehring', zip: '83562'},
    { city: 'Stephanskirchen', zip: '83071'},
    { city: 'Neufraunhofen', zip: '84181'},
    { city: 'Reichertsheim', zip: '84437'},
    { city: 'Trausnitz', zip: '92555'},
    { city: 'Leipzig', zip: '04205'},
    { city: 'Reichenbach/Vogtl.', zip: '08468'},
    { city: 'Niedermurach', zip: '92545'},
    { city: 'Nobitz, Göhren, Windischleuba', zip: '04603'},
    { city: 'Eggstätt', zip: '83125'},
    { city: 'Moosbach', zip: '92709'},
    { city: 'Jördenstorf, Prebberede u.a.', zip: '17168'},
    { city: 'Kirchberg', zip: '08107'},
    { city: 'Brandenburg/ Havel', zip: '14772'},
    { city: 'Saal', zip: '18317'},
    { city: 'Nauen', zip: '14641'},
    { city: 'Landau a.d. Isar', zip: '94405'},
    { city: 'Eichendorf', zip: '94428'},
    { city: 'Zwönitz', zip: '08297'},
    { city: 'Mariaposching', zip: '94553'},
    { city: 'Fehrbellin, Temnitzquell, Märkisch Linden u.a.', zip: '16818'},
    { city: 'Wesenberg', zip: '17255'},
    { city: 'Mittweida, Kriebstein', zip: '09648'},
    { city: 'Lindow u.a.', zip: '16835'},
    { city: 'Bischofswiesen', zip: '83483'},
    { city: 'Chemnitz', zip: '09131'},
    { city: 'Belgern-Schildau', zip: '04874'},
    { city: 'Lohberg', zip: '93470'},
    { city: 'Roßwein', zip: '04741'},
    { city: 'Kirchberg', zip: '94259'},
    { city: 'Oranienburg, Mühlenbecker Land', zip: '16515'},
    { city: 'Tettenweis', zip: '94167'},
    { city: 'Birkenwerder', zip: '16547'},
    { city: 'Berlin Charlottenburg', zip: '14057'},
    { city: 'Glienicke/Nordbahn', zip: '16548'},
    { city: 'Berlin Steglitz', zip: '12169'},
    { city: 'Berlin Friedenau', zip: '12159'},
    { city: 'Berlin Wedding', zip: '13347'},
    { city: 'Berlin', zip: '12277'},
    { city: 'Berlin Mitte', zip: '10115'},
    { city: 'Riedlhütte', zip: '94566'},
    { city: 'Berlin Kreuzberg', zip: '10963'},
    { city: 'Berlin Buckow', zip: '12349'},
    { city: 'Berlin Kreuzberg', zip: '10997'},
    { city: 'Berlin Prenzlauer Berg', zip: '10409'},
    { city: 'Barnstorf, Eydelstedt, Drentwede', zip: '49406'},
    { city: 'Eschbronn', zip: '78664'},
    { city: 'Biedenkopf', zip: '35216'},
    { city: 'Bünde', zip: '32257'},
    { city: 'Mannheim', zip: '68239'},
    { city: 'Bielefeld', zip: '33689'},
    { city: 'Lahnau', zip: '35633'},
    { city: 'Deißlingen', zip: '78652'},
    { city: 'Bensheim', zip: '64625'},
    { city: 'Hiddenhausen', zip: '32120'},
    { city: 'Trossingen', zip: '78647'},
    { city: 'Gondelsheim', zip: '75053'},
    { city: 'Friedberg (Hessen)', zip: '61169'},
    { city: 'Frankfurt am Main', zip: '60323'},
    { city: 'Östringen', zip: '76684'},
    { city: 'Bad Nauheim', zip: '61231'},
    { city: 'Gosheim', zip: '78559'},
    { city: 'Fernwald', zip: '35463'},
    { city: 'Worpswede', zip: '27726'},
    { city: 'Sternenfels', zip: '75447'},
    { city: 'Gärtringen', zip: '71116'},
    { city: 'Volkertshausen', zip: '78269'},
    { city: 'Renquishausen', zip: '78603'},
    { city: 'Bordelum', zip: '25852'},
    { city: 'Horn-Bad Meinberg', zip: '32805'},
    { city: 'Brombachtal', zip: '64753'},
    { city: 'Leibertingen, Buchheim', zip: '88637'},
    { city: 'Stockach', zip: '78333'},
    { city: 'Tübingen', zip: '72070'},
    { city: 'Pennigsehl', zip: '31621'},
    { city: 'Tübingen', zip: '72072'},
    { city: 'Gemünden (Felda)', zip: '35329'},
    { city: 'Burladingen', zip: '72393'},
    { city: 'Tübingen', zip: '72074'},
    { city: 'Hasselroth', zip: '63594'},
    { city: 'Luhden', zip: '31711'},
    { city: 'Marklohe', zip: '31608'},
    { city: 'Haßmersheim', zip: '74855'},
    { city: 'Limbach', zip: '74838'},
    { city: 'Walddorfhäslach', zip: '72141'},
    { city: 'Stuttgart', zip: '70199'},
    { city: 'Elsenfeld', zip: '63820'},
    { city: 'Husum', zip: '31632'},
    { city: 'Flein', zip: '74223'},
    { city: 'Überlingen', zip: '88662'},
    { city: 'Benningen am Neckar', zip: '71726'},
    { city: 'Freiburg (Elbe)', zip: '21729'},
    { city: 'Amorbach', zip: '63916'},
    { city: 'Grebenhain', zip: '36355'},
    { city: 'Scheer', zip: '72516'},
    { city: 'Möckmühl', zip: '74219'},
    { city: 'Waiblingen', zip: '71336'},
    { city: 'Dörpstedt', zip: '24869'},
    { city: 'Ellhofen', zip: '74248'},
    { city: 'Wiesen, Wiesener Forst', zip: '63831'},
    { city: 'Illmensee', zip: '88636'},
    { city: 'Hameln', zip: '31785'},
    { city: 'Hardthausen am Kocher', zip: '74239'},
    { city: 'Hayingen', zip: '72534'},
    { city: 'Meggerdorf, Friedrichsholm, Friedrichsgraben u.a.', zip: '24799'},
    { city: 'Börde-Hakel', zip: '39448'},
    { city: 'Reichertshofen', zip: '85084'},
    { city: 'Neuhaus a.d.Pegnitz', zip: '91284'},
    { city: 'Grünwald', zip: '82031'},
    { city: 'München', zip: '80339'},
    { city: 'Harsdorf', zip: '95499'},
    { city: 'Karstädt, Dambeck, Klüß', zip: '19357'},
    { city: 'Birgland', zip: '92262'},
    { city: 'München', zip: '80331'},
    { city: 'Marktleugast', zip: '95352'},
    { city: 'Riedenburg', zip: '93339'},
    { city: 'München', zip: '81679'},
    { city: 'Magdeburg', zip: '39104'},
    { city: 'Stadtroda u.a.', zip: '07646'},
    { city: 'Magdeburg', zip: '39126'},
    { city: 'Hohenbrunn', zip: '85662'},
    { city: 'Haar', zip: '85540'},
    { city: 'Barby', zip: '39249'},
    { city: 'Bad Doberan, Bartenshagen-Parkentin u.a.', zip: '18209'},
    { city: 'Ensdorf', zip: '92266'},
    { city: 'Brand', zip: '95682'},
    { city: 'Schmidmühlen', zip: '92287'},
    { city: 'Menteroda, Obermehler', zip: '99996'},
    { city: 'Bad Sachsa', zip: '37441'},
    { city: 'Meine', zip: '38527'},
    { city: 'Benshausen', zip: '98554'},
    { city: 'Sachsen b. Ansbach', zip: '91623'},
    { city: 'Wittmar', zip: '38329'},
    { city: 'Mauerstetten', zip: '87665'},
    { city: 'Oberharz am Brocken', zip: '38877'},
    { city: 'Wolframs-Eschenbach', zip: '91639'},
    { city: 'Lamerdingen', zip: '86862'},
    { city: 'Roklum', zip: '38325'},
    { city: 'Gräfenroda', zip: '99330'},
    { city: 'Pommersfelden', zip: '96178'},
    { city: 'Bergfeld', zip: '38467'},
    { city: 'Ammerndorf', zip: '90614'},
    { city: 'Abenberg', zip: '91183'},
    { city: 'Arnstadt', zip: '99310'},
    { city: 'Schwabach', zip: '91126'},
    { city: 'Bergen', zip: '29468'},
    { city: 'Grainau', zip: '82491'},
    { city: 'Lichtenfels', zip: '96215'},
    { city: 'Kelbra (Kyffhäuser)', zip: '06537'},
    { city: 'Flensburg, Tastrup', zip: '24943'},
    { city: 'Neuhof', zip: '36119'},
    { city: 'Krempe, Grevenkop, Süderau, Muchelndorf', zip: '25361'},
    { city: 'Ebersbach an der Fils', zip: '73061'},
    { city: 'Kassel', zip: '34123'},
    { city: 'Aura i. Sinngrund', zip: '97773'},
    { city: 'Münsterdorf', zip: '25587'},
    { city: 'Rothenfels', zip: '97851'},
    { city: 'Lägerdorf', zip: '25566'},
    { city: 'Burgsinn', zip: '97775'},
    { city: 'Roden', zip: '97849'},
    { city: 'Rieneck', zip: '97794'},
    { city: 'Bad Schussenried', zip: '88427'},
    { city: 'Buxtehude', zip: '21614'},
    { city: 'Uslar', zip: '37170'},
    { city: 'Schneverdingen, Heimbuch', zip: '29640'},
    { city: 'Mühlhausen im Täle', zip: '73347'},
    { city: 'Alfdorf, Schillinghof', zip: '73553'},
    { city: 'Gammelshausen', zip: '73108'},
    { city: 'Berlin Gropiusstadt', zip: '12353'},
    { city: 'Berlin Alt Treptow', zip: '12435'},
    { city: 'Berlin', zip: '10319'},
    { city: 'Berlin Biesdorf', zip: '12683'},
    { city: 'Uckerland, Groß Luckow, Schönhausen', zip: '17337'},
    { city: 'Melchow, Chorin u.a.', zip: '16230'},
    { city: 'Glashütte', zip: '01768'},
    { city: 'Bannewitz', zip: '01728'},
    { city: 'Angermünde', zip: '16278'},
    { city: 'Neu-Seeland, Neupetershain', zip: '03103'},
    { city: 'Letschin', zip: '15324'},
    { city: 'Weißenberg, Hochkirch u.a.', zip: '02627'},
    { city: 'Zittau u.a.', zip: '02763'},
    { city: 'Görlitz', zip: '02828'},
    { city: 'Kirchen (Sieg)', zip: '57548'},
    { city: 'Freiburg im Breisgau', zip: '79100'},
    { city: 'Arnsberg', zip: '59757'},
    { city: 'Ennigerloh', zip: '59320'},
    { city: 'Kriegsfeld', zip: '67819'},
    { city: 'Seelbach', zip: '77960'},
    { city: 'Steinbach, Weitersweiler, Bennhausen, Mörsfeld, Würzweiler, Ruppertsecken u.a.', zip: '67808'},
    { city: 'Weidenthal', zip: '67475'},
    { city: 'Arnsberg', zip: '59759'},
    { city: 'Neuenkirchen-Vörden', zip: '49434'},
    { city: 'Osnabrück', zip: '49074'},
    { city: 'Ober-Olm', zip: '55270'},
    { city: 'St. Märgen', zip: '79274'},
    { city: 'Wardenburg', zip: '26203'},
    { city: 'Venningen', zip: '67482'},
    { city: 'Kleve', zip: '47533'},
    { city: 'Wegberg', zip: '41844'},
    { city: 'Linnich', zip: '52441'},
    { city: 'Kempen', zip: '47906'},
    { city: 'Tönisvorst', zip: '47918'},
    { city: 'Mönchengladbach', zip: '41236'},
    { city: 'Mettlach', zip: '66693'},
    { city: 'Krefeld', zip: '47803'},
    { city: 'Krefeld', zip: '47799'},
    { city: 'Neuss', zip: '41464'},
    { city: 'Duisburg', zip: '47178'},
    { city: 'Leiwen u.a.', zip: '54340'},
    { city: 'Hetzerath, Dierscheid, Heckenmünster', zip: '54523'},
    { city: 'Düsseldorf', zip: '40219'},
    { city: 'Walsdorf, Nohn u.a.', zip: '54578'},
    { city: 'Düsseldorf', zip: '40215'},
    { city: 'Reifferscheid, Kaltenborn, Wershofen u.a.', zip: '53520'},
    { city: 'Euskirchen', zip: '53879'},
    { city: 'Düsseldorf', zip: '40229'},
    { city: 'Ratingen', zip: '40882'},
    { city: 'Düsseldorf', zip: '40625'},
    { city: 'Köln', zip: '51063'},
    { city: 'Essen', zip: '45138'},
    { city: 'Bad Bentheim', zip: '48455'},
    { city: 'Friedrichsthal', zip: '66299'},
    { city: 'Bonn', zip: '53177'},
    { city: 'Gelsenkirchen', zip: '45889'},
    { city: 'Norden', zip: '26506'},
    { city: 'Wuppertal', zip: '42349'},
    { city: 'Herten', zip: '45699'},
    { city: 'Troisdorf', zip: '53840'},
    { city: 'Upgant-Schott, Osteel u.a.', zip: '26529'},
    { city: 'Billerbeck', zip: '48727'},
    { city: 'Büchenbeuren', zip: '55491'},
    { city: 'Weener', zip: '26826'},
    { city: 'Nickenich', zip: '56645'},
    { city: 'Andernach', zip: '56626'},
    { city: 'Olfen', zip: '59399'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Kastellaun', zip: '56288'},
    { city: 'Niederbreitbach', zip: '56589'},
    { city: 'Glan-Münchweiler', zip: '66907'},
    { city: 'Weisweil', zip: '79367'},
    { city: 'Inzlingen', zip: '79594'},
    { city: 'Schallodenbach', zip: '67701'},
    { city: 'Hargesheim', zip: '55595'},
    { city: 'Herschbach', zip: '56249'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Schwanau', zip: '77963'},
    { city: 'Wirges, Stadt', zip: '56422'},
    { city: 'Freilingen, Freirachdorf u.a.', zip: '56244'},
    { city: 'Plettenberg', zip: '58840'},
    { city: 'Willroth', zip: '56594'},
    { city: 'Elsterwerda', zip: '04910'},
    { city: 'Berlin', zip: '12679'},
    { city: 'Zeuthen', zip: '15738'},
    { city: 'Groß Köris', zip: '15746'},
    { city: 'Dresden', zip: '01169'},
    { city: 'Dresden', zip: '01159'},
    { city: 'Neureichenau', zip: '94089'},
    { city: 'Kreischa', zip: '01731'},
    { city: 'Fredersdorf-Vogelsdorf, Petershagen', zip: '15370'},
    { city: 'Rüdersdorf', zip: '15562'},
    { city: 'Dresden', zip: '01259'},
    { city: 'Dresden', zip: '01324'},
    { city: 'Ostseebad Heringsdorf', zip: '17424'},
    { city: 'Treplin, Jacobsdorf, Frankfurt (Oder)', zip: '15236'},
    { city: 'Eurasburg', zip: '82547'},
    { city: 'München', zip: '81249'},
    { city: 'Höhbeck', zip: '29478'},
    { city: 'München', zip: '81245'},
    { city: 'Querfurt, Obhausen, Mücheln u.a.', zip: '06268'},
    { city: 'Kahla', zip: '07768'},
    { city: 'Hettstedt, Endorf', zip: '06333'},
    { city: 'Happurg', zip: '91230'},
    { city: 'Neuburg-Steinhausen, Hornstorf', zip: '23974'},
    { city: 'Ködnitz', zip: '95361'},
    { city: 'Bayreuth', zip: '95445'},
    { city: 'Haimhausen', zip: '85778'},
    { city: 'München', zip: '80337'},
    { city: 'Wolnzach', zip: '85283'},
    { city: 'München', zip: '81543'},
    { city: 'Velburg', zip: '92355'},
    { city: 'Garching b. München', zip: '85748'},
    { city: 'Sachsenkam', zip: '83679'},
    { city: 'Alsleben/Saale, Plötzkau', zip: '06425'},
    { city: 'Bad Lauchstädt', zip: '06246'},
    { city: 'Biederitz, Gerwisch, Menz u.a.', zip: '39175'},
    { city: 'Nandlstadt', zip: '85405'},
    { city: 'Neuching', zip: '85467'},
    { city: 'Weißdorf', zip: '95237'},
    { city: 'Mehlmeisel', zip: '95694'},
    { city: 'Güterglück, Lindau, Deetz u.a.', zip: '39264'},
    { city: 'Fensterbach', zip: '92269'},
    { city: 'Brahmenau', zip: '07554'},
    { city: 'Kirchberg', zip: '84434'},
    { city: 'Steinberg', zip: '92449'},
    { city: 'Wiesau', zip: '95676'},
    { city: 'Pöhl', zip: '08543'},
    { city: 'Mohlsdorf-Teichwolframsdorf', zip: '07987'},
    { city: 'Hagelstadt', zip: '93095'},
    { city: 'Rostock, Graal-Müritz', zip: '18181'},
    { city: 'Barbing', zip: '93092'},
    { city: 'Velden', zip: '84149'},
    { city: 'Görzke', zip: '14828'},
    { city: 'Ziesar', zip: '14793'},
    { city: 'Rimsting', zip: '83253'},
    { city: 'Leipzig', zip: '04179'},
    { city: 'Regis-Breitingen', zip: '04565'},
    { city: 'Moosthenning', zip: '84164'},
    { city: 'Leipzig', zip: '04289'},
    { city: 'Bad Sülze', zip: '18334'},
    { city: 'Leipzig', zip: '04329'},
    { city: 'Naunhof', zip: '04683'},
    { city: 'Töging a. Inn', zip: '84513'},
    { city: 'Palling', zip: '83349'},
    { city: 'Rheinsberg', zip: '16837'},
    { city: 'Taching a. See', zip: '83373'},
    { city: 'Mirow', zip: '17252'},
    { city: 'Niederfrohna', zip: '09243'},
    { city: 'Rattenberg', zip: '94371'},
    { city: 'Niederwürschnitz', zip: '09399'},
    { city: 'Burgstädt', zip: '09217'},
    { city: 'Burghausen', zip: '84489'},
    { city: 'Schönau', zip: '84337'},
    { city: 'Chemnitz', zip: '09228'},
    { city: 'Metten', zip: '94526'},
    { city: 'Dahlen', zip: '04774'},
    { city: 'Winzer', zip: '94577'},
    { city: 'Zschopau, Gornau', zip: '09405'},
    { city: 'Stralsund', zip: '18435'},
    { city: 'Potsdam', zip: '14480'},
    { city: 'Griesbach i. Rottal', zip: '94086'},
    { city: 'Berlin Spandau', zip: '13585'},
    { city: 'Berlin Haselhorst', zip: '13599'},
    { city: 'Lychen', zip: '17279'},
    { city: 'Berlin Lübars', zip: '13469'},
    { city: 'Berlin Wilmersdorf', zip: '10707'},
    { city: 'Schildow', zip: '16552'},
    { city: 'Berlin', zip: '12307'},
    { city: 'Wäschenbeuren', zip: '73116'},
    { city: 'Ascheffel', zip: '24358'},
    { city: 'Rottenacker', zip: '89616'},
    { city: 'Ingoldingen', zip: '88456'},
    { city: 'Steinberg, Steinbergkirche', zip: '24972'},
    { city: 'Großrinderfeld', zip: '97950'},
    { city: 'Eckernförde', zip: '24340'},
    { city: 'Mutlangen', zip: '73557'},
    { city: 'Hamburg', zip: '21129'},
    { city: 'Esgrus', zip: '24402'},
    { city: 'Hammelburg', zip: '97762'},
    { city: 'Göttingen', zip: '37079'},
    { city: 'Eisingen', zip: '97249'},
    { city: 'Poppenhausen', zip: '36163'},
    { city: 'Schrozberg', zip: '74575'},
    { city: 'Iggingen', zip: '73574'},
    { city: 'Hamburg', zip: '22607'},
    { city: 'Veitshöchheim', zip: '97209'},
    { city: 'Langwedel', zip: '24631'},
    { city: 'Bartholomä', zip: '73566'},
    { city: 'Hamburg', zip: '22767'},
    { city: 'Osdorf', zip: '24251'},
    { city: 'Hamburg', zip: '20144'},
    { city: 'Celle, Wittbeck', zip: '29229'},
    { city: 'Altenholz', zip: '24161'},
    { city: 'Hamburg', zip: '22391'},
    { city: 'Holzheim', zip: '89291'},
    { city: 'Burglauer', zip: '97724'},
    { city: 'Kiel', zip: '24147'},
    { city: 'Schweinfurt', zip: '97424'},
    { city: 'Sommerach', zip: '97334'},
    { city: 'Gebsattel', zip: '91607'},
    { city: 'Rannungen', zip: '97517'},
    { city: 'Habighorst', zip: '29359'},
    { city: 'Hamburg', zip: '21039'},
    { city: 'Schweinfurt', zip: '97421'},
    { city: 'Südeichsfeld', zip: '99988'},
    { city: 'Lachen', zip: '87760'},
    { city: 'Sennfeld', zip: '97526'},
    { city: 'Stödtlen', zip: '73495'},
    { city: 'Tannhausen', zip: '73497'},
    { city: 'Plön', zip: '24306'},
    { city: 'Lüneburg', zip: '21339'},
    { city: 'Hillerse', zip: '38543'},
    { city: 'Ronsberg', zip: '87671'},
    { city: 'Steinhorst', zip: '29367'},
    { city: 'Salzgitter', zip: '38239'},
    { city: 'Wittislingen', zip: '89426'},
    { city: 'Seebach', zip: '99846'},
    { city: 'Lehrberg', zip: '91611'},
    { city: 'Haßfurt', zip: '97437'},
    { city: 'Wendisch Evern', zip: '21403'},
    { city: 'Pfronten', zip: '87459'},
    { city: 'Görisried', zip: '87657'},
    { city: 'Bad Bevensen', zip: '29549'},
    { city: 'Bertelsmann', zip: '33333'},
    { city: 'Dunningen', zip: '78655'},
    { city: 'Bad Soden am Taunus', zip: '65812'},
    { city: 'Wetzlar', zip: '35586'},
    { city: 'Blumberg', zip: '78176'},
    { city: 'Zimmern ob Rottweil', zip: '78658'},
    { city: 'Hallig Hooge', zip: '25859'},
    { city: 'Lottstetten', zip: '79807'},
    { city: 'Alsbach-Hähnlein', zip: '64665'},
    { city: 'Heddesheim', zip: '68542'},
    { city: 'Kronau', zip: '76709'},
    { city: 'Laudenbach', zip: '69514'},
    { city: 'Dietingen', zip: '78661'},
    { city: 'Engelsbrand', zip: '75331'},
    { city: 'Frankfurt am Main', zip: '60431'},
    { city: 'Tating, Westerhever, Tümlauer Koog', zip: '25881'},
    { city: 'Heidelberg', zip: '69121'},
    { city: 'Frankfurt am Main', zip: '60320'},
    { city: 'Leimen', zip: '69181'},
    { city: 'Gunningen', zip: '78594'},
    { city: 'Karben', zip: '61184'},
    { city: 'Modautal', zip: '64397'},
    { city: 'Frankfurt am Main', zip: '60386'},
    { city: 'Hambergen, Holste u.a.', zip: '27729'},
    { city: 'Oberderdingen', zip: '75038'},
    { city: 'Offenbach am Main', zip: '63065'},
    { city: 'Fischbachtal', zip: '64405'},
    { city: 'Bremen', zip: '28201'},
    { city: 'Frankenau', zip: '35110'},
    { city: 'Friedrichskoog', zip: '25718'},
    { city: 'Hanau', zip: '63456'},
    { city: 'Bruchhausen-Vilsen, Süstedt', zip: '27305'},
    { city: 'Bruchköbel', zip: '63486'},
    { city: 'Bremen', zip: '28307'},
    { city: 'Reichartshausen', zip: '74934'},
    { city: 'Barlt, Busenwurth', zip: '25719'},
    { city: 'Bad Driburg', zip: '33014'},
    { city: 'Ortenberg', zip: '63683'},
    { city: 'Sindelfingen', zip: '71065'},
    { city: 'Lützelbach', zip: '64750'},
    { city: 'Meerbeck', zip: '31715'},
    { city: 'Weilbach', zip: '63937'},
    { city: 'Kirchheim am Neckar', zip: '74366'},
    { city: 'Nienstädt', zip: '31688'},
    { city: 'Hessisch Oldendorf', zip: '31840'},
    { city: 'Filderstadt', zip: '70794'},
    { city: 'Bad Friedrichshall', zip: '74177'},
    { city: 'Albersdorf', zip: '25767'},
    { city: 'Hausen', zip: '63840'},
    { city: 'Haßbergen', zip: '31626'},
    { city: 'Liebenau (Hessen)', zip: '34396'},
    { city: 'Birstein', zip: '63633'},
    { city: 'Emmerthal', zip: '31860'},
    { city: 'Wacken', zip: '25596'},
    { city: 'Marbach am Neckar', zip: '71672'},
    { city: 'Roigheim', zip: '74255'},
    { city: 'Ottrau', zip: '34633'},
    { city: 'Bad Nenndorf', zip: '31542'},
    { city: 'Adelsheim', zip: '74740'},
    { city: 'Hülben', zip: '72584'},
    { city: 'Stade', zip: '21683'},
    { city: 'Wernau (Neckar)', zip: '73249'},
    { city: 'Hodenhagen u.a.', zip: '29693'},
    { city: 'Barsinghausen', zip: '30890'},
    { city: 'Sittensen u.a.', zip: '27419'},
    { city: 'Bischbrunn', zip: '97836'},
    { city: 'Schernfeld', zip: '85132'},
    { city: 'Dollnstein', zip: '91795'},
    { city: 'Bad Frankenhausen/Kyffhäuser', zip: '06567'},
    { city: 'Nürnberg', zip: '90443'},
    { city: 'Türkenfeld', zip: '82299'},
    { city: 'Nürnberg', zip: '90455'},
    { city: 'Redwitz a.d. Rodach', zip: '96257'},
    { city: 'Kölleda', zip: '99625'},
    { city: 'Wanzleben-Börde', zip: '39164'},
    { city: 'Gilching', zip: '82205'},
    { city: 'Seeshaupt', zip: '82402'},
    { city: 'Bernried', zip: '82347'},
    { city: 'Winkelhaid', zip: '90610'},
    { city: 'Kipfenberg', zip: '85110'},
    { city: 'Emmering', zip: '82275'},
    { city: 'Probstzella', zip: '07330'},
    { city: 'Seeland', zip: '06469'},
    { city: 'Berching', zip: '92334'},
    { city: 'Auhausen', zip: '86736'},
    { city: 'Altenmedingen', zip: '29575'},
    { city: 'Eltmann', zip: '97483'},
    { city: 'Bleckede', zip: '21354'},
    { city: 'Lübeck', zip: '23558'},
    { city: 'Ziethen', zip: '23911'},
    { city: 'Himbergen', zip: '29584'},
    { city: 'Bruckberg', zip: '91590'},
    { city: 'Bonstetten', zip: '86486'},
    { city: 'Oberostendorf', zip: '86869'},
    { city: 'Rentweinsdorf', zip: '96184'},
    { city: 'Walsdorf', zip: '96194'},
    { city: 'Dähre, Diesdorf, Wallstawe', zip: '29413'},
    { city: 'Igling', zip: '86859'},
    { city: 'Schwabsoien', zip: '86987'},
    { city: 'Cadolzburg', zip: '90556'},
    { city: 'Tülau', zip: '38474'},
    { city: 'Schmiechen', zip: '86511'},
    { city: 'Salzwedel', zip: '29410'},
    { city: 'Saulgrub', zip: '82442'},
    { city: 'Rennertshofen', zip: '86643'},
    { city: 'Solnhofen', zip: '91807'},
    { city: 'Litzendorf', zip: '96123'},
    { city: 'Pöttmes', zip: '86554'},
    { city: 'Burgheim', zip: '86666'},
    { city: 'Nürnberg', zip: '90431'},
    { city: 'Eggolsheim', zip: '91330'},
    { city: 'Aichach', zip: '86551'},
    { city: 'Langensendelbach', zip: '91094'},
    { city: 'Runkel', zip: '65594'},
    { city: 'Wilhelmshaven', zip: '26382'},
    { city: 'Hilter', zip: '49176'},
    { city: 'Hausach', zip: '77756'},
    { city: 'Schmallenberg', zip: '57392'},
    { city: 'Hochstadt', zip: '76879'},
    { city: 'Gau-Odernheim', zip: '55239'},
    { city: 'Offenbach an der Queich', zip: '76877'},
    { city: 'Monsheim', zip: '67590'},
    { city: 'Mainz', zip: '55120'},
    { city: 'Gerolsheim', zip: '67229'},
    { city: 'Oldenburg (Oldenburg)', zip: '26135'},
    { city: 'Bonndorf im Schwarzwald', zip: '79848'},
    { city: 'Lustadt', zip: '67363'},
    { city: 'Hochdorf-Assenheim', zip: '67126'},
    { city: 'Löffingen', zip: '79843'},
    { city: 'Hude (Oldenburg)', zip: '27798'},
    { city: 'Dillenburg', zip: '35690'},
    { city: 'Neupotz', zip: '76777'},
    { city: 'Villingen-Schwenningen', zip: '78052'},
    { city: 'Frankenthal (Pfalz)', zip: '67227'},
    { city: 'Hanhofen', zip: '67374'},
    { city: 'Eggenstein-Leopoldshafen', zip: '76344'},
    { city: 'Glashütten', zip: '61479'},
    { city: 'Römerberg', zip: '67354'},
    { city: 'Rosenberg', zip: '74749'},
    { city: 'Allmersbach im Tal', zip: '71573'},
    { city: 'Hochdorf', zip: '73269'},
    { city: 'Stolk', zip: '24890'},
    { city: 'Unterwaldhausen', zip: '88379'},
    { city: 'Dürmentingen', zip: '88525'},
    { city: 'Söhrewald', zip: '34320'},
    { city: 'Staufenberg', zip: '34355'},
    { city: 'Wiesensteig', zip: '73349'},
    { city: 'Beckdorf', zip: '21643'},
    { city: 'Nübbel', zip: '24809'},
    { city: 'Alheim', zip: '36211'},
    { city: 'Fraunberg', zip: '85447'},
    { city: 'Gattendorf', zip: '95185'},
    { city: 'Weihmichl', zip: '84107'},
    { city: 'Erbendorf', zip: '92681'},
    { city: 'Bad Alexandersbad', zip: '95680'},
    { city: 'Lengdorf', zip: '84435'},
    { city: 'Rostock', zip: '18106'},
    { city: 'Bad Dürrenberg', zip: '06231'},
    { city: 'Dorfen', zip: '84405'},
    { city: 'Rostock', zip: '18057'},
    { city: 'Neustadt (Dosse) u.a.', zip: '16845'},
    { city: 'Mallersdorf-Pfaffenberg', zip: '84066'},
    { city: 'Wackersdorf', zip: '92442'},
    { city: 'Griesstätt', zip: '83556'},
    { city: 'Raguhn-Jeßnitz', zip: '06779'},
    { city: 'Bodenwöhr', zip: '92439'},
    { city: 'Floß', zip: '92685'},
    { city: 'Schöneck/Vogtl.', zip: '08261'},
    { city: 'Wurmsham', zip: '84189'},
    { city: 'Wald', zip: '93192'},
    { city: 'Leipzig', zip: '04317'},
    { city: 'Leipzig', zip: '04318'},
    { city: 'Leipzig', zip: '04316'},
    { city: 'Schneeberg', zip: '08289'},
    { city: 'Löbnitz', zip: '18314'},
    { city: 'Bad Schmiedeberg', zip: '06905'},
    { city: 'Callenberg, Hohenstein-Ernstthal, Bernsdorf', zip: '09337'},
    { city: 'Wittenberg', zip: '06888'},
    { city: 'Tribsees', zip: '18465'},
    { city: 'Röhrsdorf', zip: '09247'},
    { city: 'Wallerfing', zip: '94574'},
    { city: 'Arnbruck', zip: '93471'},
    { city: 'Triftern', zip: '84371'},
    { city: 'Prohn', zip: '18445'},
    { city: 'Frankenberg', zip: '09669'},
    { city: 'Marktschellenberg', zip: '83487'},
    { city: 'Regen', zip: '94209'},
    { city: 'Nuthetal', zip: '14558'},
    { city: 'Herzberg/ Elster', zip: '04916'},
    { city: 'Zschopau', zip: '09434'},
    { city: 'Pockau-Lengefeld (Pockau)', zip: '09509'},
    { city: 'Borgsdorf', zip: '16556'},
    { city: 'Liebenwalde', zip: '16559'},
    { city: 'Hohen Neuendorf OT Bergfelde', zip: '16562'},
    { city: 'Berlin Lichtenfelde', zip: '12203'},
    { city: 'Mühlenbecker Land', zip: '16567'},
    { city: 'Berlin Steglitz', zip: '12167'},
    { city: 'Berlin Wilhelmsdorf', zip: '10715'},
    { city: 'Berlin', zip: '10827'},
    { city: 'Greifswald', zip: '17489'},
    { city: 'Königstein im Taunus', zip: '61462'},
    { city: 'Karlsruhe', zip: '76139'},
    { city: 'Bruchsal', zip: '76646'},
    { city: 'Bielefeld', zip: '33605'},
    { city: 'Bielefeld', zip: '33609'},
    { city: 'Cuxhaven', zip: '27478'},
    { city: 'Delmenhorst', zip: '27753'},
    { city: 'Kämpfelbach', zip: '75236'},
    { city: 'Neubulach', zip: '75387'},
    { city: 'Oerlinghausen', zip: '33813'},
    { city: 'Frankfurt am Main', zip: '60487'},
    { city: 'Ebhausen', zip: '72224'},
    { city: 'Bad Liebenzell', zip: '75378'},
    { city: 'Eisingen', zip: '75239'},
    { city: 'Herford', zip: '32049'},
    { city: 'Birkenau', zip: '69488'},
    { city: 'Marburg', zip: '35037'},
    { city: 'Marburg', zip: '35039'},
    { city: 'Niddatal', zip: '61194'},
    { city: 'Schwaförden', zip: '27252'},
    { city: 'Zaisenhausen', zip: '75059'},
    { city: 'Wiesenbach', zip: '69257'},
    { city: 'Reichelsheim (Wetterau)', zip: '61203'},
    { city: 'Schöneck', zip: '61137'},
    { city: 'Bremen', zip: '28213'},
    { city: 'Tönning', zip: '25832'},
    { city: 'Königsheim', zip: '78598'},
    { city: 'Illingen', zip: '75428'},
    { city: 'Sachsenheim', zip: '74343'},
    { city: 'Vaihingen an der Enz', zip: '71665'},
    { city: 'Schwaigern', zip: '74193'},
    { city: 'Grasberg', zip: '28879'},
    { city: 'Dörentrup', zip: '32694'},
    { city: 'Rottenburg am Neckar', zip: '72108'},
    { city: 'Rinteln', zip: '31737'},
    { city: 'Büdingen', zip: '63654'},
    { city: 'Zeven, Elsdorf', zip: '27404'},
    { city: 'Reichenau', zip: '78479'},
    { city: 'Viöl', zip: '25884'},
    { city: 'Herdwangen-Schönach', zip: '88634'},
    { city: 'Antrifttal', zip: '36326'},
    { city: 'Stuttgart', zip: '70192'},
    { city: 'Nordsehl', zip: '31717'},
    { city: 'Marienmünster', zip: '37696'},
    { city: 'Stuttgart', zip: '70174'},
    { city: 'Stuttgart', zip: '70599'},
    { city: 'Billigheim', zip: '74842'},
    { city: 'Stuttgart', zip: '70376'},
    { city: 'Pleidelsheim', zip: '74385'},
    { city: 'Fritzlar', zip: '34560'},
    { city: 'Sailauf', zip: '63877'},
    { city: 'Fellbach', zip: '70734'},
    { city: 'Mengen', zip: '88512'},
    { city: 'Wabern', zip: '34590'},
    { city: 'Lauterbach', zip: '36341'},
    { city: 'Dammbach', zip: '63874'},
    { city: 'Meersburg', zip: '88709'},
    { city: 'Immenstaad am Bodensee', zip: '88090'},
    { city: 'Gomadingen', zip: '72532'},
    { city: 'Obersulm', zip: '74182'},
    { city: 'Altbach', zip: '73776'},
    { city: 'Kassel', zip: '34132'},
    { city: 'Münsingen', zip: '72525'},
    { city: 'Icking', zip: '82057'},
    { city: 'Denkendorf', zip: '85095'},
    { city: 'Hettstedt, Endorf', zip: '06333'},
    { city: 'Straßlach-Dingharting', zip: '82064'},
    { city: 'Remptendorf', zip: '07368'},
    { city: 'Jena', zip: '07745'},
    { city: 'Hirschbach', zip: '92275'},
    { city: 'Bayreuth', zip: '95447'},
    { city: 'Bindlach', zip: '95463'},
    { city: 'Breitenbrunn', zip: '92363'},
    { city: 'München', zip: '81667'},
    { city: 'Bad Steben', zip: '95138'},
    { city: 'Nienburg (Saale)', zip: '06429'},
    { city: 'Schönebeck', zip: '39218'},
    { city: 'Gefrees', zip: '95482'},
    { city: 'Schauenstein', zip: '95197'},
    { city: 'Hallbergmoos', zip: '85399'},
    { city: 'Calbe, Rosenburg u.a.', zip: '39240'},
    { city: 'Siegenburg', zip: '93354'},
    { city: 'Hof', zip: '95030'},
    { city: 'Halle/ Saale', zip: '06126'},
    { city: 'Klingenmünster u.a.', zip: '76889'},
    { city: 'Hasel', zip: '79686'},
    { city: 'Westerburg', zip: '56457'},
    { city: 'Bockhorn', zip: '26345'},
    { city: 'Sprendlingen', zip: '55576'},
    { city: 'Biberach', zip: '77781'},
    { city: 'Soest', zip: '59494'},
    { city: 'Wörrstadt', zip: '55286'},
    { city: 'Sinzheim', zip: '76547'},
    { city: 'Heidesheim am Rhein', zip: '55262'},
    { city: 'Bad Waldsee', zip: '88339'},
    { city: 'Soltau', zip: '29614'},
    { city: 'Borgstedt', zip: '24794'},
    { city: 'Hamburg', zip: '22559'},
    { city: 'Hardegsen', zip: '37181'},
    { city: 'Hannover', zip: '30161'},
    { city: 'Hannover', zip: '30161'},
    { city: 'Nüsttal', zip: '36167'},
    { city: 'Ilshofen', zip: '74532'},
    { city: 'Undeloh', zip: '21274'},
    { city: 'Diekholzen', zip: '31199'},
    { city: 'Frankenhardt', zip: '74586'},
    { city: 'Rot an der Rot', zip: '88430'},
    { city: 'Göttingen', zip: '37085'},
    { city: 'Bendestorf', zip: '21227'},
    { city: 'Hamburg', zip: '22767'},
    { city: 'Hamburg', zip: '22041'},
    { city: 'Stimpfach', zip: '74597'},
    { city: 'Bellenberg', zip: '89287'},
    { city: 'Marktbreit', zip: '97340'},
    { city: 'Albertshofen', zip: '97320'},
    { city: 'Wathlingen', zip: '29339'},
    { city: 'Bad Salzungen', zip: '36433'},
    { city: 'Volkach', zip: '97332'},
    { city: 'Kirchgellersen, Westergellersen, Südergellersen', zip: '21394'},
    { city: 'Babenhausen', zip: '87727'},
    { city: 'Beedenbostel', zip: '29355'},
    { city: 'Oberschönegg', zip: '87770'},
    { city: 'Salzgitter', zip: '38229'},
    { city: 'Haldenwang', zip: '87490'},
    { city: 'Burgau', zip: '89331'},
    { city: 'Leiferde', zip: '38542'},
    { city: 'Stetten', zip: '87778'},
    { city: 'Ursberg', zip: '86513'},
    { city: 'Pfaffenhausen', zip: '87772'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Glött', zip: '89353'},
    { city: 'Möttingen', zip: '86753'},
    { city: 'Eutin, Süsel', zip: '23701'},
    { city: 'Fischach', zip: '86850'},
    { city: 'Scherstetten', zip: '86872'},
    { city: 'Schlotheim', zip: '99994'},
    { city: 'Westendorf', zip: '87679'},
    { city: 'Bernbeuren', zip: '86975'},
    { city: 'Meinheim', zip: '91802'},
    { city: 'Lübeck', zip: '23570'},
    { city: 'Aindling', zip: '86447'},
    { city: 'Rehling', zip: '86508'},
    { city: 'Heiligenhafen', zip: '23774'},
    { city: 'Halberstadt', zip: '38820'},
    { city: 'Erlangen', zip: '91054'},
    { city: 'Kassel', zip: '34134'},
    { city: 'Kollmar, Pagensand', zip: '25377'},
    { city: 'Bissingen an der Teck', zip: '73266'},
    { city: 'Friedrichshafen', zip: '88046'},
    { city: 'Großerlach', zip: '71577'},
    { city: 'Uslar', zip: '37170'},
    { city: 'Meckenbeuren', zip: '88074'},
    { city: 'Selk, Geltdorf, Hahnekrug', zip: '24884'},
    { city: 'Seester', zip: '25370'},
    { city: 'Sörup', zip: '24966'},
    { city: 'Nonnenhorn', zip: '88149'},
    { city: 'Haunetal', zip: '36166'},
    { city: 'Börtlingen', zip: '73104'},
    { city: 'Hünstetten, Idstein', zip: '65510'},
    { city: 'Mainz', zip: '55126'},
    { city: 'Greifenstein', zip: '35753'},
    { city: 'Hornberg', zip: '78132'},
    { city: 'Vechta', zip: '49377'},
    { city: 'Wiesbaden', zip: '65187'},
    { city: 'Offstein', zip: '67591'},
    { city: 'Mainz', zip: '55118'},
    { city: 'Drebber', zip: '49457'},
    { city: 'Gütersloh', zip: '33332'},
    { city: 'Bilzingsleben Kannawurf Oldisleben', zip: '06578'},
    { city: 'Fehmarn', zip: '23769'},
    { city: 'Eglfing', zip: '82436'},
    { city: 'Lützow', zip: '19209'},
    { city: 'Eschenlohe', zip: '82438'},
    { city: 'Igensdorf', zip: '91338'},
    { city: 'Pyrbaum', zip: '90602'},
    { city: 'Hollfeld', zip: '96142'},
    { city: 'Rückersdorf', zip: '90607'},
    { city: 'Arendsee', zip: '39619'},
    { city: 'Postbauer-Heng', zip: '92353'},
    { city: 'Gorleben', zip: '29475'},
    { city: 'Berlin Wartenberg', zip: '13059'},
    { city: 'Berlin Falkenberg', zip: '13057'},
    { city: 'Putbus', zip: '18581'},
    { city: 'Plessa, Schraden', zip: '04928'},
    { city: 'Berlin Köpenick', zip: '12559'},
    { city: 'Dresden', zip: '01097'},
    { city: 'Dresden', zip: '01326'},
    { city: 'Karlshagen', zip: '17449'},
    { city: 'Strausberg', zip: '15344'},
    { city: 'Straupitz', zip: '15913'},
    { city: 'Kolkwitz', zip: '03099'},
    { city: 'Vogelsang-Warsin, Meiersberg, Mönkebude u.a.', zip: '17375'},
    { city: 'Vogelsang-Warsin, Meiersberg, Mönkebude u.a.', zip: '17375'},
    { city: 'Cottbus', zip: '03055'},
    { city: 'Kevelaer-Twisteden', zip: '47624'},
    { city: 'Waxweiler', zip: '54649'},
    { city: 'Elsdorf', zip: '50189'},
    { city: 'Newel', zip: '54309'},
    { city: 'Saarlouis', zip: '66740'},
    { city: 'Niersbach, Sehlem, Plein u.a.', zip: '54518'},
    { city: 'Osburg, Gusterath, Farschweiler, Kasel u.a.', zip: '54317'},
    { city: 'Düsseldorf', zip: '40474'},
    { city: 'Duisburg', zip: '47058'},
    { city: 'Salmtal', zip: '54528'},
    { city: 'Mülheim an der Ruhr', zip: '45478'},
    { city: 'Ahaus', zip: '48683'},
    { city: 'Piesport', zip: '54498'},
    { city: 'Mülheim an der Ruhr', zip: '45468'},
    { city: 'Eppelborn', zip: '66571'},
    { city: 'Malborn', zip: '54426'},
    { city: 'Gelsenkirchen', zip: '45896'},
    { city: 'Solingen', zip: '42719'},
    { city: 'Saarbrücken', zip: '66132'},
    { city: 'Kandern', zip: '79400'},
    { city: 'Dortmund', zip: '44289'},
    { city: 'Ellern (Hunsrück), Schnorbach', zip: '55497'},
    { city: 'Lüdenscheid', zip: '58509'},
    { city: 'Reichshof', zip: '51580'},
    { city: 'Sankt Goar', zip: '56329'},
    { city: 'Bad Krozingen', zip: '79189'},
    { city: 'Ladbergen', zip: '49549'},
    { city: 'Otterbach', zip: '67731'},
    { city: 'Bruchweiler-Bärenbach u.a.', zip: '76891'},
    { city: 'Kaiserslautern', zip: '67657'},
    { city: 'Siershahn', zip: '56427'},
    { city: 'Dortmund', zip: '44229'},
    { city: 'Lehmen, Niederfell, Oberfell, Wolken u.a.', zip: '56332'},
    { city: 'Windeck', zip: '51570'},
    { city: 'Hundsbach', zip: '55621'},
    { city: 'Pfeffelbach', zip: '66871'},
    { city: 'Breitscheid, Dattenberg, Hausen, Hümmerich, Kasbach-Ohlenberg, Roßbach u.a.', zip: '53547'},
    { city: 'Gevelsberg', zip: '58285'},
    { city: 'Kirchberg u.a.', zip: '55481'},
    { city: 'Witten', zip: '58453'},
    { city: 'Baltrum', zip: '26579'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Burscheid', zip: '51399'},
    { city: 'Pünderich', zip: '56862'},
    { city: 'Bochum', zip: '44879'},
    { city: 'Meppen', zip: '49716'},
    { city: 'Kleinich', zip: '54483'},
    { city: 'Bochum', zip: '44867'},
    { city: 'Siegburg', zip: '53721'},
    { city: 'Berglern', zip: '85459'},
    { city: 'Pastetten', zip: '85669'},
    { city: 'Pressath', zip: '92690'},
    { city: 'Röslau', zip: '95195'},
    { city: 'Hausen', zip: '93345'},
    { city: 'Halle/ Saale', zip: '06110'},
    { city: 'Pullenreuth', zip: '95704'},
    { city: 'Aken (Elbe)', zip: '06385'},
    { city: 'Schnaittenbach', zip: '92253'},
    { city: 'Langquaid', zip: '84085'},
    { city: 'Isen', zip: '84424'},
    { city: 'Hohenmölsen', zip: '06679'},
    { city: 'Regensburg', zip: '93049'},
    { city: 'Herrngiersdorf', zip: '84097'},
    { city: 'Gera', zip: '07551'},
    { city: 'Ramerberg', zip: '83561'},
    { city: 'Güstrow', zip: '18273'},
    { city: 'Neustadt a.d. Waldnaab', zip: '92660'},
    { city: 'Rostock, Gelbensande, Rövershagen u.a.', zip: '18182'},
    { city: 'Bechtsried', zip: '92699'},
    { city: 'Eiselfing', zip: '83549'},
    { city: 'Aufhausen', zip: '93089'},
    { city: 'Aschau i. Chiemgau', zip: '83229'},
    { city: 'Bach an der Donau', zip: '93090'},
    { city: 'Markneukirchen', zip: '08258'},
    { city: 'Oranienbaum-Wörlitz', zip: '06785'},
    { city: 'Coswig (Anhalt)', zip: '06869'},
    { city: 'Brennberg', zip: '93179'},
    { city: 'Obing', zip: '83119'},
    { city: 'Gräfenhainichen', zip: '06773'},
    { city: 'Walderbach', zip: '93194'},
    { city: 'Marlow', zip: '18337'},
    { city: 'Taufkirchen', zip: '84574'},
    { city: 'Rositz, Starkenberg, Treben', zip: '04617'},
    { city: 'Thanstein', zip: '92554'},
    { city: 'Schönheide', zip: '08304'},
    { city: 'Taucha', zip: '04425'},
    { city: 'Polling', zip: '84570'},
    { city: 'Garching a.d. Alz', zip: '84518'},
    { city: 'St. Georgen', zip: '83368'},
    { city: 'Traitsching', zip: '93455'},
    { city: 'Traunreut', zip: '83374'},
    { city: 'Kastl', zip: '84556'},
    { city: 'Simbach', zip: '94436'},
    { city: 'Franzburg, Richtenberg, u.a.', zip: '18461'},
    { city: 'Otzing', zip: '94563'},
    { city: 'Niepars', zip: '18442'},
    { city: 'Bad Reichenhall', zip: '83435'},
    { city: 'Chemnitz', zip: '09114'},
    { city: 'Waldheim', zip: '04736'},
    { city: 'Grimmen', zip: '18507'},
    { city: 'Egglham', zip: '84385'},
    { city: 'Trebbin', zip: '14959'},
    { city: 'Grünhainichen', zip: '09579'},
    { city: 'Hiddensee', zip: '18565'},
    { city: 'Berlin Westend', zip: '14052'},
    { city: 'Berlin Wedding', zip: '13405'},
    { city: 'Berlin Reinickendorf', zip: '13403'},
    { city: 'Berlin Wilmersdorf', zip: '10719'},
    { city: 'Berlin Moabit', zip: '10555'},
    { city: 'Berlin Lankwitz', zip: '12249'},
    { city: 'Krien u.a.', zip: '17391'},
    { city: 'Berlin Schöneberg', zip: '10829'},
    { city: 'Berlin', zip: '12309'},
    { city: 'Lehesten', zip: '07349'},
    { city: 'Tschirn', zip: '96367'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'Presseck', zip: '95355'},
    { city: 'Hummeltal', zip: '95503'},
    { city: 'Banzkow, Sukow', zip: '19079'},
    { city: 'München', zip: '81475'},
    { city: 'Bismark', zip: '39629'},
    { city: 'Schnackenburg', zip: '29493'},
    { city: 'Tangerhütte u.a.', zip: '39517'},
    { city: 'Oberschleißheim', zip: '85764'},
    { city: 'München', zip: '80993'},
    { city: 'Creußen', zip: '95473'},
    { city: 'München', zip: '81545'},
    { city: 'Auerbach i.d. OPf.', zip: '91275'},
    { city: 'München', zip: '80933'},
    { city: 'Neukloster', zip: '23992'},
    { city: 'Sauerlach', zip: '82054'},
    { city: 'Freyburg, Balgstädt', zip: '06632'},
    { city: 'Emtmannsberg', zip: '95517'},
    { city: 'Ziegenrück', zip: '07924'},
    { city: 'Magdeburg', zip: '39114'},
    { city: 'Pliening', zip: '85652'},
    { city: 'Bützow u.a.', zip: '18246'},
    { city: 'Eisenberg, Gösen, Hainspitz', zip: '07607'},
    { city: 'Nittendorf', zip: '93152'},
    { city: 'Hamm', zip: '59063'},
    { city: 'Merzhausen', zip: '79249'},
    { city: 'Freiburg im Breisgau', zip: '79098'},
    { city: 'Rüdesheim am Rhein', zip: '65385'},
    { city: 'Freiburg im Breisgau', zip: '79108'},
    { city: 'Glandorf', zip: '49219'},
    { city: 'Sundern', zip: '59846'},
    { city: 'Oestrich-Winkel', zip: '65375'},
    { city: 'Höhn', zip: '56462'},
    { city: 'Gutach im Breisgau', zip: '79261'},
    { city: 'Esthal', zip: '67472'},
    { city: 'Landau in der Pfalz', zip: '76829'},
    { city: 'Arnsberg', zip: '59821'},
    { city: 'Bernau im Schwarzwald', zip: '79872'},
    { city: 'Holdorf', zip: '49451'},
    { city: 'Scheibenhardt', zip: '76779'},
    { city: 'Mühlenbach', zip: '77796'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Melsbach', zip: '56581'},
    { city: 'Wildenbungert, Gondershausen, Nörtershausen u.a.', zip: '56283'},
    { city: 'Hagen', zip: '58097'},
    { city: 'Nümbrecht', zip: '51588'},
    { city: 'Reifenberg', zip: '66507'},
    { city: 'Nordkirchen', zip: '59394'},
    { city: 'Höheinöd, Petersberg u.a.', zip: '66989'},
    { city: 'Hagen', zip: '58095'},
    { city: 'Winningen', zip: '56333'},
    { city: 'Birnbach', zip: '57612'},
    { city: 'Mönchengladbach', zip: '41069'},
    { city: 'Rheurdt', zip: '47509'},
    { city: 'Tawern', zip: '54456'},
    { city: 'Stadtkyll', zip: '54589'},
    { city: 'Kyllburg', zip: '54655'},
    { city: 'Moers', zip: '47447'},
    { city: 'Oberhausen', zip: '46117'},
    { city: 'Oberhausen', zip: '46119'},
    { city: 'Erkrath', zip: '40699'},
    { city: 'Reifferscheid, Kaltenborn, Wershofen u.a.', zip: '53520'},
    { city: 'Dorsten', zip: '46282'},
    { city: 'Essen', zip: '45359'},
    { city: 'Leverkusen', zip: '51371'},
    { city: 'Köln', zip: '50931'},
    { city: 'Morbach', zip: '54497'},
    { city: 'Köln', zip: '51103'},
    { city: 'Essen', zip: '45136'},
    { city: 'Saarbrücken', zip: '66129'},
    { city: 'Essen', zip: '45309'},
    { city: 'Neustadt an der Weinstraße', zip: '67435'},
    { city: 'Seebach', zip: '77889'},
    { city: 'Wiesbaden', zip: '65195'},
    { city: 'Selters', zip: '65618'},
    { city: 'Mainz', zip: '55116'},
    { city: 'Rheinstetten', zip: '76287'},
    { city: 'Nierstein', zip: '55283'},
    { city: 'Schifferstadt', zip: '67105'},
    { city: 'Hofheim am Taunus', zip: '65719'},
    { city: 'Karlsruhe', zip: '76199'},
    { city: 'Karlsruhe', zip: '76137'},
    { city: 'Kirn', zip: '55606'},
    { city: 'Dortmund', zip: '44319'},
    { city: 'Iserlohn', zip: '58642'},
    { city: 'Altenkirchen (Westerwald)', zip: '57610'},
    { city: 'Münster', zip: '48157'},
    { city: 'Wyhl', zip: '79369'},
    { city: 'Niederkirchen', zip: '67700'},
    { city: 'Hamm (Sieg)', zip: '57577'},
    { city: 'Schallstadt', zip: '79227'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Selters (Westerwald)', zip: '56242'},
    { city: 'Steinen', zip: '79585'},
    { city: 'Riegel Kaiserstuhl', zip: '79359'},
    { city: 'Sohren', zip: '55487'},
    { city: 'Bad Hönningen', zip: '53557'},
    { city: 'Dortmund', zip: '44359'},
    { city: 'Dortmund', zip: '44357'},
    { city: 'Kirn', zip: '55606'},
    { city: 'Briedel', zip: '56867'},
    { city: 'Sinzig', zip: '53489'},
    { city: 'Senheim', zip: '56820'},
    { city: 'Udestedt, Mönchenholzhausen u.a.', zip: '99198'},
    { city: 'Nürnberg', zip: '90471'},
    { city: 'Pollenfeld', zip: '85131'},
    { city: 'Wittenförden u.a.', zip: '19073'},
    { city: 'Schwaig b. Nürnberg, Behringersdorfer Forst', zip: '90571'},
    { city: 'Bad Blankenburg', zip: '07422'},
    { city: 'Tutzing', zip: '82327'},
    { city: 'Trebel', zip: '29494'},
    { city: 'Mansfeld', zip: '06343'},
    { city: 'Olching', zip: '82140'},
    { city: 'Lübstorf', zip: '19069'},
    { city: 'Weißenbrunn', zip: '96369'},
    { city: 'Lenggries', zip: '83661'},
    { city: 'Neukirch', zip: '88099'},
    { city: 'Langenhagen', zip: '30851'},
    { city: 'Warthausen', zip: '88447'},
    { city: 'Mulfingen', zip: '74673'},
    { city: 'Alfeld (Leine)', zip: '31061'},
    { city: 'Ebersburg', zip: '36157'},
    { city: 'Schenefeld', zip: '22869'},
    { city: 'Bütthard', zip: '97244'},
    { city: 'Zell a. Main', zip: '97299'},
    { city: 'Retzstadt', zip: '97282'},
    { city: 'Ochsenhausen', zip: '88416'},
    { city: 'Abtsgmünd', zip: '73453'},
    { city: 'Heubach', zip: '73540'},
    { city: 'Hamburg', zip: '20457'},
    { city: 'Rot am See', zip: '74585'},
    { city: 'Hamburg', zip: '21107'},
    { city: 'Laupheim', zip: '88471'},
    { city: 'Hamburg', zip: '20251'},
    { city: 'Ochsenfurt', zip: '97199'},
    { city: 'Eggestorf', zip: '21272'},
    { city: 'Hamburg', zip: '20537'},
    { city: 'Flintbek', zip: '24220'},
    { city: 'Hamburg', zip: '22393'},
    { city: 'Buxheim', zip: '87740'},
    { city: 'Kiel', zip: '24105'},
    { city: 'Vierhöfen', zip: '21444'},
    { city: 'Windelsbach', zip: '91635'},
    { city: 'Niederstotzingen', zip: '89168'},
    { city: 'Probsteierhagen', zip: '24253'},
    { city: 'Ahnsbeck', zip: '29353'},
    { city: 'Eimke', zip: '29578'},
    { city: 'Waldstetten', zip: '89367'},
    { city: 'Betzendorf', zip: '21386'},
    { city: 'Fargau-Pratjau', zip: '24256'},
    { city: 'Bardowick, Wittorf, Barum', zip: '21357'},
    { city: 'Wilburgstetten', zip: '91634'},
    { city: 'Hohenhorn', zip: '21526'},
    { city: 'Reinfeld (Holstein)', zip: '23858'},
    { city: 'Sprakensehl', zip: '29365'},
    { city: 'Goslar', zip: '38640'},
    { city: 'Bosau', zip: '23715'},
    { city: 'Flachslanden', zip: '91604'},
    { city: 'Braunschweig', zip: '38118'},
    { city: 'Spenge', zip: '32139'},
    { city: 'Nordenham', zip: '26954'},
    { city: 'Ketsch', zip: '68775'},
    { city: 'Oberndorf am Neckar', zip: '78727'},
    { city: 'Epfendorf', zip: '78736'},
    { city: 'Münchhausen', zip: '35117'},
    { city: 'Vöhringen', zip: '72189'},
    { city: 'Paderborn', zip: '33106'},
    { city: 'Wildberg', zip: '72218'},
    { city: 'Gießen', zip: '35392'},
    { city: 'Wellendingen', zip: '78669'},
    { city: 'Neuenkirchen, Scholen', zip: '27251'},
    { city: 'Pohlheim', zip: '35415'},
    { city: 'Frankfurt am Main', zip: '60599'},
    { city: 'Korbach', zip: '34497'},
    { city: 'Simmozheim', zip: '75397'},
    { city: 'Dotternhausen', zip: '72359'},
    { city: 'Ötisheim', zip: '75443'},
    { city: 'Herrenberg', zip: '71083'},
    { city: 'Kirchhain', zip: '35274'},
    { city: 'Groß-Umstadt', zip: '64823'},
    { city: 'Bisingen', zip: '72406'},
    { city: 'Hanau', zip: '63452'},
    { city: 'Hechingen', zip: '72379'},
    { city: 'Ranstadt', zip: '63691'},
    { city: 'Hammersbach', zip: '63546'},
    { city: 'Neufeld, Schmedeswurth', zip: '25724'},
    { city: 'Erlensee', zip: '63526'},
    { city: 'Schaafheim', zip: '64850'},
    { city: 'Rodenbach', zip: '63517'},
    { city: 'Dußlingen', zip: '72144'},
    { city: 'Brunsbüttel', zip: '25541'},
    { city: 'Siegelsbach', zip: '74936'},
    { city: 'Dettenhausen', zip: '72135'},
    { city: 'Niederwöhren', zip: '31712'},
    { city: 'Neckarzimmern', zip: '74865'},
    { city: 'Oederquart', zip: '21734'},
    { city: 'Ludwigsburg', zip: '71636'},
    { city: 'Talheim', zip: '74388'},
    { city: 'Sankt Margarethen', zip: '25572'},
    { city: 'Stuttgart', zip: '70327'},
    { city: 'Untergruppenbach', zip: '74199'},
    { city: 'Bothel, Kirchwalsede u.a.', zip: '27386'},
    { city: 'Rotenburg', zip: '27356'},
    { city: 'Hohentengen', zip: '88367'},
    { city: 'Kassel', zip: '34131'},
    { city: 'Ahnatal', zip: '34292'},
    { city: 'Grebenau', zip: '36323'},
    { city: 'Oberboihingen', zip: '72644'},
    { city: 'Zwiefalten', zip: '88529'},
    { city: 'Köngen', zip: '73257'},
    { city: 'Glückstadt', zip: '25348'},
    { city: 'Grabenstetten', zip: '72582'},
    { city: 'Stade', zip: '21682'},
    { city: 'Reimlingen', zip: '86756'},
    { city: 'Reinstorf', zip: '21400'},
    { city: 'Boizenburg, Gresse, Greven u.a.', zip: '19258'},
    { city: 'Calberlah', zip: '38547'},
    { city: 'Welden', zip: '86465'},
    { city: 'Suhl', zip: '98529'},
    { city: 'Schwenningen', zip: '89443'},
    { city: 'Großvargula, Tonna', zip: '99958'},
    { city: 'Schönewörde', zip: '29396'},
    { city: 'Wilhelmsdorf', zip: '91489'},
    { city: 'Jembke', zip: '38477'},
    { city: 'Roßtal', zip: '90574'},
    { city: 'Beetzendorf, Rohrberg, Jübar', zip: '38489'},
    { city: 'Süpplingen, Frellstedt', zip: '38373'},
    { city: 'Warberg', zip: '38378'},
    { city: 'Velpke', zip: '38458'},
    { city: 'Gundelsheim', zip: '96163'},
    { city: 'Hirschaid', zip: '96114'},
    { city: 'Zapfendorf', zip: '96199'},
    { city: 'Hofstetten', zip: '86928'},
    { city: 'Huy', zip: '38838'},
    { city: 'Wessobrunn', zip: '82405'},
    { city: 'Großenbrode', zip: '23775'},
    { city: 'Ehekirchen', zip: '86676'},
    { city: 'Horgenzell', zip: '88263'},
    { city: 'Lütjenwestedt, Tackesdorf', zip: '25585'},
    { city: 'Altshausen', zip: '88361'},
    { city: 'Kirchheim (Hessen)', zip: '36275'},
    { city: 'Hollern-Twielenfleth', zip: '21723'},
    { city: 'Jagel, Lottorf', zip: '24878'},
    { city: 'Sauensiek', zip: '21644'},
    { city: 'Althütte', zip: '71566'},
    { city: 'Gehrden', zip: '30989'},
    { city: 'Apensen', zip: '21641'},
    { city: 'Kalbach', zip: '36148'},
    { city: 'Luckau, Waldrehna, Heideblick, Fürstlich Drehna', zip: '15926'},
    { city: 'Binz', zip: '18609'},
    { city: 'Berlin Bohnsdorf', zip: '12526'},
    { city: 'Biesenthal', zip: '16359'},
    { city: 'Philippsreut', zip: '94158'},
    { city: 'Karlshagen', zip: '17449'},
    { city: 'Königsbrück u.a.', zip: '01936'},
    { city: 'Karlshagen', zip: '17449'},
    { city: 'Dresden', zip: '01465'},
    { city: 'Torgelow', zip: '17358'},
    { city: 'Eisenhüttenstadt', zip: '15890'},
    { city: 'Zittau', zip: '02788'},
    { city: 'Rothenburg/O.L.', zip: '02929'},
    { city: 'Müllheim', zip: '79379'},
    { city: 'Staudernheim', zip: '55568'},
    { city: 'Heitersheim', zip: '79423'},
    { city: 'Holzwickede', zip: '59439'},
    { city: 'Ibbenbüren', zip: '49479'},
    { city: 'Fischbach, Erfweiler u.a.', zip: '66996'},
    { city: 'Heitersheim', zip: '79423'},
    { city: 'Drensteinfurt', zip: '48317'},
    { city: 'Münster', zip: '48145'},
    { city: 'Friedeburg', zip: '26446'},
    { city: 'Bad Ems Umland', zip: '56132'},
    { city: 'Miehlen u.a.', zip: '56357'},
    { city: 'Winterborn, Waldgrehweiler, Niedermoschel, u.a.', zip: '67822'},
    { city: 'Hemer', zip: '58675'},
    { city: 'Nußbach', zip: '67759'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Bad Kreuznach', zip: '55583'},
    { city: 'Hügelsheim', zip: '76549'},
    { city: 'Wilhelmshaven', zip: '26384'},
    { city: 'Ottenhöfen im Schwarzwald', zip: '77883'},
    { city: 'Bockenheim an der Weinstraße', zip: '67278'},
    { city: 'Kirchheim an der Weinstraße', zip: '67281'},
    { city: 'Weilburg', zip: '35781'},
    { city: 'Mainz', zip: '55127'},
    { city: 'Oldenburg (Oldenburg)', zip: '26121'},
    { city: 'Rheda-Wiedenbrück', zip: '33378'},
    { city: 'Melle', zip: '49326'},
    { city: 'Bad Rippoldsau-Schapbach', zip: '77776'},
    { city: 'Visbek', zip: '49429'},
    { city: 'Wiesbaden', zip: '65189'},
    { city: 'Freudenstadt', zip: '72250'},
    { city: 'Bellheim', zip: '76756'},
    { city: 'Gernsbach', zip: '76593'},
    { city: 'Malsch', zip: '76316'},
    { city: 'Weilmünster', zip: '35789'},
    { city: 'Dillenburg', zip: '35689'},
    { city: 'Donaueschingen', zip: '78166'},
    { city: 'Mittenaar', zip: '35756'},
    { city: 'Bestwig', zip: '59909'},
    { city: 'Lembruch, Burlage', zip: '49459'},
    { city: 'Düngenheim', zip: '56761'},
    { city: 'Herten', zip: '45701'},
    { city: 'Niederwörresbach', zip: '55758'},
    { city: 'Bonn', zip: '53229'},
    { city: 'Remscheid', zip: '42857'},
    { city: 'Hinte', zip: '26759'},
    { city: 'Klotten', zip: '56818'},
    { city: 'Irmenach', zip: '56843'},
    { city: 'Neunkirchen', zip: '66538'},
    { city: 'Bochum', zip: '44797'},
    { city: 'Herne', zip: '44623'},
    { city: 'Binningen', zip: '56754'},
    { city: 'Horstmar', zip: '48612'},
    { city: 'Daleiden, Preischeid u.a.', zip: '54689'},
    { city: 'Grefrath', zip: '47929'},
    { city: 'Prüm', zip: '54595'},
    { city: 'Mönchengladbach', zip: '41189'},
    { city: 'Pronsfeld', zip: '54597'},
    { city: 'Viersen', zip: '41748'},
    { city: 'Düren', zip: '52355'},
    { city: 'Ayl, Trassem u.a.', zip: '54441'},
    { city: 'Irrel', zip: '54666'},
    { city: 'Schüller', zip: '54586'},
    { city: 'Kaarst', zip: '41564'},
    { city: 'Badem, Gindorf, Neidenbach', zip: '54657'},
    { city: 'Duisburg', zip: '47137'},
    { city: 'Daun', zip: '54550'},
    { city: 'Mülheim an der Ruhr', zip: '45479'},
    { city: 'Oberhausen', zip: '46145'},
    { city: 'Zeltingen-Rachtig, Erden, Lösnich u.a.', zip: '54492'},
    { city: 'Alfter', zip: '53347'},
    { city: 'Malborn', zip: '54426'},
    { city: 'Haltern am See', zip: '45721'},
    { city: 'Sögel u.a.', zip: '49751'},
    { city: 'Aurich', zip: '26603'},
    { city: 'Esens, Neuharlingersiel u.a.', zip: '26427'},
    { city: 'Pirmasens', zip: '66954'},
    { city: 'Koblenz', zip: '56075'},
    { city: 'Koblenz', zip: '56073'},
    { city: 'Esterwegen u.a.', zip: '26897'},
    { city: 'Dortmund', zip: '44287'},
    { city: 'Puderbach', zip: '56305'},
    { city: 'Dürrholz', zip: '56307'},
    { city: 'Imsbach', zip: '67817'},
    { city: 'Oberried', zip: '79254'},
    { city: 'Gundersweiler, Gonbach u.a.', zip: '67724'},
    { city: 'Waldkirch', zip: '79183'},
    { city: 'Schönborn', zip: '56370'},
    { city: 'Göllheim', zip: '67307'},
    { city: 'Rieste', zip: '49597'},
    { city: 'Bad Iburg', zip: '49186'},
    { city: 'Görwihl', zip: '79733'},
    { city: 'Aarbergen', zip: '65326'},
    { city: 'Osnabrück', zip: '49088'},
    { city: 'Homburg', zip: '66424'},
    { city: 'Kruft', zip: '56642'},
    { city: 'Zweibrücken', zip: '66482'},
    { city: 'Dortmund', zip: '44388'},
    { city: 'Kretz', zip: '56630'},
    { city: 'Haselünne', zip: '49740'},
    { city: 'Gemünden', zip: '55490'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Urmitz', zip: '56220'},
    { city: 'Dollerup', zip: '24989'},
    { city: 'Bad Fallingbostel, Osterheide', zip: '29683'},
    { city: 'Groß Wittensee', zip: '24361'},
    { city: 'Sterup', zip: '24996'},
    { city: 'Stadt Schwäbisch Gmünd', zip: '73529'},
    { city: 'Bodnegg', zip: '88285'},
    { city: 'Salach', zip: '73084'},
    { city: 'Hannover', zip: '30559'},
    { city: 'Hannover', zip: '30521'},
    { city: 'Friedland', zip: '37133'},
    { city: 'Gerabronn', zip: '74582'},
    { city: 'Hamburg', zip: '22605'},
    { city: 'Alveslohe', zip: '25486'},
    { city: 'Hamburg', zip: '22523'},
    { city: 'Gettorf u.a.', zip: '24214'},
    { city: 'Gerstetten', zip: '89547'},
    { city: 'Norderstedt', zip: '22846'},
    { city: 'Crailsheim', zip: '74564'},
    { city: 'Norderstedt', zip: '22844'},
    { city: 'Oberstaufen', zip: '87534'},
    { city: 'Isny im Allgäu', zip: '88316'},
    { city: 'Euerdorf', zip: '97717'},
    { city: 'Maasholm, Schleimünde', zip: '24404'},
    { city: 'Langenau', zip: '89129'},
    { city: 'Hamburg', zip: '22337'},
    { city: 'Dettelbach', zip: '97337'},
    { city: 'Seth', zip: '23845'},
    { city: 'Hamburg', zip: '22359'},
    { city: 'Buch', zip: '89290'},
    { city: 'Leezen', zip: '23816'},
    { city: 'Laboe', zip: '24235'},
    { city: 'Wört', zip: '73499'},
    { city: 'Ungerhausen', zip: '87781'},
    { city: 'Markt Nordheim', zip: '91478'},
    { city: 'Meinersen', zip: '38536'},
    { city: 'Dombühl', zip: '91601'},
    { city: 'Sugenheim', zip: '91484'},
    { city: 'Prichsenstadt', zip: '97357'},
    { city: 'Neuburg a.d. Kammel', zip: '86476'},
    { city: 'Bad Windsheim', zip: '91438'},
    { city: 'Oberschwarzach', zip: '97516'},
    { city: 'Münsterhausen', zip: '86505'},
    { city: 'Hohenfelde', zip: '24257'},
    { city: 'Wieseth', zip: '91632'},
    { city: 'Knetzgau', zip: '97478'},
    { city: 'Malente, Kirchnüchel', zip: '23714'},
    { city: 'Bichl', zip: '83673'},
    { city: 'Neumarkt i.d. OPf.', zip: '92318'},
    { city: 'Deining', zip: '92364'},
    { city: 'München', zip: '80636'},
    { city: 'Pößneck', zip: '07381'},
    { city: 'Lobenstein', zip: '07356'},
    { city: 'Neufahrn b. Freising', zip: '85375'},
    { city: 'Weidenberg, Kirchenpingarten', zip: '95466'},
    { city: 'Ilberstedt', zip: '06408'},
    { city: 'Hahnbach', zip: '92256'},
    { city: 'Ammerthal', zip: '92260'},
    { city: 'Kümmersbruck', zip: '92245'},
    { city: 'Deuerling', zip: '93180'},
    { city: 'Wörth', zip: '85457'},
    { city: 'Kirschkau, Pausa-Mühltroff', zip: '07919'},
    { city: 'Nürnberg', zip: '90419'},
    { city: 'Gardelegen', zip: '39649'},
    { city: 'Oberweißbach u.a.', zip: '98744'},
    { city: 'Pinzberg', zip: '91361'},
    { city: 'Jesenwang', zip: '82287'},
    { city: 'Krün', zip: '82493'},
    { city: 'Wörthsee', zip: '82237'},
    { city: 'Kronach', zip: '96317'},
    { city: 'Plankenfels', zip: '95515'},
    { city: 'Gaimersheim', zip: '85080'},
    { city: 'Hecklingen', zip: '39444'},
    { city: 'Stadland', zip: '26935'},
    { city: 'Villingen-Schwenningen', zip: '78048'},
    { city: 'Neuhofen', zip: '67141'},
    { city: 'Ludwigshafen am Rhein', zip: '67059'},
    { city: 'Waldolms', zip: '35647'},
    { city: 'Bad Wildbad', zip: '75323'},
    { city: 'Bremen', zip: '28777'},
    { city: 'Lemwerder', zip: '27809'},
    { city: 'Lohra', zip: '35102'},
    { city: 'Delmenhorst', zip: '27755'},
    { city: 'Frankfurt am Main', zip: '60488'},
    { city: 'Leimen', zip: '69181'},
    { city: 'Frankfurt am Main', zip: '60438'},
    { city: 'Delmenhorst', zip: '27749'},
    { city: 'Frankfurt am Main', zip: '60433'},
    { city: 'Heidelberg', zip: '69115'},
    { city: 'Bremen', zip: '28237'},
    { city: 'Hilzingen', zip: '78247'},
    { city: 'Habel, Gröde', zip: '25869'},
    { city: 'Lindenfels', zip: '64678'},
    { city: 'Affinghausen und Sudwalde', zip: '27257'},
    { city: 'Florstadt', zip: '61197'},
    { city: 'Babenhausen', zip: '64832'},
    { city: 'Bremen', zip: '28309'},
    { city: 'Renningen', zip: '71272'},
    { city: 'Meldorf', zip: '25704'},
    { city: 'Kleinostheim', zip: '63801'},
    { city: 'Allensbach', zip: '78476'},
    { city: 'Binau', zip: '74862'},
    { city: 'Bitz', zip: '72475'},
    { city: 'Buchholz', zip: '31710'},
    { city: 'Fahrenbach', zip: '74864'},
    { city: 'Gundelsheim', zip: '74831'},
    { city: 'Stuttgart', zip: '70193'},
    { city: 'Breuna', zip: '34479'},
    { city: 'Pollhagen', zip: '31718'},
    { city: 'Romrod', zip: '36329'},
    { city: 'Wölpinghausen', zip: '31556'},
    { city: 'Reutlingen', zip: '72768'},
    { city: 'Veringenstadt', zip: '72519'},
    { city: 'Krauchenwies', zip: '72505'},
    { city: 'Sigmaringendorf', zip: '72517'},
    { city: 'Neuhausen auf den Fildern', zip: '73765'},
    { city: 'Pahlen', zip: '25794'},
    { city: 'Freudenberg, Collenberg', zip: '97896'},
    { city: 'Mengen', zip: '88512'},
    { city: 'Haste, Hohnhorst', zip: '31559'},
    { city: 'Neunkirchen', zip: '63930'},
    { city: 'Winnenden', zip: '71364'},
    { city: 'Backnang', zip: '71522'},
    { city: 'Stade', zip: '21684'},
    { city: 'Riedhausen', zip: '88377'},
    { city: 'Klein Wesenberg', zip: '23860'},
    { city: 'Münchsteinach', zip: '91481'},
    { city: 'Ilsenburg, Nordharz', zip: '38871'},
    { city: 'Gutenstetten', zip: '91468'},
    { city: 'Mickhausen', zip: '86866'},
    { city: 'Krummesse, Klempau', zip: '23628'},
    { city: 'Breitenfelde, Lankau', zip: '23881'},
    { city: 'Buttenwiesen', zip: '86647'},
    { city: 'Bobingen', zip: '86399'},
    { city: 'Gnotzheim', zip: '91728'},
    { city: 'Kaltental', zip: '87662'},
    { city: 'Kaisheim', zip: '86687'},
    { city: 'Geschwenda', zip: '98716'},
    { city: 'Gevensleben', zip: '38384'},
    { city: 'Pfofeld', zip: '91738'},
    { city: 'Ilmenau', zip: '98694'},
    { city: 'Pürgen', zip: '86932'},
    { city: 'Weißenburg i. Bay.', zip: '91781'},
    { city: 'Finning', zip: '86923'},
    { city: 'Harbke, Sommersdorf, Wefensleben, Ummendorf, Eilsleben', zip: '39365'},
    { city: 'Coppenbrügge', zip: '31863'},
    { city: 'Forchtenberg', zip: '74670'},
    { city: 'Kassel', zip: '34121'},
    { city: 'Großenlüder', zip: '36137'},
    { city: 'Böklund u.a.', zip: '24860'},
    { city: 'Weilheim an der Teck', zip: '73235'},
    { city: 'Neidlingen', zip: '73272'},
    { city: 'Esselbach', zip: '97839'},
    { city: 'Schwäbisch Hall', zip: '74523'},
    { city: 'Kupferzell', zip: '74635'},
    { city: 'Duingen', zip: '31089'},
    { city: 'Pausa-Mühltroff', zip: '07952'},
    { city: 'Bad Aibling', zip: '83043'},
    { city: 'Rostock, Lambrechtshagen', zip: '18069'},
    { city: 'Halle/ Saale', zip: '06116'},
    { city: 'Plauen, Rößnitz', zip: '08527'},
    { city: 'Schwarzenfeld', zip: '92521'},
    { city: 'Regensburg', zip: '93055'},
    { city: 'Tegernheim', zip: '93105'},
    { city: 'Püchersreuth', zip: '92715'},
    { city: 'Rostock, Graal-Müritz', zip: '18181'},
    { city: 'Mintraching', zip: '93098'},
    { city: 'Neustadt (Dosse) u.a.', zip: '16845'},
    { city: 'Groitzsch', zip: '04539'},
    { city: 'Guteneck', zip: '92543'},
    { city: 'Flossenbürg', zip: '92696'},
    { city: 'Pittenhart', zip: '83132'},
    { city: 'Jettenbach', zip: '84555'},
    { city: 'Falkenstein', zip: '93167'},
    { city: 'Seeon-Seebruck', zip: '83358'},
    { city: 'Belzig', zip: '14806'},
    { city: 'Brandenburg/ Havel', zip: '14770'},
    { city: 'Wittenberg', zip: '06888'},
    { city: 'Groß Kreutz', zip: '14550'},
    { city: 'Velgast', zip: '18469'},
    { city: 'Neukirchen am Teisenberg', zip: '83364'},
    { city: 'Mühlau', zip: '09241'},
    { city: 'Jahnsdorf', zip: '09387'},
    { city: 'Chemnitz', zip: '09117'},
    { city: 'Leisnig', zip: '04703'},
    { city: 'Michendorf', zip: '14552'},
    { city: 'Niederwiesa', zip: '09577'},
    { city: 'Künzing', zip: '94550'},
    { city: 'Rotthalmünster', zip: '94094'},
    { city: 'Samtens', zip: '18573'},
    { city: 'Riesa', zip: '01587'},
    { city: 'Bad Liebenwerda', zip: '04924'},
    { city: 'Jarmen', zip: '17126'},
    { city: 'Am Mellensee', zip: '15838'},
    { city: 'Dorfchemnitz, Mulda, Sayda', zip: '09619'},
    { city: 'Berlin Niederschönhausen', zip: '13156'},
    { city: 'Berlin Rudow', zip: '12355'},
    { city: 'Thyrnau', zip: '94136'},
    { city: 'Berlin Mahlsdorf', zip: '12623'},
    { city: 'Freital', zip: '01705'},
    { city: 'Joachimsthal u.a.', zip: '16247'},
    { city: 'Schönwalde', zip: '15910'},
    { city: 'Lübben (Spreewald)', zip: '15907'},
    { city: 'Dresden', zip: '01465'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Benz, Heringsdorf u.a.', zip: '17429'},
    { city: 'Beeskow', zip: '15848'},
    { city: 'Seebad Ahlbeck', zip: '17419'},
    { city: 'Wittichenau', zip: '02997'},
    { city: 'Löbau, Kottmar u.a.', zip: '02708'},
    { city: 'Neuschönau', zip: '94556'},
    { city: 'Panketal', zip: '16341'},
    { city: 'Berlin', zip: '12619'},
    { city: 'Sonnen', zip: '94164'},
    { city: 'Bad Freienwalde u.a.', zip: '16259'},
    { city: 'Neuhausen/Spree', zip: '03058'},
    { city: 'Golzow, Zechin u.a.', zip: '15328'},
    { city: 'Bernstadt a. d. Eigen', zip: '02748'},
    { city: 'Brüggen', zip: '41379'},
    { city: 'Aachen', zip: '52062'},
    { city: 'Nettetal', zip: '41334'},
    { city: 'Winterspelt', zip: '54616'},
    { city: 'Körperich u.a.', zip: '54675'},
    { city: 'Sonsbeck', zip: '47665'},
    { city: 'Wasserliesch', zip: '54332'},
    { city: 'Mechernich', zip: '53894'},
    { city: 'Moers', zip: '47441'},
    { city: 'Wallerfangen', zip: '66798'},
    { city: 'Trier', zip: '54293'},
    { city: 'Wesel', zip: '46485'},
    { city: 'Erftstadt', zip: '50374'},
    { city: 'Ringe, Laar, Emlichheim', zip: '49824'},
    { city: 'Duisburg', zip: '47169'},
    { city: 'Duisburg', zip: '47051'},
    { city: 'Köln', zip: '50827'},
    { city: 'Altenahr, Berg, Kalenborn, Kirchsahr', zip: '53505'},
    { city: 'Heiden', zip: '46359'},
    { city: 'Saarbrücken', zip: '66113'},
    { city: 'Köln', zip: '51105'},
    { city: 'Essen', zip: '45134'},
    { city: 'Wuppertal', zip: '42327'},
    { city: 'Deuselbach, Hermeskeil, Rorodt', zip: '54411'},
    { city: 'Dissen', zip: '49201'},
    { city: 'Jade', zip: '26349'},
    { city: 'Wolfach, Oberwolfach', zip: '77709'},
    { city: 'Elchesheim-Illingen', zip: '76477'},
    { city: 'Westhofen, Bermersheim', zip: '67593'},
    { city: 'Haßloch', zip: '67454'},
    { city: 'Bad Berleburg', zip: '57319'},
    { city: 'Mainz Ebersheim, Hechtsheim', zip: '55129'},
    { city: 'Friedenweiler', zip: '79877'},
    { city: 'St. Georgen', zip: '78112'},
    { city: 'Hördt', zip: '76771'},
    { city: 'Wildeshausen', zip: '27793'},
    { city: 'Villingen-Schwenningen', zip: '78052'},
    { city: 'Karlsruhe', zip: '76135'},
    { city: 'Dettenheim', zip: '76706'},
    { city: 'Wieden', zip: '79695'},
    { city: 'Geisenheim', zip: '65366'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Rickenbach', zip: '79736'},
    { city: 'Durbach', zip: '77770'},
    { city: 'Burgschwalbach', zip: '65558'},
    { city: 'Gau-Bickelheim', zip: '55599'},
    { city: 'Hohenstein', zip: '65329'},
    { city: 'Altleiningen', zip: '67317'},
    { city: 'Limburg', zip: '65555'},
    { city: 'Kindenheim', zip: '67271'},
    { city: 'Münster', zip: '48149'},
    { city: 'Lorup, Rastdorf', zip: '26901'},
    { city: 'Münster', zip: '48153'},
    { city: 'Recke', zip: '49509'},
    { city: 'Wittlingen', zip: '79599'},
    { city: 'Ibbenbüren', zip: '49477'},
    { city: 'Mehlbach', zip: '67735'},
    { city: 'Kaiserslautern', zip: '67659'},
    { city: 'Ransbach-Baumbach', zip: '56235'},
    { city: 'Kaiserslautern', zip: '67663'},
    { city: 'Drolshagen', zip: '57489'},
    { city: 'Mogendorf, Ebernhahn, Staudt u.a.', zip: '56424'},
    { city: 'Berschweiler bei Baumholder', zip: '55777'},
    { city: 'Waltrop', zip: '45731'},
    { city: 'Lehmen, Niederfell, Oberfell, Wolken u.a.', zip: '56332'},
    { city: 'Wildenbungert, Gondershausen, Nörtershausen u.a.', zip: '56283'},
    { city: 'Rammelsbach u.a.', zip: '66887'},
    { city: 'Gummersbach', zip: '51643'},
    { city: 'Waldbröl', zip: '51545'},
    { city: 'Merxheim', zip: '55627'},
    { city: 'Hesel, Neukamperfehn u.a.', zip: '26835'},
    { city: 'Hinzweiler', zip: '67756'},
    { city: 'Grumbach', zip: '67745'},
    { city: 'Sankt Ingbert', zip: '66386'},
    { city: 'Dülmen', zip: '48249'},
    { city: 'Bochum', zip: '44867'},
    { city: 'Birkenfeld u.a.', zip: '55765'},
    { city: 'Herne', zip: '44653'},
    { city: 'Metelen', zip: '48629'},
    { city: 'Wuppertal', zip: '42285'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Nebra, Kaiserpfalz', zip: '06642'},
    { city: 'Egling', zip: '82544'},
    { city: 'München', zip: '80997'},
    { city: 'Baierbrunn', zip: '82065'},
    { city: 'Nordhalben', zip: '96365'},
    { city: 'Helbra', zip: '06311'},
    { city: 'Osterburg, Altmärkische Höhe', zip: '39606'},
    { city: 'Mistelbach', zip: '95511'},
    { city: 'München', zip: '81476'},
    { city: 'Schnabelwaid', zip: '91289'},
    { city: 'München', zip: '80798'},
    { city: 'Bischofsgrün', zip: '95493'},
    { city: 'Weißenstadt', zip: '95163'},
    { city: 'Warmensteinach', zip: '95485'},
    { city: 'Glonn', zip: '85625'},
    { city: 'Feilitzsch', zip: '95183'},
    { city: 'Laaber, Brunn', zip: '93164'},
    { city: 'Ettenstatt', zip: '91796'},
    { city: 'Nürnberg', zip: '90408'},
    { city: 'Sonnefeld', zip: '96242'},
    { city: 'Weidhausen b. Coburg', zip: '96279'},
    { city: 'Weimar', zip: '99428'},
    { city: 'Gardelegen', zip: '39638'},
    { city: 'Karlshuld', zip: '86668'},
    { city: 'Großweil', zip: '82439'},
    { city: 'Hitzhofen', zip: '85122'},
    { city: 'Steinbach a. Wald', zip: '96361'},
    { city: 'Mistelgau', zip: '95490'},
    { city: 'Attenweiler', zip: '88448'},
    { city: 'Bad Ditzenbach', zip: '73342'},
    { city: 'Pattensen', zip: '30982'},
    { city: 'Hannover', zip: '30179'},
    { city: 'Schwäbisch Gmünd, Täferrot', zip: '73527'},
    { city: 'Wildflecken', zip: '97772'},
    { city: 'Leinach', zip: '97274'},
    { city: 'Weikersheim', zip: '97990'},
    { city: 'Berkatal', zip: '37297'},
    { city: 'Heimenkirch', zip: '88178'},
    { city: 'Bühlerzell', zip: '74426'},
    { city: 'Sibbesse', zip: '31079'},
    { city: 'Hamburg', zip: '22459'},
    { city: 'Hamburg', zip: '20355'},
    { city: 'Hamburg', zip: '20146'},
    { city: 'Unterpleichfeld', zip: '97294'},
    { city: 'Rumohr', zip: '24254'},
    { city: 'Hamburg', zip: '22083'},
    { city: 'Großharrie', zip: '24625'},
    { city: 'Hamburg', zip: '22415'},
    { city: 'Elchingen', zip: '89275'},
    { city: 'Kirchdorf an der Iller', zip: '88457'},
    { city: 'Kiel Russee', zip: '24111'},
    { city: 'Hamburg', zip: '22049'},
    { city: 'Hüttlingen', zip: '73460'},
    { city: 'Faßberg', zip: '29328'},
    { city: 'Holle', zip: '31188'},
    { city: 'Hamburg', zip: '22395'},
    { city: 'Albertshofen', zip: '97320'},
    { city: 'Schwanfeld', zip: '97523'},
    { city: 'Heidenheim an der Brenz', zip: '89522'},
    { city: 'Steinsfeld', zip: '91628'},
    { city: 'Wipfeld', zip: '97537'},
    { city: 'Schwentinetal', zip: '24223'},
    { city: 'Neresheim', zip: '73450'},
    { city: 'Elbe', zip: '38274'},
    { city: 'Buch a. Wald', zip: '91592'},
    { city: 'Offingen', zip: '89362'},
    { city: 'Bad Lauterberg', zip: '37431'},
    { city: 'Dürrlauingen', zip: '89350'},
    { city: 'Brunstorf', zip: '21524'},
    { city: 'Lüneburg', zip: '21337'},
    { city: 'Braunschweig', zip: '38116'},
    { city: 'Königsberg i. Bay.', zip: '97486'},
    { city: 'Ansbach', zip: '91522'},
    { city: 'Körner, Weinbergen', zip: '99998'},
    { city: 'Goslar', zip: '38644'},
    { city: 'Schmitten', zip: '61389'},
    { city: 'Bischoffen', zip: '35649'},
    { city: 'Mannheim', zip: '68199'},
    { city: 'Waldbronn', zip: '76337'},
    { city: 'Wurster Nordseeküste', zip: '27639'},
    { city: 'Hagen', zip: '27628'},
    { city: 'Karlsdorf-Neuthard', zip: '76689'},
    { city: 'Neulußheim', zip: '68809'},
    { city: 'Hambrücken', zip: '76707'},
    { city: 'Pfungstadt', zip: '64319'},
    { city: 'Heidelberg', zip: '69123'},
    { city: 'Bremerhaven', zip: '27574'},
    { city: 'Rosenfeld', zip: '72348'},
    { city: 'Frankfurt am Main', zip: '60329'},
    { city: 'Paderborn', zip: '33104'},
    { city: 'Oland', zip: '25867'},
    { city: 'Engen', zip: '78234'},
    { city: 'Gorxheimertal', zip: '69517'},
    { city: 'Dieburg', zip: '64807'},
    { city: 'Groß-Bieberau', zip: '64401'},
    { city: 'Deckenpfronn', zip: '75392'},
    { city: 'Süderlügum, Braderup u.a.', zip: '25923'},
    { city: 'Nordstrand, Elisabeth-Sophien-Koog, Südfall', zip: '25845'},
    { city: 'Bremen', zip: '28279'},
    { city: 'Bremen', zip: '28359'},
    { city: 'Wesselburen', zip: '25764'},
    { city: 'Otterndorf', zip: '21762'},
    { city: 'Echzell', zip: '61209'},
    { city: 'Ittlingen', zip: '74930'},
    { city: 'Hanau', zip: '63457'},
    { city: 'Michelstadt', zip: '64720'},
    { city: 'Irndorf', zip: '78597'},
    { city: 'Ottersberg', zip: '28870'},
    { city: 'Sindelfingen', zip: '71063'},
    { city: 'Holzgerlingen', zip: '71088'},
    { city: 'Wietzen', zip: '31613'},
    { city: 'Stockstadt am Main', zip: '63811'},
    { city: 'Sankt Annen, Rehm-Flehde-Bargen', zip: '25776'},
    { city: 'Hemmingstedt', zip: '25770'},
    { city: 'Leinfelden-Echterdingen', zip: '70771'},
    { city: 'Tamm', zip: '71732'},
    { city: 'Mosbach', zip: '74821'},
    { city: 'Waldenbuch', zip: '71111'},
    { city: 'Wolfhagen', zip: '34466'},
    { city: 'Balge', zip: '31609'},
    { city: 'Mömbris', zip: '63776'},
    { city: 'Süderhastedt', zip: '25727'},
    { city: 'Neckarwestheim', zip: '74382'},
    { city: 'Stuttgart', zip: '70184'},
    { city: 'Uhldingen-Mühlhofen', zip: '88690'},
    { city: 'Neckartenzlingen', zip: '72654'},
    { city: 'Lindhorst', zip: '31698'},
    { city: 'Wilster', zip: '25554'},
    { city: 'Erdmannhausen', zip: '71729'},
    { city: 'Denkendorf', zip: '73770'},
    { city: 'Meggerdorf, Friedrichsholm, Friedrichsgraben u.a.', zip: '24799'},
    { city: 'Dorfprozelten', zip: '97904'},
    { city: 'Schuby', zip: '24850'},
    { city: 'Bodenwerder, Pegestorf, Kirchbrak, Hehlen', zip: '37619'},
    { city: 'Elbe-Parey', zip: '39317'},
    { city: 'Stäbelow, Kritzmow', zip: '18198'},
    { city: 'Regensburg', zip: '93059'},
    { city: 'Langenwetzendorf', zip: '07957'},
    { city: 'Zeitz', zip: '06711'},
    { city: 'Mitterteich', zip: '95666'},
    { city: 'Unterreit', zip: '83567'},
    { city: 'Amerang', zip: '83123'},
    { city: 'Wusterwitz, Rosenau, Bensdorf', zip: '14789'},
    { city: 'Leipzig', zip: '04107'},
    { city: 'Ellefeld', zip: '08236'},
    { city: 'Rötha', zip: '04571'},
    { city: 'Havelsee', zip: '14798'},
    { city: 'Zwickau', zip: '08058'},
    { city: 'Meerane', zip: '08393'},
    { city: 'Kirchroth', zip: '94356'},
    { city: 'Seeon-Seebruck', zip: '83376'},
    { city: 'Bad Düben', zip: '04849'},
    { city: 'Remse', zip: '08373'},
    { city: 'Steinach', zip: '94377'},
    { city: 'Langenleuba-Niederhain', zip: '04618'},
    { city: 'Teising', zip: '84576'},
    { city: 'Lichtenstein', zip: '09350'},
    { city: 'Burgkirchen an der Alz', zip: '84508'},
    { city: 'Teisendorf', zip: '83317'},
    { city: 'Taura b. Burgstädt', zip: '09249'},
    { city: 'Rimbach', zip: '93485'},
    { city: 'Postmünster', zip: '84389'},
    { city: 'Geyer', zip: '09468'},
    { city: 'Bayerisch Gmain', zip: '83457'},
    { city: 'Auerbach', zip: '09392'},
    { city: 'Neustrelitz', zip: '17235'},
    { city: 'Potsdam', zip: '14473'},
    { city: 'Langdorf', zip: '94264'},
    { city: 'Berlin Spandau', zip: '13581'},
    { city: 'Altentreptow', zip: '17087'},
    { city: 'Berlin Charlottenburg', zip: '10585'},
    { city: 'Berlin Schöneberg', zip: '10783'},
    { city: 'Berlin Kreuzberg', zip: '10969'},
    { city: 'Greifswald', zip: '17493'},
    { city: 'Berlin Mitte', zip: '10119'},
    { city: 'Röckingen', zip: '91740'},
    { city: 'Stockelsdorf', zip: '23617'},
    { city: 'Tambach-Dietharz/ Thür.', zip: '99897'},
    { city: 'Langenneufnach', zip: '86863'},
    { city: 'Emskirchen', zip: '91448'},
    { city: 'Lübeck St. Lorenz Nord', zip: '23554'},
    { city: 'Wittingen', zip: '29378'},
    { city: 'Großvargula, Tonna', zip: '99958'},
    { city: 'Mühlhausen', zip: '96172'},
    { city: 'Heilsbronn', zip: '91560'},
    { city: 'Soltendiek', zip: '29594'},
    { city: 'Gersthofen', zip: '86368'},
    { city: 'Wolfsburg', zip: '38446'},
    { city: 'Groß Twülpstedt', zip: '38464'},
    { city: 'Thierhaupten', zip: '86672'},
    { city: 'Augsburg', zip: '86165'},
    { city: 'Augsburg', zip: '86163'},
    { city: 'Büddenstedt', zip: '38372'},
    { city: 'Ried', zip: '86510'},
    { city: 'Kuhfelde', zip: '29416'},
    { city: 'Flensburg, Tastrup', zip: '24943'},
    { city: 'Ottenbüttel', zip: '25591'},
    { city: 'Idstedt', zip: '24879'},
    { city: 'Garbsen', zip: '30826'},
    { city: 'Negenborn', zip: '37643'},
    { city: 'Uttenweiler', zip: '88524'},
    { city: 'Esselbach', zip: '97839'},
    { city: 'Osterstedt', zip: '25590'},
    { city: 'Michelfeld', zip: '74545'},
    { city: 'Waldenburg', zip: '74638'},
    { city: 'Munderkingen', zip: '89597'},
    { city: 'Heist', zip: '25492'},
    { city: 'Achberg', zip: '88147'},
    { city: 'Deggingen', zip: '73326'},
    { city: 'Appen', zip: '25482'},
    { city: 'Bad Mergentheim', zip: '97980'},
    { city: 'Eiterfeld', zip: '36132'},
    { city: 'Gingen an der Fils', zip: '73333'},
    { city: 'Hannover', zip: '30175'},
    { city: 'Hochdorf', zip: '88454'},
    { city: 'Hannover', zip: '30625'},
    { city: 'Kist, Irtenberger Wald', zip: '97270'},
    { city: 'Erlabrunn', zip: '97250'},
    { city: 'Quickborn', zip: '25451'},
    { city: 'Geroldshausen', zip: '97256'},
    { city: 'Hambühren', zip: '29313'},
    { city: 'Hamburg', zip: '22609'},
    { city: 'Lamspringe', zip: '31195'},
    { city: 'Burkardroth', zip: '97705'},
    { city: 'Wildeck', zip: '36208'},
    { city: 'Röthenbach (Allgäu)', zip: '88167'},
    { city: 'Staig', zip: '89195'},
    { city: 'Essingen', zip: '73457'},
    { city: 'Hamburg', zip: '20354'},
    { city: 'Theilheim', zip: '97288'},
    { city: 'Dietenheim', zip: '89165'},
    { city: 'Bad Bocklet', zip: '97708'},
    { city: 'Hamburg', zip: '22089'},
    { city: 'Bergtheim, Oberpleichfeld', zip: '97241'},
    { city: 'Katlenburg-Lindau', zip: '37191'},
    { city: 'Frickenhausen', zip: '97252'},
    { city: 'Hamburg', zip: '22043'},
    { city: 'Blaichach', zip: '87544'},
    { city: 'Nahe', zip: '23866'},
    { city: 'Treffurt/Ifta', zip: '99830'},
    { city: 'Kolitzheim', zip: '97509'},
    { city: 'Heere', zip: '38277'},
    { city: 'Bubesheim', zip: '89347'},
    { city: 'Egg an der Günz', zip: '87743'},
    { city: 'Mihla', zip: '99826'},
    { city: 'Herzberg, Elbingerode, Hörden', zip: '37412'},
    { city: 'Schonungen', zip: '97453'},
    { city: 'Sulzfeld', zip: '97633'},
    { city: 'Dürrwangen', zip: '91602'},
    { city: 'Lütjensee', zip: '22952'},
    { city: 'Lüneburg', zip: '21335'},
    { city: 'Gerdau', zip: '29581'},
    { city: 'Markt Bibart', zip: '91477'},
    { city: 'Dingolshausen', zip: '97497'},
    { city: 'Kirchheim in Schwaben', zip: '87757'},
    { city: 'Adendorf', zip: '21365'},
    { city: 'Zarpen', zip: '23619'},
    { city: 'Goslar', zip: '38642'},
    { city: 'Suhl, Marisfeld, Rohr u.a.', zip: '98530'},
    { city: 'Winterbach', zip: '89368'},
    { city: 'Goslar', zip: '38642'},
    { city: 'Ebeleben', zip: '99713'},
    { city: 'Wesendorf', zip: '29392'},
    { city: 'Braunschweig', zip: '38124'},
    { city: 'Insel Poel', zip: '23999'},
    { city: 'Kirchensittenbach', zip: '91241'},
    { city: 'München', zip: '80999'},
    { city: 'Hummeltal', zip: '95503'},
    { city: 'Pinnow', zip: '19065'},
    { city: 'München', zip: '81373'},
    { city: 'München', zip: '81369'},
    { city: 'Neuengönna u.a.', zip: '07778'},
    { city: 'Königstein', zip: '92281'},
    { city: 'München', zip: '80805'},
    { city: 'Ranis', zip: '07389'},
    { city: 'Goldkronach', zip: '95497'},
    { city: 'Schleiz', zip: '07907'},
    { city: 'Tegernsee', zip: '83684'},
    { city: 'Magdeburg', zip: '39114'},
    { city: 'Plattenburg', zip: '19339'},
    { city: 'Gammelsdorf', zip: '85408'},
    { city: 'Tuntenhausen', zip: '83104'},
    { city: 'Eching', zip: '84174'},
    { city: 'Landshut', zip: '84034'},
    { city: 'Kiefersfelden', zip: '83088'},
    { city: 'Flintsbach a. Inn', zip: '83126'},
    { city: 'Weiden in der OPf., Theisseil', zip: '92637'},
    { city: 'Thalmassing', zip: '93107'},
    { city: 'Regensburg', zip: '93057'},
    { city: 'Dessau-Roßlau', zip: '06862'},
    { city: 'Berga/Elster', zip: '07980'},
    { city: 'Schirmitz', zip: '92718'},
    { city: 'Sandersdorf-Brehna', zip: '06794'},
    { city: 'Riedering', zip: '83083'},
    { city: 'Treuen', zip: '08233'},
    { city: 'Großpösna', zip: '04463'},
    { city: 'Unterwössen', zip: '83246'},
    { city: 'Kienberg', zip: '83361'},
    { city: 'Wusterhausen', zip: '16868'},
    { city: 'Reit im Winkl', zip: '83242'},
    { city: 'Schönsee', zip: '92539'},
    { city: 'Traunreut', zip: '83301'},
    { city: 'Mamming', zip: '94437'},
    { city: 'Pleiskirchen', zip: '84568'},
    { city: 'Wittenberg', zip: '06889'},
    { city: 'Zschorlau', zip: '08321'},
    { city: 'Brück, Borkheide u.a.', zip: '14822'},
    { city: 'Waging a. See', zip: '83329'},
    { city: 'Straßkirchen', zip: '94342'},
    { city: 'Zingst a. Darß', zip: '18374'},
    { city: 'Kirchdorf a. Inn', zip: '84375'},
    { city: 'Pfarrkirchen', zip: '84347'},
    { city: 'Chemnitz', zip: '09125'},
    { city: 'Chemnitz', zip: '09130'},
    { city: 'Marktschellenberg', zip: '83487'},
    { city: 'Leubsdorf, Gornau, Augustusburg', zip: '09573'},
    { city: 'Schöfweg', zip: '94572'},
    { city: 'Außernzell', zip: '94532'},
    { city: 'Feldberger Seenlandschaft', zip: '17258'},
    { city: 'Eppenschlag', zip: '94536'},
    { city: 'Berlin Charlottenburg', zip: '10627'},
    { city: 'Berlin Märkisches Viertel', zip: '13439'},
    { city: 'Berlin Rosenthal', zip: '13158'},
    { city: 'Passau', zip: '94034'},
    { city: 'Putbus', zip: '18581'},
    { city: 'Berlin Pankow', zip: '13189'},
    { city: 'Berlin Britz', zip: '12347'},
    { city: 'Wellheim', zip: '91809'},
    { city: 'Althegnenberg', zip: '82278'},
    { city: 'Oberhausen', zip: '86697'},
    { city: 'Raisting', zip: '82399'},
    { city: 'Effeltrich', zip: '91090'},
    { city: 'Steinach', zip: '96523'},
    { city: 'Oberschweinbach', zip: '82294'},
    { city: 'Marktzeuln', zip: '96275'},
    { city: 'Altomünster', zip: '85250'},
    { city: 'Allersberg', zip: '90584'},
    { city: 'Walchensee', zip: '82432'},
    { city: 'Iffeldorf', zip: '82393'},
    { city: 'Rastow', zip: '19077'},
    { city: 'Hettstedt, Endorf', zip: '06333'},
    { city: 'Marktrodach', zip: '96364'},
    { city: 'Lutzingen', zip: '89440'},
    { city: 'Zusmarshausen', zip: '86441'},
    { city: 'Schönewörde', zip: '29396'},
    { city: 'Westheim', zip: '91747'},
    { city: 'Weste', zip: '29599'},
    { city: 'Großaitingen', zip: '86845'},
    { city: 'Gessertshausen', zip: '86459'},
    { city: 'Lübeck', zip: '23552'},
    { city: 'Langerringen', zip: '86853'},
    { city: 'Bad Tennstedt', zip: '99955'},
    { city: 'Wolfsburg', zip: '38440'},
    { city: 'Göhrde', zip: '29473'},
    { city: 'Mitteleschenbach', zip: '91734'},
    { city: 'Landsberg a. Lech', zip: '86899'},
    { city: 'Frensdorf', zip: '96158'},
    { city: 'Alesheim', zip: '91793'},
    { city: 'Peiting', zip: '86971'},
    { city: 'Vilgertshofen', zip: '86946'},
    { city: 'Rain', zip: '86641'},
    { city: 'Helmstedt', zip: '38350'},
    { city: 'Hötensleben, Völpke, Ottleben u.a.', zip: '39393'},
    { city: 'Scheßlitz', zip: '96110'},
    { city: 'Dörfles-Esbach', zip: '96487'},
    { city: 'Rockhausen, Klettbach', zip: '99102'},
    { city: 'Waldkirchen', zip: '94065'},
    { city: 'Obernzell', zip: '94130'},
    { city: 'Berlin Köpenick', zip: '12559'},
    { city: 'Uckerland, Groß Luckow, Schönhausen', zip: '17337'},
    { city: 'Königs Wusterhausen', zip: '15712'},
    { city: 'Erkner', zip: '15537'},
    { city: 'Großräschen', zip: '01983'},
    { city: 'Hohenaspe', zip: '25582'},
    { city: 'Kassel', zip: '34127'},
    { city: 'Fronreute', zip: '88273'},
    { city: 'Kassel, Fuldatal', zip: '34233'},
    { city: 'Mittelangeln', zip: '24986'},
    { city: 'Hetlingen', zip: '25491'},
    { city: 'Fockbek', zip: '24787'},
    { city: 'Weißbach', zip: '74679'},
    { city: 'Lorch', zip: '73547'},
    { city: 'Heiningen', zip: '73092'},
    { city: 'Schwedt', zip: '16303'},
    { city: 'Biesendahlshof, Berkholz-Meyenburg', zip: '16306'},
    { city: 'Müllrose', zip: '15299'},
    { city: 'Ostritz, Schönau-Berzdorf', zip: '02899'},
    { city: 'Groß-Gerau', zip: '64521'},
    { city: 'Nauheim', zip: '64569'},
    { city: 'Karlsruhe', zip: '76227'},
    { city: 'Graben-Neudorf', zip: '76676'},
    { city: 'Büren', zip: '33142'},
    { city: 'Battenberg', zip: '35088'},
    { city: 'Frankfurt am Main', zip: '65929'},
    { city: 'Bremerhaven', zip: '27580'},
    { city: 'Herford', zip: '32051'},
    { city: 'Heuchelheim', zip: '35452'},
    { city: 'Frankfurt am Main', zip: '60528'},
    { city: 'Ober-Mörlen', zip: '61239'},
    { city: 'Langen', zip: '63225'},
    { city: 'Linden', zip: '35440'},
    { city: 'Herford', zip: '32052'},
    { city: 'Darmstadt', zip: '64291'},
    { city: 'Lautertal (Odenwald)', zip: '64686'},
    { city: 'Tuttlingen', zip: '78532'},
    { city: 'Hille', zip: '32479'},
    { city: 'Pforzheim', zip: '75175'},
    { city: 'Frankfurt am Main', zip: '60385'},
    { city: 'Zimmern unter der Burg', zip: '72369'},
    { city: 'Staufenberg', zip: '35460'},
    { city: 'Lich', zip: '35423'},
    { city: 'Rödermark', zip: '63322'},
    { city: 'Cölbe', zip: '35091'},
    { city: 'Ebsdorfergrund', zip: '35085'},
    { city: 'Tiefenbronn', zip: '75233'},
    { city: 'Münster', zip: '64839'},
    { city: 'Petershagen', zip: '32469'},
    { city: 'Maintal', zip: '63477'},
    { city: 'Risum-Lindholm, Stedesand', zip: '25920'},
    { city: 'Mönsheim', zip: '71297'},
    { city: 'Eschelbronn', zip: '74927'},
    { city: 'Öhningen', zip: '78337'},
    { city: 'Nusplingen', zip: '72362'},
    { city: 'Mossautal', zip: '64756'},
    { city: 'Orsingen-Nenzingen', zip: '78359'},
    { city: 'Diemelstadt', zip: '34474'},
    { city: 'Neuenkirchen', zip: '25792'},
    { city: 'Aglasterhausen', zip: '74858'},
    { city: 'Ladelund', zip: '25926'},
    { city: 'Edertal', zip: '34549'},
    { city: 'Albstadt', zip: '72458'},
    { city: 'Neckargerach', zip: '69437'},
    { city: 'Aschaffenburg', zip: '63741'},
    { city: 'Stuttgart', zip: '70565'},
    { city: 'Heilbronn', zip: '74081'},
    { city: 'Sulzbach am Main', zip: '63834'},
    { city: 'Dörverden', zip: '27313'},
    { city: 'Ludwigsburg', zip: '71638'},
    { city: 'Behrendorf, Bondelum', zip: '25850'},
    { city: 'Reutlingen', zip: '72766'},
    { city: 'Eschau', zip: '63863'},
    { city: 'Eggstedt', zip: '25721'},
    { city: 'Altdorf', zip: '72655'},
    { city: 'Brokdorf', zip: '25576'},
    { city: 'Neukirchen (Knüll)', zip: '34626'},
    { city: 'Kernen im Remstal', zip: '71394'},
    { city: 'Hanerau-Hademarschen, Seefeld u.a.', zip: '25557'},
    { city: 'Aspach', zip: '71546'},
    { city: 'Wewelsfleth', zip: '25599'},
    { city: 'Wrohm', zip: '25799'},
    { city: 'Wertheim', zip: '97877'},
    { city: 'Dettingen unter Teck', zip: '73265'},
    { city: 'Öhringen', zip: '74613'},
    { city: 'Hagen', zip: '58099'},
    { city: 'Lünen', zip: '44534'},
    { city: 'Gummersbach', zip: '51645'},
    { city: 'Ochtersum', zip: '26489'},
    { city: 'Dortmund', zip: '44267'},
    { city: 'Hagen', zip: '58099'},
    { city: 'Mittelbrunn, Queidersbach u.a.', zip: '66851'},
    { city: 'Sobernheim', zip: '55566'},
    { city: 'Übach-Palenberg', zip: '52531'},
    { city: 'Kevelaer-Winnekendonk', zip: '47626'},
    { city: 'Viersen', zip: '41748'},
    { city: 'Krefeld', zip: '47804'},
    { city: 'Krefeld', zip: '47829'},
    { city: 'Bettenfeld, Niederöfflingen u.a.', zip: '54533'},
    { city: 'Dillingen/Saar', zip: '66763'},
    { city: 'Oberhausen', zip: '46045'},
    { city: 'Köln', zip: '50767'},
    { city: 'Malborn', zip: '54426'},
    { city: 'Adenau, Kottenborn u.a.', zip: '53518'},
    { city: 'Saarbrücken', zip: '66128'},
    { city: 'Köln', zip: '50677'},
    { city: 'Essen', zip: '45147'},
    { city: 'Wülfrath', zip: '42489'},
    { city: 'Gelsenkirchen', zip: '45897'},
    { city: 'Leverkusen', zip: '51375'},
    { city: 'Deuselbach, Hermeskeil, Rorodt', zip: '54411'},
    { city: 'Meschede', zip: '59872'},
    { city: 'Edesheim', zip: '67483'},
    { city: 'Herxheim', zip: '76863'},
    { city: 'Wiesbaden', zip: '65197'},
    { city: 'Herborn', zip: '35745'},
    { city: 'Dittelsheim-Heßloch', zip: '67596'},
    { city: 'Wiesbaden', zip: '65193'},
    { city: 'Dirmstein', zip: '67246'},
    { city: 'Gommersheim', zip: '67377'},
    { city: 'Bodenheim', zip: '55294'},
    { city: 'Lauterbach', zip: '78730'},
    { city: 'Westheim (Pfalz)', zip: '67368'},
    { city: 'Lingenfeld', zip: '67360'},
    { city: 'Gütersloh', zip: '33330'},
    { city: 'Werther (Westf.)', zip: '33824'},
    { city: 'Biblis', zip: '68647'},
    { city: 'Breidenbach', zip: '35236'},
    { city: 'Solms', zip: '35606'},
    { city: 'Mehlingen', zip: '67678'},
    { city: 'Mogendorf, Ebernhahn, Staudt u.a.', zip: '56424'},
    { city: 'Lohnsfeld', zip: '67727'},
    { city: 'Freiburg im Breisgau', zip: '79110'},
    { city: 'Essen (Oldenburg)', zip: '49632'},
    { city: 'Katzenelnbogen', zip: '56368'},
    { city: 'Bad Säckingen', zip: '79713'},
    { city: 'Steinbach, Weitersweiler, Bennhausen, Mörsfeld, Würzweiler, Ruppertsecken u.a.', zip: '67808'},
    { city: 'Feldberg', zip: '79868'},
    { city: 'Carlsberg', zip: '67316'},
    { city: 'Flonheim', zip: '55237'},
    { city: 'Burgschwalbach', zip: '65558'},
    { city: 'Simonswald', zip: '79263'},
    { city: 'Breitnau', zip: '79874'},
    { city: 'Burgschwalbach', zip: '65558'},
    { city: 'Steinweiler', zip: '76872'},
    { city: 'Oelde', zip: '59302'},
    { city: 'Solingen', zip: '42653'},
    { city: 'Büchel', zip: '56823'},
    { city: 'Bad Neuenahr-Ahrweiler', zip: '53474'},
    { city: 'Bonn', zip: '53115'},
    { city: 'Peterswald-Löffelscheid u.a.', zip: '56858'},
    { city: 'Bell', zip: '56745'},
    { city: 'Hattingen', zip: '45529'},
    { city: 'Wermelskirchen', zip: '42929'},
    { city: 'Bochum', zip: '44791'},
    { city: 'Remscheid', zip: '42899'},
    { city: 'Peterswald-Löffelscheid u.a.', zip: '56858'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Südbrookmerland', zip: '26624'},
    { city: 'Unna', zip: '59425'},
    { city: 'Lörrach', zip: '79540'},
    { city: 'Fürthen', zip: '57539'},
    { city: 'Kleinmaischeid', zip: '56271'},
    { city: 'Voltlage', zip: '49599'},
    { city: 'Tecklenburg', zip: '49545'},
    { city: 'Freilingen, Freirachdorf u.a.', zip: '56244'},
    { city: 'Hattert', zip: '57644'},
    { city: 'Kaiserslautern', zip: '67655'},
    { city: 'Steinbach, Weitersweiler, Bennhausen, Mörsfeld, Würzweiler, Ruppertsecken u.a.', zip: '67808'},
    { city: 'Feilbingert', zip: '67824'},
    { city: 'Salzbergen', zip: '48499'},
    { city: 'Westoverledingen', zip: '26810'},
    { city: 'Havixbeck', zip: '48329'},
    { city: 'Bechhofen', zip: '66894'},
    { city: 'Dortmund', zip: '44227'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Wettstetten', zip: '85139'},
    { city: 'Petershausen', zip: '85238'},
    { city: 'Plech', zip: '91287'},
    { city: 'Stadtsteinach', zip: '95346'},
    { city: 'Seehausen, Werben, Leppin u.a.', zip: '39615'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'Ludwigschorgast', zip: '95364'},
    { city: 'München', zip: '80796'},
    { city: 'Bad Berneck im Fichtelgebirge', zip: '95460'},
    { city: 'Miesbach', zip: '83714'},
    { city: 'Anzing', zip: '85646'},
    { city: 'Weißenfels, Stößen', zip: '06667'},
    { city: 'Freihung', zip: '92271'},
    { city: 'Kirschkau, Pausa-Mühltroff', zip: '07919'},
    { city: 'Freudenberg', zip: '92272'},
    { city: 'Frankleben', zip: '06259'},
    { city: 'Nagel', zip: '95697'},
    { city: 'Gera, Zedlitz u.a.', zip: '07557'},
    { city: 'Leuna', zip: '06237'},
    { city: 'Regensburg', zip: '93051'},
    { city: 'Landshut, Altdorf', zip: '84032'},
    { city: 'Friedenfels', zip: '95688'},
    { city: 'Albaching', zip: '83544'},
    { city: 'Zeitlarn', zip: '93197'},
    { city: 'Dummerstorf', zip: '18196'},
    { city: 'Ronneburg, Braunichswalde, Großenstein u.a.', zip: '07580'},
    { city: 'Schwarzach b. Nabburg', zip: '92548'},
    { city: 'Dessau-Roßlau', zip: '06844'},
    { city: 'Rathenow', zip: '14712'},
    { city: 'Bad Brambach', zip: '08648'},
    { city: 'Leipzig', zip: '04159'},
    { city: 'Wittstock/Dosse, Heiligengrabe', zip: '16909'},
    { city: 'Schnaitsee', zip: '83530'},
    { city: 'Auerbach/Vogtl.', zip: '08209'},
    { city: 'Brandenburg/ Havel', zip: '14774'},
    { city: 'Leipzig', zip: '04349'},
    { city: 'Engelsberg', zip: '84549'},
    { city: 'Pilsting', zip: '94431'},
    { city: 'Pemfling', zip: '93482'},
    { city: 'Waldmünchen', zip: '93449'},
    { city: 'Schlema', zip: '08301'},
    { city: 'Treuenbrietzen', zip: '14929'},
    { city: 'Kirchanschöring', zip: '83417'},
    { city: 'Hartmannsdorf', zip: '09232'},
    { city: 'Kötzting', zip: '93444'},
    { city: 'Amtsberg', zip: '09439'},
    { city: 'Flöha', zip: '09557'},
    { city: 'Miltzow u.a.', zip: '18519'},
    { city: 'Riesa', zip: '01591'},
    { city: 'Sponholz, Neunkirchen u.a.', zip: '17039'},
    { city: 'Berlin Schmargendorf', zip: '14199'},
    { city: 'Fürstenstein', zip: '94538'},
    { city: 'Berlin Reinickendorf', zip: '13437'},
    { city: 'Gützkow', zip: '17506'},
    { city: 'Berlin Mariendorf', zip: '12109'},
    { city: 'Röderland, Großthiemig u.a.', zip: '04932'},
    { city: 'Wilsdruff', zip: '01723'},
    { city: 'Berlin Prenzlauer Berg', zip: '10407'},
    { city: 'Tharandt u.a.', zip: '01737'},
    { city: 'Bernau', zip: '16321'},
    { city: 'Berlin Alt-Hohenschönhausen', zip: '13055'},
    { city: 'Berlin Friedrichsfelde', zip: '10315'},
    { city: 'Dorfhain', zip: '01738'},
    { city: 'Teupitz', zip: '15755'},
    { city: 'Friedland, Galenbeck, Datzetal', zip: '17099'},
    { city: 'Berlin', zip: '12629'},
    { city: 'Bestensee', zip: '15741'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Eggesin', zip: '17367'},
    { city: 'Göda', zip: '02633'},
    { city: 'Nürnberg', zip: '90411'},
    { city: 'Rockhausen, Klettbach', zip: '99102'},
    { city: 'Odelzhausen', zip: '85235'},
    { city: 'Pähl', zip: '82396'},
    { city: 'Landsberied', zip: '82290'},
    { city: 'Seefeld', zip: '82229'},
    { city: 'Woltersdorf', zip: '29497'},
    { city: 'Krün', zip: '82494'},
    { city: 'Ludwigslust', zip: '19288'},
    { city: 'Lenzen', zip: '19309'},
    { city: 'Weichering', zip: '86706'},
    { city: 'Benediktbeuern', zip: '83671'},
    { city: 'Teuschnitz', zip: '96358'},
    { city: 'Aachen', zip: '52072'},
    { city: 'Viersen', zip: '41751'},
    { city: 'Mönchengladbach', zip: '41061'},
    { city: 'Kamp-Lintfort', zip: '47475'},
    { city: 'Düren', zip: '52351'},
    { city: 'Preist', zip: '54664'},
    { city: 'Dinslaken', zip: '46535'},
    { city: 'Schermbeck', zip: '46514'},
    { city: 'Borken', zip: '46325'},
    { city: 'Reifferscheid, Kaltenborn, Wershofen u.a.', zip: '53520'},
    { city: 'Düsseldorf', zip: '40223'},
    { city: 'Köln', zip: '50765'},
    { city: 'Swisttal', zip: '53913'},
    { city: 'Hoogstede', zip: '49846'},
    { city: 'Ahrbrück, Heckenbach, Hönningen, Kesseling, Rech', zip: '53506'},
    { city: 'Köln', zip: '50670'},
    { city: 'Essen', zip: '45143'},
    { city: 'Ürzig', zip: '54539'},
    { city: 'Gladbeck', zip: '45968'},
    { city: 'Merchweiler', zip: '66589'},
    { city: 'Bonn', zip: '53121'},
    { city: 'Rammelsbach u.a.', zip: '66887'},
    { city: 'Gummersbach', zip: '51647'},
    { city: 'Mittelbrunn, Queidersbach u.a.', zip: '66851'},
    { city: 'Detern', zip: '26847'},
    { city: 'Mackenbach', zip: '67686'},
    { city: 'Peterswald-Löffelscheid u.a.', zip: '56858'},
    { city: 'Hückeswagen', zip: '42499'},
    { city: 'Radevormwald', zip: '42477'},
    { city: 'Witten', zip: '58452'},
    { city: 'Asbach, Buchholz', zip: '53567'},
    { city: 'Leer', zip: '26789'},
    { city: 'Tiefenbach u.a.', zip: '55471'},
    { city: 'Gelsenkirchen Rotthausen', zip: '45884'},
    { city: 'Schöppingen', zip: '48624'},
    { city: 'Herne', zip: '44649'},
    { city: 'Norderney', zip: '26548'},
    { city: 'Oberlangen, Niederlangen', zip: '49779'},
    { city: 'Wuppertal', zip: '42281'},
    { city: 'Bunde', zip: '26831'},
    { city: 'Herne', zip: '44629'},
    { city: 'Bad Breisig, Waldorf, Gönnersdorf', zip: '53498'},
    { city: 'Waldsee', zip: '67165'},
    { city: 'Ganderkesee', zip: '27777'},
    { city: 'Twistringen', zip: '27239'},
    { city: 'Harpstedt, Groß Ippener, Colnrade u.a.', zip: '27243'},
    { city: 'Pfalzgrafenweiler', zip: '72285'},
    { city: 'Mannheim', zip: '68309'},
    { city: 'Weiterstadt', zip: '64331'},
    { city: 'Bad Homburg v.d. Höhe', zip: '61348'},
    { city: 'Königsbach-Stein', zip: '75203'},
    { city: 'Wetter', zip: '35083'},
    { city: 'Wettenberg', zip: '35435'},
    { city: 'Weimar (Lahn)', zip: '35096'},
    { city: 'Mühltal', zip: '64367'},
    { city: 'Borchen', zip: '33178'},
    { city: 'Delmenhorst', zip: '27755'},
    { city: 'Frankfurt am Main', zip: '60311'},
    { city: 'Gießen', zip: '35394'},
    { city: 'Mörlenbach', zip: '69509'},
    { city: 'Diepenau', zip: '31603'},
    { city: 'Burgwald', zip: '35099'},
    { city: 'Marburg', zip: '35043'},
    { city: 'Gottmadingen', zip: '78244'},
    { city: 'Vlotho', zip: '32602'},
    { city: 'Lichtenau', zip: '33165'},
    { city: 'Offenbach am Main', zip: '63075'},
    { city: 'Bondorf', zip: '71149'},
    { city: 'Bremen', zip: '28277'},
    { city: 'Neckarsteinach', zip: '69239'},
    { city: 'Rauschenberg', zip: '35282'},
    { city: 'Worpswede', zip: '27726'},
    { city: 'Heimsheim', zip: '71296'},
    { city: 'Neuenkirchen', zip: '21763'},
    { city: 'Albstadt', zip: '72459'},
    { city: 'Bodelshausen', zip: '72411'},
    { city: 'Ditzingen', zip: '71254'},
    { city: 'Leonberg', zip: '71229'},
    { city: 'Lamstedt', zip: '21769'},
    { city: 'Ofterdingen', zip: '72131'},
    { city: 'Hirzenhain', zip: '63697'},
    { city: 'Großwallstadt', zip: '63868'},
    { city: 'Stadthagen', zip: '31655'},
    { city: 'Hessigheim', zip: '74394'},
    { city: 'Untereisesheim', zip: '74257'},
    { city: 'Bad Pyrmont', zip: '31812'},
    { city: 'Drakenburg', zip: '31623'},
    { city: 'Stöckse', zip: '31638'},
    { city: 'Wunstorf', zip: '31515'},
    { city: 'Collenberg', zip: '97903'},
    { city: 'Bad Soden-Salmünster', zip: '63628'},
    { city: 'Löwenstein', zip: '74245'},
    { city: 'Handewitt', zip: '24976'},
    { city: 'Spiegelberg', zip: '71579'},
    { city: 'Flensburg', zip: '24939'},
    { city: 'Gräfendorf', zip: '97782'},
    { city: 'Hannover', zip: '30167'},
    { city: 'Wrist', zip: '25563'},
    { city: 'Amtzell', zip: '88279'},
    { city: 'Prisdorf', zip: '25497'},
    { city: 'Erbach', zip: '89155'},
    { city: 'Ruppertshofen', zip: '73577'},
    { city: 'Waldstetten', zip: '73550'},
    { city: 'Oberdischingen', zip: '89610'},
    { city: 'Rellingen', zip: '25462'},
    { city: 'Thüngen', zip: '97289'},
    { city: 'Vellberg', zip: '74541'},
    { city: 'Ulm', zip: '89079'},
    { city: 'Böhmenkirch', zip: '89558'},
    { city: 'Kappeln', zip: '24376'},
    { city: 'Hamburg', zip: '22763'},
    { city: 'Burgdorf', zip: '31303'},
    { city: 'Hildesheim', zip: '31134'},
    { city: 'Randersacker', zip: '97236'},
    { city: 'Hamburg', zip: '22335'},
    { city: 'Wain', zip: '88489'},
    { city: 'Hamburg', zip: '22297'},
    { city: 'Bernstadt', zip: '89182'},
    { city: 'Hamburg', zip: '22299'},
    { city: 'Oldendorf (Luhe), Amelinghausen, Rehlingen', zip: '21385'},
    { city: 'Ellwangen (Jagst)', zip: '73479'},
    { city: 'Hamburg', zip: '22047'},
    { city: 'Nersingen', zip: '89278'},
    { city: 'Osterode am Harz', zip: '37520'},
    { city: 'Duderstadt', zip: '37115'},
    { city: 'Eisenheim', zip: '97247'},
    { city: 'Höfer', zip: '29361'},
    { city: 'Glinde', zip: '21509'},
    { city: 'Schwentinental', zip: '24222'},
    { city: 'Radbruch', zip: '21449'},
    { city: 'Ascheberg', zip: '24326'},
    { city: 'Ascheberg', zip: '24326'},
    { city: 'Vierhöfen', zip: '21444'},
    { city: 'Schönberg (Holstein)', zip: '24217'},
    { city: 'Kröppelshagen-Fahrendorf', zip: '21529'},
    { city: 'Hanstedt', zip: '29582'},
    { city: 'Seth', zip: '23845'},
    { city: 'Markt Rettenbach', zip: '87733'},
    { city: 'Wallerstein', zip: '86757'},
    { city: 'Braunschweig', zip: '38122'},
    { city: 'Ahrensbök', zip: '23623'},
    { city: 'Vordorf', zip: '38533'},
    { city: 'Rötgesbüttel', zip: '38531'},
    { city: 'Braunschweig', zip: '38108'},
    { city: 'Oberaurach', zip: '97514'},
    { city: 'Weihenzell', zip: '91629'},
    { city: 'Kissenbrück', zip: '38324'},
    { city: 'Wasbüttel', zip: '38553'},
    { city: 'Vestenbergsgreuth', zip: '91487'},
    { city: 'Biessenhofen', zip: '87640'},
    { city: 'Burgebrach', zip: '96138'},
    { city: 'Zella-Mehlis', zip: '98544'},
    { city: 'Pansdorf', zip: '23689'},
    { city: 'Rieden am Forggensee', zip: '87669'},
    { city: 'Suhl', zip: '98527'},
    { city: 'Harztor', zip: '99768'},
    { city: 'Großhabersdorf', zip: '90613'},
    { city: 'Suhl', zip: '98711'},
    { city: 'Langweid a. Lech', zip: '86462'},
    { city: 'Oberndorf a.Lech', zip: '86698'},
    { city: 'Münster', zip: '86692'},
    { city: 'Reichling', zip: '86934'},
    { city: 'Schöningen', zip: '38364'},
    { city: 'Holzheim', zip: '86684'},
    { city: 'Ilmenau', zip: '98694'},
    { city: 'Unterammergau', zip: '82497'},
    { city: 'Stadtilm, Ilmtal', zip: '99326'},
    { city: 'Oberammergau', zip: '82487'},
    { city: 'Dannenberg', zip: '29451'},
    { city: 'Betzdorf', zip: '57518'},
    { city: 'Edewecht', zip: '26188'},
    { city: 'Herdorf', zip: '57562'},
    { city: 'Garrel', zip: '49681'},
    { city: 'Appenweier', zip: '77767'},
    { city: 'Cloppenburg', zip: '49661'},
    { city: 'Landau in der Pfalz', zip: '76829'},
    { city: 'Bad Laer', zip: '49196'},
    { city: 'Wörth', zip: '76744'},
    { city: 'Ruppertsberg', zip: '67152'},
    { city: 'Herzebrock-Clarholz', zip: '33442'},
    { city: 'Ühlingen-Birkendorf', zip: '79777'},
    { city: 'Freudenstadt', zip: '72250'},
    { city: 'Hörnum (Sylt)', zip: '25997'},
    { city: 'Stadland', zip: '26937'},
    { city: 'Germersheim', zip: '76726'},
    { city: 'Rüsselsheim', zip: '65428'},
    { city: 'Ludwigshafen am Rhein', zip: '67067'},
    { city: 'Gütersloh', zip: '33330'},
    { city: 'Aichhalden', zip: '78733'},
    { city: 'Schlitz', zip: '36110'},
    { city: 'Niederaula', zip: '36272'},
    { city: 'Alt Duvenstedt', zip: '24791'},
    { city: 'Dassel', zip: '37586'},
    { city: 'Fahrdorf', zip: '24857'},
    { city: 'Schelklingen', zip: '89601'},
    { city: 'Göppingen', zip: '73033'},
    { city: 'Nieste', zip: '34329'},
    { city: 'Alfdorf, Schillinghof', zip: '73553'},
    { city: 'Kellinghusen', zip: '25548'},
    { city: 'Fulda', zip: '36039'},
    { city: 'Steimel', zip: '57614'},
    { city: 'Kamen', zip: '59174'},
    { city: 'Lauterecken u.a.', zip: '67742'},
    { city: 'Fürthen', zip: '57539'},
    { city: 'Eitelborn', zip: '56337'},
    { city: 'Morsbach', zip: '51597'},
    { city: 'Iserlohn', zip: '58638'},
    { city: 'Bad Ems', zip: '56130'},
    { city: 'Weiler bei Bingen', zip: '55413'},
    { city: 'Bönen', zip: '59199'},
    { city: 'Singhofen', zip: '56379'},
    { city: 'Mogendorf, Ebernhahn, Staudt u.a.', zip: '56424'},
    { city: 'Waldalgesheim', zip: '55425'},
    { city: 'Westerstede', zip: '26655'},
    { city: 'Oberkotzau', zip: '95145'},
    { city: 'Weischlitz u.a.', zip: '08538'},
    { city: 'Kaltenbrunn', zip: '92700'},
    { city: 'Lübz, Passow', zip: '19386'},
    { city: 'Rohr i. NB', zip: '93352'},
    { city: 'Rostock', zip: '18109'},
    { city: 'Thierstein', zip: '95199'},
    { city: 'Berga/Elster', zip: '07980'},
    { city: 'Ergoldsbach', zip: '84061'},
    { city: 'Plauen', zip: '08529'},
    { city: 'Köfering', zip: '93096'},
    { city: 'Donaustauf', zip: '93093'},
    { city: 'Bad Elster', zip: '08645'},
    { city: 'Langenbernsdorf', zip: '08428'},
    { city: 'Rositz, Starkenberg, Treben', zip: '04617'},
    { city: 'Vohenstrauß', zip: '92648'},
    { city: 'Sünching', zip: '93104'},
    { city: 'Neumark', zip: '08496'},
    { city: 'Mengkofen', zip: '84152'},
    { city: 'Grassau', zip: '83224'},
    { city: 'Mettenheim', zip: '84562'},
    { city: 'Prerow a. Darß', zip: '18375'},
    { city: 'Langenweißbach, Wildenfels', zip: '08134'},
    { city: 'Tüßling', zip: '84577'},
    { city: 'St. Egidien', zip: '09356'},
    { city: 'Rattiszell', zip: '94372'},
    { city: 'Geratskirchen', zip: '84552'},
    { city: 'Perasdorf', zip: '94366'},
    { city: 'Belgern-Schildau', zip: '04889'},
    { city: 'Dietersburg', zip: '84378'},
    { city: 'Saaldorf', zip: '83416'},
    { city: 'Hartha', zip: '04746'},
    { city: 'Schönwalde', zip: '14621'},
    { city: 'Wiesa', zip: '09488'},
    { city: 'Potsdam', zip: '14471'},
    { city: 'Böbrach', zip: '94255'},
    { city: 'Lam', zip: '93462'},
    { city: 'Stubenberg', zip: '94166'},
    { city: 'Ostrau', zip: '04749'},
    { city: 'Burow', zip: '17089'},
    { city: 'Neubrandenburg', zip: '17033'},
    { city: 'Berlin Spandau', zip: '13597'},
    { city: 'Weißenborn, Oberschöna', zip: '09600'},
    { city: 'Bad Füssing', zip: '94072'},
    { city: 'Berlin Zehlendorf', zip: '14165'},
    { city: 'Berlin Tegel', zip: '13507'},
    { city: 'Passau', zip: '94036'},
    { city: 'Reinsberg', zip: '09634'},
    { city: 'Greifswald', zip: '17489'},
    { city: 'Käbschütztal, Klipphausen, Diera-Zehren', zip: '01665'},
    { city: 'Berlin Kreuzberg', zip: '10961'},
    { city: 'Berlin', zip: '12305'},
    { city: 'Berlin Pankow', zip: '13187'},
    { city: 'Berlin Friedrichshain', zip: '10249'},
    { city: 'Ringelai', zip: '94160'},
    { city: 'Engelthal/Offenhausen', zip: '91238'},
    { city: 'Bad Bibra, Finne u.a.', zip: '06647'},
    { city: 'Beilngries', zip: '92339'},
    { city: 'Wallhausen, Blankenheim', zip: '06528'},
    { city: 'Neuried', zip: '82061'},
    { city: 'Pullach i. Isartal', zip: '82049'},
    { city: 'München', zip: '81379'},
    { city: 'Rosenthal am Rennsteig', zip: '07366'},
    { city: 'Grafengehaig', zip: '95356'},
    { city: 'Mindelstetten', zip: '93349'},
    { city: 'Himmelkron', zip: '95502'},
    { city: 'Laucha an der Unstrut', zip: '06636'},
    { city: 'Marktschorgast', zip: '95509'},
    { city: 'Spornitz', zip: '19372'},
    { city: 'Waakirchen', zip: '83666'},
    { city: 'Brunnthal', zip: '85649'},
    { city: 'Warngau', zip: '83627'},
    { city: 'Edelsfeld', zip: '92265'},
    { city: 'Perleberg, Berge u.a.', zip: '19348'},
    { city: 'Vorbach', zip: '95519'},
    { city: 'Kröpelin, Carinerland', zip: '18236'},
    { city: 'Warmensteinach', zip: '95485'},
    { city: 'Petersberg', zip: '06193'},
    { city: 'Hirschberg', zip: '07927'},
    { city: 'Mücheln', zip: '06255'},
    { city: 'Abensberg', zip: '93326'},
    { city: 'Bad Klosterlausnitz', zip: '07639'},
    { city: 'Markt Schwaben', zip: '85570'},
    { city: 'Bad Köstritz', zip: '07586'},
    { city: 'Bruckmühl', zip: '83052'},
    { city: 'Berlin Oberschöneweide', zip: '12459'},
    { city: 'Prenzlau, Nordwestuckermark u.a.', zip: '17291'},
    { city: 'Königs Wusterhausen', zip: '15711'},
    { city: 'Uckerland, Groß Luckow, Schönhausen', zip: '17337'},
    { city: 'Dresden', zip: '01217'},
    { city: 'Ottendorf-Okrilla', zip: '01458'},
    { city: 'Wolgast', zip: '17438'},
    { city: 'Karlshagen', zip: '17449'},
    { city: 'Wendisch Rietz', zip: '15864'},
    { city: 'Brüssow', zip: '17326'},
    { city: 'Weißwasser, Boxberg', zip: '02943'},
    { city: 'Neusalza-Spremberg', zip: '02742'},
    { city: 'Rheinböllen', zip: '55494'},
    { city: 'Neuenburg am Rhein', zip: '79395'},
    { city: 'Odenbach', zip: '67748'},
    { city: 'Braubach', zip: '56338'},
    { city: 'Endingen am Kaiserstuhl', zip: '79346'},
    { city: 'Freiburg im Breisgau', zip: '79112'},
    { city: 'Schneckenhausen', zip: '67699'},
    { city: 'Hamm', zip: '59067'},
    { city: 'Münstertal', zip: '79244'},
    { city: 'Ettenheim', zip: '77955'},
    { city: 'Malterdingen', zip: '79364'},
    { city: 'Reute', zip: '79276'},
    { city: 'Roetgen', zip: '52159'},
    { city: 'Mönchengladbach', zip: '41179'},
    { city: 'Mönchengladbach', zip: '41069'},
    { city: 'Perl', zip: '66706'},
    { city: 'Viersen', zip: '41747'},
    { city: 'Issum', zip: '47661'},
    { city: 'Ayl, Trassem u.a.', zip: '54441'},
    { city: 'Bedburg', zip: '50181'},
    { city: 'Wesel', zip: '46487'},
    { city: 'Tawern', zip: '54456'},
    { city: 'Vettweiß', zip: '52391'},
    { city: 'Kerpen', zip: '50170'},
    { city: 'Rommerskirchen', zip: '41569'},
    { city: 'Trier', zip: '54290'},
    { city: 'Vreden', zip: '48691'},
    { city: 'Duisburg', zip: '47053'},
    { city: 'Nalbach', zip: '66809'},
    { city: 'Großlittgen', zip: '54534'},
    { city: 'Köln', zip: '50859'},
    { city: 'Köln', zip: '50858'},
    { city: 'Düsseldorf', zip: '40595'},
    { city: 'Dorsten', zip: '46284'},
    { city: 'Köln', zip: '50969'},
    { city: 'Köln', zip: '50674'},
    { city: 'Neuhütten', zip: '54422'},
    { city: 'Solingen', zip: '42699'},
    { city: 'Saarbrücken', zip: '66121'},
    { city: 'Kempenich', zip: '56746'},
    { city: 'Wachtberg', zip: '53343'},
    { city: 'Wipperfürth', zip: '51688'},
    { city: 'Ruppichteroth', zip: '53809'},
    { city: 'Waldbreitbach, Hasuen', zip: '56588'},
    { city: 'Hagen', zip: '58089'},
    { city: 'Bruchmühlbach-Miesau', zip: '66892'},
    { city: 'Aurich', zip: '26607'},
    { city: 'Troisdorf', zip: '53842'},
    { city: 'Wuppertal', zip: '42117'},
    { city: 'Enkirch u.a.', zip: '56850'},
    { city: 'Hoppstädten-Weiersbach', zip: '55768'},
    { city: 'Wuppertal', zip: '42369'},
    { city: 'Brücken, Oberbrombach u.a.', zip: '55767'},
    { city: 'Recklinghausen', zip: '45657'},
    { city: 'Oer-Erkenschwick', zip: '45739'},
    { city: 'Wuppertal', zip: '42289'},
    { city: 'Bochum', zip: '44787'},
    { city: 'Rheinbreitbach', zip: '53619'},
    { city: 'Herne', zip: '44623'},
    { city: 'Hagen', zip: '58089'},
    { city: 'Herzlake, Dohren', zip: '49770'},
    { city: 'Nürnberg', zip: '90439'},
    { city: 'Rätzlingen, Wegenstedt, Calvörde, Böddensell u.a.', zip: '39359'},
    { city: 'Utting a. Ammersee', zip: '86919'},
    { city: 'Uffing a. Staffelsee', zip: '82449'},
    { city: 'Nürnberg', zip: '90403'},
    { city: 'Wielenbach', zip: '82407'},
    { city: 'Nürnberg', zip: '90482'},
    { city: 'Sonneberg', zip: '96515'},
    { city: 'Wegeleben', zip: '38828'},
    { city: 'Nürnberg', zip: '90473'},
    { city: 'Nürnberg', zip: '90411'},
    { city: 'Neuhaus-Schierschnitz, Judenbach', zip: '96524'},
    { city: 'Eckental', zip: '90542'},
    { city: 'Langenmosen', zip: '86571'},
    { city: 'Aresing', zip: '86561'},
    { city: 'Eitensheim', zip: '85117'},
    { city: 'Obertrubach', zip: '91286'},
    { city: 'Ludwigshafen am Rhein', zip: '67067'},
    { city: 'Neuwerk', zip: '27499'},
    { city: 'Dettighofen', zip: '79802'},
    { city: 'Gernsheim', zip: '64579'},
    { city: 'Bremerhaven', zip: '27572'},
    { city: 'Süderoog, Pellworm', zip: '25849'},
    { city: 'Willingen (Upland)', zip: '34508'},
    { city: 'Ladenburg', zip: '68526'},
    { city: 'Tuningen', zip: '78609'},
    { city: 'Hemsbach', zip: '69502'},
    { city: 'Walldorf', zip: '69190'},
    { city: 'Egelsbach', zip: '63329'},
    { city: 'Delmenhorst', zip: '27751'},
    { city: 'Ispringen', zip: '75228'},
    { city: 'Darmstadt', zip: '64287'},
    { city: 'Spaichingen', zip: '78549'},
    { city: 'Frankfurt am Main, Opernturm', zip: '60306'},
    { city: 'Bad Salzuflen', zip: '32105'},
    { city: 'Nordleda', zip: '21765'},
    { city: 'Abtsteinach', zip: '69518'},
    { city: 'Hirschhorn, Brombach, Heddesbach', zip: '69434'},
    { city: 'Kürnbach', zip: '75057'},
    { city: 'Bremen', zip: '28209'},
    { city: 'Aidlingen', zip: '71134'},
    { city: 'Ostelsheim', zip: '75395'},
    { city: 'Neustetten', zip: '72149'},
    { city: 'Bremervörde', zip: '27432'},
    { city: 'Husum, Schwesing u.a.', zip: '25813'},
    { city: 'Leibertingen, Buchheim', zip: '88637'},
    { city: 'Güglingen', zip: '74363'},
    { city: 'Waldbrunn', zip: '69429'},
    { city: 'Gerlingen', zip: '70839'},
    { city: 'Mainaschaff', zip: '63814'},
    { city: 'Selsingen', zip: '27446'},
    { city: 'Nordheim', zip: '74226'},
    { city: 'Heeßen, Bad Eilsen', zip: '31707'},
    { city: 'Steinenbronn', zip: '71144'},
    { city: 'Schwabstedt', zip: '25876'},
    { city: 'Naumburg', zip: '34311'},
    { city: 'Schlaitdorf', zip: '72667'},
    { city: 'Mönchberg', zip: '63933'},
    { city: 'Reutlingen', zip: '72762'},
    { city: 'Lüdersfeld', zip: '31702'},
    { city: 'Eningen', zip: '72800'},
    { city: 'Riederich', zip: '72585'},
    { city: 'Heimbuchenthal', zip: '63872'},
    { city: 'Laufach', zip: '63846'},
    { city: 'Grafenberg', zip: '72661'},
    { city: 'Gudensberg', zip: '34281'},
    { city: 'Dettingen an der Erms', zip: '72581'},
    { city: 'Hameln', zip: '31789'},
    { city: 'Börm', zip: '24863'},
    { city: 'Oppenweiler', zip: '71570'},
    { city: 'Eschenbach', zip: '73107'},
    { city: 'Birkenfeld', zip: '97834'},
    { city: 'Moisburg', zip: '21647'},
    { city: 'Hauneck', zip: '36282'},
    { city: 'Aukrug, Wiedenborstel', zip: '24613'},
    { city: 'Schacht-Audorf', zip: '24790'},
    { city: 'Bad Brückenau', zip: '97769'},
    { city: 'Gössenheim', zip: '97780'},
    { city: 'Altheim', zip: '89605'},
    { city: 'Eußenheim', zip: '97776'},
    { city: 'Bredenbek', zip: '24796'},
    { city: 'Lentföhrden', zip: '24632'},
    { city: 'Handeloh', zip: '21256'},
    { city: 'Blaufelden', zip: '74572'},
    { city: 'Rasdorf', zip: '36169'},
    { city: 'Arnstein', zip: '97450'},
    { city: 'Hamburg', zip: '22457'},
    { city: 'Hamburg', zip: '20257'},
    { city: 'Adelheidsdorf', zip: '29352'},
    { city: 'Hamburg', zip: '20539'},
    { city: 'Hamburg', zip: '22303'},
    { city: 'Schönau a.d. Brend', zip: '97659'},
    { city: 'Tangstedt', zip: '22889'},
    { city: 'Oberstdorf', zip: '87561'},
    { city: 'Westhausen', zip: '73463'},
    { city: 'Geslau', zip: '91608'},
    { city: 'Bopfingen', zip: '73441'},
    { city: 'Mechtersen', zip: '21358'},
    { city: 'Rödelsee', zip: '97348'},
    { city: 'Burk', zip: '91596'},
    { city: 'Lauenburg/Elbe', zip: '21481'},
    { city: 'Uelzen', zip: '29525'},
    { city: 'Aitrang', zip: '87648'},
    { city: 'Malente, Kirchnüchel', zip: '23714'},
    { city: 'Ziemetshausen', zip: '86473'},
    { city: 'Wahrenholz', zip: '29399'},
    { city: 'Osterwieck', zip: '38835'},
    { city: 'Römstedt', zip: '29591'},
    { city: 'Bad Schwartau', zip: '23611'},
    { city: 'Roßhaupten', zip: '87672'},
    { city: 'Lübeck', zip: '23564'},
    { city: 'Königslutter am Elm', zip: '38154'},
    { city: 'Augsburg', zip: '86199'},
    { city: 'Untermeitingen', zip: '86836'},
    { city: 'Unterdießen', zip: '86944'},
    { city: 'Zirndorf', zip: '90513'},
    { city: 'Rottenbuch', zip: '82401'},
    { city: 'Ettal', zip: '82488'},
    { city: 'Katzhütte', zip: '98746'},
    { city: 'Erfurt', zip: '99091'},
    { city: 'Weißensee', zip: '99631'},
    { city: 'Weferlingen, Behnsdorf, Belsdorf u.a.', zip: '39356'},
    { city: 'Ballenstedt, Harzgerode', zip: '06493'},
    { city: 'Königsee-Rottenbach u.a.', zip: '07426'},
    { city: 'Nürnberg', zip: '90429'},
    { city: 'Erfurt', zip: '99096'},
    { city: 'Ebertsheim', zip: '67280'},
    { city: 'Lauf', zip: '77886'},
    { city: 'Oppenau', zip: '77728'},
    { city: 'Bad Rothenfelde', zip: '49214'},
    { city: 'Erndtebrück', zip: '57339'},
    { city: 'Triberg im Schwarzwald', zip: '78098'},
    { city: 'Hagenbach', zip: '76767'},
    { city: 'Freisbach', zip: '67361'},
    { city: 'Muggensturm', zip: '76461'},
    { city: 'Langenberg', zip: '33449'},
    { city: 'Dannstadt-Schauernheim', zip: '67125'},
    { city: 'Stemwede', zip: '32351'},
    { city: 'Wenningstedt-Braderup (Sylt)', zip: '25996'},
    { city: 'Harthausen', zip: '67376'},
    { city: 'Stühlingen', zip: '79780'},
    { city: 'Kampen (Sylt)', zip: '25999'},
    { city: 'Worms', zip: '67547'},
    { city: 'Karlsruhe', zip: '76185'},
    { city: 'Flörsheim am Main', zip: '65439'},
    { city: 'Riedstadt', zip: '64560'},
    { city: 'Ludwigshafen am Rhein', zip: '67063'},
    { city: 'Friesenheim', zip: '77948'},
    { city: 'Meudt, Molsberg, Hundsangen, Niederahr u.a.', zip: '56414'},
    { city: 'Wöllstein', zip: '55597'},
    { city: 'Stegen', zip: '79252'},
    { city: 'Sande', zip: '26452'},
    { city: 'Kirrweiler (Pfalz)', zip: '67489'},
    { city: 'Siegen', zip: '57076'},
    { city: 'Landau in der Pfalz', zip: '76829'},
    { city: 'Kiedrich', zip: '65399'},
    { city: 'Osnabrück', zip: '49086'},
    { city: 'Schlüchtern', zip: '36381'},
    { city: 'Römerstein', zip: '72587'},
    { city: 'Schorndorf', zip: '73614'},
    { city: 'Horst', zip: '25358'},
    { city: 'Ohmden', zip: '73275'},
    { city: 'Horneburg', zip: '21640'},
    { city: 'Urbach', zip: '73660'},
    { city: 'Plüderhausen', zip: '73655'},
    { city: 'Adelberg', zip: '73099'},
    { city: 'Dielmissen', zip: '37633'},
    { city: 'Bomlitz', zip: '29699'},
    { city: 'Struxdorf, Schnarup-Thumby', zip: '24891'},
    { city: 'Tostedt, Kakenstorf u.a.', zip: '21255'},
    { city: 'Jevenstedt', zip: '24808'},
    { city: 'Gütersloh', zip: '33335'},
    { city: 'Bielefeld', zip: '33619'},
    { city: 'Villingen-Schwenningen', zip: '78052'},
    { city: 'Schwanewede', zip: '28790'},
    { city: 'Bielefeld', zip: '33615'},
    { city: 'Wagenfeld', zip: '49419'},
    { city: 'Griesheim', zip: '64347'},
    { city: 'Wetzlar', zip: '35582'},
    { city: 'Bremerhaven', zip: '27576'},
    { city: 'Heppenheim (Bergstraße)', zip: '64646'},
    { city: 'Bad Teinach-Zavelstein', zip: '75385'},
    { city: 'Bretten', zip: '75015'},
    { city: 'Frankfurt am Main', zip: '60325'},
    { city: 'Darmstadt', zip: '64289'},
    { city: 'Diemelsee', zip: '34519'},
    { city: 'Neulingen', zip: '75245'},
    { city: 'Lichtenfels', zip: '35104'},
    { city: 'Rockenberg', zip: '35519'},
    { city: 'Paderborn', zip: '33102'},
    { city: 'Frankfurt am Main', zip: '60388'},
    { city: 'Haigerloch', zip: '72401'},
    { city: 'Bremen', zip: '28217'},
    { city: 'Neckargemünd', zip: '69151'},
    { city: 'Mötzingen', zip: '71159'},
    { city: 'Friolzheim', zip: '71292'},
    { city: 'Nordstrand, Elisabeth-Sophien-Koog, Südfall', zip: '25845'},
    { city: 'Hirschhorn, Brombach, Heddesbach', zip: '69434'},
    { city: 'Rabenau', zip: '35466'},
    { city: 'Bremen', zip: '28207'},
    { city: 'Raddestorf', zip: '31604'},
    { city: 'Hildrizhausen', zip: '71157'},
    { city: 'Eberbach', zip: '69412'},
    { city: 'Erbach', zip: '64711'},
    { city: 'Albstadt', zip: '72461'},
    { city: 'Limeshain', zip: '63694'},
    { city: 'Blomberg', zip: '32825'},
    { city: 'Bückeburg', zip: '31675'},
    { city: 'Willebadessen', zip: '34439'},
    { city: 'Stetten am kalten Markt', zip: '72510'},
    { city: 'Ronneburg', zip: '63549'},
    { city: 'Langwedel', zip: '27299'},
    { city: 'Sigmaringen', zip: '72488'},
    { city: 'Owingen', zip: '88696'},
    { city: 'Reutlingen', zip: '72770'},
    { city: 'Asperg', zip: '71679'},
    { city: 'Stuttgart', zip: '70437'},
    { city: 'Stuttgart', zip: '70186'},
    { city: 'Schöllkrippen, Blankenbach', zip: '63825'},
    { city: 'Heilbronn', zip: '74072'},
    { city: 'Stuttgart', zip: '70378'},
    { city: 'Schrecksbach', zip: '34637'},
    { city: 'Lautertal', zip: '36369'},
    { city: 'Höxter', zip: '37671'},
    { city: 'Esslingen am Neckar', zip: '73734'},
    { city: 'Heigenbrücken', zip: '63869'},
    { city: 'Neuffen', zip: '72639'},
    { city: 'Hammah', zip: '21714'},
    { city: 'Harsefeld', zip: '21698'},
    { city: 'Hafenlohr, Rothenbuch', zip: '97840'},
    { city: 'Eichenzell', zip: '36124'},
    { city: 'Dörzbach', zip: '74677'},
    { city: 'Hemmingen', zip: '30966'},
    { city: 'Nordstemmen', zip: '31171'},
    { city: 'Ulsnis', zip: '24897'},
    { city: 'Sarstedt', zip: '31157'},
    { city: 'Buchholz in der Nordheide', zip: '21244'},
    { city: 'Borstel-Hohenraden', zip: '25494'},
    { city: 'Hergatz', zip: '88145'},
    { city: 'Kißlegg', zip: '88353'},
    { city: 'Meißner', zip: '37290'},
    { city: 'Giebelstadt', zip: '97232'},
    { city: 'Oberreute', zip: '88179'},
    { city: 'Westerstetten', zip: '89198'},
    { city: 'Bordesholm', zip: '24582'},
    { city: 'Steinheim am Albuch', zip: '89555'},
    { city: 'Eibelstadt', zip: '97246'},
    { city: 'Hamburg', zip: '20095'},
    { city: 'Dietenheim', zip: '89165'},
    { city: 'Bockenem', zip: '31167'},
    { city: 'Gerstungen', zip: '99834'},
    { city: 'Hamburg', zip: '22305'},
    { city: 'Hamburg', zip: '22175'},
    { city: 'Uffenheim', zip: '97215'},
    { city: 'Kiel', zip: '24116'},
    { city: 'Hamburg', zip: '22115'},
    { city: 'Hamburg', zip: '22143'},
    { city: 'Hamburg', zip: '22145'},
    { city: 'Hamburg', zip: '22145'},
    { city: 'Stimpfach', zip: '74597'},
    { city: 'Bröckel', zip: '29356'},
    { city: 'Creuzburg', zip: '99831'},
    { city: 'Schönkirchen', zip: '24232'},
    { city: 'Hermaringen', zip: '89568'},
    { city: 'Vögelsen', zip: '21360'},
    { city: 'Deutsch Evern', zip: '21407'},
    { city: 'Gifhorn', zip: '38518'},
    { city: 'Braunschweig', zip: '38120'},
    { city: 'Drei Gleichen', zip: '99869'},
    { city: 'Bleicherode', zip: '99752'},
    { city: 'Wolfenbüttel', zip: '38300'},
    { city: 'Oettingen i. Bay.', zip: '86732'},
    { city: 'Mönchsdeggingen', zip: '86751'},
    { city: 'Themar', zip: '98660'},
    { city: 'Lüder', zip: '29394'},
    { city: 'Ettringen', zip: '86833'},
    { city: 'Ebelsbach', zip: '97500'},
    { city: 'Luisenthal, Ohrdruf, Wolfis', zip: '99885'},
    { city: 'Amberg', zip: '86854'},
    { city: 'Weyhausen', zip: '38554'},
    { city: 'Timmendorfer Strand', zip: '23669'},
    { city: 'Mertingen', zip: '86690'},
    { city: 'Jerxheim', zip: '38381'},
    { city: 'Bamberg', zip: '96047'},
    { city: 'Rohr', zip: '91189'},
    { city: 'Pleinfeld', zip: '91785'},
    { city: 'Augsburg', zip: '86150'},
    { city: 'Hallerndorf', zip: '91352'},
    { city: 'Pappenheim', zip: '91788'},
    { city: 'Garmisch-Partenkirchen (Schneefernerhaus)', zip: '82475'},
    { city: 'Grube', zip: '23749'},
    { city: 'Hollenbach', zip: '86568'},
    { city: 'Kellenhusen', zip: '23746'},
    { city: 'Hagenow u.a.', zip: '19230'},
    { city: 'Jagsthausen', zip: '74249'},
    { city: 'Oberteuringen', zip: '88094'},
    { city: 'Lenningen', zip: '73252'},
    { city: 'Leutenbach', zip: '71397'},
    { city: 'Wennigsen (Deister)', zip: '30974'},
    { city: 'Schwarmstedt u.a.', zip: '29690'},
    { city: 'Kollmar, Pagensand', zip: '25377'},
    { city: 'Dollern', zip: '21739'},
    { city: 'Boffzen, Derental', zip: '37691'},
    { city: 'Königheim', zip: '97953'},
    { city: 'Ehingen (Donau), Lauterach', zip: '89584'},
    { city: 'Eriskirch', zip: '88097'},
    { city: 'Werbach', zip: '97956'},
    { city: 'Zell unter Aichelberg', zip: '73119'},
    { city: 'Holenberg', zip: '37642'},
    { city: 'Aulendorf', zip: '88326'},
    { city: 'Wangen', zip: '73117'},
    { city: 'Helsa', zip: '34298'},
    { city: 'Eime', zip: '31036'},
    { city: 'Nachrodt-Wiblingwerde', zip: '58769'},
    { city: 'Eschbach', zip: '79427'},
    { city: 'Fürstenau', zip: '49584'},
    { city: 'Ihringen', zip: '79241'},
    { city: 'Iserlohn', zip: '58640'},
    { city: 'Seibersbach', zip: '55444'},
    { city: 'Unna', zip: '59423'},
    { city: 'Guldental', zip: '55452'},
    { city: 'Sankt Goarshausen u.a.', zip: '56346'},
    { city: 'Herbolzheim', zip: '79336'},
    { city: 'Kettenkamp, Eggermühlen, Ankum', zip: '49577'},
    { city: 'Hamm', zip: '59073'},
    { city: 'Limburg', zip: '65551'},
    { city: 'Baden-Baden', zip: '76534'},
    { city: 'Grünstadt', zip: '67269'},
    { city: 'Obrigheim (Pfalz)', zip: '67283'},
    { city: 'Rödersheim-Gronau', zip: '67127'},
    { city: 'Heßheim', zip: '67258'},
    { city: 'Sinn', zip: '35764'},
    { city: 'Steinhagen', zip: '33803'},
    { city: 'Goldenstedt', zip: '49424'},
    { city: 'Nastätten u.a.', zip: '56355'},
    { city: 'Sembach', zip: '67681'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Neuhemsbach', zip: '67680'},
    { city: 'Schuttertal', zip: '77978'},
    { city: 'Kirchheimbolanden', zip: '67292'},
    { city: 'Bischheim u.a.', zip: '67294'},
    { city: 'Edenkoben', zip: '67480'},
    { city: 'Wiefelstede', zip: '26215'},
    { city: 'Herzogenrath', zip: '52134'},
    { city: 'Niederkrüchten', zip: '41372'},
    { city: 'Langerwehe', zip: '52379'},
    { city: 'Schönecken', zip: '54614'},
    { city: 'Dahlem', zip: '53949'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Lissendorf', zip: '54587'},
    { city: 'Irsch', zip: '54451'},
    { city: 'Neuss', zip: '41462'},
    { city: 'Trier', zip: '54295'},
    { city: 'Neuss', zip: '41468'},
    { city: 'Düsseldorf', zip: '40489'},
    { city: 'Dinslaken', zip: '46539'},
    { city: 'Antweiler, Aremberg, Dorsel, Eichenbach, Aremberg, Fuchshofen und Müsch', zip: '53533'},
    { city: 'Düsseldorf', zip: '40472'},
    { city: 'Reifferscheid, Kaltenborn, Wershofen u.a.', zip: '53520'},
    { city: 'Saarbrücken', zip: '66127'},
    { city: 'Reinsfeld', zip: '54421'},
    { city: 'Gillenfeld', zip: '54558'},
    { city: 'Velen', zip: '46342'},
    { city: 'Köln', zip: '50676'},
    { city: 'Köln', zip: '50733'},
    { city: 'Ettringen', zip: '56729'},
    { city: 'Essen', zip: '45127'},
    { city: 'Bernkastel-Kues u.a.', zip: '54470'},
    { city: 'Alflen', zip: '56828'},
    { city: 'Nordhorn', zip: '48529'},
    { city: 'Bonn', zip: '53119'},
    { city: 'Essen', zip: '45259'},
    { city: 'Steinfurt', zip: '48565'},
    { city: 'Großheide', zip: '26532'},
    { city: 'Hornbach', zip: '66500'},
    { city: 'Leutesdorf', zip: '56599'},
    { city: 'Saffig', zip: '56648'},
    { city: 'Irmenach', zip: '56843'},
    { city: 'Freisen', zip: '66629'},
    { city: 'Rhede (Ems)', zip: '26899'},
    { city: 'Ediger-Eller', zip: '56814'},
    { city: 'Kirchenlamitz', zip: '95158'},
    { city: 'Köthen', zip: '06366'},
    { city: 'Droyßig, Wetterzeube', zip: '06722'},
    { city: 'Halle/ Saale', zip: '06114'},
    { city: 'Buch a. Buchrain', zip: '85656'},
    { city: 'Steinhöring', zip: '85643'},
    { city: 'Meyenburg, Kümmernitztal u.a.', zip: '16945'},
    { city: 'Hohenleuben', zip: '07958'},
    { city: 'Etzenricht', zip: '92694'},
    { city: 'Nabburg', zip: '92507'},
    { city: 'Leuchtenberg', zip: '92705'},
    { city: 'Altendorf', zip: '92540'},
    { city: 'Laberweinting', zip: '84082'},
    { city: 'Leipzig', zip: '04207'},
    { city: 'Lalendorf, Langhagen', zip: '18279'},
    { city: 'Kröning', zip: '84178'},
    { city: 'Oberbergkirchen', zip: '84564'},
    { city: 'Teunz', zip: '92552'},
    { city: 'Pleystein', zip: '92714'},
    { city: 'Leipzig', zip: '04279'},
    { city: 'Chiemsee', zip: '83256'},
    { city: 'Aham', zip: '84168'},
    { city: 'Dingolfing', zip: '84130'},
    { city: 'Rötz', zip: '92444'},
    { city: 'Eilenburg u.a.', zip: '04838'},
    { city: 'Ahrenshagen-Daskow, Trinwillershagen u.a.', zip: '18320'},
    { city: 'Röbel/Müritz', zip: '17207'},
    { city: 'Machern', zip: '04827'},
    { city: 'Stadlern', zip: '92549'},
    { city: 'Willmering', zip: '93497'},
    { city: 'Torgau, Dreiheide', zip: '04860'},
    { city: 'Tann', zip: '84367'},
    { city: 'Crottendorf', zip: '09474'},
    { city: 'Johanniskirchen', zip: '84381'},
    { city: 'Patersdorf', zip: '94265'},
    { city: 'Potsdam', zip: '14476'},
    { city: 'Wittibreut', zip: '84384'},
    { city: 'Annaberg-Buchholz, Mildenau', zip: '09456'},
    { city: 'Kößlarn', zip: '94149'},
    { city: 'Ruhstorf a.d. Rott', zip: '94099'},
    { city: 'Schlieben', zip: '04936'},
    { city: 'Berlin Charlottenburg', zip: '10589'},
    { city: 'Berlin Charlottenburg', zip: '10587'},
    { city: 'Berlin Steglitz', zip: '12163'},
    { city: 'Berlin Moabit', zip: '10551'},
    { city: 'Neuburg a. Inn', zip: '94127'},
    { city: 'Berlin Mariendorf', zip: '12107'},
    { city: 'Berlin Kreuzberg', zip: '10965'},
    { city: 'Berlin Gesundbrunnen', zip: '13357'},
    { city: 'Perlesreut', zip: '94157'},
    { city: 'Schorfheide', zip: '16244'},
    { city: 'Berlin Friedrichshain', zip: '10243'},
    { city: 'Berlin Neukölln', zip: '12043'},
    { city: 'Erfurt', zip: '99085'},
    { city: 'Dömitz', zip: '19303'},
    { city: 'Kottgeisering', zip: '82288'},
    { city: 'Ebermannstadt', zip: '91320'},
    { city: 'Nürnberg', zip: '90471'},
    { city: 'Wittenförden u.a.', zip: '19073'},
    { city: 'Spatzenhausen', zip: '82447'},
    { city: 'Eberfing', zip: '82390'},
    { city: 'Seeland', zip: '06466'},
    { city: 'Wonsees', zip: '96197'},
    { city: 'Waischenfeld', zip: '91344'},
    { city: 'Schnaittach', zip: '91220'},
    { city: 'Weimar', zip: '99425'},
    { city: 'Bergkirchen', zip: '85232'},
    { city: 'Kinding', zip: '85125'},
    { city: 'Mainleus', zip: '95336'},
    { city: 'Kochel a. See', zip: '82431'},
    { city: 'Puchheim', zip: '82178'},
    { city: 'Reichenschwand', zip: '91244'},
    { city: 'Schwerin', zip: '19055'},
    { city: 'Scheyern', zip: '85298'},
    { city: 'Sengenthal', zip: '92369'},
    { city: 'Steinwiesen', zip: '96349'},
    { city: 'München', zip: '81243'},
    { city: 'Karlsfeld', zip: '85757'},
    { city: 'Klostermansfeld, Benndorf', zip: '06308'},
    { city: 'Alfeld', zip: '91236'},
    { city: 'Großmehring', zip: '85098'},
    { city: 'München', zip: '81477'},
    { city: 'Paunzhausen', zip: '85307'},
    { city: 'Magdeburg', zip: '39110'},
    { city: 'Barleben', zip: '39179'},
    { city: 'München', zip: '80804'},
    { city: 'Reichersbeuern', zip: '83677'},
    { city: 'Wittenberge, Rühstädt', zip: '19322'},
    { city: 'Painten', zip: '93351'},
    { city: 'Parsdorf/Hergolding', zip: '85599'},
    { city: 'Sparneck', zip: '95234'},
    { city: 'Hörgertshausen', zip: '85413'},
    { city: 'Legde/Quitzöbel, Bad Wilsnack', zip: '19336'},
    { city: 'Münchenbernsdorf, Schwarzbach, Bocka', zip: '07589'},
    { city: 'Wriezen', zip: '16269'},
    { city: 'Briesen, Rauen u.a.', zip: '15518'},
    { city: 'Bad Schandau', zip: '01814'},
    { city: 'Neutrebbin, Neuhardenberg', zip: '15320'},
    { city: 'Blankensee, Grambow u.a.', zip: '17322'},
    { city: 'Guben, Schenkendöbern', zip: '03172'},
    { city: 'Berlin Niederschöneweide', zip: '12439'},
    { city: 'Lauchhammer', zip: '01979'},
    { city: 'Usedom u.a.', zip: '17406'},
    { city: 'Lünen', zip: '44536'},
    { city: 'Dortmund', zip: '44339'},
    { city: 'Dellfeld', zip: '66503'},
    { city: 'Horhausen (Westerwald)', zip: '56593'},
    { city: 'Lauterecken u.a.', zip: '67742'},
    { city: 'Emmelshausen', zip: '56281'},
    { city: 'Nortmoor', zip: '26845'},
    { city: 'Neuenburg am Rhein', zip: '79395'},
    { city: 'Hutthurm', zip: '94116'},
    { city: 'Coswig', zip: '01640'},
    { city: 'Mauth', zip: '94151'},
    { city: 'Untergriesbach', zip: '94107'},
    { city: 'Rabenau', zip: '01734'},
    { city: 'Uckerland, Groß Luckow, Schönhausen', zip: '17337'},
    { city: 'Strasburg', zip: '17335'},
    { city: 'Pasewalk u.a.', zip: '17309'},
    { city: 'Lichtenow, Altlandsberg u.a.', zip: '15345'},
    { city: 'Koserow', zip: '17459'},
    { city: 'Arnsdorf b. Dresden', zip: '01477'},
    { city: 'Harsewinkel', zip: '33428'},
    { city: 'Gütenbach', zip: '78148'},
    { city: 'Budenheim', zip: '55257'},
    { city: 'Baden-Baden', zip: '76530'},
    { city: 'Oldenburg (Oldenburg)', zip: '26125'},
    { city: 'Amrum', zip: '25946'},
    { city: 'Karlsruhe', zip: '76187'},
    { city: 'Alpirsbach', zip: '72275'},
    { city: 'Königsfeld im Schwarzwald', zip: '78126'},
    { city: 'Unterkirnach', zip: '78089'},
    { city: 'Speyer', zip: '67346'},
    { city: 'Philippsburg', zip: '76661'},
    { city: 'Schönau im Schwarzwald', zip: '79677'},
    { city: 'Willstätt', zip: '77731'},
    { city: 'Denzlingen', zip: '79211'},
    { city: 'Hochspeyer', zip: '67691'},
    { city: 'Freiburg im Breisgau', zip: '79106'},
    { city: 'Helgoland', zip: '27498'},
    { city: 'Frankenstein, Neidenfels, Frankeneck', zip: '67468'},
    { city: 'Ingelheim am Rhein', zip: '55218'},
    { city: 'Weisenheim am Berg', zip: '67273'},
    { city: 'Beelen', zip: '48361'},
    { city: 'Kamenz', zip: '01917'},
    { city: 'Krackow, Nadrensee', zip: '17329'},
    { city: 'Cottbus', zip: '03048'},
    { city: 'Treplin, Jacobsdorf, Frankfurt (Oder)', zip: '15236'},
    { city: 'Cottbus', zip: '03052'},
    { city: 'Markersdorf, Neißeaue u.a.', zip: '02829'},
    { city: 'Görlitz', zip: '02826'},
    { city: 'Jetzendorf', zip: '85305'},
    { city: 'Gräfelfing', zip: '82166'},
    { city: 'Querfurt, Obhausen, Mücheln u.a.', zip: '06268'},
    { city: 'Schwerin', zip: '19063'},
    { city: 'Sülzetal', zip: '39171'},
    { city: 'Bad Sulza', zip: '99518'},
    { city: 'Seegebiet Mansfelder Land', zip: '06317'},
    { city: 'München', zip: '81539'},
    { city: 'München', zip: '80939'},
    { city: 'Freising', zip: '85354'},
    { city: 'Edelsfeld', zip: '92265'},
    { city: 'Naumburg', zip: '06618'},
    { city: 'Kelheim', zip: '93309'},
    { city: 'Hohenburg', zip: '92277'},
    { city: 'Magdeburg', zip: '39114'},
    { city: 'Hohenfels', zip: '92366'},
    { city: 'Poing', zip: '85586'},
    { city: 'Ebersberg', zip: '85560'},
    { city: 'Weißenstadt', zip: '95163'},
    { city: 'Peterswald-Löffelscheid u.a.', zip: '56858'},
    { city: 'Lüdinghausen', zip: '59348'},
    { city: 'Laer', zip: '48366'},
    { city: 'Beltheim', zip: '56290'},
    { city: 'Schönenberg-Kübelberg', zip: '66901'},
    { city: 'Neuenkirchen', zip: '48485'},
    { city: 'Ochtendung', zip: '56299'},
    { city: 'Witten', zip: '58454'},
    { city: 'Altenkirchen', zip: '66903'},
    { city: 'Kirn', zip: '55606'},
    { city: 'Essen', zip: '45279'},
    { city: 'Wietmarschen', zip: '49835'},
    { city: 'Gelsenkirchen', zip: '45886'},
    { city: 'Zell (Mosel)', zip: '56856'},
    { city: 'Remscheid', zip: '42853'},
    { city: 'Wuppertal', zip: '42283'},
    { city: 'Bad Honnef', zip: '53604'},
    { city: 'Altenglan', zip: '66885'},
    { city: 'Senden', zip: '48308'},
    { city: 'Dortmund', zip: '44135'},
    { city: 'Efringen-Kirchen', zip: '79588'},
    { city: 'Monzingen', zip: '55569'},
    { city: 'Heroldsberg', zip: '90562'},
    { city: 'Wustrow', zip: '29462'},
    { city: 'Erfurt', zip: '99098'},
    { city: 'Königsfeld', zip: '96167'},
    { city: 'Nürnberg', zip: '90475'},
    { city: 'Burgkunstadt', zip: '96224'},
    { city: 'Schwarzenbruck', zip: '90592'},
    { city: 'Gräfenthal', zip: '98743'},
    { city: 'Tettau', zip: '96355'},
    { city: 'Großweil', zip: '82439'},
    { city: 'Gauting', zip: '82131'},
    { city: 'Brunnen', zip: '86564'},
    { city: 'Münsing', zip: '82541'},
    { city: 'Obersüßbach', zip: '84101'},
    { city: 'Merseburg', zip: '06217'},
    { city: 'Triglitz, Putlitz', zip: '16949'},
    { city: 'Wunsiedel', zip: '95632'},
    { city: 'Halle/ Saale', zip: '06108'},
    { city: 'Furth', zip: '84095'},
    { city: 'Mantel', zip: '92708'},
    { city: 'Havelberg', zip: '39539'},
    { city: 'Greiz', zip: '07973'},
    { city: 'Hohenpolding', zip: '84432'},
    { city: 'Berga/Elster', zip: '07980'},
    { city: 'Pfreimd', zip: '92536'},
    { city: 'Markranstädt', zip: '04420'},
    { city: 'Krakow, Dobbin-Linstow u.a.', zip: '18292'},
    { city: 'Alteglofsheim', zip: '93087'},
    { city: 'Pfakofen', zip: '93101'},
    { city: 'Leipzig', zip: '04109'},
    { city: 'Atting', zip: '94348'},
    { city: 'Marklkofen', zip: '84163'},
    { city: 'Wiesenfelden', zip: '94344'},
    { city: 'Glauchau', zip: '08371'},
    { city: 'Kitzscher', zip: '04567'},
    { city: 'Tiefenbach', zip: '93464'},
    { city: 'Bad Lausick', zip: '04651'},
    { city: 'Siegsdorf', zip: '83313'},
    { city: 'Bennewitz, Machern', zip: '04828'},
    { city: 'Trebsen/Mulde', zip: '04687'},
    { city: 'Malgersdorf', zip: '84333'},
    { city: 'Ketzin', zip: '14669'},
    { city: 'Prackenbach', zip: '94267'},
    { city: 'Annaburg', zip: '06925'},
    { city: 'Laufen', zip: '83410'},
    { city: 'Berchtesgaden & Schönau', zip: '83471'},
    { city: 'Gransee, Löwenberg', zip: '16775'},
    { city: 'Niederalteich', zip: '94557'},
    { city: 'Oschatz', zip: '04758'},
    { city: 'Potsdam', zip: '14467'},
    { city: 'Gingst', zip: '18569'},
    { city: 'Berlin Westend', zip: '14055'},
    { city: 'Neubrandenburg', zip: '17034'},
    { city: 'Berlin Wilmersdorf', zip: '10777'},
    { city: 'Berlin-West', zip: '13407'},
    { city: 'Berlin Blankenfelde', zip: '13159'},
    { city: 'Berlin Prenzlauer Berg', zip: '10435'},
    { city: 'Sagard', zip: '18551'},
    { city: 'Aßlar', zip: '35614'},
    { city: 'Mannheim', zip: '68307'},
    { city: 'Brake', zip: '26919'},
    { city: 'Mannheim', zip: '68169'},
    { city: 'Liederbach am Taunus', zip: '65835'},
    { city: 'Butzbach', zip: '35510'},
    { city: 'Espelkamp', zip: '32339'},
    { city: 'Bielefeld', zip: '33609'},
    { city: 'Sulz am Neckar', zip: '72172'},
    { city: 'Zwingenberg', zip: '64673'},
    { city: 'Kirchlengern', zip: '32278'},
    { city: 'Dossenheim', zip: '69221'},
    { city: 'Pforzheim', zip: '75180'},
    { city: 'Bremen', zip: '28197'},
    { city: 'Gießen', zip: '35390'},
    { city: 'Frankfurt am Main', zip: '60322'},
    { city: 'Heppenheim (Bergstraße)', zip: '64646'},
    { city: 'Mühlhausen', zip: '69242'},
    { city: 'Bremen', zip: '28259'},
    { city: 'Ölbronn-Dürrn', zip: '75248'},
    { city: 'Schömberg', zip: '72355'},
    { city: 'Syke', zip: '28857'},
    { city: 'Althengstett', zip: '75382'},
    { city: 'Bammental', zip: '69245'},
    { city: 'Wilhelmsfeld', zip: '69259'},
    { city: 'Fränkisch-Crumbach', zip: '64407'},
    { city: 'Minden', zip: '32425'},
    { city: 'Wohratal', zip: '35288'},
    { city: 'Nidda', zip: '63667'},
    { city: 'Hattstedt u.a.', zip: '25856'},
    { city: 'Gemmingen', zip: '75050'},
    { city: 'Stolzenau', zip: '31592'},
    { city: 'Neuberg', zip: '63543'},
    { city: 'Kirchardt', zip: '74912'},
    { city: 'Tübingen', zip: '72076'},
    { city: 'Volkmarsen', zip: '34471'},
    { city: 'Mömlingen', zip: '63853'},
    { city: 'Heilbronn', zip: '74078'},
    { city: 'Obernburg a.Main', zip: '63785'},
    { city: 'Wald', zip: '88639'},
    { city: 'Bad Wimpfen', zip: '74206'},
    { city: 'Lauffen am Neckar', zip: '74348'},
    { city: 'Wannweil', zip: '72827'},
    { city: 'Burg (Dithmarschen)', zip: '25712'},
    { city: 'Neckarsulm', zip: '74172'},
    { city: 'Heilbronn', zip: '74074'},
    { city: 'Auhagen, Sachsenhagen', zip: '31553'},
    { city: 'Stuttgart', zip: '70372'},
    { city: 'Seckach', zip: '74743'},
    { city: 'Großbettlingen', zip: '72663'},
    { city: 'Holstenniendorf', zip: '25584'},
    { city: 'Schneeberg', zip: '63936'},
    { city: 'Beuren', zip: '72660'},
    { city: 'Meggerdorf, Friedrichsholm, Friedrichsgraben u.a.', zip: '24799'},
    { city: 'Hohnstorf (Elbe), Hittbergen', zip: '21522'},
    { city: 'Braunschweig', zip: '38100'},
    { city: 'Leinatal', zip: '99894'},
    { city: 'Irsee', zip: '87660'},
    { city: 'Walkertshofen', zip: '86877'},
    { city: 'Hildburghausen', zip: '98646'},
    { city: 'Blindheim', zip: '89434'},
    { city: 'Oberharz am Brocken', zip: '38875'},
    { city: 'Wolfsburg', zip: '38442'},
    { city: 'Pfarrweisach', zip: '96176'},
    { city: 'Oldenburg in Holstein', zip: '23758'},
    { city: 'Rosche', zip: '29571'},
    { city: 'Schönberg', zip: '23923'},
    { city: 'Prem', zip: '86984'},
    { city: 'Asbach-Bäumenheim', zip: '86663'},
    { city: 'Gremsdorf', zip: '91350'},
    { city: 'Ilmenau', zip: '98694'},
    { city: 'Gebesee', zip: '99189'},
    { city: 'Schwifting', zip: '86940'},
    { city: 'Röttenbach', zip: '91341'},
    { city: 'Böbing', zip: '82389'},
    { city: 'Rottenbuch', zip: '82401'},
    { city: 'Altendorf', zip: '96146'},
    { city: 'Neukirchen', zip: '23779'},
    { city: 'Grevesmühlen, Stepenitztal, Upahl u.a.', zip: '23936'},
    { city: 'Nürnberg', zip: '90427'},
    { city: 'Luckau (Wendland)', zip: '29487'},
    { city: 'Fehmarn', zip: '23769'},
    { city: 'Erfurt', zip: '99084'},
    { city: 'Erfurt', zip: '99086'},
    { city: 'Weil am Rhein', zip: '79576'},
    { city: 'Lemberg', zip: '66969'},
    { city: 'Lahnstein', zip: '56112'},
    { city: 'Filsum', zip: '26849'},
    { city: 'Münster', zip: '48165'},
    { city: 'Koblenz', zip: '56077'},
    { city: 'Rümmingen', zip: '79595'},
    { city: 'Unna', zip: '59427'},
    { city: 'Meisenheim', zip: '55590'},
    { city: 'Badenweiler', zip: '79410'},
    { city: 'Hillscheid', zip: '56204'},
    { city: 'Selters (Westerwald)', zip: '56242'},
    { city: 'Kleines Wiesental', zip: '79692'},
    { city: 'Balve', zip: '58802'},
    { city: 'Vörstetten', zip: '79279'},
    { city: 'Schlat', zip: '73114'},
    { city: 'Brokstedt', zip: '24616'},
    { city: 'Laatzen', zip: '30880'},
    { city: 'Waldkappel', zip: '37284'},
    { city: 'Blaustein', zip: '89134'},
    { city: 'Amstetten', zip: '73340'},
    { city: 'Damp', zip: '24351'},
    { city: 'Achstetten', zip: '88480'},
    { city: 'Nörten-Hardenberg', zip: '37176'},
    { city: 'Hamburg', zip: '21075'},
    { city: 'Henstedt-Ulzburg', zip: '24558'},
    { city: 'Altheim (Alb)', zip: '89174'},
    { city: 'Illerkirchberg', zip: '89171'},
    { city: 'Königsbronn', zip: '89551'},
    { city: 'Missen-Wilhams', zip: '87547'},
    { city: 'Bark', zip: '23826'},
    { city: 'Kiel', zip: '24118'},
    { city: 'Neusitz', zip: '91616'},
    { city: 'Reinbek', zip: '21465'},
    { city: 'Langelsheim', zip: '38685'},
    { city: 'Burgbernheim', zip: '91593'},
    { city: 'Medlingen', zip: '89441'},
    { city: 'Lülsfeld', zip: '97511'},
    { city: 'Gundremmingen', zip: '89355'},
    { city: 'Aachen', zip: '52068'},
    { city: 'Aachen', zip: '52080'},
    { city: 'Hallschlag', zip: '54611'},
    { city: 'Krefeld', zip: '47807'},
    { city: 'Krefeld', zip: '47798'},
    { city: 'Meerbusch', zip: '40667'},
    { city: 'Neuss', zip: '41460'},
    { city: 'Bad Münstereifel', zip: '53902'},
    { city: 'Südlohn', zip: '46354'},
    { city: 'Wilsum', zip: '49849'},
    { city: 'Düsseldorf', zip: '40217'},
    { city: 'Düsseldorf', zip: '40212'},
    { city: 'Köln', zip: '50935'},
    { city: 'Rheinbach', zip: '53359'},
    { city: 'Bottrop', zip: '46240'},
    { city: 'Gladbeck', zip: '45964'},
    { city: 'Saarbrücken', zip: '66111'},
    { city: 'Leverkusen', zip: '51381'},
    { city: 'Traben-Trarbach', zip: '56841'},
    { city: 'Schöntal', zip: '74214'},
    { city: 'Havetoft', zip: '24873'},
    { city: 'Dägeling, Neuenbrook', zip: '25578'},
    { city: 'Golmbach', zip: '37640'},
    { city: 'Elmshorn', zip: '25335'},
    { city: 'Halle', zip: '37620'},
    { city: 'Obermarchtal', zip: '89611'},
    { city: 'Hattenhofen', zip: '73110'},
    { city: 'Hetlingen', zip: '25491'},
    { city: 'Laichingen', zip: '89150'},
    { city: 'Allmendingen', zip: '89604'},
    { city: 'Hünfeld', zip: '36088'},
    { city: 'Rechberghausen', zip: '73098'},
    { city: 'Halle/ Saale', zip: '06124'},
    { city: 'Pielenhofen', zip: '93188'},
    { city: 'Schwandorf', zip: '92421'},
    { city: 'Waldershof', zip: '95679'},
    { city: 'Gera', zip: '07548'},
    { city: 'Kolbermoor', zip: '83059'},
    { city: 'Rosenheim', zip: '83024'},
    { city: 'Pechbrunn', zip: '95701'},
    { city: 'Berga/Elster', zip: '07980'},
    { city: 'Störnstein', zip: '92721'},
    { city: 'Netzschkau, Limbach', zip: '08491'},
    { city: 'Coswig (Anhalt)', zip: '06868'},
    { city: 'Leipzig', zip: '04209'},
    { city: 'Gars a. Inn', zip: '83559'},
    { city: 'Wiesent', zip: '93109'},
    { city: 'Leipzig', zip: '04356'},
    { city: 'Leipzig', zip: '04357'},
    { city: 'Kemberg', zip: '06901'},
    { city: 'Waidhaus', zip: '92726'},
    { city: 'Aiterhofen', zip: '94330'},
    { city: 'Nußdorf', zip: '83365'},
    { city: 'Falkenfels', zip: '94350'},
    { city: 'Waffenbrunn', zip: '93494'},
    { city: 'Rechlin', zip: '17248'},
    { city: 'Haibach', zip: '94353'},
    { city: 'Lößnitz', zip: '08294'},
    { city: 'Chamerau', zip: '93466'},
    { city: 'Wurmannsquick', zip: '84329'},
    { city: 'Arnstorf', zip: '94424'},
    { city: 'Werder/ Havel', zip: '14542'},
    { city: 'Kremmen', zip: '16766'},
    { city: 'Roßbach', zip: '94439'},
    { city: 'Potsdam', zip: '14476'},
    { city: 'Ehrenfriedersdorf', zip: '09427'},
    { city: 'Döbeln, Großweitzschen u.a.', zip: '04720'},
    { city: 'Falkenberg/ Elster', zip: '04895'},
    { city: 'Eppendorf', zip: '09575'},
    { city: 'Berlin Tegel', zip: '13503'},
    { city: 'Aicha vorm Wald', zip: '94529'},
    { city: 'Berlin Moabit', zip: '10559'},
    { city: 'Bobritzsch', zip: '09627'},
    { city: 'Berlin Mitte', zip: '10179'},
    { city: 'Friedrichshafen', zip: '88045'},
    { city: 'Rechtenbach', zip: '97848'},
    { city: 'Beringstedt', zip: '25575'},
    { city: 'Esselbach', zip: '97839'},
    { city: 'Niestetal', zip: '34266'},
    { city: 'Ebersbach-Musbach', zip: '88371'},
    { city: 'Krautheim', zip: '74238'},
    { city: 'Neuendorf', zip: '97788'},
    { city: 'Hannover', zip: '30419'},
    { city: 'Baienfurt', zip: '88255'},
    { city: 'Büdelsdorf, Rickert', zip: '24782'},
    { city: 'Mittenwalde', zip: '15749'},
    { city: 'Berlin', zip: '12487'},
    { city: 'Halbe', zip: '15757'},
    { city: 'Dresden', zip: '01127'},
    { city: 'Breitenberg', zip: '94139'},
    { city: 'Calau, Bronkow', zip: '03205'},
    { city: 'Oberbarnim, Märkische Höhe u.a.', zip: '15377'},
    { city: 'Großharthau, Frankenthal', zip: '01909'},
    { city: 'Beiersdorf, Oppach', zip: '02736'},
    { city: 'Ostrhauderfehn', zip: '26842'},
    { city: 'Clausen', zip: '66978'},
    { city: 'Kreimbach-Kaulbach', zip: '67757'},
    { city: 'Becherbach', zip: '67827'},
    { city: 'Spiekeroog', zip: '26474'},
    { city: 'Geiselberg', zip: '67715'},
    { city: 'Freilingen, Freirachdorf u.a.', zip: '56244'},
    { city: 'Birken-Honigsessen', zip: '57587'},
    { city: 'Wilgartswiesen', zip: '76848'},
    { city: 'Menden', zip: '58706'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Kippenheim', zip: '77971'},
    { city: 'Dielkirchen', zip: '67811'},
    { city: 'Jever', zip: '26441'},
    { city: 'Nastätten u.a.', zip: '56355'},
    { city: 'Wilgartswiesen', zip: '76848'},
    { city: 'Annweiler am Trifels', zip: '76855'},
    { city: 'Schortens', zip: '26419'},
    { city: 'Freiburg im Breisgau', zip: '79115'},
    { city: 'Rheinau', zip: '77866'},
    { city: 'Elkenroth', zip: '57578'},
    { city: 'Bolanden', zip: '67295'},
    { city: 'Bischheim u.a.', zip: '67294'},
    { city: 'Renchen', zip: '77871'},
    { city: 'Dreisen, Standenbühl', zip: '67816'},
    { city: 'Venningen', zip: '67482'},
    { city: 'Frankenstein, Neidenfels, Frankeneck', zip: '67468'},
    { city: 'Bakum', zip: '49456'},
    { city: 'Waldbrunn', zip: '65620'},
    { city: 'Köln', zip: '51147'},
    { city: 'Essen', zip: '45307'},
    { city: 'Reil', zip: '56861'},
    { city: 'Schiffweiler', zip: '66578'},
    { city: 'Wuppertal', zip: '42115'},
    { city: 'Enkirch u.a.', zip: '56850'},
    { city: 'Lingen', zip: '49808'},
    { city: 'Bochum', zip: '44807'},
    { city: 'Bochum', zip: '44799'},
    { city: 'Wettringen', zip: '48493'},
    { city: 'Breitenbach', zip: '66916'},
    { city: 'Bochum', zip: '44799'},
    { city: 'Linz am Rhein, Ockenfels', zip: '53545'},
    { city: 'Wetter (Ruhr)', zip: '58300'},
    { city: 'Dornum', zip: '26553'},
    { city: 'Sankt Katharinen (Landkreis Neuwied)', zip: '53562'},
    { city: 'Eitorf', zip: '53783'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Wildenbungert, Gondershausen, Nörtershausen u.a.', zip: '56283'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Rheine', zip: '48432'},
    { city: 'Auggen', zip: '79424'},
    { city: 'Taarstedt', zip: '24893'},
    { city: 'Barmstedt', zip: '25355'},
    { city: 'Hannover', zip: '30171'},
    { city: 'Hannover', zip: '30659'},
    { city: 'Dornstadt', zip: '89160'},
    { city: 'Bergen, Lohheide u.a.', zip: '29303'},
    { city: 'Holtsee', zip: '24363'},
    { city: 'Lauterstein', zip: '73111'},
    { city: 'Ronshausen', zip: '36217'},
    { city: 'Ellerbek', zip: '25474'},
    { city: 'Bispingen', zip: '29646'},
    { city: 'Weiler-Simmerberg', zip: '88171'},
    { city: 'Ulm', zip: '89081'},
    { city: 'Nentershausen', zip: '36214'},
    { city: 'Böbingen an der Rems', zip: '73560'},
    { city: 'Hilders, Ehrenberg', zip: '36115'},
    { city: 'Schechingen', zip: '73579'},
    { city: 'Heringen', zip: '36266'},
    { city: 'Kirchberg an der Jagst', zip: '74592'},
    { city: 'Schwendi', zip: '88477'},
    { city: 'Hamburg', zip: '22765'},
    { city: 'Hamburg', zip: '21109'},
    { city: 'Aichstetten', zip: '88317'},
    { city: 'Schellerten', zip: '31174'},
    { city: 'Berkheim', zip: '88450'},
    { city: 'Struvenhütten', zip: '24643'},
    { city: 'Fladungen', zip: '97650'},
    { city: 'Aalen', zip: '73431'},
    { city: 'Nienhagen', zip: '29336'},
    { city: 'Stelle', zip: '21435'},
    { city: 'Hamburg', zip: '22179'},
    { city: 'Hamburg', zip: '22397'},
    { city: 'Ippesheim', zip: '97258'},
    { city: 'Poppenhausen', zip: '97490'},
    { city: 'Herbrechtingen', zip: '89542'},
    { city: 'Oerlenbach', zip: '97714'},
    { city: 'Münnerstadt', zip: '97702'},
    { city: 'Wettringen', zip: '91631'},
    { city: 'Kreßberg', zip: '74594'},
    { city: 'Buchenberg', zip: '87474'},
    { city: 'Immenstadt im Allgäu', zip: '87509'},
    { city: 'Peine', zip: '31228'},
    { city: 'Insingen', zip: '91610'},
    { city: 'Ohrenbach', zip: '91620'},
    { city: 'Hohenroth', zip: '97618'},
    { city: 'Kleinlangheim', zip: '97355'},
    { city: 'Hawangen', zip: '87749'},
    { city: 'Siek', zip: '22962'},
    { city: 'Embsen', zip: '21409'},
    { city: 'Salzgitter', zip: '38259'},
    { city: 'Ebershausen', zip: '86491'},
    { city: 'Untrasried', zip: '87496'},
    { city: 'Oy-Mittelberg', zip: '87466'},
    { city: 'Melbeck, Barnstedt', zip: '21406'},
    { city: 'Rohlstorf', zip: '23821'},
    { city: 'Geschendorf', zip: '23815'},
    { city: 'Thannhausen', zip: '86470'},
    { city: 'Ellrich', zip: '99755'},
    { city: 'Barum', zip: '29576'},
    { city: 'Gerolfingen', zip: '91726'},
    { city: 'Poxdorf', zip: '91099'},
    { city: 'Mittelstetten', zip: '82293'},
    { city: 'Sangerhausen', zip: '06526'},
    { city: 'Neunkirchen a. Brand', zip: '91077'},
    { city: 'Wendelstein', zip: '90530'},
    { city: 'Neuburg an der Donau', zip: '86633'},
    { city: 'Igensdorf', zip: '91338'},
    { city: 'Aufseß', zip: '91347'},
    { city: 'Obersöchering', zip: '82395'},
    { city: 'Schiltberg', zip: '86576'},
    { city: 'Gardelegen', zip: '39638'},
    { city: 'Buxheim', zip: '85114'},
    { city: 'Antdorf', zip: '82387'},
    { city: 'Pentenried', zip: '82349'},
    { city: 'Mühlhausen', zip: '92360'},
    { city: 'Schwerin', zip: '19059'},
    { city: 'Börde-Hakel', zip: '39448'},
    { city: 'Hepberg', zip: '85120'},
    { city: 'Plate', zip: '19086'},
    { city: 'Rerik, Bastorf, Biendorf', zip: '18230'},
    { city: 'Seubersdorf i.d. OPf.', zip: '92358'},
    { city: 'Vohburg a.d. Donau', zip: '85088'},
    { city: 'Magdeburg', zip: '39122'},
    { city: 'Attenkirchen', zip: '85395'},
    { city: 'Höhenkirchen-Siegertsbrunn', zip: '85635'},
    { city: 'Feldkirchen', zip: '85622'},
    { city: 'Burg', zip: '39288'},
    { city: 'Tanna', zip: '07922'},
    { city: 'Volkenschwand', zip: '84106'},
    { city: 'Markt Schwaben', zip: '85570'},
    { city: 'Groß-Rohrheim', zip: '68649'},
    { city: 'Rödinghausen', zip: '32289'},
    { city: 'Kronberg im Taunus', zip: '61476'},
    { city: 'Büttelborn', zip: '64572'},
    { city: 'Mannheim', zip: '68219'},
    { city: 'Schwalbach am Taunus', zip: '65824'},
    { city: 'Biebertal', zip: '35444'},
    { city: 'Birkenfeld', zip: '75217'},
    { city: 'Oberreichenbach', zip: '75394'},
    { city: 'Ubstadt-Weiher', zip: '76698'},
    { city: 'Medebach', zip: '59964'},
    { city: 'Frankfurt am Main', zip: '60327'},
    { city: 'Bremen', zip: '28759'},
    { city: 'Pforzheim', zip: '75177'},
    { city: 'Cuxhaven', zip: '27472'},
    { city: 'Niebüll', zip: '25899'},
    { city: 'Heidelberg', zip: '69117'},
    { city: 'Heidelberg', zip: '69118'},
    { city: 'Jettingen', zip: '71131'},
    { city: 'Habel, Gröde', zip: '25869'},
    { city: 'Starzach', zip: '72181'},
    { city: 'Balingen', zip: '72336'},
    { city: 'Mühlacker', zip: '75417'},
    { city: 'Reichelsheim (Odenwald)', zip: '64385'},
    { city: 'Büsum', zip: '25761'},
    { city: 'Rangendingen', zip: '72414'},
    { city: 'Nufringen', zip: '71154'},
    { city: 'Bremen', zip: '28327'},
    { city: 'Ehningen', zip: '71139'},
    { city: 'Radolfzell am Bodensee', zip: '78315'},
    { city: 'Eberdingen', zip: '71735'},
    { city: 'Höchst i. Odw.', zip: '64739'},
    { city: 'Großkrotzenburg', zip: '63538'},
    { city: 'Brackenheim', zip: '74336'},
    { city: 'Sankt Annen, Rehm-Flehde-Bargen', zip: '25776'},
    { city: 'Markgröningen', zip: '71706'},
    { city: 'Bönnigheim', zip: '74357'},
    { city: 'Korntal-Münchingen', zip: '70825'},
    { city: 'Medelby', zip: '24994'},
    { city: 'Konstanz', zip: '78467'},
    { city: 'Glattbach', zip: '63864'},
    { city: 'Erlenbach a.Main', zip: '63906'},
    { city: 'Oldendorf', zip: '21726'},
    { city: 'Kutenholz', zip: '27449'},
    { city: 'Esslingen am Neckar', zip: '73730'},
    { city: 'Freiensteinau', zip: '36399'},
    { city: 'Weibersbrunn, Rohrbrunner Forst', zip: '63879'},
    { city: 'Rothenbuch, Rothenbucher Forst', zip: '63860'},
    { city: 'Riedlingen', zip: '88499'},
    { city: 'Burgstetten', zip: '71576'},
    { city: 'Heinsen', zip: '37649'},
    { city: 'Steinau an der Straße', zip: '36396'},
    { city: 'Herbertingen', zip: '88518'},
    { city: 'Groß Rheide', zip: '24872'},
    { city: 'Bad Karlshafen', zip: '34385'},
    { city: 'Hafenlohr, Rothenbuch', zip: '97840'},
    { city: 'Marktoberdorf', zip: '87616'},
    { city: 'Diespeck', zip: '91456'},
    { city: 'Kaufbeuren', zip: '87600'},
    { city: 'Wernigerode', zip: '38879'},
    { city: 'Füssen', zip: '87629'},
    { city: 'Megesheim', zip: '86750'},
    { city: 'Merkendorf', zip: '91732'},
    { city: 'Wernigerode, Nordharz', zip: '38855'},
    { city: 'Gerhardshofen', zip: '91466'},
    { city: 'Muhr a. See', zip: '91735'},
    { city: 'Diedorf', zip: '86420'},
    { city: 'Wolfsburg', zip: '38444'},
    { city: 'Monheim', zip: '86653'},
    { city: 'Buchdorf', zip: '86675'},
    { city: 'Herzogenaurach', zip: '91074'},
    { city: 'Zarrentin', zip: '19246'},
    { city: 'Nesse-Apfelstädt, Nottleben', zip: '99192'},
    { city: 'Kyffhäuserland', zip: '99707'},
    { city: 'Oebisfelde', zip: '39646'},
    { city: 'Erlangen', zip: '91058'},
    { city: 'Gangelt, Selfkant', zip: '52538'},
    { city: 'Kevelaer-Mitte', zip: '47623'},
    { city: 'Kevelaer-Wetten', zip: '47625'},
    { city: 'Hellenthal', zip: '53940'},
    { city: 'Titz', zip: '52445'},
    { city: 'Nideggen', zip: '52385'},
    { city: 'Nittel', zip: '54453'},
    { city: 'Moers', zip: '47445'},
    { city: 'Meerbusch', zip: '40670'},
    { city: 'Landscheid', zip: '54526'},
    { city: 'Duisburg', zip: '47059'},
    { city: 'Duisburg', zip: '47119'},
    { city: 'Wadgassen', zip: '66787'},
    { city: 'Düsseldorf', zip: '40225'},
    { city: 'Schwalbach', zip: '66773'},
    { city: 'Dormagen', zip: '41541'},
    { city: 'Wittlich', zip: '54516'},
    { city: 'Juist, Memmert', zip: '26571'},
    { city: 'Riegelsberg', zip: '66292'},
    { city: 'Uersfeld', zip: '56767'},
    { city: 'Essen', zip: '45133'},
    { city: 'Essen', zip: '45144'},
    { city: 'Köln', zip: '50678'},
    { city: 'Nohfelden', zip: '66625'},
    { city: 'Twist', zip: '49767'},
    { city: 'Kaisersesch', zip: '56759'},
    { city: 'Mainz', zip: '55124'},
    { city: 'Lippstadt', zip: '59556'},
    { city: 'Löhnberg', zip: '35792'},
    { city: 'Forbach', zip: '76596'},
    { city: 'Weinbach', zip: '35796'},
    { city: 'Dietzhölztal', zip: '35716'},
    { city: 'Mainz', zip: '55130'},
    { city: 'Ginsheim-Gustavsburg', zip: '65462'},
    { city: 'Worms', zip: '67549'},
    { city: 'Ehringshausen', zip: '35630'},
    { city: 'Melle', zip: '49328'},
    { city: 'Eich', zip: '67575'},
    { city: 'Bielefeld', zip: '33649'},
    { city: 'Seewald', zip: '72297'},
    { city: 'Hardt', zip: '78739'},
    { city: 'Halle/ Saale', zip: '06128'},
    { city: 'Döhlau', zip: '95182'},
    { city: 'Rottenburg a.d. Laaber', zip: '84056'},
    { city: 'Brannenburg', zip: '83098'},
    { city: 'Zeitz, Gutenborn u.a.', zip: '06712'},
    { city: 'Landshut, Altdorf', zip: '84032'},
    { city: 'Rosenbach', zip: '08548'},
    { city: 'Gera', zip: '07551'},
    { city: 'Wernberg-Köblitz', zip: '92533'},
    { city: 'Landshut', zip: '84036'},
    { city: 'Vogtareuth', zip: '83569'},
    { city: 'Hohenberg a.d. Eger', zip: '95691'},
    { city: 'Pegau, Elstertrebnitz', zip: '04523'},
    { city: 'Konnersreuth', zip: '95692'},
    { city: 'Sandersdorf-Brehna', zip: '06792'},
    { city: 'Waldthurn', zip: '92727'},
    { city: 'Tännesberg', zip: '92723'},
    { city: 'Pfatter', zip: '93102'},
    { city: 'Gars am Inn', zip: '83546'},
    { city: 'Premnitz', zip: '14727'},
    { city: 'Neukieritzsch, Deutzen', zip: '04575'},
    { city: 'Neukirchen-Balbini', zip: '92445'},
    { city: 'Rodewisch', zip: '08228'},
    { city: 'Zwickau', zip: '08062'},
    { city: 'Saal', zip: '18317'},
    { city: 'Gräfenhainichen', zip: '06772'},
    { city: 'Traunstein', zip: '83278'},
    { city: 'Ascha', zip: '94347'},
    { city: 'Konzell', zip: '94357'},
    { city: 'Wonneberg', zip: '83379'},
    { city: 'Stollberg/Erzgeb.', zip: '09366'},
    { city: 'Neukalen', zip: '17154'},
    { city: 'Gleißenberg', zip: '93477'},
    { city: 'Mockrehna', zip: '04862'},
    { city: 'Marktl', zip: '84533'},
    { city: 'Teisnach', zip: '94244'},
    { city: 'Seddiner See', zip: '14554'},
    { city: 'Berlin Wannsee', zip: '14109'},
    { city: 'Zwiesel', zip: '94227'},
    { city: 'Berlin Westend', zip: '14053'},
    { city: 'Innernzell', zip: '94548'},
    { city: 'Großbeeren', zip: '14979'},
    { city: 'Berlin-Lichterfelde', zip: '12209'},
    { city: 'Berlin Wedding', zip: '13351'},
    { city: 'Schlier', zip: '88281'},
    { city: 'Eschenbach', zip: '73107'},
    { city: 'Brodersby, Goltoft', zip: '24864'},
    { city: 'Steinfeld', zip: '24888'},
    { city: 'Emkendorf', zip: '24802'},
    { city: 'Winsen (Aller)', zip: '29308'},
    { city: 'Geislingen an der Steige', zip: '73312'},
    { city: 'Oberleichtersbach', zip: '97789'},
    { city: 'Dipperz', zip: '36160'},
    { city: 'Schondra', zip: '97795'},
    { city: 'Hemdingen', zip: '25485'},
    { city: 'Halstenbek', zip: '25469'},
    { city: 'Holzdorf', zip: '24364'},
    { city: 'Kaltenkirchen', zip: '24568'},
    { city: 'Würzburg', zip: '97080'},
    { city: 'Geisa', zip: '36419'},
    { city: 'Bühlertann', zip: '74424'},
    { city: 'Hohenroda', zip: '36284'},
    { city: 'Würzburg', zip: '97070'},
    { city: 'Weidenstetten', zip: '89197'},
    { city: 'Bad Salzdetfurth', zip: '31162'},
    { city: 'Rosenberg', zip: '73494'},
    { city: 'Oberelsbach', zip: '97656'},
    { city: 'Seevetal', zip: '21220'},
    { city: 'Flintbek', zip: '24220'},
    { city: 'Salzhausen', zip: '21376'},
    { city: 'Dettingen an der Iller', zip: '88451'},
    { city: 'Uetze', zip: '31311'},
    { city: 'Celle', zip: '29221'},
    { city: 'Hamburg', zip: '22119'},
    { city: 'Altenstadt', zip: '89281'},
    { city: 'Legau', zip: '87764'},
    { city: 'Herbrechtingen', zip: '89542'},
    { city: 'Rainau', zip: '73492'},
    { city: 'Rickling', zip: '24635'},
    { city: 'Kirchbarkau', zip: '24245'},
    { city: 'Trappenkamp', zip: '24610'},
    { city: 'Pleß', zip: '87773'},
    { city: 'Benningen', zip: '87734'},
    { city: 'Winterrieden', zip: '87785'},
    { city: 'Dinkelsbühl', zip: '91550'},
    { city: 'Mellrichstadt', zip: '97638'},
    { city: 'Feuchtwangen', zip: '91555'},
    { city: 'Grettstadt', zip: '97508'},
    { city: 'Eldingen', zip: '29351'},
    { city: 'Liebenburg', zip: '38704'},
    { city: 'Ziertheim', zip: '89446'},
    { city: 'Kuddewörde', zip: '22958'},
    { city: 'Bienenbüttel', zip: '29553'},
    { city: 'Bad Langensalza', zip: '99947'},
    { city: 'Grönwohld', zip: '22956'},
    { city: 'Waltershausen', zip: '99880'},
    { city: 'Dillingen a.d. Donau', zip: '89407'},
    { city: 'Salgen', zip: '87775'},
    { city: 'Ribbesbüttel', zip: '38551'},
    { city: 'Suhl, Marisfeld, Rohr u.a.', zip: '98530'},
    { city: 'Suhl, Marisfeld, Rohr u.a.', zip: '98530'},
    { city: 'Hohenahr', zip: '35644'},
    { city: 'Bielefeld', zip: '33647'},
    { city: 'Bielefeld', zip: '33739'},
    { city: 'Dornhan', zip: '72175'},
    { city: 'Gladenbach', zip: '35075'},
    { city: 'Dauchingen', zip: '78083'},
    { city: 'Schopfloch', zip: '72296'},
    { city: 'Reilingen', zip: '68799'},
    { city: 'Langgöns', zip: '35428'},
    { city: 'Rottweil', zip: '78628'},
    { city: 'Darmstadt', zip: '64295'},
    { city: 'Frankfurt am Main', zip: '60439'},
    { city: 'Haiterbach', zip: '72221'},
    { city: 'Eppelheim', zip: '69214'},
    { city: 'Durchhausen', zip: '78591'},
    { city: 'Rohrdorf', zip: '72229'},
    { city: 'Frankfurt am Main', zip: '60314'},
    { city: 'Rimbach', zip: '64668'},
    { city: 'Balgheim', zip: '78582'},
    { city: 'Eppertshausen', zip: '64859'},
    { city: 'Bremen', zip: '28199'},
    { city: 'Weyhe', zip: '28844'},
    { city: 'Dürbheim', zip: '78589'},
    { city: 'Offenbach am Main', zip: '63073'},
    { city: 'Singen', zip: '78224'},
    { city: 'Waibstadt', zip: '74915'},
    { city: 'Kolbingen', zip: '78600'},
    { city: 'Unter-Hainbrunn', zip: '64757'},
    { city: 'Warburg', zip: '34414'},
    { city: 'Moos', zip: '78345'},
    { city: 'Bad Rappenau', zip: '74906'},
    { city: 'Mainhausen', zip: '63533'},
    { city: 'Bodman-Ludwigshafen', zip: '78351'},
    { city: 'Sersheim', zip: '74372'},
    { city: 'Zwingenberg', zip: '69439'},
    { city: 'Freudental', zip: '74392'},
    { city: 'Stuttgart', zip: '70569'},
    { city: 'Erligheim', zip: '74391'},
    { city: 'Sipplingen', zip: '78354'},
    { city: 'Landesbergen', zip: '31628'},
    { city: 'Ulrichstein', zip: '35327'},
    { city: 'Miltenberg', zip: '63897'},
    { city: 'Borgentreich', zip: '34434'},
    { city: 'Ludwigsburg', zip: '71634'},
    { city: 'Aichtal', zip: '72631'},
    { city: 'Ingersheim', zip: '74379'},
    { city: 'Freiberg am Neckar', zip: '71691'},
    { city: 'Geiselbach', zip: '63826'},
    { city: 'Ludwigsburg', zip: '71642'},
    { city: 'Bempflingen', zip: '72658'},
    { city: 'Erfde', zip: '24803'},
    { city: 'Mespelbrunn', zip: '63875'},
    { city: 'Rotenburg', zip: '27356'},
    { city: 'Waiblingen', zip: '71334'},
    { city: 'Ostrach', zip: '88356'},
    { city: 'Silberstedt, Schwittschau', zip: '24887'},
    { city: 'Aichwald', zip: '73773'},
    { city: 'Kassel', zip: '34128'},
    { city: 'Boffzen, Derental', zip: '37691'},
    { city: 'Külsheim', zip: '97900'},
    { city: 'Querfurt, Obhausen, Mücheln u.a.', zip: '06268'},
    { city: 'Röhrmoos', zip: '85244'},
    { city: 'Vierkirchen', zip: '85256'},
    { city: 'München', zip: '81247'},
    { city: 'Eisleben', zip: '06295'},
    { city: 'Krölpa', zip: '07387'},
    { city: 'München', zip: '80639'},
    { city: 'Staßfurt', zip: '39446'},
    { city: 'München', zip: '81371'},
    { city: 'Guttenberg', zip: '95358'},
    { city: 'Schweitenkirchen', zip: '85301'},
    { city: 'München', zip: '80803'},
    { city: 'Neufahrn b. Freising', zip: '85376'},
    { city: 'Magdeburg', zip: '39108'},
    { city: 'München', zip: '81925'},
    { city: 'Illschwang', zip: '92278'},
    { city: 'Haar', zip: '85540'},
    { city: 'Teutschenthal', zip: '06179'},
    { city: 'Moosinning', zip: '85452'},
    { city: 'Neustadt a. Kulm', zip: '95514'},
    { city: 'Wittenberge, Rühstädt', zip: '19322'},
    { city: 'Trabitz', zip: '92724'},
    { city: 'Kastl', zip: '95506'},
    { city: 'Spornitz', zip: '19372'},
    { city: 'Wildenberg', zip: '93359'},
    { city: 'Südharz, Berga', zip: '06536'},
    { city: 'Erxleben, Nordgermersleben u.a.', zip: '39343'},
    { city: 'Weilersbach', zip: '91365'},
    { city: 'Brüsewitz', zip: '19071'},
    { city: 'Hedersleben', zip: '06458'},
    { city: 'Pressig', zip: '96332'},
    { city: 'Seeland', zip: '06464'},
    { city: 'Ahorntal', zip: '95491'},
    { city: 'Aitrang', zip: '87648'},
    { city: 'Burgpreppach', zip: '97496'},
    { city: 'Blekendorf', zip: '24327'},
    { city: 'Hedeper', zip: '38322'},
    { city: 'Wiedergeltingen', zip: '86879'},
    { city: 'Kirchlauter', zip: '96166'},
    { city: 'Gudow', zip: '23899'},
    { city: 'Seßlach', zip: '96145'},
    { city: 'Amt Neuhaus, Stapel', zip: '19273'},
    { city: 'Veilsdorf', zip: '98669'},
    { city: 'Reckendorf', zip: '96182'},
    { city: 'Arnstadt', zip: '99338'},
    { city: 'Genderkingen', zip: '86682'},
    { city: 'Biberau, Masserberg', zip: '98666'},
    { city: 'Spalt', zip: '91174'},
    { city: 'Langenstein, Derenburg', zip: '38895'},
    { city: 'Kinsau', zip: '86981'},
    { city: 'Penzing', zip: '86929'},
    { city: 'Lautertal', zip: '96486'},
    { city: 'Fürth', zip: '90762'},
    { city: 'Erfurt', zip: '99087'},
    { city: 'Nürnberg', zip: '90451'},
    { city: 'Malsfeld', zip: '34323'},
    { city: 'Visselhövede', zip: '27374'},
    { city: 'Guxhagen', zip: '34302'},
    { city: 'Pfedelbach', zip: '74629'},
    { city: 'Herzhorn, Kamerlanderdeich', zip: '25379'},
    { city: 'Glücksburg, Munkbrarup', zip: '24960'},
    { city: 'Wees', zip: '24999'},
    { city: 'Uhingen', zip: '73066'},
    { city: 'Lohfelden', zip: '34253'},
    { city: 'Berg', zip: '88276'},
    { city: 'Ravensburg', zip: '88214'},
    { city: 'Hollern-Twielenfleth', zip: '21723'},
    { city: 'Westerheim', zip: '72589'},
    { city: 'Hohenwestedt', zip: '24594'},
    { city: 'Untermarchtal', zip: '89617'},
    { city: 'Tolk, Twedt', zip: '24894'},
    { city: 'Dürnau', zip: '73105'},
    { city: 'Hannover', zip: '30455'},
    { city: 'Hannover', zip: '30453'},
    { city: 'Röhrnbach', zip: '94133'},
    { city: 'Büchlberg', zip: '94124'},
    { city: 'Berlin Altglienicke', zip: '12524'},
    { city: 'Wolgast', zip: '17438'},
    { city: 'Dresden', zip: '01157'},
    { city: 'Woltersdorf', zip: '15569'},
    { city: 'Dresden', zip: '01069'},
    { city: 'Rüdersdorf', zip: '15378'},
    { city: 'Bad Saarow-Pieskow', zip: '15526'},
    { city: 'Blankensee, Grambow u.a.', zip: '17322'},
    { city: 'Cottbus', zip: '03054'},
    { city: 'Sohland a. d. Spree', zip: '02689'},
    { city: 'Görlitz', zip: '02827'},
    { city: 'Pfeffenhausen', zip: '84076'},
    { city: 'Wolfsegg', zip: '93195'},
    { city: 'Gera, Zedlitz u.a.', zip: '07557'},
    { city: 'Rostock, Lambrechtshagen', zip: '18069'},
    { city: 'Parkstein', zip: '92711'},
    { city: 'Lappersdorf', zip: '93138'},
    { city: 'Sankt Wolfgang', zip: '84427'},
    { city: 'Rostock', zip: '18147'},
    { city: 'Plauen', zip: '08523'},
    { city: 'Falkenberg', zip: '95685'},
    { city: 'Schmölln, Altkirchen, Nöbdenitz u.a.', zip: '04626'},
    { city: 'Werdau', zip: '08412'},
    { city: 'Ribnitz-Damgarten', zip: '18311'},
    { city: 'Bernau a. Chiemsee', zip: '83233'},
    { city: 'Weng', zip: '84187'},
    { city: 'Bodenkirchen', zip: '84155'},
    { city: 'Seeon-Seebruck', zip: '83370'},
    { city: 'Übersee', zip: '83236'},
    { city: 'Steinberg', zip: '08237'},
    { city: 'Leipzig', zip: '04319'},
    { city: 'Oberneukirchen', zip: '84565'},
    { city: 'Straubing', zip: '94315'},
    { city: 'Borsdorf', zip: '04451'},
    { city: 'Brandis', zip: '04824'},
    { city: 'Altötting', zip: '84503'},
    { city: 'Oelsnitz/Erzgebirge', zip: '09376'},
    { city: 'Rochlitz', zip: '09306'},
    { city: 'Aholming', zip: '94527'},
    { city: 'Brieselang', zip: '14656'},
    { city: 'Arzberg, Beilrode', zip: '04886'},
    { city: 'Chemnitz', zip: '09127'},
    { city: 'Rosenow', zip: '17091'},
    { city: 'Arrach', zip: '93474'},
    { city: 'Velten, Oberkrämer', zip: '16727'},
    { city: 'Schaufling', zip: '94571'},
    { city: 'Bodenmais', zip: '94249'},
    { city: 'Hiddensee', zip: '18565'},
    { city: 'Sponholz, Neunkirchen u.a.', zip: '17039'},
    { city: 'Grattersdorf', zip: '94541'},
    { city: 'Mühlberg, Bad Liebenwerda', zip: '04931'},
    { city: 'Berlin Grunewald', zip: '14193'},
    { city: 'Zossen', zip: '15806'},
    { city: 'Berlin Charlottenburg', zip: '10623'},
    { city: 'Templin, Boitzenburg u.a.', zip: '17268'},
    { city: 'Berlin Schöneberg', zip: '12157'},
    { city: 'Blankenfelde-Mahlow', zip: '15827'},
    { city: 'Berlin Mitte', zip: '10117'},
    { city: 'Greifswald', zip: '17493'},
    { city: 'Spantekow', zip: '17392'},
    { city: 'Karlsbad', zip: '76307'},
    { city: 'Brühl', zip: '68782'},
    { city: 'Mannheim', zip: '68167'},
    { city: 'Loxstedt', zip: '27612'},
    { city: 'Sulzbach (Taunus)', zip: '65843'},
    { city: 'Eschborn', zip: '65760'},
    { city: 'Friedrichsdorf', zip: '61381'},
    { city: 'Bremen', zip: '28755'},
    { city: 'Freistatt, Varrel, Wehrbleck', zip: '27259'},
    { city: 'Pforzheim', zip: '75179'},
    { city: 'Lollar', zip: '35457'},
    { city: 'Geestland', zip: '27624'},
    { city: 'Frankfurt am Main', zip: '60316'},
    { city: 'Neuhausen', zip: '75242'},
    { city: 'Bad Oeynhausen', zip: '32549'},
    { city: 'Langenhorn, Ockholm u.a.', zip: '25842'},
    { city: 'Wehingen, Reichenbach', zip: '78564'},
    { city: 'Bad Oeynhausen', zip: '32545'},
    { city: 'Bremen', zip: '28357'},
    { city: 'Ratshausen', zip: '72365'},
    { city: 'Lemgo', zip: '32657'},
    { city: 'Mühlheim am Main', zip: '63165'},
    { city: 'Nidderau', zip: '61130'},
    { city: 'Asendorf', zip: '27330'},
    { city: 'Homberg (Ohm)', zip: '35315'},
    { city: 'Stockach', zip: '78333'},
    { city: 'Wöhrden', zip: '25797'},
    { city: 'Oyten', zip: '28876'},
    { city: 'Wingst', zip: '21789'},
    { city: 'Reichenau', zip: '78479'},
    { city: 'Weddingstedt', zip: '25795'},
    { city: 'Hoya, Hoyerhagen, Hilgermissen', zip: '27318'},
    { city: 'Brakel', zip: '33034'},
    { city: 'Kirchzell', zip: '63931'},
    { city: 'Estorf', zip: '31629'},
    { city: 'Schwalmstadt', zip: '34613'},
    { city: 'Gelnhausen', zip: '63571'},
    { city: 'Laudenbach', zip: '63925'},
    { city: 'Verden', zip: '27283'},
    { city: 'Haibach', zip: '63808'},
    { city: 'Wächtersbach', zip: '63607'},
    { city: 'Borken', zip: '34582'},
    { city: 'Röllbach', zip: '63934'},
    { city: 'Metzingen', zip: '72555'},
    { city: 'Esslingen am Neckar', zip: '73728'},
    { city: 'Bad Orb', zip: '63619'},
    { city: 'Kirchberg', zip: '71737'},
    { city: 'Frickenhausen', zip: '72636'},
    { city: 'Pfronstetten', zip: '72539'},
    { city: 'Bretzfeld', zip: '74626'},
    { city: 'Flörsbachtal', zip: '63639'},
    { city: 'Schenefeld', zip: '25560'},
    { city: 'Schwarzenborn', zip: '34639'},
    { city: 'Bodenfelde, Wahlsburg', zip: '37194'},
    { city: 'Greifenberg', zip: '86926'},
    { city: 'Dahme', zip: '23747'},
    { city: 'Huglfing', zip: '82386'},
    { city: 'Adelschlag', zip: '85111'},
    { city: 'Artern/Unstrut u.a.', zip: '06556'},
    { city: 'Gachenbach', zip: '86565'},
    { city: 'Starnberg', zip: '82319'},
    { city: 'Neunkirchen am Sand', zip: '91233'},
    { city: 'Hergisdorf', zip: '06313'},
    { city: 'Schäftlarn', zip: '82067'},
    { city: 'München', zip: '80638'},
    { city: 'Gerbstedt', zip: '06347'},
    { city: 'Magdeburg', zip: '39116'},
    { city: 'Kranzberg', zip: '85402'},
    { city: 'München', zip: '81545'},
    { city: 'München', zip: '80799'},
    { city: 'München', zip: '80801'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'Könnern', zip: '06420'},
    { city: 'Magdeburg', zip: '39114'},
    { city: 'Aiglsbach', zip: '84089'},
    { city: 'Biederitz, Gerwisch, Menz u.a.', zip: '39175'},
    { city: 'Kirchheim b. München', zip: '85551'},
    { city: 'Parchim', zip: '19370'},
    { city: 'Triptis', zip: '07819'},
    { city: 'Schönebeck (Elbe)', zip: '39217'},
    { city: 'Konradsreuth', zip: '95176'},
    { city: 'Berlin Baumschulenweg', zip: '12437'},
    { city: 'Sonnewalde', zip: '03249'},
    { city: 'Hauzenberg', zip: '94051'},
    { city: 'Hinterschmiding', zip: '94146'},
    { city: 'Berlin Wiesengrund', zip: '12587'},
    { city: 'Jandelsbrunn', zip: '94118'},
    { city: 'Berlin Rahnsdorf', zip: '12589'},
    { city: 'Dresden', zip: '01187'},
    { city: 'Ortrand', zip: '01990'},
    { city: 'Dresden', zip: '01067'},
    { city: 'Dresden', zip: '01129'},
    { city: 'Dresden', zip: '01108'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Lohmen', zip: '01847'},
    { city: 'Bischofswerda u.a.', zip: '01877'},
    { city: 'Neustadt i. Sa.', zip: '01844'},
    { city: 'Cottbus', zip: '03042'},
    { city: 'Leutersdorf, Spitzkunnersdorf', zip: '02794'},
    { city: 'Olbersdorf', zip: '02785'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Flammersfeld', zip: '57632'},
    { city: 'Dortmund', zip: '44265'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Seesbach', zip: '55629'},
    { city: 'Anhausen', zip: '56584'},
    { city: 'Landstuhl', zip: '66849'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Urbach', zip: '56317'},
    { city: 'Bendorf', zip: '56170'},
    { city: 'Argenthal', zip: '55496'},
    { city: 'Coesfeld', zip: '48653'},
    { city: 'Marl', zip: '45772'},
    { city: 'Gelsenkirchen', zip: '45897'},
    { city: 'Heimbach', zip: '55779'},
    { city: 'Hage, Halbemond u.a.', zip: '26524'},
    { city: 'Wuppertal', zip: '42389'},
    { city: 'Treis-Karden', zip: '56253'},
    { city: 'Witten', zip: '58456'},
    { city: 'Castrop-Rauxel', zip: '44575'},
    { city: 'Mastershausen', zip: '56869'},
    { city: 'Kusel', zip: '66869'},
    { city: 'Westerholt, Schweindorf u.a.', zip: '26556'},
    { city: 'Hütschenhausen', zip: '66882'},
    { city: 'Bodnegg', zip: '88285'},
    { city: 'Langenhagen (Flughafen)', zip: '30669'},
    { city: 'Nellingen', zip: '89191'},
    { city: 'Karsbach', zip: '97783'},
    { city: 'Spraitbach', zip: '73565'},
    { city: 'Hannover', zip: '30173'},
    { city: 'Welle', zip: '21261'},
    { city: 'Durlangen, Weggen-Ziegelhütte, Leinhäusle', zip: '73568'},
    { city: 'Griesingen', zip: '89608'},
    { city: 'Kuchen', zip: '73329'},
    { city: 'Wittighausen', zip: '97957'},
    { city: 'Dornstadt', zip: '89160'},
    { city: 'Hannover', zip: '30539'},
    { city: 'Reichenberg, Guttenberger Wald', zip: '97234'},
    { city: 'Lindenberg im Allgäu', zip: '88161'},
    { city: 'Fuchsstadt', zip: '97727'},
    { city: 'Würzburg', zip: '97074'},
    { city: 'Schnürpflingen', zip: '89194'},
    { city: 'Hermannsburg', zip: '29320'},
    { city: 'Senden', zip: '89250'},
    { city: 'Hamburg', zip: '22339'},
    { city: 'Kirchberg an der Iller', zip: '88486'},
    { city: 'Kitzingen', zip: '97318'},
    { city: 'Winsen', zip: '21423'},
    { city: 'Wulften', zip: '37199'},
    { city: 'Bad Neustadt an der Saale', zip: '97616'},
    { city: 'Bibertal', zip: '89346'},
    { city: 'Bargteheide, Delingsdorf u.a.', zip: '22941'},
    { city: 'Heikendorf', zip: '24226'},
    { city: 'Schweinfurt', zip: '97422'},
    { city: 'Dingelstädt', zip: '37351'},
    { city: 'Gallmersgarten', zip: '91605'},
    { city: 'Lengede', zip: '38268'},
    { city: 'Schmalkalden', zip: '98574'},
    { city: 'Ellzee', zip: '89352'},
    { city: 'Bachhagel', zip: '89429'},
    { city: 'Bächingen a.d. Brenz', zip: '89431'},
    { city: 'Salzgitter', zip: '38226'},
    { city: 'Marschacht', zip: '21436'},
    { city: 'Betzigau', zip: '87488'},
    { city: 'Brotterode-Trusetal', zip: '98596'},
    { city: 'Obergünzburg', zip: '87634'},
    { city: 'Hörselberg-Hainich', zip: '99820'},
    { city: 'Dentlein a. Forst', zip: '91599'},
    { city: 'Weiltingen', zip: '91744'},
    { city: 'Aislingen', zip: '89344'},
    { city: 'Wolfenbüttel', zip: '38304'},
    { city: 'Bundorf', zip: '97494'},
    { city: 'Herzberg, Elbingerode, Hörden', zip: '37412'},
    { city: 'Landensberg', zip: '89361'},
    { city: 'Mittelneufnach', zip: '86868'},
    { city: 'Woltersdorf, Müssen u.a.', zip: '21516'},
    { city: 'Scharbeutz, Süsel', zip: '23684'},
    { city: 'Rieden', zip: '87668'},
    { city: 'Rätzlingen', zip: '29590'},
    { city: 'Emersacker', zip: '86494'},
    { city: 'Oberhof', zip: '98559'},
    { city: 'Stötten am Auerberg', zip: '87675'},
    { city: 'Groß Grönau', zip: '23627'},
    { city: 'Lonnerstadt', zip: '91475'},
    { city: 'Haundorf', zip: '91729'},
    { city: 'Dittenheim', zip: '91723'},
    { city: 'Waal', zip: '86875'},
    { city: 'Weisendorf', zip: '91085'},
    { city: 'Untermeitingen', zip: '86836'},
    { city: 'Kemmern', zip: '96164'},
    { city: 'Ellgau', zip: '86679'},
    { city: 'Augsburg', zip: '86152'},
    { city: 'Thale, Blankenburg', zip: '06502'},
    { city: 'Straußfurt', zip: '99634'},
    { city: 'Memmelsdorf', zip: '96117'},
    { city: 'Frankenblick, Schalkau, Bachfeld', zip: '96528'},
    { city: 'Fürth', zip: '90766'},
    { city: 'Heringsdorf', zip: '23777'},
    { city: 'Wittenburg u.a.', zip: '19243'},
    { city: 'Dasing', zip: '86453'},
    { city: 'Forchheim', zip: '91301'},
    { city: 'Klütz', zip: '23948'},
    { city: 'Aachen', zip: '52078'},
    { city: 'Straelen', zip: '47638'},
    { city: 'Hürtgenwald', zip: '52393'},
    { city: 'Xanten', zip: '46509'},
    { city: 'Lasel', zip: '54612'},
    { city: 'Mönchengladbach', zip: '41066'},
    { city: 'Krefeld', zip: '47839'},
    { city: 'Korschenbroich', zip: '41352'},
    { city: 'Nettersheim', zip: '53947'},
    { city: 'Birresborn', zip: '54574'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Spangdahlem', zip: '54529'},
    { city: 'Hünxe', zip: '46569'},
    { city: 'Hürth', zip: '50354'},
    { city: 'Düsseldorf', zip: '40211'},
    { city: 'Ratingen', zip: '40885'},
    { city: 'Düsseldorf', zip: '40231'},
    { city: 'Lebach', zip: '66822'},
    { city: 'Püttlingen', zip: '66346'},
    { city: 'Gusenburg', zip: '54413'},
    { city: 'Mülheim an der Ruhr', zip: '45470'},
    { city: 'Reifferscheid, Kaltenborn, Wershofen u.a.', zip: '53520'},
    { city: 'Essen', zip: '45357'},
    { city: 'Bottrop', zip: '46236'},
    { city: 'Hilden', zip: '40723'},
    { city: 'Ulmen', zip: '56766'},
    { city: 'Wintrich', zip: '54487'},
    { city: 'Essen', zip: '45239'},
    { city: 'Köln', zip: '50679'},
    { city: 'Niederkassel', zip: '53859'},
    { city: 'Saarbrücken', zip: '66123'},
    { city: 'Köln', zip: '51149'},
    { city: 'Solingen', zip: '42657'},
    { city: 'Kleinblittersdorf', zip: '66271'},
    { city: 'Espenau', zip: '34314'},
    { city: 'Winterbach', zip: '73650'},
    { city: 'Zweiflingen', zip: '74639'},
    { city: 'Fleischwangen', zip: '88373'},
    { city: 'Bevern', zip: '37639'},
    { city: 'Rudersberg', zip: '73635'},
    { city: 'Kassel', zip: '34125'},
    { city: 'Garbsen', zip: '30823'},
    { city: 'Bad Buchau', zip: '88422'},
    { city: 'Oberweser', zip: '34399'},
    { city: 'Neuenstein', zip: '74632'},
    { city: 'Niedernhall', zip: '74676'},
    { city: 'Wasserburg (Bodensee)', zip: '88142'},
    { city: 'Breisach am Rhein', zip: '79206'},
    { city: 'Katzweiler', zip: '67734'},
    { city: 'Münster', zip: '48155'},
    { city: 'Löningen', zip: '49624'},
    { city: 'Wittmund', zip: '26409'},
    { city: 'Merdingen', zip: '79291'},
    { city: 'Hilgert', zip: '56206'},
    { city: 'Ballrechten-Dottingen', zip: '79282'},
    { city: 'Staufen im Breisgau', zip: '79219'},
    { city: 'Apen', zip: '26689'},
    { city: 'Neuhäusel', zip: '56335'},
    { city: 'Rheinfelden (Baden)', zip: '79618'},
    { city: 'Freiburg im Breisgau', zip: '79111'},
    { city: 'Mahlberg', zip: '77972'},
    { city: 'Rüdesheim', zip: '55593'},
    { city: 'Ahlen', zip: '59227'},
    { city: 'Kappelrodeck', zip: '77876'},
    { city: 'Deidesheim', zip: '67146'},
    { city: 'Kandel', zip: '76870'},
    { city: 'Bühlertal', zip: '77830'},
    { city: 'Gutach (Schwarzwaldbahn)', zip: '77793'},
    { city: 'Nieder-Olm', zip: '55268'},
    { city: 'Niedernhausen', zip: '65527'},
    { city: 'Wiesbaden', zip: '65207'},
    { city: 'Freudenstadt', zip: '72250'},
    { city: 'Sylt', zip: '25980'},
    { city: 'Mettenheim', zip: '67582'},
    { city: 'Leimersheim', zip: '76774'},
    { city: 'Hohentengen am Hochrhein', zip: '79801'},
    { city: 'Schramberg', zip: '78713'},
    { city: 'Nordenham', zip: '26954'},
    { city: 'Emmerzhausen, Niederdreisbach, Steinebach', zip: '57520'},
    { city: 'Elmstein', zip: '67471'},
    { city: 'Werl', zip: '59457'},
    { city: 'Nastätten u.a.', zip: '56355'},
    { city: 'Bersenbrück', zip: '49593'},
    { city: 'Wattenheim', zip: '67319'},
    { city: 'Eisenberg (Pfalz)', zip: '67304'},
    { city: 'Elz', zip: '65604'},
    { city: 'Lambrecht (Pfalz)', zip: '67466'},
    { city: 'Fischerbach, Haslach, Hofstetten', zip: '77716'},
    { city: 'Goch', zip: '47574'},
    { city: 'Baesweiler', zip: '52499'},
    { city: 'Bleialf', zip: '54608'},
    { city: 'Wachtendonk', zip: '47669'},
    { city: 'Viersen', zip: '41747'},
    { city: 'Ralingen', zip: '54310'},
    { city: 'Kall', zip: '53925'},
    { city: 'Walsdorf, Nohn u.a.', zip: '54578'},
    { city: 'Duisburg', zip: '47179'},
    { city: 'Neuss', zip: '41470'},
    { city: 'Euskirchen', zip: '53881'},
    { city: 'Völklingen', zip: '66333'},
    { city: 'Duisburg', zip: '47166'},
    { city: 'Düsseldorf', zip: '40547'},
    { city: 'Uelsen, Halle, Gölenkamp, Getelo', zip: '49843'},
    { city: 'Düsseldorf', zip: '40237'},
    { city: 'Düsseldorf', zip: '40593'},
    { city: 'Bornheim', zip: '53332'},
    { city: 'Essen', zip: '45356'},
    { city: 'Ettringen', zip: '56729'},
    { city: 'Leverkusen', zip: '51379'},
    { city: 'Leichlingen', zip: '42799'},
    { city: 'Quierschied', zip: '66287'},
    { city: 'Essen', zip: '45130'},
    { city: 'Essen', zip: '45128'},
    { city: 'Köln', zip: '51069'},
    { city: 'Rastede', zip: '26180'},
    { city: 'Schonach im Schwarzwald', zip: '78136'},
    { city: 'Kallstadt', zip: '67169'},
    { city: 'Anröchte', zip: '59609'},
    { city: 'Butjadingen', zip: '26969'},
    { city: 'Wiesbaden', zip: '65183'},
    { city: 'Wiesbaden', zip: '65185'},
    { city: 'Durmersheim', zip: '76448'},
    { city: 'Wintersheim', zip: '67587'},
    { city: 'Bräunlingen', zip: '78199'},
    { city: 'Freudenstadt', zip: '72250'},
    { city: 'Lemförde u.a.', zip: '49448'},
    { city: 'Lippstadt', zip: '59555'},
    { city: 'Dillenburg', zip: '35688'},
    { city: 'Donaueschingen', zip: '78166'},
    { city: 'Dudenhofen', zip: '67373'},
    { city: 'Lampertheim', zip: '68623'},
    { city: 'Stockstadt am Rhein', zip: '64589'},
    { city: 'Fischbach, Erfweiler u.a.', zip: '66996'},
    { city: 'Bad Bergzabern u.a.', zip: '76887'},
    { city: 'Malterdingen', zip: '79364'},
    { city: 'Münster-Sarmsheim', zip: '55424'},
    { city: 'Freiburg im Breisgau', zip: '79106'},
    { city: 'Freiburg im Breisgau', zip: '79117'},
    { city: 'Offenburg', zip: '77656'},
    { city: 'Todtnau', zip: '79674'},
    { city: 'Osnabrück', zip: '49076'},
    { city: 'Rhodt u.a.', zip: '76835'},
    { city: 'Nisterau u.a.', zip: '56472'},
    { city: 'Siegen', zip: '57072'},
    { city: 'Offenburg', zip: '77654'},
    { city: 'Ramsen', zip: '67305'},
    { city: 'Ohlsbach', zip: '77797'},
    { city: 'Gommersheim', zip: '67377'},
    { city: 'Georgsmarienhütte', zip: '49124'},
    { city: 'Murg', zip: '79730'},
    { city: 'Schluchsee', zip: '79859'},
    { city: 'Raubach', zip: '56316'},
    { city: 'Altena', zip: '58762'},
    { city: 'Unna', zip: '59425'},
    { city: 'Lörrach', zip: '79541'},
    { city: 'Bad Ems Umland', zip: '56132'},
    { city: 'Sankt Goarshausen u.a.', zip: '56346'},
    { city: 'Münster', zip: '48167'},
    { city: 'Sendenhorst', zip: '48324'},
    { city: 'Eichstetten', zip: '79356'},
    { city: 'Hamm', zip: '59075'},
    { city: 'Friesoythe', zip: '26169'},
    { city: 'Rockenhausen, Bisterschied u.a.', zip: '67806'},
    { city: 'Montabaur', zip: '56410'},
    { city: 'Gundersweiler, Gonbach u.a.', zip: '67724'},
    { city: 'Pfaffenweiler', zip: '79292'},
    { city: 'Winterborn, Waldgrehweiler, Niedermoschel, u.a.', zip: '67822'},
    { city: 'Freiburg im Breisgau', zip: '79114'},
    { city: 'Bochum', zip: '44866'},
    { city: 'Namborn', zip: '66640'},
    { city: 'Bergisch Gladbach', zip: '51429'},
    { city: 'Wehr', zip: '56653'},
    { city: 'Herne', zip: '44625'},
    { city: 'Bochum', zip: '44789'},
    { city: 'Dörpen, Lehe, u.a.', zip: '26892'},
    { city: 'Castrop-Rauxel', zip: '44579'},
    { city: 'Nordwalde', zip: '48356'},
    { city: 'Dortmund', zip: '44137'},
    { city: 'Lünne, Schapen, Spelle', zip: '48480'},
    { city: 'Mohrkirch, Rügge', zip: '24405'},
    { city: 'Hannover', zip: '30457'},
    { city: 'Blaubeuren', zip: '89143'},
    { city: 'Sigmarszell', zip: '88138'},
    { city: 'Grünsfeld', zip: '97947'},
    { city: 'Stadt Schwäbisch Gmünd', zip: '73529'},
    { city: 'Vogt', zip: '88267'},
    { city: 'Buchholz in der Nordheide', zip: '21244'},
    { city: 'Nortorf', zip: '24589'},
    { city: 'Wolpertshausen', zip: '74549'},
    { city: 'Hannover', zip: '30627'},
    { city: 'Rosengarten', zip: '21224'},
    { city: 'Friedewald', zip: '36289'},
    { city: 'Leinzell', zip: '73575'},
    { city: 'Ilshofen', zip: '74532'},
    { city: 'Ulm', zip: '89081'},
    { city: 'Neumünster', zip: '24536'},
    { city: 'Eschwege', zip: '37269'},
    { city: 'Hamburg', zip: '20253'},
    { city: 'Creglingen', zip: '97993'},
    { city: 'Norderstedt', zip: '22850'},
    { city: 'Celle', zip: '29225'},
    { city: 'Aitrach', zip: '88319'},
    { city: 'Illerrieden', zip: '89186'},
    { city: 'Bönebüttel', zip: '24620'},
    { city: 'Kaltennordheim', zip: '36452'},
    { city: 'Seesen', zip: '38723'},
    { city: 'Weißenborn', zip: '37299'},
    { city: 'Memmingen', zip: '87700'},
    { city: 'Kiel', zip: '24114'},
    { city: 'Boos', zip: '87737'},
    { city: 'Lauchheim', zip: '73466'},
    { city: 'Wolfertschwenden', zip: '87787'},
    { city: 'Langlingen', zip: '29364'},
    { city: 'Hohne', zip: '29362'},
    { city: 'Mellrichstadt', zip: '97638'},
    { city: 'Wensin', zip: '23827'},
    { city: 'Ebstorf', zip: '29574'},
    { city: 'Illesheim', zip: '91471'},
    { city: 'Oberscheinfeld', zip: '91483'},
    { city: 'Riesbürg', zip: '73469'},
    { city: 'Wonfurt', zip: '97539'},
    { city: 'Ederheim', zip: '86739'},
    { city: 'Unteregg', zip: '87782'},
    { city: 'Marktoffingen', zip: '86748'},
    { city: 'Artlenburg', zip: '21380'},
    { city: 'Rauhenebrach', zip: '96181'},
    { city: 'Goslar', zip: '38644'},
    { city: 'Glasau', zip: '23719'},
    { city: 'Geseke', zip: '59590'},
    { city: 'Oberhausen-Rheinhausen', zip: '68794'},
    { city: 'Wetzlar', zip: '35578'},
    { city: 'Hatzfeld', zip: '35116'},
    { city: 'Bielefeld', zip: '33659'},
    { city: 'Wetzlar Garbeinheim', zip: '35583'},
    { city: 'Bielefeld', zip: '33602'},
    { city: 'Bielefeld', zip: '33604'},
    { city: 'Bielefeld', zip: '33607'},
    { city: 'Gießen', zip: '35398'},
    { city: 'Rottweil', zip: '78628'},
    { city: 'Frankfurt am Main', zip: '60486'},
    { city: 'Heidelberg', zip: '69124'},
    { city: 'Frankfurt am Main', zip: '60326'},
    { city: 'Bremen', zip: '28757'},
    { city: 'Bad Salzuflen', zip: '32107'},
    { city: 'Frankfurt am Main', zip: '60598'},
    { city: 'Sulingen', zip: '27232'},
    { city: 'Neukirchen, Aventoft', zip: '25927'},
    { city: 'Garding, Osterhever, Poppenbüll u.a.', zip: '25836'},
    { city: 'Ober-Ramstadt', zip: '64372'},
    { city: 'Hausen ob Verena', zip: '78595'},
    { city: 'Maulbronn', zip: '75433'},
    { city: 'Weil der Stadt', zip: '71263'},
    { city: 'Rielasingen-Worblingen', zip: '78239'},
    { city: 'Bremen', zip: '28203'},
    { city: 'Obernheim', zip: '72364'},
    { city: 'Wiernsheim', zip: '75446'},
    { city: 'Ihlienworth', zip: '21775'},
    { city: 'Hanau', zip: '63454'},
    { city: 'Kalletal', zip: '32689'},
    { city: 'Gemünden', zip: '35285'},
    { city: 'Rutesheim', zip: '71277'},
    { city: 'Asendorf', zip: '27330'},
    { city: 'Uelvesbüll, Witzwort', zip: '25889'},
    { city: 'Glauburg', zip: '63695'},
    { city: 'Kirtorf', zip: '36320'},
    { city: 'Reichenau', zip: '78479'},
    { city: 'Großenwiehe, Lindewitt', zip: '24969'},
    { city: 'Leese', zip: '31633'},
    { city: 'Windbergen', zip: '25729'},
    { city: 'Goldbach', zip: '63773'},
    { city: 'Nienburg/Weser', zip: '31582'},
    { city: 'Pfullingen', zip: '72793'},
    { city: 'Stuttgart', zip: '70191'},
    { city: 'Lügde', zip: '32676'},
    { city: 'Lauenhagen', zip: '31714'},
    { city: 'Ostfildern', zip: '73760'},
    { city: 'Drochtersen', zip: '21706'},
    { city: 'Heiligenberg', zip: '88633'},
    { city: 'Daisendorf', zip: '88718'},
    { city: 'Freudenberg, Collenberg', zip: '97896'},
    { city: 'Steimbke', zip: '31634'},
    { city: 'Eberstadt', zip: '74246'},
    { city: 'Hofgeismar', zip: '34369'},
    { city: 'Harrislee', zip: '24955'},
    { city: 'Stadtprozelten', zip: '97909'},
    { city: 'Beidenfleth, Klein Kampen', zip: '25573'},
    { city: 'Widdern', zip: '74259'},
    { city: 'Hohn', zip: '24806'},
    { city: 'Wiesthal', zip: '97859'},
    { city: 'Tetenhusen', zip: '24817'},
    { city: 'Markt Taschendorf', zip: '91480'},
    { city: 'Trautskirchen', zip: '90619'},
    { city: 'Uehlfeld', zip: '91486'},
    { city: 'Neustadt', zip: '23730'},
    { city: 'Oberhaid', zip: '96173'},
    { city: 'Halblech', zip: '87642'},
    { city: 'Baunach', zip: '96148'},
    { city: 'Eisfeld, Auengrund', zip: '98673'},
    { city: 'Nordendorf', zip: '86695'},
    { city: 'Greußen Clingen Großenehrich', zip: '99718'},
    { city: 'Adelsdorf', zip: '91325'},
    { city: 'Rennau, Querenhorst, Mariental, Grasleben', zip: '38368'},
    { city: 'Südharz, Berga', zip: '06536'},
    { city: 'Egling a.d. Paar', zip: '86492'},
    { city: 'Hohenpeißenberg', zip: '82383'},
    { city: 'Rödental', zip: '96472'},
    { city: 'Erfurt', zip: '99089'},
    { city: 'Obergriesbach', zip: '86573'},
    { city: 'Werlte, Vrees, Lahn', zip: '49757'},
    { city: 'Thaleischweiler-Fröschen', zip: '66987'},
    { city: 'Vallendar', zip: '56179'},
    { city: 'Rehborn', zip: '55592'},
    { city: 'Rothselberg u.a.', zip: '67753'},
    { city: 'Wiesmoor', zip: '26639'},
    { city: 'Münchweiler an der Rodalb', zip: '66981'},
    { city: 'Barßel', zip: '26676'},
    { city: 'Heltersberg', zip: '67716'},
    { city: 'Trippstadt u.a.', zip: '67705'},
    { city: 'Nastätten u.a.', zip: '56355'},
    { city: 'Ostbevern', zip: '48346'},
    { city: 'Neuried', zip: '77743'},
    { city: 'Teningen', zip: '79331'},
    { city: 'Maulburg', zip: '79689'},
    { city: 'Ebringen', zip: '79285'},
    { city: 'Gebhardshain', zip: '57580'},
    { city: 'Alzey', zip: '55232'},
    { city: 'Taunusstein', zip: '65232'},
    { city: 'Wackernheim', zip: '55263'},
    { city: 'Armsheim', zip: '55288'},
    { city: 'Haiger', zip: '35708'},
    { city: 'Höchenschwand', zip: '79862'},
    { city: 'Dogern', zip: '79804'},
    { city: 'Hochstadt', zip: '76879'},
    { city: 'Steinmauern', zip: '76479'},
    { city: 'Warstein', zip: '59581'},
    { city: 'Bad Camberg', zip: '65520'},
    { city: 'Wiesbaden', zip: '65205'},
    { city: 'Weingarten (Pfalz)', zip: '67366'},
    { city: 'Kuhardt', zip: '76773'},
    { city: 'Itzehoe', zip: '25524'},
    { city: 'Fintel, Lauenbrück u.a.', zip: '27389'},
    { city: 'Ebenweiler', zip: '88370'},
    { city: 'Neustadt a. Main', zip: '97845'},
    { city: 'Holzmaden', zip: '73271'},
    { city: 'Nübel', zip: '24881'},
    { city: 'Busdorf', zip: '24866'},
    { city: 'Weingarten', zip: '88250'},
    { city: 'Heroldstatt', zip: '72535'},
    { city: 'Freiburg im Breisgau', zip: '79106'},
    { city: 'Alpenrod', zip: '57642'},
    { city: 'Unnau', zip: '57648'},
    { city: 'Bretzenheim', zip: '55559'},
    { city: 'Mudersbach', zip: '57555'},
    { city: 'Limburg', zip: '65556'},
    { city: 'Wilhelmshaven', zip: '26388'},
    { city: 'Neustadt an der Weinstraße', zip: '67434'},
    { city: 'Burgschwalbach', zip: '65558'},
    { city: 'Alzey', zip: '55232'},
    { city: 'Hettenleidelheim', zip: '67310'},
    { city: 'Bernsdorf', zip: '02994'},
    { city: 'Hohnstein', zip: '01848'},
    { city: 'Spreetal, Elsterheide', zip: '02979'},
    { city: 'Neukirch/Lausitz', zip: '01904'},
    { city: 'Sebnitz', zip: '01855'},
    { city: 'Wilthen', zip: '02681'},
    { city: 'Treplin, Jacobsdorf, Frankfurt (Oder)', zip: '15236'},
    { city: 'Berlin Weißensee', zip: '13086'},
    { city: 'Berlin Britz', zip: '12359'},
    { city: 'Berlin', zip: '12687'},
    { city: 'Berlin', zip: '12685'},
    { city: 'Dippoldiswalde', zip: '01744'},
    { city: 'Dresden', zip: '01069'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Weichs', zip: '85258'},
    { city: 'Bismark', zip: '39628'},
    { city: 'Wolfratshausen', zip: '82515'},
    { city: 'Hebertshausen', zip: '85241'},
    { city: 'Wismar', zip: '23970'},
    { city: 'München', zip: '81375'},
    { city: 'Untersteinach', zip: '95369'},
    { city: 'Rohrbach', zip: '85296'},
    { city: 'Weigendorf', zip: '91249'},
    { city: 'Güsten', zip: '39439'},
    { city: 'Kupferberg', zip: '95362'},
    { city: 'Brüel', zip: '19412'},
    { city: 'Magdeburg', zip: '39128'},
    { city: 'Jena', zip: '07747'},
    { city: 'München', zip: '81673'},
    { city: 'Parsberg', zip: '92331'},
    { city: 'Feldkirchen', zip: '85622'},
    { city: 'Grasbrunn', zip: '85630'},
    { city: 'Köditz', zip: '95189'},
    { city: 'Adelshofen', zip: '82276'},
    { city: 'Nürnberg', zip: '90480'},
    { city: 'Titting', zip: '85135'},
    { city: 'Wallhausen, Blankenheim', zip: '06528'},
    { city: 'Altenkunstadt', zip: '96264'},
    { city: 'Walting', zip: '85137'},
    { city: 'Greding', zip: '91171'},
    { city: 'Freystadt', zip: '92342'},
    { city: 'Eichenau', zip: '82223'},
    { city: 'Schwabhausen', zip: '85247'},
    { city: 'Lehnstedt u.a.', zip: '99441'},
    { city: 'Aachen', zip: '52074'},
    { city: 'Geilenkirchen', zip: '52511'},
    { city: 'Kerken', zip: '47647'},
    { city: 'Schleiden', zip: '53937'},
    { city: 'Hamminkeln', zip: '46499'},
    { city: 'Jünkerath', zip: '54584'},
    { city: 'Wiltingen', zip: '54459'},
    { city: 'Voerde (Niederrhein)', zip: '46562'},
    { city: 'Moers', zip: '47443'},
    { city: 'Leiwen u.a.', zip: '54340'},
    { city: 'Düsseldorf', zip: '40239'},
    { city: 'Wadern', zip: '66687'},
    { city: 'Bottrop', zip: '46244'},
    { city: 'Oberhausen', zip: '46047'},
    { city: 'Hilden, Düsseldorf', zip: '40721'},
    { city: 'Hilden, Düsseldorf', zip: '40721'},
    { city: 'Langenfeld', zip: '40764'},
    { city: 'Saarbrücken', zip: '66115'},
    { city: 'Saarbrücken', zip: '66119'},
    { city: 'Essen', zip: '45329'},
    { city: 'Köln', zip: '51067'},
    { city: 'Gelsenkirchen', zip: '45883'},
    { city: 'Dernau', zip: '53507'},
    { city: 'Wiehl', zip: '51674'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Hörstel', zip: '48477'},
    { city: 'Straßenhaus', zip: '56587'},
    { city: 'Vinningen, Trulben, Ruppertsweiler u.a.', zip: '66957'},
    { city: 'Rhauderfehn', zip: '26817'},
    { city: 'Eßweiler', zip: '67754'},
    { city: 'Sobernheim', zip: '55566'},
    { city: 'Wuppertal', zip: '42113'},
    { city: 'Enkirch u.a.', zip: '56850'},
    { city: 'Kürten', zip: '51515'},
    { city: 'Wuppertal', zip: '42275'},
    { city: 'Castrop-Rauxel', zip: '44581'},
    { city: 'Waldmohr', zip: '66914'},
    { city: 'Castrop-Rauxel', zip: '44577'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Niederwörresbach', zip: '55758'},
    { city: 'Lengerich u.a.', zip: '49838'},
    { city: 'Neubörger, Neulehe', zip: '26909'},
    { city: 'Loburg, Leitzkau', zip: '39279'},
    { city: 'Langenpreising', zip: '85465'},
    { city: 'Rosenbach', zip: '08539'},
    { city: 'Burglengenfeld', zip: '93133'},
    { city: 'Zeulenroda-Triebes, Weißendorf', zip: '07950'},
    { city: 'Rehau', zip: '95111'},
    { city: 'Genthin, Hohenseeden, Zabakuck u.a.', zip: '39307'},
    { city: 'Elmenhorst/Lichtenhagen, Rostock', zip: '18107'},
    { city: 'Elmenhorst/Lichtenhagen, Rostock', zip: '18107'},
    { city: 'Buch a. Erlbach', zip: '84172'},
    { city: 'Thiersheim', zip: '95707'},
    { city: 'Adorf', zip: '08626'},
    { city: 'Fuchsmühl', zip: '95689'},
    { city: 'Landshut', zip: '84036'},
    { city: 'Rohrdorf', zip: '83101'},
    { city: 'Pirk', zip: '92712'},
    { city: 'Landshut', zip: '84028'},
    { city: 'Sandersdorf-Brehna', zip: '06796'},
    { city: 'Bergen', zip: '08239'},
    { city: 'Postau', zip: '84103'},
    { city: 'Tännesberg', zip: '92723'},
    { city: 'Dierhagen', zip: '18347'},
    { city: 'Geiselhöring', zip: '94333'},
    { city: 'Schleching', zip: '83259'},
    { city: 'Tessin, Grammow u.a.', zip: '18195'},
    { city: 'Gerzen', zip: '84175'},
    { city: 'Gstadt a. Chiemsee', zip: '83257'},
    { city: 'Loiching', zip: '84180'},
    { city: 'Hirschfeld', zip: '08144'},
    { city: 'Egglkofen', zip: '84546'},
    { city: 'Gangkofen', zip: '84140'},
    { city: 'Langenleuba-Niederhain', zip: '04618'},
    { city: 'Barth', zip: '18356'},
    { city: 'Geithain', zip: '04643'},
    { city: 'Bogen', zip: '94327'},
    { city: 'Limbach-Oberfrohna', zip: '09212'},
    { city: 'Zahna-Elster', zip: '06895'},
    { city: 'Mehring', zip: '84561'},
    { city: 'Neukirchen/Erzgeb.', zip: '09221'},
    { city: 'Geringswalde', zip: '09326'},
    { city: 'Wermsdorf', zip: '04779'},
    { city: 'Gelenau/Erzgeb.', zip: '09423'},
    { city: 'Chemnitz', zip: '09126'},
    { city: 'Drachselsried', zip: '94256'},
    { city: 'Stralsund', zip: '18437'},
    { city: 'Leubsdorf, Gornau, Augustusburg', zip: '09573'},
    { city: 'Börnichen, Gornau', zip: '09437'},
    { city: 'Marienberg', zip: '09496'},
    { city: 'Leegebruch', zip: '16767'},
    { city: 'Strehla', zip: '01616'},
    { city: 'Berlin Halensee', zip: '10711'},
    { city: 'Berlin-West', zip: '13409'},
    { city: 'Großenhain, Ebersbach u.a.', zip: '01561'},
    { city: 'Meißen', zip: '01662'},
    { city: 'Königsdorf', zip: '82549'},
    { city: 'Wallenfels', zip: '96346'},
    { city: 'München', zip: '80995'},
    { city: 'Neustadt-Glewe', zip: '19306'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'München', zip: '80935'},
    { city: 'Jena', zip: '07749'},
    { city: 'München', zip: '81671'},
    { city: 'Otterfing', zip: '83624'},
    { city: 'München', zip: '81829'},
    { city: 'Berg', zip: '95180'},
    { city: 'Amberg', zip: '92224'},
    { city: 'Ihrlerstein', zip: '93346'},
    { city: 'Immenreuth', zip: '95505'},
    { city: 'Braunsbedra', zip: '06242'},
    { city: 'Güterglück, Lindau, Deetz u.a.', zip: '39264'},
    { city: 'Schwarzenbach a.d. Saale', zip: '95126'},
    { city: 'Tröstau', zip: '95709'},
    { city: 'Kallmünz', zip: '93183'},
    { city: 'Duggendorf', zip: '93182'},
    { city: 'Farchant', zip: '82490'},
    { city: 'Nürnberg', zip: '90469'},
    { city: 'Nürnberg', zip: '90491'},
    { city: 'Herrsching a. Ammersee', zip: '82211'},
    { city: 'Udestedt, Mönchenholzhausen u.a.', zip: '99198'},
    { city: 'Boltenhagen', zip: '23946'},
    { city: 'Schöngeising', zip: '82296'},
    { city: 'Saalfeld/Saale', zip: '07318'},
    { city: 'Neu Kaliß', zip: '19294'},
    { city: 'Blankenhain', zip: '99444'},
    { city: 'Burgthann', zip: '90559'},
    { city: 'Rastenberg', zip: '99636'},
    { city: 'Pottenstein', zip: '91278'},
    { city: 'Klein Offenseth-Sparrieshoop', zip: '25365'},
    { city: 'Unterstadion', zip: '89619'},
    { city: 'Petersberg', zip: '36100'},
    { city: 'Mittelbiberach', zip: '88441'},
    { city: 'Langenhagen', zip: '30853'},
    { city: 'Waldbrunn, Irtenberger Wald', zip: '97295'},
    { city: 'Stadt Schwäbisch Gmünd', zip: '73525'},
    { city: 'Igersheim', zip: '97999'},
    { city: 'Kleinrinderfeld', zip: '97271'},
    { city: 'Margetshöchheim', zip: '97276'},
    { city: 'Lonsee', zip: '89173'},
    { city: 'Mietingen', zip: '88487'},
    { city: 'Freden (Leine)', zip: '31084'},
    { city: 'Neu-Eichenberg', zip: '37249'},
    { city: 'Felde', zip: '24242'},
    { city: 'Hamburg', zip: '22457'},
    { city: 'Hanstedt, Asendorf', zip: '21271'},
    { city: 'Rabenkirchen-Faulück', zip: '24407'},
    { city: 'Algermissen', zip: '31191'},
    { city: 'Norderstedt', zip: '22848'},
    { city: 'Hamburg', zip: '20255'},
    { city: 'Hamburg', zip: '20357'},
    { city: 'Bad Kissingen', zip: '97688'},
    { city: 'Kisdorf', zip: '24629'},
    { city: 'Hamburg', zip: '20149'},
    { city: 'Celle', zip: '29223'},
    { city: 'Hohenhameln', zip: '31249'},
    { city: 'Aub', zip: '97239'},
    { city: 'Hamburg', zip: '21037'},
    { city: 'Schillsdorf', zip: '24637'},
    { city: 'Stadtlengsfeld, Weilar, Urnshausen', zip: '36457'},
    { city: 'Bad Grund', zip: '37539'},
    { city: 'Wankendorf', zip: '24601'},
    { city: 'Hahausen, Lutter, Wallmoden', zip: '38729'},
    { city: 'Sonthofen', zip: '87527'},
    { city: 'Hamburg', zip: '21029'},
    { city: 'Nattheim', zip: '89564'},
    { city: 'Reinbek', zip: '21465'},
    { city: 'Schopfloch', zip: '91626'},
    { city: 'Ottobeuren', zip: '87724'},
    { city: 'Hoisdorf', zip: '22955'},
    { city: 'Theres', zip: '97531'},
    { city: 'Tannhausen', zip: '73497'},
    { city: 'Michelau i. Steigerwald, Hundelshausen', zip: '97513'},
    { city: 'Braunschweig', zip: '38112'},
    { city: 'Obernzenn', zip: '91619'},
    { city: 'Nördlingen', zip: '86720'},
    { city: 'Viernau u.a.', zip: '98547'},
    { city: 'Kollow', zip: '21527'},
    { city: 'Wrestedt', zip: '29559'},
    { city: 'Hofheim i. UFr.', zip: '97461'},
    { city: 'Braunschweig', zip: '38110'},
    { city: 'Wagenhoff, Ringelah', zip: '38559'},
    { city: 'Jelmstorf', zip: '29585'},
    { city: 'Dinkelscherben', zip: '86424'},
    { city: 'Bayrischzell', zip: '83735'},
    { city: 'Teugn', zip: '93356'},
    { city: 'Halle/ Saale', zip: '06112'},
    { city: 'Sandau', zip: '39524'},
    { city: 'Regensburg', zip: '93053'},
    { city: 'Obertraubling', zip: '93083'},
    { city: 'Arzberg', zip: '95659'},
    { city: 'Laage, Wardow u.a.', zip: '18299'},
    { city: 'Schirnding', zip: '95706'},
    { city: 'Leipzig', zip: '04158'},
    { city: 'Leipzig', zip: '04105'},
    { city: 'Böhlen', zip: '04564'},
    { city: 'Breitbrunn a. Chiemsee', zip: '83254'},
    { city: 'Beetzsee, Wollin, Wenzlow, Golzow u.a.', zip: '14778'},
    { city: 'Leipzig', zip: '04315'},
    { city: 'Winklarn', zip: '92559'},
    { city: 'Falkenberg', zip: '84326'},
    { city: 'Bockau', zip: '08324'},
    { city: 'Johanngeorgenstadt', zip: '08349'},
    { city: 'Hohndorf', zip: '09394'},
    { city: 'Neuötting', zip: '84524'},
    { city: 'Reischach', zip: '84571'},
    { city: 'Mitterskirchen', zip: '84335'},
    { city: 'Sankt Englmar', zip: '94379'},
    { city: 'Claußnitz', zip: '09236'},
    { city: 'Potsdam', zip: '14478'},
    { city: 'Kleinmachnow', zip: '14532'},
    { city: 'Berlin Nikolassee', zip: '14129'},
    { city: 'Zenting', zip: '94579'},
    { city: 'Kirchdorf i. Wald', zip: '94261'},
    { city: 'Hohen Neuendorf', zip: '16540'},
    { city: 'Dahme u.a.', zip: '15936'},
    { city: 'Baruth', zip: '15837'},
    { city: 'Berlin Wedding', zip: '13353'},
    { city: 'Berlin Tiergarten', zip: '10787'},
    { city: 'Berlin Moabit', zip: '10557'},
    { city: 'Doberlug-Kirchhain', zip: '03253'},
    { city: 'Groß Miltzow', zip: '17349'},
    { city: 'Berlin Tempelhof', zip: '12101'},
    { city: 'Sankt Oswald', zip: '94568'},
    { city: 'Berlin Prenzlauer Berg', zip: '10437'},
    { city: 'Berlin Prenzlauer Berg', zip: '10405'},
    { city: 'Berlin', zip: '12305'},
    { city: 'Friedland, Galenbeck, Datzetal', zip: '17099'},
    { city: 'Delbrück', zip: '33129'},
    { city: 'Kriftel', zip: '65830'},
    { city: 'Wetzlar', zip: '35580'},
    { city: 'Neuwerk', zip: '27499'},
    { city: 'Bad Dürrheim', zip: '78073'},
    { city: 'Bremerhaven, Bremen', zip: '27568'},
    { city: 'Bremerhaven, Bremen', zip: '27568'},
    { city: 'Hüllhorst', zip: '32609'},
    { city: 'Bremen', zip: '28755'},
    { city: 'Bassum', zip: '27211'},
    { city: 'Malsch', zip: '69254'},
    { city: 'Calw', zip: '75365'},
    { city: 'Roßdorf', zip: '64380'},
    { city: 'Rottenburg am Neckar', zip: '72108'},
    { city: 'Weilen unter den Rinnen', zip: '72367'},
    { city: 'Dormettingen', zip: '72358'},
    { city: 'Simmozheim', zip: '75397'},
    { city: 'Rodgau', zip: '63110'},
    { city: 'Bremen', zip: '28211'},
    { city: 'Aach', zip: '78267'},
    { city: 'Eigeltingen', zip: '78253'},
    { city: 'Grünberg', zip: '35305'},
    { city: 'Grosselfingen', zip: '72415'},
    { city: 'Bärenthal', zip: '78580'},
    { city: 'Gnarrenburg', zip: '27442'},
    { city: 'Achim', zip: '28832'},
    { city: 'Stadtallendorf', zip: '35260'},
    { city: 'Steinheim', zip: '32839'},
    { city: 'Nieheim', zip: '33039'},
    { city: 'Stuttgart', zip: '70499'},
    { city: 'Besigheim', zip: '74354'},
    { city: 'Stuttgart', zip: '70435'},
    { city: 'Kleinheubach, Rüdenau', zip: '63924'},
    { city: 'Linden, Barkenholm', zip: '25791'},
    { city: 'Himmelpforten', zip: '21709'},
    { city: 'Bingen', zip: '72511'},
    { city: 'Marbach am Neckar', zip: '71672'},
    { city: 'Schwalmtal', zip: '36318'},
    { city: 'Herbstein', zip: '36358'},
    { city: 'Schafstedt, Weidenhof, Bornholt', zip: '25725'},
    { city: 'Langenenslingen', zip: '88515'},
    { city: 'Oberstenfeld', zip: '71720'},
    { city: 'St. Johann', zip: '72813'},
    { city: 'Affalterbach', zip: '71563'},
    { city: 'Heinrichsthal', zip: '63871'},
    { city: 'Flensburg', zip: '24941'},
    { city: 'Hameln', zip: '31789'},
    { city: 'Kassel', zip: '34130'},
    { city: 'Bodenfelde, Wahlsburg', zip: '37194'},
    { city: 'Tussenhausen', zip: '86874'},
    { city: 'Seeg', zip: '87637'},
    { city: 'Werther Hohenstein Wolkramshausen', zip: '99735'},
    { city: 'Maroldsweisach', zip: '96126'},
    { city: 'Türkheim', zip: '86842'},
    { city: 'Schönbrunn i. Steigerwald', zip: '96185'},
    { city: 'Ustersbach', zip: '86514'},
    { city: 'Dahlenburg', zip: '21368'},
    { city: 'Osloß', zip: '38557'},
    { city: 'Schwabmünchen', zip: '86830'},
    { city: 'Polsingen', zip: '91805'},
    { city: 'Rodach b. Coburg', zip: '96476'},
    { city: 'Hagenbüchach', zip: '91469'},
    { city: 'Lauter', zip: '96169'},
    { city: 'Neusäß', zip: '86356'},
    { city: 'Westendorf, Kühlenthal', zip: '86707'},
    { city: 'Markt Berolzheim', zip: '91801'},
    { city: 'Brome', zip: '38465'},
    { city: 'Neu Darchau', zip: '29490'},
    { city: 'Süpplingenburg', zip: '38376'},
    { city: 'Affing', zip: '86444'},
    { city: 'Pettstadt', zip: '96175'},
    { city: 'Augsburg', zip: '86161'},
    { city: 'Karwitz', zip: '29481'},
    { city: 'Bahrdorf', zip: '38459'},
    { city: 'Büchenbach', zip: '91186'},
    { city: 'Berglen', zip: '73663'},
    { city: 'Knüllwald', zip: '34593'},
    { city: 'Lohr a. Main', zip: '97816'},
    { city: 'Seestermühe', zip: '25371'},
    { city: 'Wolpertswende', zip: '88284'},
    { city: 'Kiebitzreihe', zip: '25368'},
    { city: 'Ravensburg', zip: '88212'},
    { city: 'Mittelsinn', zip: '97785'},
    { city: 'Ronnenberg', zip: '30952'},
    { city: 'Lorch', zip: '73547'},
    { city: 'Hessisch Lichtenau', zip: '37235'},
    { city: 'Berlin Buckow', zip: '12351'},
    { city: 'Berlin Friedrichshain', zip: '10247'},
    { city: 'Klingenberg', zip: '01774'},
    { city: 'Berlin Schmöckwitz', zip: '12527'},
    { city: 'Schulzendorf b. Eichenwade', zip: '15732'},
    { city: 'Dorfhain', zip: '01738'},
    { city: 'Ducherow', zip: '17398'},
    { city: 'Dresden', zip: '01127'},
    { city: 'Dresden', zip: '01219'},
    { city: 'Dresden', zip: '01277'},
    { city: 'Senftenberg', zip: '01968'},
    { city: 'Fürstenwalde/ Spree', zip: '15517'},
    { city: 'Müncheberg', zip: '15374'},
    { city: 'Hoyerswerda', zip: '02977'},
    { city: 'Cunewalde', zip: '02733'},
    { city: 'Frankfurt/ Oder', zip: '15230'},
    { city: 'Krauschwitz, Weißkeißel', zip: '02957'},
    { city: 'Rietschen', zip: '02956'},
    { city: 'Oybin', zip: '02797'},
    { city: 'Neuerburg u.a.', zip: '54673'},
    { city: 'Stolberg (Rhld.)', zip: '52222'},
    { city: 'Bollendorf', zip: '54669'},
    { city: 'Freudenburg', zip: '54450'},
    { city: 'Zülpich', zip: '53909'},
    { city: 'Blankenheim', zip: '53945'},
    { city: 'Beckingen', zip: '66701'},
    { city: 'Duisburg', zip: '47229'},
    { city: 'Itterbeck/Wielen', zip: '49847'},
    { city: 'Neuss', zip: '41469'},
    { city: 'Dinslaken', zip: '46537'},
    { city: 'Dormagen', zip: '41540'},
    { city: 'Ensdorf', zip: '66806'},
    { city: 'Ratingen', zip: '40880'},
    { city: 'Oberhausen', zip: '46149'},
    { city: 'Bettenfeld, Niederöfflingen u.a.', zip: '54533'},
    { city: 'Monheim am Rhein', zip: '40789'},
    { city: 'Köln', zip: '50937'},
    { city: 'Köln', zip: '50997'},
    { city: 'Hilden', zip: '40724'},
    { city: 'Köln', zip: '50668'},
    { city: 'Essen', zip: '45141'},
    { city: 'Essen', zip: '45327'},
    { city: 'Oberthal', zip: '66649'},
    { city: 'Lüdenscheid', zip: '58513'},
    { city: 'Buggingen', zip: '79426'},
    { city: 'Rust', zip: '77977'},
    { city: 'Menden', zip: '58708'},
    { city: 'Kappel-Grafenhausen', zip: '77966'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Everswinkel', zip: '48351'},
    { city: 'Singhofen', zip: '56379'},
    { city: 'Olpe', zip: '57462'},
    { city: 'Zell im Wiesental', zip: '79669'},
    { city: 'Freiamt', zip: '79348'},
    { city: 'Alfhausen', zip: '49594'},
    { city: 'Börrstadt', zip: '67725'},
    { city: 'Bad Zwischenahn', zip: '26160'},
    { city: 'Lippetal', zip: '59510'},
    { city: 'Neunkirchen', zip: '57290'},
    { city: 'Armsheim', zip: '55288'},
    { city: 'Netphen', zip: '57250'},
    { city: 'Rennerod, Zehnhausen, Nister-Möhrendorf, Waigandshain', zip: '56477'},
    { city: 'Papenburg', zip: '26871'},
    { city: 'Beltheim', zip: '56290'},
    { city: 'Neuwied', zip: '56567'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Contwig', zip: '66497'},
    { city: 'Altenberge', zip: '48341'},
    { city: 'Kleinbundenbach', zip: '66501'},
    { city: 'Weisenheim am Berg', zip: '67273'},
    { city: 'Furtwangen im Schwarzwald', zip: '78120'},
    { city: 'Freinsheim', zip: '67251'},
    { city: 'Oldenburg (Oldenburg)', zip: '26133'},
    { city: 'Bietigheim', zip: '76467'},
    { city: 'Fußgönheim', zip: '67136'},
    { city: 'Bad Essen', zip: '49152'},
    { city: 'Rietberg', zip: '33397'},
    { city: 'Mommenheim', zip: '55278'},
    { city: 'Karlsruhe', zip: '76149'},
    { city: 'Wutach', zip: '79879'},
    { city: 'Essen', zip: '45277'},
    { city: 'Bonn', zip: '53127'},
    { city: 'Marl', zip: '45770'},
    { city: 'Gelsenkirchen', zip: '45888'},
    { city: 'Sankt Augustin', zip: '53757'},
    { city: 'Recklinghausen', zip: '45659'},
    { city: 'Bochum', zip: '44795'},
    { city: 'Ediger-Eller', zip: '56814'},
    { city: 'Briedel', zip: '56867'},
    { city: 'Simmern/Hunsrück u.a.', zip: '55469'},
    { city: 'Rengsdorf', zip: '56579'},
    { city: 'Großefehn', zip: '26629'},
    { city: 'Münster', zip: '48163'},
    { city: 'Dortmund', zip: '44309'},
    { city: 'Ascheberg', zip: '59387'},
    { city: 'Rothselberg u.a.', zip: '67753'},
    { city: 'Forstinning', zip: '85661'},
    { city: 'Bockhorn', zip: '85461'},
    { city: 'Neusorg', zip: '95700'},
    { city: 'Halle/ Saale', zip: '06132'},
    { city: 'Weiherhammer', zip: '92729'},
    { city: 'Halle/ Saale', zip: '06130'},
    { city: 'Bad Abbach', zip: '93077'},
    { city: 'Oelsnitz', zip: '08606'},
    { city: 'Landsberg', zip: '06188'},
    { city: 'Rostock', zip: '18119'},
    { city: 'Zörbig', zip: '06780'},
    { city: 'Emmering', zip: '83550'},
    { city: 'Rosenheim', zip: '83026'},
    { city: 'Tiefenbach', zip: '84184'},
    { city: 'Ergolding, Landshut', zip: '84030'},
    { city: 'Elsterberg', zip: '07985'},
    { city: 'Plößberg', zip: '95703'},
    { city: 'Roitzsch, Petersroda', zip: '06809'},
    { city: 'Halfing', zip: '83128'},
    { city: 'Frasdorf', zip: '83112'},
    { city: 'Wiesenburg', zip: '14827'},
    { city: 'Vilsbiburg', zip: '84137'},
    { city: 'Prien a. Chiemsee, Herrenchiemssee', zip: '83209'},
    { city: 'Georgenberg', zip: '92697'},
    { city: 'Mähring', zip: '95695'},
    { city: 'Mühldorf a. Inn', zip: '84453'},
    { city: 'Bergen', zip: '83346'},
    { city: 'Fehrbellin, Temnitzquell, Märkisch Linden u.a.', zip: '16818'},
    { city: 'Stein a.d. Traun', zip: '83371'},
    { city: 'Unterdietfurt', zip: '84339'},
    { city: 'Lunzenau', zip: '09328'},
    { city: 'Schneizlreuth', zip: '83458'},
    { city: 'Inzell', zip: '83334'},
    { city: 'Neukirchen', zip: '94362'},
    { city: 'Emmerting', zip: '84547'},
    { city: 'Anger', zip: '83454'},
    { city: 'Arnschwang', zip: '93473'},
    { city: 'Petting', zip: '83367'},
    { city: 'Jüterbog', zip: '14913'},
    { city: 'Ramsau b. Berchtesgaden', zip: '83486'},
    { city: 'Achslach', zip: '94250'},
    { city: 'Möllenhagen', zip: '17219'},
    { city: 'Demmin u.a.', zip: '17111'},
    { city: 'Lichtenau', zip: '09244'},
    { city: 'Chemnitz', zip: '09113'},
    { city: 'Freilassing', zip: '83395'},
    { city: 'Berlin Spandau', zip: '13583'},
    { city: 'Cölpin', zip: '17094'},
    { city: 'Zehdenick', zip: '16792'},
    { city: 'Zeithain', zip: '01619'},
    { city: 'Passau', zip: '94036'},
    { city: 'Berlin Friedenau', zip: '12161'},
    { city: 'Greifswald', zip: '17493'},
    { city: 'Berlin Wedding', zip: '13355'},
    { city: 'Berlin Heinelsdorf', zip: '13089'},
    { city: 'Eichenbarleben, Irxleben, Niederndodeleben u.a.', zip: '39167'},
    { city: 'Unterschleißheim', zip: '85716'},
    { city: 'München', zip: '80809'},
    { city: 'München', zip: '80336'},
    { city: 'Karstädt, Dambeck, Klüß', zip: '19357'},
    { city: 'München', zip: '80333'},
    { city: 'München', zip: '80937'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'Magdeburg', zip: '39118'},
    { city: 'Kreuth', zip: '83708'},
    { city: 'München', zip: '81737'},
    { city: 'München', zip: '81735'},
    { city: 'Lichtenberg', zip: '95192'},
    { city: 'Bürgel u.a.', zip: '07616'},
    { city: 'Speichersdorf', zip: '95469'},
    { city: 'Freising', zip: '85356'},
    { city: 'Eschenbach i.d. OPf.', zip: '92676'},
    { city: 'Magdeburg', zip: '39114'},
    { city: 'Elsendorf', zip: '84094'},
    { city: 'Oberpframmern', zip: '85667'},
    { city: 'Hirschau', zip: '92242'},
    { city: 'Nürnberg', zip: '90425'},
    { city: 'Nürnberg', zip: '90459'},
    { city: 'Adelzhausen', zip: '86559'},
    { city: 'Fürstenfeldbruck', zip: '82256'},
    { city: 'Röthenbach an der Pegnitz', zip: '90552'},
    { city: 'Markt Indersdorf', zip: '85229'},
    { city: 'Planegg/Krailling', zip: '82152'},
    { city: 'Karlskron', zip: '85123'},
    { city: 'Börde-Hakel', zip: '39448'},
    { city: 'Berlin Rummelsburg', zip: '10317'},
    { city: 'Klein Bünzow', zip: '17390'},
    { city: 'Schöneiche bei Berlin', zip: '15566'},
    { city: 'Wegscheid', zip: '94110'},
    { city: 'Storkow', zip: '15859'},
    { city: 'Vogelsang-Warsin, Meiersberg, Mönkebude u.a.', zip: '17375'},
    { city: 'Oderberg u.a.', zip: '16248'},
    { city: 'Schipkau', zip: '01994'},
    { city: 'Zinnowitz', zip: '17454'},
    { city: 'Sebnitz', zip: '01855'},
    { city: 'Frankfurt/ Oder', zip: '15234'},
    { city: 'Emmerich am Rhein', zip: '46446'},
    { city: 'Schwalmtal', zip: '41366'},
    { city: 'Heimbach', zip: '52396'},
    { city: 'Mönchengladbach', zip: '41063'},
    { city: 'Mönchengladbach', zip: '41199'},
    { city: 'Düren', zip: '52349'},
    { city: 'Mönchengladbach', zip: '41061'},
    { city: 'Grevenbroich', zip: '41517'},
    { city: 'Trierweiler', zip: '54311'},
    { city: 'Grevenbroich', zip: '41515'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Rhede', zip: '46414'},
    { city: 'Duisburg', zip: '47226'},
    { city: 'Weiskirchen', zip: '66709'},
    { city: 'Bettenfeld, Niederöfflingen u.a.', zip: '54533'},
    { city: 'Heusweiler', zip: '66265'},
    { city: 'Ratingen', zip: '40883'},
    { city: 'Deuselbach, Hermeskeil, Rorodt', zip: '54411'},
    { city: 'Köln', zip: '50939'},
    { city: 'Gronau', zip: '48599'},
    { city: 'Neuhütten', zip: '54422'},
    { city: 'Essen', zip: '45326'},
    { city: 'Essen', zip: '45257'},
    { city: 'Weißenthurm', zip: '56575'},
    { city: 'Rheine', zip: '48429'},
    { city: 'Emsdetten', zip: '48282'},
    { city: 'Börger', zip: '26904'},
    { city: 'Boppard', zip: '56154'},
    { city: 'Mittelbrunn, Queidersbach u.a.', zip: '66851'},
    { city: 'Koblenz', zip: '56072'},
    { city: 'Hagen', zip: '58093'},
    { city: 'Dortmund', zip: '44329'},
    { city: 'Kierspe', zip: '58566'},
    { city: 'Bergisch Gladbach', zip: '51467'},
    { city: 'Mandelbachtal', zip: '66399'},
    { city: 'Wuppertal', zip: '42103'},
    { city: 'Herne', zip: '44651'},
    { city: 'Bochum', zip: '44793'},
    { city: 'Bochum', zip: '44809'},
    { city: 'Wuppertal', zip: '42277'},
    { city: 'Bochum', zip: '44801'},
    { city: 'Lindlar', zip: '51789'},
    { city: 'Schwelm', zip: '58332'},
    { city: 'Altenkirchen', zip: '66903'},
    { city: 'Dortmund', zip: '44149'},
    { city: 'Neubörger, Neulehe', zip: '26909'},
    { city: 'Niederwörresbach', zip: '55758'},
    { city: 'Kastellaun', zip: '56288'},
    { city: 'Pfeffelbach', zip: '66871'},
    { city: 'Olsberg', zip: '59939'},
    { city: 'Otterstadt', zip: '67166'},
    { city: 'Bad Endbach', zip: '35080'},
    { city: 'Verl', zip: '33415'},
    { city: 'Simmersfeld', zip: '72226'},
    { city: 'Mannheim', zip: '68163'},
    { city: 'Dobel', zip: '75335'},
    { city: 'Brilon', zip: '59929'},
    { city: 'Villingen-Schwenningen', zip: '78054'},
    { city: 'Bruchsal', zip: '76646'},
    { city: 'Villingen-Schwenningen', zip: '78056'},
    { city: 'Bielefeld', zip: '33611'},
    { city: 'Langeneß', zip: '25863'},
    { city: 'Schwetzingen', zip: '68723'},
    { city: 'Bremerhaven', zip: '27570'},
    { city: 'Geisingen', zip: '78187'},
    { city: 'Rosbach v.d. Höhe', zip: '61191'},
    { city: 'Rauenberg', zip: '69231'},
    { city: 'Frankfurt', zip: '60308'},
    { city: 'Heidelberg', zip: '69126'},
    { city: 'Seitingen-Oberflacht', zip: '78606'},
    { city: 'Fürth', zip: '64658'},
    { city: 'Groß-Zimmern', zip: '64846'},
    { city: 'Sinsheim', zip: '74889'},
    { city: 'Wimsheim', zip: '71299'},
    { city: 'Lilienthal', zip: '28865'},
    { city: 'Maasen, Mellinghausen', zip: '27249'},
    { city: 'Bremen', zip: '28329'},
    { city: 'Twistetal', zip: '34477'},
    { city: 'Riede', zip: '27339'},
    { city: 'Hainburg', zip: '63512'},
    { city: 'Seligenstadt', zip: '63500'},
    { city: 'Bad Arolsen', zip: '34454'},
    { city: 'Pfaffenhofen', zip: '74397'},
    { city: 'Mittelstenahe', zip: '21770'},
    { city: 'Böblingen', zip: '71032'},
    { city: 'Waldbrunn', zip: '69429'},
    { city: 'Alzenau', zip: '63755'},
    { city: 'Schönaich', zip: '71101'},
    { city: 'Schweringen, Warpe, Bücken', zip: '27333'},
    { city: 'Reichenau', zip: '78479'},
    { city: 'Obernkirchen', zip: '31683'},
    { city: 'Rehburg-Loccum', zip: '31547'},
    { city: 'Stuttgart', zip: '70597'},
    { city: 'Konstanz', zip: '78462'},
    { city: 'Krummendeich', zip: '21732'},
    { city: 'Reutlingen', zip: '72764'},
    { city: 'Zierenberg', zip: '34289'},
    { city: 'Fellbach', zip: '70736'},
    { city: 'Apelern, Rodenberg', zip: '31552'},
    { city: 'Linsburg', zip: '31636'},
    { city: 'Marbach am Neckar', zip: '71672'},
    { city: 'Bad Urach', zip: '72574'},
    { city: 'Langenbrettach', zip: '74243'},
    { city: 'Walsrode, Ostenholz', zip: '29664'},
    { city: 'Hameln', zip: '31789'},
    { city: 'Friedrichshafen', zip: '88048'},
    { city: 'Baltmannsweiler', zip: '73666'},
    { city: 'Holzminden', zip: '37603'},
    { city: 'Biberach an der Riß', zip: '88400'},
    { city: 'Hannover', zip: '30449'},
    { city: 'Pinneberg', zip: '25421'},
    { city: 'Öpfingen', zip: '89614'},
    { city: 'Bad Wurzach', zip: '88410'},
    { city: 'Eschach, Obergröningen', zip: '73569'},
    { city: 'Maselheim', zip: '88437'},
    { city: 'Wasbek', zip: '24647'},
    { city: 'Niederstetten', zip: '97996'},
    { city: 'Timmaspe', zip: '24644'},
    { city: 'Hildesheim', zip: '31139'},
    { city: 'Wiemersdorf', zip: '24649'},
    { city: 'Hamburg', zip: '22761'},
    { city: 'Riedenheim', zip: '97283'},
    { city: 'Wehretal', zip: '37287'},
    { city: 'Gutenzell-Hürbel', zip: '88484'},
    { city: 'Heuchlingen', zip: '73572'},
    { city: 'Hamburg', zip: '22455'},
    { city: 'Mögglingen', zip: '73563'},
    { city: 'Beimerstetten', zip: '89179'},
    { city: 'Göttingen', zip: '37085'},
    { city: 'Hamburg', zip: '20259'},
    { city: 'Winterhausen', zip: '97286'},
    { city: 'Marxen', zip: '21439'},
    { city: 'Hamburg', zip: '20099'},
    { city: 'Hartenholm', zip: '24628'},
    { city: 'Tannheim', zip: '88459'},
    { city: 'Seth', zip: '23845'},
    { city: 'Tangstedt', zip: '22889'},
    { city: 'Hamburg', zip: '22149'},
    { city: 'Wriedel', zip: '29565'},
    { city: 'Asselfingen', zip: '89176'},
    { city: 'Eisenach', zip: '99817'},
    { city: 'Schwallungen', zip: '98590'},
    { city: 'Memmingerberg', zip: '87766'},
    { city: 'Trittau', zip: '22946'},
    { city: 'Burgberg im Allgäu', zip: '87545'},
    { city: 'Aumühle', zip: '21521'},
    { city: 'Gundelfingen a.d. Donau', zip: '89423'},
    { city: 'Kempten (Allgäu)', zip: '87435'},
    { city: 'Vogtei, Kammerforst u.a.', zip: '99986'},
    { city: 'Winsen', zip: '21423'},
    { city: 'Leutershausen', zip: '91578'},
    { city: 'Steinburg', zip: '22964'},
    { city: 'Haldenwang', zip: '89356'},
    { city: 'Höheinöd, Petersberg u.a.', zip: '66989'},
    { city: 'Eimeldingen', zip: '79591'},
    { city: 'Hargesheim', zip: '55595'},
    { city: 'Osterspai', zip: '56340'},
    { city: 'Pracht', zip: '57589'},
    { city: 'Weitersburg', zip: '56191'},
    { city: 'Nauort', zip: '56237'},
    { city: 'Rümmingen', zip: '79595'},
    { city: 'Oberwesel', zip: '55430'},
    { city: 'Wissen, Hövels u.a.', zip: '57537'},
    { city: 'Dierdorf', zip: '56269'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Kenzingen', zip: '79341'},
    { city: 'Neuenrade', zip: '58809'},
    { city: 'Umkirch', zip: '79224'},
    { city: 'Meißenheim', zip: '77974'},
    { city: 'Hallgarten', zip: '67826'},
    { city: 'Singhofen', zip: '56379'},
    { city: 'Ehingen a. Ries', zip: '86741'},
    { city: 'Höchstädt a.d. Donau', zip: '89420'},
    { city: 'Wolfenbüttel', zip: '38302'},
    { city: 'Emmendorf', zip: '29579'},
    { city: 'Markt Wald', zip: '86865'},
    { city: 'Neetze', zip: '21398'},
    { city: 'Horgau', zip: '86497'},
    { city: 'Bokensdorf', zip: '38556'},
    { city: 'Ratzeburg', zip: '23909'},
    { city: 'Lübeck Schlutup/St. Gertrud', zip: '23568'},
    { city: 'Fünfstetten', zip: '86681'},
    { city: 'Nahrendorf', zip: '21369'},
    { city: 'Tiddische', zip: '38473'},
    { city: 'Schwabbruck', zip: '86986'},
    { city: 'Puschendorf', zip: '90617'},
    { city: 'Augsburg', zip: '86156'},
    { city: 'Bamberg', zip: '96052'},
    { city: 'Kaufering', zip: '86916'},
    { city: 'Heßdorf', zip: '91093'},
    { city: 'Danndorf', zip: '38461'},
    { city: 'Coburg', zip: '96450'},
    { city: 'Grömitz', zip: '23743'},
    { city: 'Rögling', zip: '86703'},
    { city: 'Mering', zip: '86415'},
    { city: 'Niederfüllbach', zip: '96489'},
    { city: 'Menden', zip: '58710'},
    { city: 'Hauenstein', zip: '76846'},
    { city: 'Wittnau', zip: '79299'},
    { city: 'Waldleiningen, Fischbach', zip: '67693'},
    { city: 'Horben', zip: '79289'},
    { city: 'Ahlen', zip: '59229'},
    { city: 'Bellingen, Kölbingen, Gemünden u.a.', zip: '56459'},
    { city: 'Bösel', zip: '26219'},
    { city: 'Hagen am Teutoburger Wald', zip: '49170'},
    { city: 'Gau-Bickelheim', zip: '55599'},
    { city: 'Hasbergen', zip: '49205'},
    { city: 'Eltville am Rhein', zip: '65346'},
    { city: 'Bad Bergzabern u.a.', zip: '76887'},
    { city: 'Osnabrück', zip: '49084'},
    { city: 'Oberharmersbach', zip: '77784'},
    { city: 'Eltville am Rhein', zip: '65344'},
    { city: 'Forst an der Weinstraße', zip: '67147'},
    { city: 'Bohmte', zip: '49163'},
    { city: 'Meckenheim', zip: '67149'},
    { city: 'Borgholzhausen', zip: '33829'},
    { city: 'Birkenheide', zip: '67134'},
    { city: 'Mainz', zip: '55131'},
    { city: 'Beindersheim', zip: '67259'},
    { city: 'Diepholz', zip: '49356'},
    { city: 'Braunfels', zip: '35619'},
    { city: 'Guntersblum', zip: '67583'},
    { city: 'Bischofsheim', zip: '65474'},
    { city: 'Notzingen', zip: '73274'},
    { city: 'Immenhausen', zip: '34376'},
    { city: 'Flieden', zip: '36103'},
    { city: 'Mehrstetten', zip: '72537'},
    { city: 'Morschen', zip: '34326'},
    { city: 'Triefenstein', zip: '97855'},
    { city: 'Holzen, Eschershausen, Eimen', zip: '37632'},
    { city: 'Hamweddel', zip: '24816'},
    { city: 'Garbsen', zip: '30827'},
    { city: 'Oberstadion', zip: '89613'},
    { city: 'Grafing b. München', zip: '85567'},
    { city: 'Südliches Anhalt u.a.', zip: '06369'},
    { city: 'Rostock, Papendorf u.a.', zip: '18059'},
    { city: 'Brahmenau', zip: '07554'},
    { city: 'Marktredwitz', zip: '95615'},
    { city: 'Pfaffing', zip: '83539'},
    { city: 'Edling', zip: '83533'},
    { city: 'Reuth b. Erbendorf', zip: '92717'},
    { city: 'Plau am See', zip: '19395'},
    { city: 'Dessau-Roßlau', zip: '06861'},
    { city: 'Wasserburg a. Inn', zip: '83512'},
    { city: 'Schonstett', zip: '83137'},
    { city: 'Altenthann', zip: '93177'},
    { city: 'Malchow u.a.', zip: '17213'},
    { city: 'Roding', zip: '93426'},
    { city: 'Oberviechtach', zip: '92526'},
    { city: 'Waldkraiburg', zip: '84478'},
    { city: 'Zwickau', zip: '08060'},
    { city: 'Dahmen, Groß Wokern, Teterow', zip: '17166'},
    { city: 'Leipzig', zip: '04328'},
    { city: 'Borna', zip: '04552'},
    { city: 'Feldkirchen', zip: '94351'},
    { city: 'Mülsen', zip: '08132'},
    { city: 'Friesack', zip: '14662'},
    { city: 'Reinsdorf', zip: '08141'},
    { city: 'Pösing', zip: '93483'},
    { city: 'Reisbach', zip: '94419'},
    { city: 'Unterneukirchen', zip: '84579'},
    { city: 'Stallwang', zip: '94375'},
    { city: 'Hunderdorf', zip: '94336'},
    { city: 'Glewitz', zip: '18513'},
    { city: 'Hebertsfelden', zip: '84332'},
    { city: 'Kollnburg', zip: '94262'},
    { city: 'Offenberg', zip: '94560'},
    { city: 'Chemnitz', zip: '09123'},
    { city: 'Ainring', zip: '83404'},
    { city: 'Möllenbeck', zip: '17237'},
    { city: 'Grafling', zip: '94539'},
    { city: 'Loitz', zip: '17121'},
    { city: 'Bärenstein', zip: '09471'},
    { city: 'Fürstenberg', zip: '16798'},
    { city: 'Großolbersdorf', zip: '09432'},
    { city: 'Auerbach', zip: '94530'},
    { city: 'Stralsund', zip: '18439'},
    { city: 'Schöllnach', zip: '94508'},
    { city: 'Windorf', zip: '94575'},
    { city: 'Pocking', zip: '94060'},
    { city: 'Olbernhau, Pfaffroda, Heidersdorf', zip: '09526'},
    { city: 'Berlin Charlottenburg-Nord', zip: '13627'},
    { city: 'Berlin Lichtenfelde', zip: '12205'},
    { city: 'Berlin Wilmersdorf', zip: '14197'},
    { city: 'Greifswald', zip: '17493'},
    { city: 'Neukirchen vorm Wald', zip: '94154'},
    { city: 'Berlin Tiergarten', zip: '10785'},
    { city: 'Berlin Kreuzberg', zip: '10967'},
    { city: 'Ingolstadt', zip: '85055'},
    { city: 'Vorra', zip: '91247'},
    { city: 'Leezen', zip: '19067'},
    { city: 'München', zip: '80686'},
    { city: 'München', zip: '80637'},
    { city: 'Gaißach', zip: '83674'},
    { city: 'Neukirchen b. Sulzbach-Rosen', zip: '92259'},
    { city: 'Freyburg, Balgstädt', zip: '06632'},
    { city: 'Saalburg-Ebersdorf', zip: '07929'},
    { city: 'München', zip: '81677'},
    { city: 'Naila', zip: '95119'},
    { city: 'München', zip: '81929'},
    { city: 'Ottobrunn/Riemerling', zip: '85521'},
    { city: 'Ismaning', zip: '85737'},
    { city: 'Neuengönna u.a.', zip: '07778'},
    { city: 'Putzbrunn', zip: '85640'},
    { city: 'Aying', zip: '85653'},
    { city: 'Bad Berneck im Fichtelgebirge', zip: '95460'},
    { city: 'Rottach-Egern', zip: '83700'},
    { city: 'Egmating', zip: '85658'},
    { city: 'Eitting', zip: '85462'},
    { city: 'Gebenbach', zip: '92274'},
    { city: 'Hof', zip: '95032'},
    { city: 'Auma-Weidatal', zip: '07955'},
    { city: 'Ebersdorf b. Coburg', zip: '96237'},
    { city: 'Michelau i. OFr.', zip: '96247'},
    { city: 'Hattenhofen', zip: '82285'},
    { city: 'Wiesenthau', zip: '91369'},
    { city: 'Damnatz', zip: '29472'},
    { city: 'Kühbach', zip: '86556'},
    { city: 'Gusborn', zip: '29476'},
    { city: 'Wiesenttal', zip: '91346'},
    { city: 'Berg im Gau', zip: '86562'},
    { city: 'Weimar', zip: '99427'},
    { city: 'Leinburg', zip: '91227'},
    { city: 'Ludwigsstadt', zip: '96337'},
    { city: 'Hohenwart', zip: '86558'},
    { city: 'Unterwellenborn', zip: '07333'},
    { city: 'Nusse', zip: '23896'},
    { city: 'Braunschweig', zip: '38104'},
    { city: 'Arberg', zip: '91722'},
    { city: 'Sondershausen', zip: '99706'},
    { city: 'Gotha', zip: '99867'},
    { city: 'Wittingen', zip: '29379'},
    { city: 'Mölln', zip: '23879'},
    { city: 'Kasseedorf', zip: '23717'},
    { city: 'Laugna', zip: '86502'},
    { city: 'Meitingen', zip: '86405'},
    { city: 'Ehingen', zip: '86678'},
    { city: 'Lensahn', zip: '23738'},
    { city: 'Altenstadt', zip: '86972'},
    { city: 'Erfurt', zip: '99090'},
    { city: 'Marxheim', zip: '86688'},
    { city: 'Ellingen', zip: '91792'},
    { city: 'Augsburg', zip: '86159'},
    { city: 'Augsburg', zip: '86167'},
    { city: 'Untersiemau', zip: '96253'},
    { city: 'Gadebusch', zip: '19205'},
    { city: 'Möhrendorf/Mark', zip: '91096'},
    { city: 'Fürth', zip: '90763'},
    { city: 'Nürnberg', zip: '90449'},
    { city: 'Neuhaus am Rennweg, Lauscha', zip: '98724'},
    { city: 'Berlin Neukölln', zip: '12055'},
    { city: 'Großenhain', zip: '01558'},
    { city: 'Berlin Lichtenberg', zip: '10365'},
    { city: 'Lubmin', zip: '17509'},
    { city: 'Berlin Neu-Schönhausen', zip: '13051'},
    { city: 'Hartmannsdorf-Reichenau', zip: '01762'},
    { city: 'Uckerland, Groß Luckow, Schönhausen', zip: '17337'},
    { city: 'Heidesee', zip: '15754'},
    { city: 'Eberswalde', zip: '16227'},
    { city: 'Briesen, Rauen u.a.', zip: '15518'},
    { city: 'Peitz', zip: '03185'},
    { city: 'Doberschau-Gaußig, Großpostwitz, Obergurig', zip: '02692'},
    { city: 'Seifhennersdorf', zip: '02782'},
    { city: 'Kottmar', zip: '02739'},
    { city: 'Hamm', zip: '67580'},
    { city: 'Mannheim', zip: '68305'},
    { city: 'Kelsterbach', zip: '65451'},
    { city: 'Neu-Anspach', zip: '61267'},
    { city: 'Weingarten', zip: '76356'},
    { city: 'Pfinztal', zip: '76327'},
    { city: 'Mörfelden-Walldorf', zip: '64546'},
    { city: 'Geestland', zip: '27607'},
    { city: 'Neuenbürg', zip: '75305'},
    { city: 'Jestetten', zip: '79798'},
    { city: 'Höfen an der Enz', zip: '75339'},
    { city: 'Rodenäs', zip: '25924'},
    { city: 'Bielefeld', zip: '33699'},
    { city: 'Frankfurt am Main', zip: '65933'},
    { city: 'Bremerhaven', zip: '27578'},
    { city: 'Darmstadt', zip: '64293'},
    { city: 'Sandhausen', zip: '69207'},
    { city: 'Tengen', zip: '78250'},
    { city: 'Wünnenberg', zip: '33181'},
    { city: 'Bremerhaven', zip: '27578'},
    { city: 'Cuxhaven', zip: '27474'},
    { city: 'Empfingen', zip: '72186'},
    { city: 'Friedrichskoog', zip: '25718'},
    { city: 'Geislingen', zip: '72351'},
    { city: 'Angelbachtal', zip: '74918'},
    { city: 'Wurmlingen', zip: '78573'},
    { city: 'Heiligkreuzsteinach', zip: '69253'},
    { city: 'Bremen', zip: '28219'},
    { city: 'Wölfersheim', zip: '61200'},
    { city: 'Meckesheim', zip: '74909'},
    { city: 'Gäufelden', zip: '71126'},
    { city: 'Detmold', zip: '32760'},
    { city: 'Hungen', zip: '35410'},
    { city: 'Hausen am Tann', zip: '72361'},
    { city: 'Eppingen', zip: '75031'},
    { city: 'Brensbach', zip: '64395'},
    { city: 'Spechbach', zip: '74937'},
    { city: 'Hirrlingen', zip: '72145'},
    { city: 'Weissach', zip: '71287'},
    { city: 'Siedenburg, Staffhorst', zip: '27254'},
    { city: 'Beuron', zip: '88631'},
    { city: 'Waldeck', zip: '34513'},
    { city: 'Schwarzach', zip: '74869'},
    { city: 'Heide u.a.', zip: '25746'},
    { city: 'Mössingen', zip: '72116'},
    { city: 'Hüffenhardt', zip: '74928'},
    { city: 'Winterlingen', zip: '72474'},
    { city: 'Amorbach', zip: '63916'},
    { city: 'Reichenau', zip: '78479'},
    { city: 'Inzigkofen', zip: '72514'},
    { city: 'Aschaffenburg', zip: '63743'},
    { city: 'Klingenberg a. Main', zip: '63911'},
    { city: 'Löwenstedt', zip: '25864'},
    { city: 'Elztal', zip: '74834'},
    { city: 'Stuttgart', zip: '70173'},
    { city: 'Steinheim, Murr', zip: '71711'},
    { city: 'Lichtenstein', zip: '72805'},
    { city: 'Schefflenz', zip: '74850'},
    { city: 'Neustadt am Rübenberge', zip: '31535'},
    { city: 'Frielendorf', zip: '34621'},
    { city: 'Wohlde', zip: '24899'},
    { city: 'Hameln', zip: '31787'},
    { city: 'Tarp', zip: '24963'},
    { city: 'Frammersbach', zip: '97833'},
    { city: 'Wendlingen am Neckar', zip: '73240'},
    { city: 'Ellingstedt', zip: '24870'},
    { city: 'Ertingen', zip: '88521'},
    { city: 'Hameln', zip: '31789'},
    { city: 'Sieverstedt', zip: '24885'},
    { city: 'Monschau', zip: '52156'},
    { city: 'Stolberg (Rhld.)', zip: '52222'},
    { city: 'Mönchengladbach', zip: '41068'},
    { city: 'Ayl, Trassem u.a.', zip: '54441'},
    { city: 'Büdesheim', zip: '54610'},
    { city: 'Duisburg', zip: '47239'},
    { city: 'Duisburg', zip: '47259'},
    { city: 'Neuss', zip: '41466'},
    { city: 'Saarwellingen', zip: '66793'},
    { city: 'Leiwen u.a.', zip: '54340'},
    { city: 'Barweiler, Bauler, Hoffeld, Pomster, Wiesemscheid, Wirft', zip: '53534'},
    { city: 'Bodenbach, Kelberg, Kirsbach u.a.', zip: '53539'},
    { city: 'Köln', zip: '50933'},
    { city: 'Bottrop', zip: '46242'},
    { city: 'Saarbrücken', zip: '66126'},
    { city: 'Esche, Georgsdorf, Lage, Neuenhaus, Osterwald', zip: '49828'},
    { city: 'Leverkusen', zip: '51373'},
    { city: 'Malborn', zip: '54426'},
    { city: 'Velbert', zip: '42553'},
    { city: 'Gelsenkirchen', zip: '45881'},
    { city: 'Wedel', zip: '22880'},
    { city: 'Urspringen', zip: '97857'},
    { city: 'Hollenstedt, Drestedt u.a.', zip: '21279'},
    { city: 'Zellingen', zip: '97225'},
    { city: 'Bargstedt, Brammer, Oldenbüttel', zip: '24793'},
    { city: 'Gronau (Leine)', zip: '31028'},
    { city: 'Großalmerode', zip: '37247'},
    { city: 'Michelbach an der Bilz', zip: '74544'},
    { city: 'Witzenhausen', zip: '37213'},
    { city: 'Rabenkirchen-Faulück', zip: '24407'},
    { city: 'Kirchheim', zip: '97268'},
    { city: 'Göggingen', zip: '73571'},
    { city: 'Würzburg', zip: '97082'},
    { city: 'Großenaspe', zip: '24623'},
    { city: 'Leutkirch im Allgäu', zip: '88299'},
    { city: 'Göttingen', zip: '37073'},
    { city: 'Hamburg', zip: '22453'},
    { city: 'Wasserlosen', zip: '97535'},
    { city: 'Hamburg', zip: '22301'},
    { city: 'Neuler', zip: '73491'},
    { city: 'Hamburg', zip: '22307'},
    { city: 'Wasungen', zip: '98634'},
    { city: 'Kiel', zip: '24113'},
    { city: 'Gieboldehausen, Rhumequelle', zip: '37434'},
    { city: 'Dermbach, Wiesenthal', zip: '36466'},
    { city: 'Wanfried', zip: '37281'},
    { city: 'Bargfeld-Stegen', zip: '23863'},
    { city: 'Ilsede', zip: '31241'},
    { city: 'Kötz', zip: '89359'},
    { city: 'Aumühle', zip: '21521'},
    { city: 'Wildemann', zip: '38709'},
    { city: 'Tremsbüttel', zip: '22967'},
    { city: 'Suderburg', zip: '29556'},
    { city: 'Mindelheim', zip: '87719'},
    { city: 'Burghaslach', zip: '96152'},
    { city: 'Maihingen', zip: '86747'},
    { city: 'Winnweiler', zip: '67722'},
    { city: 'Au (Breisgau)', zip: '79280'},
    { city: 'Wickede (Ruhr)', zip: '58739'},
    { city: 'Schutterwald', zip: '77746'},
    { city: 'Hamm', zip: '59071'},
    { city: 'Freiburg im Breisgau', zip: '79104'},
    { city: 'Alpenrod', zip: '57642'},
    { city: 'Schönborn', zip: '56370'},
    { city: 'Nisterau u.a.', zip: '56472'},
    { city: 'Welver', zip: '59514'},
    { city: 'Frankenstein, Neidenfels, Frankeneck', zip: '67468'},
    { city: 'Ortenberg', zip: '77799'},
    { city: 'Gengenbach', zip: '77723'},
    { city: 'Sankt Peter', zip: '79271'},
    { city: 'Osnabrück', zip: '49080'},
    { city: 'Varel', zip: '26316'},
    { city: 'Edenkoben', zip: '67480'},
    { city: 'Elbtal', zip: '65627'},
    { city: 'Emstek', zip: '49685'},
    { city: 'Oldenburg (Oldenburg)', zip: '26131'},
    { city: 'Schönwald im Schwarzwald', zip: '78141'},
    { city: 'Au am Rhein', zip: '76474'},
    { city: 'Mommenheim', zip: '55278'},
    { city: 'Ober-Olm', zip: '55270'},
    { city: 'Zeiskam', zip: '67378'},
    { city: 'Bischweier', zip: '76476'},
    { city: 'Leun', zip: '35638'},
    { city: 'Böhl-Iggelheim', zip: '67459'},
    { city: 'Gütersloh', zip: '33334'},
    { city: 'Eppstein', zip: '65817'},
    { city: 'Weisenbach', zip: '76599'},
    { city: 'Ettlingen', zip: '76275'},
    { city: 'List', zip: '25992'},
    { city: 'Kelkheim', zip: '65779'},
    { city: 'Berne', zip: '27804'},
    { city: 'Hasloch', zip: '97907'},
    { city: 'Ahorn', zip: '74744'},
    { city: 'Tettnang', zip: '88069'},
    { city: 'Kressbronn am Bodensee', zip: '88079'},
    { city: 'Welzheim', zip: '73642'},
    { city: 'Regesbostel', zip: '21649'},
    { city: 'Schneverdingen, Heimbuch', zip: '29640'},
    { city: 'Elze', zip: '31008'},
    { city: 'Hohenstadt/Drackenstein', zip: '73345'},
    { city: 'Bergisch Gladbach', zip: '51467'},
    { city: 'Düngenheim', zip: '56761'},
    { city: 'Bergisch Gladbach', zip: '51427'},
    { city: 'Bonn', zip: '53129'},
    { city: 'Mayen', zip: '56727'},
    { city: 'Niederzissen', zip: '56651'},
    { city: 'Rösrath', zip: '51503'},
    { city: 'Gersheim', zip: '66453'},
    { city: 'Hattingen', zip: '45525'},
    { city: 'Idar-Oberstein', zip: '55743'},
    { city: 'Hennef (Sieg)', zip: '53773'},
    { city: 'Fischingen', zip: '79592'},
    { city: 'Lauterecken u.a.', zip: '67742'},
    { city: 'Iserlohn', zip: '58644'},
    { city: 'Odernheim am Glan', zip: '55571'},
    { city: 'Menslage', zip: '49637'},
    { city: 'Norheim u.a.', zip: '55585'},
    { city: 'Dernbach (Westerwald)', zip: '56428'},
    { city: 'Freiburg im Breisgau', zip: '79110'},
    { city: 'Ihlow', zip: '26632'},
    { city: 'Lingen', zip: '49811'},
    { city: 'Müden', zip: '56254'},
    { city: 'Brücken (Pfalz)', zip: '66904'},
    { city: 'Hagen', zip: '58135'},
    { city: 'Herschweiler-Pettersheim', zip: '66909'},
    { city: 'Langweiler', zip: '67746'},
    { city: 'Steinwenden u.a.', zip: '66879'},
    { city: 'Wildenbungert, Gondershausen, Nörtershausen u.a.', zip: '56283'},
    { city: 'Blomberg, Neuschoo', zip: '26487'},
    { city: 'Offenbach-Hundheim', zip: '67749'},
    { city: 'Birnbach', zip: '57612'},
    { city: 'Fischbachau', zip: '83730'},
    { city: 'Frauenneuharting', zip: '83553'},
    { city: 'Schmidgaden', zip: '92546'},
    { city: 'Jößnitz', zip: '08547'},
    { city: 'Neustadt (Dosse) u.a.', zip: '16845'},
    { city: 'Dessau-Roßlau', zip: '06846'},
    { city: 'Delitzsch, Krostitz u.a.', zip: '04509'},
    { city: 'Dessau-Roßlau', zip: '06862'},
    { city: 'Schwarzhofen', zip: '92447'},
    { city: 'Heldenstein', zip: '84431'},
    { city: 'Aschau a. Inn', zip: '84544'},
    { city: 'Klingenthal', zip: '08267'},
    { city: 'Zwickau', zip: '08064'},
    { city: 'Brandenburg/Havel', zip: '14776'},
    { city: 'Wilkau-Haßlau', zip: '08112'},
    { city: 'Gnoien u.a.', zip: '17179'},
    { city: 'Grimma', zip: '04668'},
    { city: 'Hartenstein', zip: '08118'},
    { city: 'Dargun', zip: '17159'},
    { city: 'Scheibenberg', zip: '09481'},
    { city: 'Schwielowswee', zip: '14548'},
    { city: 'Wittenhagen', zip: '18510'},
    { city: 'Chemnitz', zip: '09112'},
    { city: 'Chemnitz', zip: '09111'},
    { city: 'Chemnitz', zip: '09128'},
    { city: 'Hainichen, Rossau, Striegistal', zip: '09661'},
    { city: 'Wolkenstein', zip: '09429'},
    { city: 'Vilshofen an der Donau', zip: '94474'},
    { city: 'Berlin', zip: '12279'},
    { city: 'Berlin Tempelhof', zip: '12103'},
    { city: 'Rangsdorf', zip: '15834'},
    { city: 'Woldegk', zip: '17348'},
    { city: 'Berlin Mariendorf', zip: '12107'},
    { city: 'Friedland', zip: '17098'},
    { city: 'Süderbrarup', zip: '24392'},
    { city: 'Bad Überkingen', zip: '73337'},
    { city: 'Hannover', zip: '30159'},
    { city: 'Wolfegg', zip: '88364'},
    { city: 'Ellerhoop', zip: '25373'},
    { city: 'Einbeck, Kreiensen', zip: '37574'},
    { city: 'Hamburg', zip: '22587'},
    { city: 'Witzenhausen', zip: '37218'},
    { city: 'Ehingen (Donau), Lauterach', zip: '89584'},
    { city: 'Padenstedt', zip: '24634'},
    { city: 'Bad Sooden-Allendorf', zip: '37242'},
    { city: 'Ellerau', zip: '25479'},
    { city: 'Dörphof', zip: '24398'},
    { city: 'Würzburg', zip: '97084'},
    { city: 'Bischofsheim a.d. Rhön', zip: '97653'},
    { city: 'Hamburg', zip: '22529'},
    { city: 'Tann', zip: '36142'},
    { city: 'Ringgau', zip: '37296'},
    { city: 'Hamburg', zip: '22419'},
    { city: 'Erolzheim', zip: '88453'},
    { city: 'Meinhard', zip: '37276'},
    { city: 'Hamburg', zip: '22087'},
    { city: 'Hamburg', zip: '20535'},
    { city: 'Oberkochen', zip: '73447'},
    { city: 'Ostheim v.d. Rhön', zip: '97645'},
    { city: 'Prosselsheim', zip: '97279'},
    { city: 'Nettelsee', zip: '24250'},
    { city: 'Kiel', zip: '24143'},
    { city: 'Osterberg', zip: '89296'},
    { city: 'Hamburg', zip: '21031'},
    { city: 'Schillingsfürst', zip: '91583'},
    { city: 'Unterlüß', zip: '29345'},
    { city: 'Mönkeberg', zip: '24248'},
    { city: 'Mainbernheim', zip: '97350'},
    { city: 'Roggenburg', zip: '89297'},
    { city: 'Salzgitter', zip: '38228'},
    { city: 'Hamfelde, Kasseburg, Köthel, Rausdorf, Schönberg', zip: '22929'},
    { city: 'Aletshausen', zip: '86480'},
    { city: 'Durach', zip: '87471'},
    { city: 'Am Ohmberg, Sonnenstein', zip: '37345'},
    { city: 'Riedbach', zip: '97519'},
    { city: 'Jettingen-Scheppach', zip: '89343'},
    { city: 'Wittelshofen', zip: '91749'},
    { city: 'Adenbüttel', zip: '38528'},
    { city: 'Goslar', zip: '38642'},
    { city: 'Ipsheim', zip: '91472'},
    { city: 'Schladen-Werla', zip: '38315'},
    { city: 'Hohenaltheim', zip: '86745'},
    { city: 'Bad Harzburg, Torfhaus', zip: '38667'},
    { city: 'Stammham', zip: '85134'},
    { city: 'Pegnitz', zip: '91257'},
    { city: 'Heinersreuth', zip: '95500'},
    { city: 'Jena, Bucha, Großpürschütz u.a.', zip: '07751'},
    { city: 'Fahrenzhausen', zip: '85777'},
    { city: 'Geroldsgrün', zip: '95179'},
    { city: 'Neubukow, Ravensberg u.a.', zip: '18233'},
    { city: 'München', zip: '81675'},
    { city: 'Pförring', zip: '85104'},
    { city: 'München', zip: '81825'},
    { city: 'Nienburg (Saale)', zip: '06429'},
    { city: 'Zell', zip: '95239'},
    { city: 'Gommern, Dannigkow', zip: '39245'},
    { city: 'Perleberg, Berge u.a.', zip: '19348'},
    { city: 'Osternienburger Land', zip: '06386'},
    { city: 'Rückholz', zip: '87494'},
    { city: 'Ruderatshofen', zip: '87674'},
    { city: 'Georgenthal/ Thür. Wald', zip: '99887'},
    { city: 'Denkte', zip: '38321'},
    { city: 'Munningen', zip: '86754'},
    { city: 'Dietenhofen', zip: '90599'},
    { city: 'Petersaurach', zip: '91580'},
    { city: 'Donauwörth', zip: '86609'},
    { city: 'Suhlendorf', zip: '29562'},
    { city: 'Wilhermsdorf', zip: '91452'},
    { city: 'Adelsried', zip: '86477'},
    { city: 'Welden', zip: '86465'},
    { city: 'Ehra-Lessien', zip: '38468'},
    { city: 'Barwedel', zip: '38476'},
    { city: 'Theilenhofen', zip: '91741'},
    { city: 'Absberg', zip: '91720'},
    { city: 'Weitramsdorf', zip: '96479'},
    { city: 'Langenaltheim', zip: '91799'},
    { city: 'Ahorn', zip: '96482'},
    { city: 'Breitengüßbach', zip: '96149'},
    { city: 'Großheirath', zip: '96269'},
    { city: 'Halberstadt, Groß Quenstedt', zip: '38822'},
    { city: 'Schwabach', zip: '91126'},
    { city: 'Apfeldorf', zip: '86974'},
    { city: 'Strullendorf', zip: '96129'},
    { city: 'Oebisfelde', zip: '39646'},
    { city: 'Nürnberg', zip: '90453'},
    { city: 'Bubenreuth', zip: '91088'},
    { city: 'Ballenstedt, Harzgerode', zip: '06493'},
    { city: 'Nürnberg', zip: '90402'},
    { city: 'Hilpoltstein', zip: '91161'},
    { city: 'Eichstätt', zip: '85072'},
    { city: 'Hochstadt a. Main', zip: '96272'},
    { city: 'Heldrungen', zip: '06577'},
    { city: 'Schneckenlohe', zip: '96277'},
    { city: 'Weißenohe', zip: '91367'},
    { city: 'Habach', zip: '82392'},
    { city: 'Schwerin', zip: '19057'},
    { city: 'Dortmund', zip: '44143'},
    { city: 'Wallhalben u.a.', zip: '66917'},
    { city: 'Maßweiler', zip: '66506'},
    { city: 'Schwerte', zip: '58239'},
    { city: 'Koblenz', zip: '56070'},
    { city: 'Rhens', zip: '56321'},
    { city: 'Kleinmaischeid', zip: '56271'},
    { city: 'Berlin Rudow', zip: '12357'},
    { city: 'Hohenleipisch', zip: '04934'},
    { city: 'Berlin', zip: '12689'},
    { city: 'Neuenhagen, Hoppegarten', zip: '15366'},
    { city: 'Königs Wusterhausen', zip: '15713'},
    { city: 'Dresden', zip: '01099'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Dresden', zip: '01279'},
    { city: 'Schipkau', zip: '01998'},
    { city: 'Lieberose', zip: '15868'},
    { city: 'Spremberg, Tschernitz u.a.', zip: '03130'},
    { city: 'Ebersbach-Neugersdorf', zip: '02730'},
    { city: 'Enzklösterle', zip: '75337'},
    { city: 'Raunheim', zip: '65479'},
    { city: 'Hüfingen', zip: '78183'},
    { city: 'Hockenheim', zip: '68766'},
    { city: 'Viernheim', zip: '68519'},
    { city: 'Hirschberg an der Bergstraße', zip: '69493'},
    { city: 'Marburg', zip: '35041'},
    { city: 'Ehrenburg', zip: '27248'},
    { city: 'Dreieich', zip: '63303'},
    { city: 'Frankfurt am Main (Taunusturm)', zip: '60310'},
    { city: 'Pforzheim', zip: '75181'},
    { city: 'Marsberg', zip: '34431'},
    { city: 'Offenbach am Main', zip: '63069'},
    { city: 'Messel', zip: '64409'},
    { city: 'Dietzenbach', zip: '63128'},
    { city: 'Paderborn', zip: '33100'},
    { city: 'Bremen', zip: '28195'},
    { city: 'Gechingen', zip: '75391'},
    { city: 'Bremen', zip: '28215'},
    { city: 'Detmold', zip: '32756'},
    { city: 'Epfenbach', zip: '74925'},
    { city: 'Altenstadt', zip: '63674'},
    { city: 'Laubach', zip: '35321'},
    { city: 'Bad König', zip: '64732'},
    { city: 'Thedinghausen, Emtinghausen', zip: '27321'},
    { city: 'Bülkau', zip: '21782'},
    { city: 'Sindelfingen', zip: '71067'},
    { city: 'Martfeld, Schwarme', zip: '27327'},
    { city: 'Jungingen', zip: '72417'},
    { city: 'Friedrichstadt, Koldenbüttel u.a.', zip: '25840'},
    { city: 'Gomaringen', zip: '72810'},
    { city: 'Bietigheim-Bissingen', zip: '74321'},
    { city: 'Bad Zwesten', zip: '34596'},
    { city: 'Möglingen', zip: '71696'},
    { city: 'Alsfeld', zip: '36304'},
    { city: 'Altenriet', zip: '72657'},
    { city: 'Erlenbach', zip: '74235'},
    { city: 'Beverungen', zip: '37688'},
    { city: 'Engstingen', zip: '72829'},
    { city: 'Kleinkahl', zip: '63828'},
    { city: 'Esslingen am Neckar', zip: '73733'},
    { city: 'Bergenhusen', zip: '24861'},
    { city: 'Eichenbühl', zip: '63928'},
    { city: 'Hollingstedt', zip: '24876'},
    { city: 'Osterburken', zip: '74706'},
    { city: 'Altenbuch', zip: '97901'},
    { city: 'Kropp u.a.', zip: '24848'},
    { city: 'Fürstenberg', zip: '37699'},
    { city: 'Remshalden', zip: '73630'},
    { city: 'Flensburg', zip: '24937'},
    { city: 'Erkelenz', zip: '41812'},
    { city: 'Viersen', zip: '41748'},
    { city: 'Mönchengladbach', zip: '41061'},
    { city: 'Ralingen', zip: '54310'},
    { city: 'Merzig', zip: '66663'},
    { city: 'Gerolstein', zip: '54568'},
    { city: 'Kerpen', zip: '50171'},
    { city: 'Speicher', zip: '54662'},
    { city: 'Bocholt', zip: '46397'},
    { city: 'Duisburg', zip: '47199'},
    { city: 'Duisburg', zip: '47198'},
    { city: 'Dormagen', zip: '41542'},
    { city: 'Manderscheid', zip: '54531'},
    { city: 'Düsseldorf', zip: '40476'},
    { city: 'Mehring', zip: '54346'},
    { city: 'Ratingen', zip: '40878'},
    { city: 'Mettmann', zip: '40822'},
    { city: 'Retterath', zip: '56769'},
    { city: 'Haan', zip: '42781'},
    { city: 'Bonn', zip: '53117'},
    { city: 'Sasbachwalden', zip: '77887'},
    { city: 'Stadecken-Elsheim', zip: '55271'},
    { city: 'Großenkneten', zip: '26197'},
    { city: 'Brechen', zip: '65611'},
    { city: 'Waldshut-Tiengen', zip: '79761'},
    { city: 'Kindenheim', zip: '67271'},
    { city: 'Merenberg', zip: '35799'},
    { city: 'Ötigheim', zip: '76470'},
    { city: 'Jockgrim', zip: '76751'},
    { city: 'Wiesbaden', zip: '65191'},
    { city: 'Schiltach', zip: '77761'},
    { city: 'Lembruch, Burlage', zip: '49459'},
    { city: 'Wutöschingen', zip: '79793'},
    { city: 'Klettgau', zip: '79771'},
    { city: 'Loßburg', zip: '72290'},
    { city: 'Siegbach', zip: '35768'},
    { city: 'Grävenwiesbach', zip: '61279'},
    { city: 'Elsdorf-Westermühlen', zip: '24800'},
    { city: 'Springe', zip: '31832'},
    { city: 'Kassel', zip: '34127'},
    { city: 'Auenwald', zip: '71549'},
    { city: 'Esselbach', zip: '97839'},
    { city: 'Kreuzwertheim', zip: '97892'},
    { city: 'Owschlag u.a.', zip: '24811'},
    { city: 'Fulda', zip: '36041'},
    { city: 'Langballig', zip: '24977'},
    { city: 'Uetersen', zip: '25436'},
    { city: 'Westermoor', zip: '25597'},
    { city: 'Heidenau', zip: '21258'},
    { city: 'Schülp bei Rendsburg', zip: '24813'},
    { city: 'Kaisersbach', zip: '73667'},
    { city: 'Burghaun', zip: '36151'},
    { city: 'Westerrönfeld', zip: '24784'},
    { city: 'Rothselberg u.a.', zip: '67753'},
    { city: 'Grumbach', zip: '67745'},
    { city: 'Rodalben', zip: '66976'},
    { city: 'Berge, Bippen', zip: '49626'},
    { city: 'Kaiserslautern', zip: '67661'},
    { city: 'Lörrach', zip: '79539'},
    { city: 'Callbach', zip: '67829'},
    { city: 'Bötzingen', zip: '79268'},
    { city: 'Gottenheim', zip: '79288'},
    { city: 'Friesenhagen', zip: '51598'},
    { city: 'Nastätten u.a.', zip: '56355'},
    { city: 'Nentershausen, Hübingen, Niederelbert u.a.', zip: '56412'},
    { city: 'Singhofen', zip: '56379'},
    { city: 'Steinbach, Weitersweiler, Bennhausen, Mörsfeld, Würzweiler, Ruppertsecken u.a.', zip: '67808'},
    { city: 'Sölden', zip: '79294'},
    { city: 'Molbergen', zip: '49696'},
    { city: 'Lastrup', zip: '49688'},
    { city: 'Emmendingen', zip: '79312'},
    { city: 'Nister', zip: '57645'},
    { city: 'Scheuerfeld', zip: '57584'},
    { city: 'Sembach', zip: '67681'},
    { city: 'Bramsche', zip: '49565'},
    { city: 'Badbergen', zip: '49635'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Heidenrod', zip: '65321'},
    { city: 'Utzenfeld', zip: '79694'},
    { city: 'Todtmoos', zip: '79682'},
    { city: 'Osnabrück', zip: '49090'},
    { city: 'Dornburg', zip: '65599'},
    { city: 'Wallertheim', zip: '55578'},
    { city: 'Wilhelmshaven', zip: '26389'},
    { city: 'Armsheim', zip: '55288'},
    { city: 'Weisenheim am Sand', zip: '67256'},
    { city: 'Sasbach', zip: '77880'},
    { city: 'Wuppertal', zip: '42399'},
    { city: 'Nottuln', zip: '48301'},
    { city: 'Brohl-Lützing', zip: '56656'},
    { city: 'Baumholder', zip: '55774'},
    { city: 'Castrop-Rauxel', zip: '44577'},
    { city: 'Stavern', zip: '49777'},
    { city: 'Bergen', zip: '55608'},
    { city: 'Bundenbach', zip: '55626'},
    { city: 'Bechhofen', zip: '66894'},
    { city: 'Bullay, Alf, Zell', zip: '56859'},
    { city: 'Bergisch Gladbach', zip: '51465'},
    { city: 'Geeste', zip: '49744'},
    { city: 'Sustrum, Lathen u.a.', zip: '49762'},
    { city: 'Remscheid', zip: '42859'},
    { city: 'Overath', zip: '51491'},
    { city: 'Herne', zip: '44623'},
    { city: 'Herne', zip: '44627'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Hohenlinden', zip: '85664'},
    { city: 'Schwarzenbach', zip: '92720'},
    { city: 'Reimershagen, Lohmen, Zehna, Hägerfelde u.a.', zip: '18276'},
    { city: 'Pentling', zip: '93080'},
    { city: 'Regenstauf', zip: '93128'},
    { city: 'Gera', zip: '07552'},
    { city: 'Teublitz', zip: '93158'},
    { city: 'Taufkirchen (Vils)', zip: '84416'},
    { city: 'Schönwald', zip: '95173'},
    { city: 'Steinkirchen', zip: '84439'},
    { city: 'Gera', zip: '07546'},
    { city: 'Rosenheim', zip: '83022'},
    { city: 'Essenbach', zip: '84051'},
    { city: 'Dessau-Roßlau', zip: '06849'},
    { city: 'Leipzig', zip: '04178'},
    { city: 'Lucka', zip: '04613'},
    { city: 'Gars a. Inn', zip: '83555'},
    { city: 'Höslwang', zip: '83129'},
    { city: 'Fraureuth', zip: '08427'},
    { city: 'Leipzig', zip: '04229'},
    { city: 'Wiesent', zip: '93109'},
    { city: 'Leipzig', zip: '04155'},
    { city: 'Mötzing', zip: '93099'},
    { city: 'Leipzig', zip: '04103'},
    { city: 'Neumarkt-Sankt Veit', zip: '84494'},
    { city: 'Beetzsee, Wollin, Wenzlow, Golzow u.a.', zip: '14778'},
    { city: 'Treffelstein', zip: '93492'},
    { city: 'Loitzendorf', zip: '94359'},
    { city: 'Gersdorf', zip: '09355'},
    { city: 'Eggenfelden', zip: '84307'},
    { city: 'Miltach', zip: '93468'},
    { city: 'Jessen (Elster)', zip: '06917'},
    { city: 'Beelitz', zip: '14547'},
    { city: 'Raschau', zip: '08352'},
    { city: 'Thalheim/Erzgebirge', zip: '09380'},
    { city: 'Gornsdorf', zip: '09390'},
    { city: 'Prohn', zip: '18445'},
    { city: 'Nuthetal', zip: '14558'},
    { city: 'Gingst', zip: '18569'},
    { city: 'Berlin Wlhelmstadt', zip: '13595'},
    { city: 'Riesa, Stauchitz, Hirschstein', zip: '01594'},
    { city: 'Berlin Tegel', zip: '13505'},
    { city: 'Neuenkirchen', zip: '17498'},
    { city: 'Uebigau-Wahrenbrück', zip: '04938'},
    { city: 'Saldenburg', zip: '94163'},
    { city: 'Seiffen/Erzgeb.', zip: '09548'},
    { city: 'Berlin Kreuzberg', zip: '12047'},
    { city: 'Passau', zip: '94032'},
    { city: 'Pörnbach', zip: '85309'},
    { city: 'Lenting', zip: '85101'},
    { city: 'Trebgast', zip: '95367'},
    { city: 'Tangerhütte u.a.', zip: '39517'},
    { city: 'Dietfurt a.d. Altmühl', zip: '92345'},
    { city: 'Oberhaching', zip: '82041'},
    { city: 'Magdeburg', zip: '39130'},
    { city: 'Magdeburg', zip: '39120'},
    { city: 'München', zip: '80539'},
    { city: 'Kirchenthumbach', zip: '91281'},
    { city: 'Magdeburg', zip: '39106'},
    { city: 'München', zip: '81827'},
    { city: 'Valley', zip: '83626'},
    { city: 'Schkölen', zip: '07619'},
    { city: 'Sternberg', zip: '19406'},
    { city: 'Langenbach', zip: '85416'},
    { city: 'Haag a.d. Amper', zip: '85410'},
    { city: 'Mehlmeisel', zip: '95694'},
    { city: 'Retschow, Admannshagen-Bargeshagen u.a.', zip: '18211'},
    { city: 'Pritzwalk, Groß Pankow', zip: '16928'},
    { city: 'Retschow, Admannshagen-Bargeshagen u.a.', zip: '18211'},
    { city: 'Meineweh, Osterfeld', zip: '06721'},
    { city: 'Berlin Blankenburg', zip: '13129'},
    { city: 'Berlin Alt-Hohenschönhausen', zip: '13053'},
    { city: 'Berlin', zip: '12681'},
    { city: 'Berlin Kaulsdorf', zip: '12621'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Pulsnitz', zip: '01896'},
    { city: 'Vetschau', zip: '03226'},
    { city: 'Penkun u.a.', zip: '17328'},
    { city: 'Großdubrau, Malschwitz', zip: '02694'},
    { city: 'Bad Muskau, Groß Düben, Gablenz', zip: '02953'},
    { city: 'Niesky, Hohendubrau u.a.', zip: '02906'},
    { city: 'Nauroth', zip: '57583'},
    { city: 'Häg-Ehrsberg', zip: '79685'},
    { city: 'Siegen', zip: '57080'},
    { city: 'Bad Bergzabern u.a.', zip: '76887'},
    { city: 'Lennestadt', zip: '57368'},
    { city: 'Aspisheim, Grolsheim', zip: '55459'},
    { city: 'Steinach', zip: '77790'},
    { city: 'Edesheim', zip: '67483'},
    { city: 'Limburg', zip: '65553'},
    { city: 'Brande-Hörnerkirchen', zip: '25364'},
    { city: 'Fulda', zip: '36043'},
    { city: 'Rotenburg an der Fulda', zip: '36199'},
    { city: 'Gaildorf', zip: '74405'},
    { city: 'Wietze', zip: '29323'},
    { city: 'Hannover', zip: '30519'},
    { city: 'Hannover', zip: '30657'},
    { city: 'Gersfeld', zip: '36129'},
    { city: 'Sibbesse', zip: '31079'},
    { city: 'Sontra', zip: '36205'},
    { city: 'Westensee', zip: '24259'},
    { city: 'Sehnde', zip: '31319'},
    { city: 'Arenshausen, Uder u.a.', zip: '37318'},
    { city: 'Gleichen', zip: '37130'},
    { city: 'Ulm', zip: '89077'},
    { city: 'Achterwehr', zip: '24239'},
    { city: 'Hildesheim', zip: '31135'},
    { city: 'Boostedt', zip: '24598'},
    { city: 'Seevetal', zip: '21217'},
    { city: 'Kalefeld', zip: '37589'},
    { city: 'Hamburg', zip: '22415'},
    { city: 'Melsdorf', zip: '24109'},
    { city: 'Hamburg', zip: '22417'},
    { city: 'Felm', zip: '24244'},
    { city: 'Fischen im Allgäu', zip: '87538'},
    { city: 'Aalen', zip: '73430'},
    { city: 'Kiel', zip: '24106'},
    { city: 'Kirchdorf an der Iller', zip: '88457'},
    { city: 'Weißenhorn', zip: '89264'},
    { city: 'Kiel', zip: '24103'},
    { city: 'Niederwerrn', zip: '97464'},
    { city: 'Söhlde', zip: '31185'},
    { city: 'Preetz', zip: '24211'},
    { city: 'Trittau', zip: '22946'},
    { city: 'Ergersheim', zip: '91465'},
    { city: 'Unterschneidheim', zip: '73485'},
    { city: 'Dischingen', zip: '89561'},
    { city: 'Haunsheim', zip: '89437'},
    { city: 'Rettenbach', zip: '89364'},
    { city: 'Krumbach (Schwaben)', zip: '86381'},
    { city: 'Neuengörs', zip: '23818'},
    { city: 'Niederorschel u.a.', zip: '37355'},
    { city: 'Tespe', zip: '21395'},
    { city: 'Brietlingen', zip: '21382'},
    { city: 'Natendorf', zip: '29587'},
    { city: 'Bad Königshofen i. Grabfeld', zip: '97631'},
    { city: 'Nesselwang', zip: '87484'},
    { city: 'Langenfeld', zip: '91474'},
    { city: 'Bissingen', zip: '86657'},
    { city: 'Südharz, Berga', zip: '06536'},
    { city: 'Lüchow', zip: '29439'},
    { city: 'Schondorf a. Ammersee', zip: '86938'},
    { city: 'Oberau', zip: '82496'},
    { city: 'Schwanstetten', zip: '90596'},
    { city: 'Udestedt, Mönchenholzhausen u.a.', zip: '99198'},
    { city: 'Königsmoos', zip: '86669'},
    { city: 'Kunreuth', zip: '91358'},
    { city: 'Lübbow', zip: '29488'},
    { city: 'Lauf an der Pegnitz', zip: '91207'},
    { city: 'Berlstedt', zip: '99439'},
    { city: 'Langendorf', zip: '29484'},
    { city: 'Sindelsdorf', zip: '82404'},
    { city: 'Weimar', zip: '99423'},
    { city: 'Allstedt', zip: '06542'},
    { city: 'Steffenberg', zip: '35239'},
    { city: 'Wetzlar', zip: '35579'},
    { city: 'Dornstetten', zip: '72280'},
    { city: 'Wetzlar', zip: '35576'},
    { city: 'Dautphetal', zip: '35232'},
    { city: 'Bielefeld', zip: '33617'},
    { city: 'Bromskirchen, Hallenberg', zip: '59969'},
    { city: 'Waldachtal', zip: '72178'},
    { city: 'Schopfloch', zip: '72296'},
    { city: 'Wetzlar', zip: '35581'},
    { city: 'Bremen', zip: '28779'},
    { city: 'Sankt Peter-Ording', zip: '25826'},
    { city: 'Allendorf', zip: '35108'},
    { city: 'Neu-Isenburg', zip: '63263'},
    { city: 'Bad Homburg v.d. Höhe', zip: '61352'},
    { city: 'Immendingen', zip: '78194'},
    { city: 'Kraichtal', zip: '76703'},
    { city: 'Heidelberg', zip: '69120'},
    { city: 'Münzenberg', zip: '35516'},
    { city: 'Frittlingen', zip: '78665'},
    { city: 'Dielheim', zip: '69234'},
    { city: 'Dautmergen', zip: '72356'},
    { city: 'Rietheim-Weilheim', zip: '78604'},
    { city: 'Niefern-Öschelbronn', zip: '75223'},
    { city: 'Uchte', zip: '31600'},
    { city: 'Bredstedt, Breklum u.a.', zip: '25821'},
    { city: 'Minden', zip: '32427'},
    { city: 'Mühlheim an der Donau', zip: '78570'},
    { city: 'Hirrlingen', zip: '72145'},
    { city: 'Neunkirchen', zip: '74867'},
    { city: 'Langenselbold', zip: '63505'},
    { city: 'Barntrup', zip: '32683'},
    { city: 'Mudau', zip: '69427'},
    { city: 'Schafflund, Meyn u.a.', zip: '24980'},
    { city: 'Johannesberg', zip: '63867'},
    { city: 'Oberndorf', zip: '21787'},
    { city: 'Stuttgart', zip: '70195'},
    { city: 'Walheim', zip: '74399'},
    { city: 'Stuttgart', zip: '70567'},
    { city: 'Wester-Ohrstedt', zip: '25885'},
    { city: 'Sottrum, Reeßum, Bötersen u.a.', zip: '27367'},
    { city: 'Stuttgart', zip: '70180'},
    { city: 'Stuttgart', zip: '70182'},
    { city: 'Gammertingen', zip: '72501'},
    { city: 'Mundelsheim', zip: '74395'},
    { city: 'Stuttgart', zip: '70329'},
    { city: 'Großbottwar', zip: '71723'},
    { city: 'Schafstedt, Weidenhof, Bornholt', zip: '25725'},
    { city: 'Schauenburg', zip: '34270'},
    { city: 'Weinsberg', zip: '74189'},
    { city: 'Engelschoff', zip: '21710'},
    { city: 'Niedenstein', zip: '34305'},
    { city: 'Lehrensteinsfeld', zip: '74251'},
    { city: 'Eichenbühl', zip: '63928'},
    { city: 'Wüstenrot, Beilstein-Stocksberg', zip: '71543'},
    { city: 'Mertloch, Welling u.a.', zip: '56753'},
    { city: 'Castrop-Rauxel', zip: '44577'},
    { city: 'Moormerland', zip: '26802'},
    { city: 'Lingen', zip: '49809'},
    { city: 'Windhagen', zip: '53578'},
    { city: 'Engelskirchen', zip: '51766'},
    { city: 'Battweiler u.a.', zip: '66484'},
    { city: 'Rheine', zip: '48432'},
    { city: 'Dortmund', zip: '44369'},
    { city: 'Rheine', zip: '48431'},
    { city: 'Herschweiler-Pettersheim', zip: '66909'},
    { city: 'Gelsenkirchen', zip: '45891'},
    { city: 'Nordhorn', zip: '48531'},
    { city: 'Troisdorf', zip: '53844'},
    { city: 'Bonn', zip: '53111'},
    { city: 'Sprockhövel', zip: '45549'},
    { city: 'Monzelfeld, Hochscheid u.a.', zip: '54472'},
    { city: 'Recklinghausen', zip: '45665'},
    { city: 'Kottenheim', zip: '56736'},
    { city: 'Datteln', zip: '45711'},
    { city: 'Dortmund', zip: '44147'},
    { city: 'Vinningen, Trulben, Ruppertsweiler u.a.', zip: '66957'},
    { city: 'Breitenfelde, Lankau', zip: '23881'},
    { city: 'Goslar', zip: '38644'},
    { city: 'Baisweil', zip: '87650'},
    { city: 'Schlüsselfeld', zip: '96132'},
    { city: 'Altenmünster', zip: '86450'},
    { city: 'Braunschweig', zip: '38126'},
    { city: 'Zeil a. Main', zip: '97475'},
    { city: 'Bröthen', zip: '21514'},
    { city: 'Wertingen', zip: '86637'},
    { city: 'Burgoberbach', zip: '91595'},
    { city: 'Pforzen', zip: '87666'},
    { city: 'Wechingen', zip: '86759'},
    { city: 'Weidenbach', zip: '91746'},
    { city: 'Oetzen', zip: '29588'},
    { city: 'Oberhof', zip: '98559'},
    { city: 'Wemding', zip: '86650'},
    { city: 'Hiltenfingen', zip: '86856'},
    { city: 'Aystetten', zip: '86482'},
    { city: 'Windsbach', zip: '91575'},
    { city: 'Rehna, Carlow u.a.', zip: '19217'},
    { city: 'Heringen/ Helme', zip: '99765'},
    { city: 'Steingaden', zip: '86989'},
    { city: 'Elleben, Wachsenburg', zip: '99334'},
    { city: 'Clenze', zip: '29459'},
    { city: 'Weil', zip: '86947'},
    { city: 'Großbreitenbach', zip: '98701'},
    { city: 'Hemhofen', zip: '91334'},
    { city: 'Geltendorf', zip: '82269'},
    { city: 'Dießen a. Ammersee', zip: '86911'},
    { city: 'Küsten', zip: '29482'},
    { city: 'Eresing', zip: '86941'},
    { city: 'Kranenburg', zip: '47559'},
    { city: 'Würselen', zip: '52146'},
    { city: 'Hückelhoven', zip: '41836'},
    { city: 'Simmerath', zip: '52152'},
    { city: 'Inden', zip: '52459'},
    { city: 'Mönchengladbach', zip: '41239'},
    { city: 'Merzenich', zip: '52399'},
    { city: 'Kordel', zip: '54306'},
    { city: 'Zemmer', zip: '54313'},
    { city: 'Bettenfeld, Niederöfflingen u.a.', zip: '54533'},
    { city: 'Borkum', zip: '26757'},
    { city: 'Mertesdorf', zip: '54318'},
    { city: 'Düsseldorf', zip: '40549'},
    { city: 'Duisburg', zip: '47249'},
    { city: 'Duisburg', zip: '47138'},
    { city: 'Duisburg', zip: '47279'},
    { city: 'Düsseldorf', zip: '40589'},
    { city: 'Köln', zip: '50829'},
    { city: 'Brühl', zip: '50321'},
    { city: 'Deuselbach, Hermeskeil, Rorodt', zip: '54411'},
    { city: 'Heiligenhaus', zip: '42579'},
    { city: 'Wesseling', zip: '50389'},
    { city: 'Köln', zip: '51143'},
    { city: 'Heek', zip: '48619'},
    { city: 'Essen', zip: '45139'},
    { city: 'Weissach im Tal', zip: '71554'},
    { city: 'Kassel', zip: '34117'},
    { city: 'Marktheidenfeld', zip: '97828'},
    { city: 'Forchtenberg', zip: '74670'},
    { city: 'Lauda-Königshofen', zip: '97922'},
    { city: 'Rendsburg', zip: '24768'},
    { city: 'Emerkingen', zip: '89607'},
    { city: 'Üttingen, Holzkirchen', zip: '97292'},
    { city: 'Steimel', zip: '57614'},
    { city: 'Münster', zip: '48143'},
    { city: 'Oberdreis', zip: '57639'},
    { city: 'Iserlohn', zip: '58636'},
    { city: 'Medard, Rathskirchen u.a.', zip: '67744'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Sankt Goarshausen u.a.', zip: '56346'},
    { city: 'Lorch', zip: '65391'},
    { city: 'Winterborn, Waldgrehweiler, Niedermoschel, u.a.', zip: '67822'},
    { city: 'Tiefenthal', zip: '67311'},
    { city: 'Weisenheim am Sand', zip: '67256'},
    { city: 'Iffezheim', zip: '76473'},
    { city: 'Damme', zip: '49401'},
    { city: 'Oldenburg (Oldenburg)', zip: '26129'},
    { city: 'Wiesbaden', zip: '65203'},
    { city: 'Gönnheim', zip: '67161'},
    { city: 'Harxheim', zip: '55296'},
    { city: 'Gaggenau', zip: '76571'},
    { city: 'Ludwigshafen am Rhein', zip: '67071'},
    { city: 'Mutterstadt', zip: '67112'},
    { city: 'Eckersdorf', zip: '95488'},
    { city: 'Grabow u.a.', zip: '19300'},
    { city: 'München', zip: '81241'},
    { city: 'Wolmirstedt u.a.', zip: '39326'},
    { city: 'Schwarzenbach a. Wald', zip: '95131'},
    { city: 'Crivitz, Friedrichsruhe u.a.', zip: '19089'},
    { city: 'Bayreuth', zip: '95444'},
    { city: 'München', zip: '81547'},
    { city: 'München', zip: '81549'},
    { city: 'Lanitz-Hassel-Tal, Molauer Land', zip: '06628'},
    { city: 'Holzkirchen', zip: '83607'},
    { city: 'Unterföhring', zip: '85774'},
    { city: 'München', zip: '81739'},
    { city: 'Grafenwöhr', zip: '92655'},
    { city: 'Bad Wiessee', zip: '83707'},
    { city: 'Mücheln/ Geiseltal', zip: '06249'},
    { city: 'Beratzhausen', zip: '93176'},
    { city: 'Poppenricht', zip: '92284'},
    { city: 'Zorneding', zip: '85604'},
    { city: 'Goldbeck, Arneburg u.a.', zip: '39596'},
    { city: 'Immenreuth', zip: '95505'},
    { city: 'Ebermannsdorf', zip: '92263'},
    { city: 'Zerbst/Anhalt', zip: '39261'},
    { city: 'Gera', zip: '07549'},
    { city: 'Plauen', zip: '08525'},
    { city: 'Luhe-Wildenau', zip: '92706'},
    { city: 'Vilsheim', zip: '84186'},
    { city: 'Rostock', zip: '18146'},
    { city: 'Nittenau', zip: '93149'},
    { city: 'Samerberg', zip: '83122'},
    { city: 'Neutraubling', zip: '93073'},
    { city: 'Geisenhausen', zip: '84144'},
    { city: 'Mylau', zip: '08499'},
    { city: 'Falkenstein/Vogtl.', zip: '08223'},
    { city: 'Niederaichbach', zip: '84100'},
    { city: 'Bärnau', zip: '95671'},
    { city: 'Niederviehbach', zip: '84183'},
    { city: 'Altenburg', zip: '04600'},
    { city: 'Rain', zip: '94369'},
    { city: 'Leiblfing', zip: '94339'},
    { city: 'Tacherting', zip: '83342'},
    { city: 'Chieming', zip: '83339'},
    { city: 'Schorndorf', zip: '93489'},
    { city: 'Malchin', zip: '17139'},
    { city: 'Mitterfels', zip: '94360'},
    { city: 'Aue', zip: '08280'},
    { city: 'Stephansposching', zip: '94569'},
    { city: 'Piding', zip: '83451'},
    { city: 'Chemnitz', zip: '09119'},
    { city: 'Moos', zip: '94554'},
    { city: 'Jöhstadt', zip: '09477'},
    { city: 'Luckenwalde', zip: '14943'},
    { city: 'Berlin Staaken', zip: '13591'},
    { city: 'Bayerisch Eisenstein', zip: '94252'},
    { city: 'Nossen', zip: '01683'},
    { city: 'Berlin Siemensstadt', zip: '13629'},
    { city: 'Berlin Wilmersdorf', zip: '10709'},
    { city: 'Berlin Charlottenburg', zip: '10629'},
    { city: 'Reinsberg', zip: '09629'},
    { city: 'Berlin Märkisches Viertel', zip: '13435'},
    { city: 'Greifswald', zip: '17493'},
    { city: 'Berlin Kreuzberg', zip: '10999'},
    { city: 'Usingen', zip: '61250'},
    { city: 'Karlsruhe', zip: '76228'},
    { city: 'Karlsruhe', zip: '76229'},
    { city: 'Bielefeld', zip: '33613'},
    { city: 'Lorsch', zip: '64653'},
    { city: 'Frankfurt am Main', zip: '60549'},
    { city: 'Stuhr', zip: '28816'},
    { city: 'Fronhausen', zip: '35112'},
    { city: 'Unterreichenbach', zip: '75399'},
    { city: 'Frankenberg', zip: '35066'},
    { city: 'Eutingen im Gäu', zip: '72184'},
    { city: 'Kieselbronn', zip: '75249'},
    { city: 'Tetenbüll', zip: '25882'},
    { city: 'Mühlhausen-Ehingen', zip: '78259'},
    { city: 'Wald-Michelbach', zip: '69483'},
    { city: 'Bubsheim', zip: '78585'},
    { city: 'Neidenstein', zip: '74933'},
    { city: 'Mücke', zip: '35325'},
    { city: 'Gaienhofen', zip: '78343'},
    { city: 'Cleebronn', zip: '74389'},
    { city: 'Sankt Michaelisdonn,Gudendorf,Volsemenhusen,Trennewurth', zip: '25693'},
    { city: 'Meßkirch, Sauldorf', zip: '88605'},
    { city: 'Balje', zip: '21730'},
    { city: 'Nehren', zip: '72147'},
    { city: 'Binnen', zip: '31619'},
    { city: 'Badisch Schöllenbach', zip: '64754'},
    { city: 'Kusterdingen', zip: '72127'},
    { city: 'Ahnsen', zip: '31708'},
    { city: 'Hespe', zip: '31693'},
    { city: 'Walddorfhäslach', zip: '72141'},
    { city: 'Drage, Seeth', zip: '25878'},
    { city: 'Neuental', zip: '34599'},
    { city: 'Albersdorf', zip: '25767'},
    { city: 'Stuttgart', zip: '70619'},
    { city: 'Ilsfeld', zip: '74360'},
    { city: 'Großenwörden', zip: '21712'},
    { city: 'Neudenau', zip: '74861'},
    { city: 'Meersburg', zip: '88709'},
    { city: 'Biebergemünd', zip: '63599'},
    { city: 'Vaale', zip: '25594'},
    { city: 'Esslingen am Neckar', zip: '73732'},
    { city: 'Unterensingen', zip: '72669'},
    { city: 'Markdorf', zip: '88677'},
    { city: 'Meggerdorf, Friedrichsholm, Friedrichsgraben u.a.', zip: '24799'},
    { city: 'Weinstadt', zip: '71384'},
    { city: 'Korb', zip: '71404'},
    { city: 'Lauenförde', zip: '37697'},
    { city: 'Kropp u.a.', zip: '24848'},
    { city: 'Bad Saulgau, Allmannsweiler', zip: '88348'},
    { city: 'Neuhausen/Erzgeb.', zip: '09544'},
    { city: 'Berlin Friedrichshain', zip: '10245'},
    { city: 'Berlin Karlshorst', zip: '10318'},
    { city: 'Sellin', zip: '18586'},
    { city: 'Radeburg', zip: '01471'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Lichtenow, Altlandsberg u.a.', zip: '15345'},
    { city: 'Ferdinandshof u.a.', zip: '17379'},
    { city: 'Dresden', zip: '01109'},
    { city: 'Melchow, Chorin u.a.', zip: '16230'},
    { city: 'Dresden', zip: '01239'},
    { city: 'Dresden', zip: '01309'},
    { city: 'Dresden', zip: '01257'},
    { city: 'Karlshagen', zip: '17449'},
    { city: 'Schipkau', zip: '01993'},
    { city: 'Bad Gottleuba-Berggießhübel', zip: '01816'},
    { city: 'Kröslin, Krummin, Lassan u.a.', zip: '17440'},
    { city: 'Ueckermünde', zip: '17373'},
    { city: 'Königstein/Sächs.Schw.', zip: '01824'},
    { city: 'Burg/Spreewald u.a.', zip: '03096'},
    { city: 'Welzow', zip: '03119'},
    { city: 'Königswartha', zip: '02699'},
    { city: 'Gartz (Oder)', zip: '16307'},
    { city: 'Cottbus', zip: '03050'},
    { city: 'Herrnhut', zip: '02747'},
    { city: 'Dickenschied u.a.', zip: '55483'},
    { city: 'Weyerbusch', zip: '57635'},
    { city: 'Dortmund', zip: '44263'},
    { city: 'Lähden', zip: '49774'},
    { city: 'Obernheim-Kirchenarnbach u.a.', zip: '66919'},
    { city: 'Meinerzhagen', zip: '58540'},
    { city: 'Bornich, Patersberg', zip: '56348'},
    { city: 'Sulzburg', zip: '79295'},
    { city: 'Schmalenberg', zip: '67718'},
    { city: 'Malberg, Norken, Höchstenbach u.a.', zip: '57629'},
    { city: 'Ringsheim', zip: '77975'},
    { city: 'March', zip: '79232'},
    { city: 'Hamm', zip: '59065'},
    { city: 'Wenden', zip: '57482'},
    { city: 'Bergisch Gladbach', zip: '51469'},
    { city: 'Engden, Isterberg, Schüttorf u.a.', zip: '48465'},
    { city: 'Wuppertal', zip: '42111'},
    { city: 'Neunkirchen', zip: '66540'},
    { city: 'Wuppertal', zip: '42119'},
    { city: 'Walchum', zip: '26907'},
    { city: 'Königswinter', zip: '53639'},
    { city: 'Wuppertal', zip: '42287'},
    { city: 'Ellenz-Poltersdorf', zip: '56821'},
    { city: 'Erpel', zip: '53579'},
    { city: 'Ennepetal', zip: '58256'},
    { city: 'Herrstein', zip: '55756'},
    { city: 'Neustadt b. Coburg', zip: '96465'},
    { city: 'Nürnberg', zip: '90455'},
    { city: 'Inning a. Ammersee', zip: '82266'},
    { city: 'Egenhofen', zip: '82281'},
    { city: 'Schwarzburg', zip: '07427'},
    { city: 'Falkenstein', zip: '06463'},
    { city: 'Aschersleben', zip: '06449'},
    { city: 'Waldburg', zip: '88289'},
    { city: 'Grünenplan, Delligsen', zip: '31073'},
    { city: 'Hannover', zip: '30451'},
    { city: 'Altertheim', zip: '97237'},
    { city: 'Hannover', zip: '30177'},
    { city: 'Barkelsby', zip: '24360'},
    { city: 'Güntersleben', zip: '97261'},
    { city: 'Hamburg', zip: '22525'},
    { city: 'Adelmannsfelden', zip: '73486'},
    { city: 'Rimpar', zip: '97222'},
    { city: 'Röttingen, Tauberrettersheim', zip: '97285'},
    { city: 'Hüttisheim', zip: '89185'},
    { city: 'Würzburg', zip: '97078'},
    { city: 'Berka/ Werra', zip: '99837'},
    { city: 'Würzburg', zip: '97076'},
    { city: 'Norderstedt', zip: '22844'},
    { city: 'Breitingen', zip: '89183'},
    { city: 'Estenfeld', zip: '97230'},
    { city: 'Vöhringen', zip: '89269'},
    { city: 'Ramsthal', zip: '97729'},
    { city: 'Soderstorf', zip: '21388'},
    { city: 'Adelshofen', zip: '91587'},
    { city: 'Pfaffenhofen a.d. Roth', zip: '89284'},
    { city: 'Worbis', zip: '37339'},
    { city: 'Albertshofen', zip: '97320'},
    { city: 'Iphofen', zip: '97346'},
    { city: 'Oberstreu', zip: '97640'},
    { city: 'Clausthal-Zellerfeld, Oberschulenberg', zip: '38678'},
    { city: 'Kirchhaslach', zip: '87755'},
    { city: 'Gerolzhofen', zip: '97447'},
    { city: 'Todendorf', zip: '22965'},
    { city: 'Sontheim', zip: '87776'},
    { city: 'Stadtlauringen', zip: '97488'},
    { city: 'Gädheim', zip: '97503'},
    { city: 'Colmberg', zip: '91598'},
    { city: 'Oberrieden', zip: '87769'},
    { city: 'Groß Oesingen', zip: '29393'},
    { city: 'Trittau', zip: '22946'},
    { city: 'Gülzow', zip: '21483'},
    { city: 'Bechhofen', zip: '91572'},
    { city: 'Sulzdorf a.d. Lederhecke', zip: '97528'},
    { city: 'Schleusingen u.a.', zip: '98553'},
    { city: 'Germaringen', zip: '87656'},
    { city: 'Wachenroth', zip: '96193'},
    { city: 'Lübeck', zip: '23562'},
    { city: 'Wolferstadt', zip: '86709'},
    { city: 'Scharbeutz', zip: '23683'},
    { city: 'Bischberg', zip: '96120'},
    { city: 'Stegaurach', zip: '96135'},
    { city: 'Hallstadt', zip: '96103'},
    { city: 'Veitsbronn', zip: '90587'},
    { city: 'Itzgrund', zip: '96274'},
    { city: 'Hohenfurch', zip: '86978'},
    { city: 'Garmisch-Partenkirchen', zip: '82467'},
    { city: 'Augsburg', zip: '86153'},
    { city: 'Königslutter am Elm', zip: '38154'},
    { city: 'Dassow', zip: '23942'},
    { city: 'Wolsdorf', zip: '38379'},
    { city: 'Stein', zip: '90547'},
    { city: 'Kissing', zip: '86438'},
    { city: 'Rott', zip: '86935'},
    { city: 'Großrudestedt, Schloßvippach u.a.', zip: '99195'},
    { city: 'Steindorf', zip: '82297'},
    { city: 'Eresing', zip: '86922'},
    { city: 'Pronsfeld', zip: '54597'},
    { city: 'Viersen', zip: '41749'},
    { city: 'Mönchengladbach', zip: '41065'},
    { city: 'Jüchen', zip: '41363'},
    { city: 'Welschbillig, Igel, Aach', zip: '54298'},
    { city: 'Krefeld', zip: '47802'},
    { city: 'Esch', zip: '54585'},
    { city: 'Krefeld', zip: '47809'},
    { city: 'Föhren', zip: '54343'},
    { city: 'Fell', zip: '54341'},
    { city: 'Duisburg', zip: '47057'},
    { city: 'Oberhausen', zip: '46049'},
    { city: 'Klausen', zip: '54524'},
    { city: 'Mülheim an der Ruhr', zip: '45473'},
    { city: 'Köln', zip: '50735'},
    { city: 'Essen', zip: '45355'},
    { city: 'Solingen', zip: '42697'},
    { city: 'Monzelfeld, Hochscheid u.a.', zip: '54472'},
    { city: 'Köln', zip: '51061'},
    { city: 'Saarbrücken', zip: '66125'},
    { city: 'Nordhorn', zip: '48527'},
    { city: 'Mayschoß', zip: '53508'},
    { city: 'Krummhörn', zip: '26736'},
    { city: 'Köln', zip: '51109'},
    { city: 'Vellmar', zip: '34246'},
    { city: 'Unterwaldhausen', zip: '88379'},
    { city: 'Flensburg', zip: '24944'},
    { city: 'Husby', zip: '24975'},
    { city: 'Mainhardt', zip: '74535'},
    { city: 'Elmshorn', zip: '25335'},
    { city: 'Reher', zip: '25593'},
    { city: 'Staufenberg', zip: '34355'},
    { city: 'Gemünden a. Main', zip: '97737'},
    { city: 'Boxberg', zip: '97944'},
    { city: 'Oberrot', zip: '74420'},
    { city: 'Witzenhausen, Gutsbezirk', zip: '37216'},
    { city: 'Freudenberg', zip: '57258'},
    { city: 'Wangerooge', zip: '26486'},
    { city: 'Bingen am Rhein', zip: '55411'},
    { city: 'Bingen am Rhein', zip: '55411'},
    { city: 'Sexau', zip: '79350'},
    { city: 'Dannenfels', zip: '67814'},
    { city: 'Aspisheim, Grolsheim', zip: '55459'},
    { city: 'Annweiler am Trifels', zip: '76855'},
    { city: 'Rheinmünster', zip: '77836'},
    { city: 'Burbach', zip: '57299'},
    { city: 'Marnheim', zip: '67297'},
    { city: 'Hahnstätten u.a.', zip: '65623'},
    { city: 'Eltville am Rhein', zip: '65345'},
    { city: 'Wilhelmshaven', zip: '26386'},
    { city: 'Limburg', zip: '65552'},
    { city: 'Saulheim', zip: '55291'},
    { city: 'Eisenbach', zip: '79871'},
    { city: 'Dillenburg', zip: '35686'},
    { city: 'Baiersbronn', zip: '72270'},
    { city: 'Osthofen', zip: '67574'},
    { city: 'Waldems', zip: '65529'},
    { city: 'Unterkirnach', zip: '78089'},
    { city: 'Bobenheim-Roxheim', zip: '67240'},
    { city: 'Linkenheim-Hochstetten', zip: '76351'},
    { city: 'Karlsruhe', zip: '76133'}];

export function getCitiesAndZips() {
    return citiesAndZips;
}